import { Vector3, Box3 } from 'three';
import $ from 'jquery';
import { EditDragControls } from './controls/EditDragControls';

import { v4 as uuidv4 } from 'uuid';
import { gsap, Expo } from 'gsap';

import {
  pointCameraToObject,
  pointCameraToCss3DObject,
  degrees_to_radians,
  radians_to_degrees,
  emptySelectOptions,
  closeTinyMCEMoreMenu,
  isValidUrl,
  arePerspectiveElements,
  notDraggableItems,
  isVraiAgentComponentMesh,
  getVraiAgentRoot,
  isVraiAgentParent,
} from './components/engine/helpers/worldHelpers';
import generate_template from './components/engine/helpers/jsonTemplateGenerators';
import { addNewProduct, getSortedProducts, updateDataOrder, emptyProductValues, getFormData } from './components/engine/helpers/getSortedProducts';
import { getImgThumb, getLowResImageUrl, getSceneImgFromThumb } from './components/engine/helpers/getImageType';

import { Scene3D } from './Scene3D';
import { VRServices } from './components/engine/VRServices';
import { VRChairObject } from './components/engine/VRChairObject';
import { VRSceneChangeObject } from './components/engine/VRSceneChangeObject';
import { VRLinkObject } from './components/engine/VRLinkObject';
import { VRShopObject } from './components/engine/VRShopObject';
import { VRYoutubeGhostObject } from './components/engine/VRYoutubeGhostObject';
import { VRIframeAgentGhost } from './components/engine/VRIframeAgentGhost';
import { VRProfileObject } from './components/engine/VRProfileObject';
import { VRStreamScreenObject } from './components/engine/VRStreamScreenObject';
import { VRBaglessRoomObject } from './components/engine/VRBaglessRoomObject';
import { VRPayPalDonationObject } from './components/engine/VRPayPalDonationObject';
import VRChessObject from './components/engine/VRChessObject';
import {
  chessTexture,
  emptyTexture,
  INDICATOR_HIT_SIZE,
  imageGallery,
  musicObjectTexture,
  paypalDonateTexture,
  tourModeScreenShareTexture,
  videoPlayer
} from './components/engine/helpers/texturesAndGeometries';
import { editModeEvents } from './events/editModeEvents';
import { custom_checkbox, group_btn, group_element } from './components/components';
import { VRInfoElement } from './components/engine/VRInfoElement';
import { VRInvisibleAction } from './components/engine/VRInvisibleAction';
import getTooltipByType from './components/engine/helpers/getTooltipByType';
import { VREmbeddedWebpageObject } from './components/engine/VREmbeddedWebpageObject';
import { UNLIMITED, validateAction, validateRoomItem, FEATURE_NAMES } from './components/MVC/rolesHelper';
import { SCENE_EVENTS } from './components/MVC/Model';
import {
  CONFIRM_NOTIFICATION_SIZE,
  CONFIRM_NOTIFICATION_THEME,
  CONFIRM_NOTIFICATION_TYPE
} from './components/Modals/Notifications/ConfirmNotification';
import { GLOBAL_EVENTS } from './constants/global';
import { VRTourScreenShare } from './components/engine/VRTourScreenShare';
import { VRImageGallery } from './components/engine/VRImageGallery';
import { galleryHasImages, getGalleryCoverUrl, getGalleryPreviewAssetUrl, GALLERY_ACCEPTED_IMAGE_FILES, GALLERY_DEFAULT_ICON_PATH, GALLERY_MODE, normalizeNextImageDuration, persistGalleryConfig } from './components/engine/helpers/imageGalleryHelper';
import { VRVideoGallery } from './components/engine/VRVideoGallery';
import { VRVideoPlayer } from './components/engine/VRVideoPlayer';
import { VRVideoPlayerWebGL } from './components/engine/VRVideoPlayerWebGL';
import { VRMusicObject } from './components/engine/VRMusicObject';
import { EDITOR_ACTIONS, SCENE_OBJECT_TYPES } from './constants/SceneObjects';
import { getActionsForType, getEventsForComponentType, getActionLabelKey, getEventLabelKey, getImageGalleryPanelActions, buildFullAgentConfigFromLibrary, mergeLibraryAgentIntoChairConfig, sceneObjectTypeSupportsEventActionsTab, isSceneLevelEventType, isSceneLevelSource, SCENE_SOURCE_TYPE, WELCOME_SOURCE_TYPE, WELCOME_OBJECT_ID, isWelcomeEventTarget, getAiEventsFromConfig, normalizeAiEvents, slugifyAiEventName, mergeComponentEventsWithAiEvents } from './constants/eventActions';
import { getAiTokenShareUrl, getSpaceViewBaseUrl, copyTextToClipboard, escapeHtml } from './helpers/aiToken';
import { VapiAgentTestModal } from './components/Modals/VapiAgentTestModal';
import { ComponentRegistry } from './constants/componentRegistry';
import RoomEditSocket from './socket/RoomEditSocket';
import { initQuillEditor, getQuillContent, setQuillContent, removeQuillEditor } from './components/engine/helpers/editorHelpers';
import { VRObject3D } from "./components/engine/VRObject3D";
import { VRVapiChairWithCSS3D } from './components/engine/VRVapiChairWithCSS3D';
import { VRVapiCameraWithCSS3D } from './components/engine/VRVapiCameraWithCSS3D';
import { VRVapiTranscriptionWithCSS3D } from './components/engine/VRVapiTranscriptionWithCSS3D';
import { VRVapiButtonWithCSS3D } from './components/engine/VRVapiButtonWithCSS3D';
import { VRIframeElement } from './components/engine/VRIframeElement';
import { VRTimerElement, normalizeTimePreset } from './components/engine/VRTimerElement';
import { VRInputFieldGuess } from './components/engine/VRInputFieldGuess';
import { VRInputField } from './components/engine/VRInputField';
import { DEFAULT_IFRAME_EMBED } from './components/iframe-UI/constants.js';


const css3DContainer = document.querySelector('#css3d');

/// TODO: Move to EditUI.js or similar with all functions
const rangeHolder = document.querySelector('.range-holder');
const distanceRange = document.querySelector('#distance_range');
const sizeRangeHolder = document.querySelector('.size-range-holder');
const sizeRange = document.querySelector('#size_range');
const removeElement = document.querySelector('.remove_element');
// const buttonsHolder = document.querySelector('.buttons-holder');
const editElement = document.querySelector('.edit_element');
const showRoomSlider = document.querySelector('.showRoomSlider');
const sliderContainer = document.querySelector('.slidecontainer');
const roomSlider = document.querySelector('#roomSlider');

const rotateXRange = document.querySelector('#rotateX_range');
const rotateYRange = document.querySelector('#rotateY_range');
const rotateXRangeHolder = document.querySelector('.rotateX-holder');
const rotateYRangeHolder = document.querySelector('.rotateY-holder');
const SIZE_RANGE_LIMITS = {
  min: 0.1,
  max: 10,
  step: 0.05,
};

const resetBtn = document.querySelector("#reset-perspective");
const videoLoopEdit = document.querySelector("#video-loop-edit");
const inputFieldGuessTimePresetEdit = document.querySelector("#input_field_guess_time_preset_edit");
const inputFieldGuessAutocloseTrueEdit = document.querySelector("#input_field_guess_autoclose_true_edit");
const inputFieldGuessAutocloseFalseEdit = document.querySelector("#input_field_guess_autoclose_false_edit");
const inputFieldValidationEdit = document.querySelector("#input_field_validation_edit");
const inputFieldMinLengthEdit = document.querySelector("#input_field_min_length_edit");
const inputFieldKeyEdit = document.querySelector("#input_field_key_edit");
const inputFieldFunnelStepEdit = document.querySelector("#input_field_funnel_step_edit");
const inputFieldAutocloseEdit = document.querySelector("#input_field_autoclose_edit");
const videoTransparentEdit = document.querySelector("#video-transparent-edit");
const videoPlayOnClickEdit = document.querySelector("#video_player_play_on_click");
const infoElementDescriptionAdvertisementLinks = document.querySelector("#info-element-description-advertisement-links");

function normalizeOptionalTimePreset(raw) {
  const value = String(raw || '').trim();
  return value ? normalizeTimePreset(value) : '';
}

// we agreed this is all going to be outside JS file
// RoomEditor will have api open, close, upload
// TODO : create RoomEditor.js,SidebarContet.js and remove all logic there

function describeEditCss3dClickAction(type) {
  const m = {
    vraiAgent: 'Edit agent – toggleSelect, showObjectMenu, agent image panel',
    vapiUserCamera: 'Edit user camera – perspective handles, showObjectMenu',
    vapiTranscription: 'Edit transcription – showObjectMenu',
    vapiButton: 'Edit agent button – showObjectMenu',
    iframeElement: 'Edit iframe – perspective handles, showObjectMenu',
    timerElement: 'Edit timer – perspective handles, showObjectMenu',
  };
  return m[type] || `Edit CSS3D component (${type}) – showObjectMenu / properties`;
}

function describeEditRaytraceClickAction(parentName, meshType) {
  return `Edit mode: showObjectMenu for parent "${parentName || '?'}" (mesh type ${meshType || '?'}) – distance/rotate sliders, JSON sync`;
}

function isVideoPlayerType(type) {
  return type === 'videoPlayer' || type === 'videoPlayerWebGL';
}

function isVideoBackgroundType(type) {
  return type === 'videoPlayerWebGL';
}

class ModeEdit extends Scene3D {

  constructor(props) {
    if (!(props)) {
      return;
    } else {
      super(props);
      this._syncModelCurrentScene();
      this.model.view = this;
      this.model._sceneNorthById = this.model._sceneNorthById || {};
      this.model._sceneNorthOriginalById = this.model._sceneNorthOriginalById || {};
      this.model._sceneNorthCompassOverrideById = this.model._sceneNorthCompassOverrideById || {};
      if (Array.isArray(this.scenes)) {
        for (const scene of this.scenes) {
          const rot = Number(scene?.sceneRotationY);
          const val = Number.isFinite(rot) ? rot : 0;
          if (scene?.id) {
            if (!Object.prototype.hasOwnProperty.call(this.model._sceneNorthOriginalById, scene.id)) {
              this.model._sceneNorthOriginalById[scene.id] = val;
            }
            if (Number.isFinite(rot) && rot !== 0) {
              this.model._sceneNorthById[scene.id] = rot;
            }
          }
        }
      }
      window.model = this;
      window.view = this;

      /**
      * Crosshair
      */
      this.addCursor();
      this.model.URLS = props.URLS;
      this.imgUrl = props.URLS.addImage;
      this.tempImgUrl = props.URLS.temporaryFileUploadUrl;
      this.vraiAgentImageUrl = '';
      this.vapiCameraImageUrl = '';
      this.squadMemberImages = ['', '', '', '', '', ''];
      this.squadActiveMembers = 1;
      this._vapiAddMode = null;
      this.updateWorld = props.URLS.updateWorld;
      this.updateSpaceTypeUrl = props.URLS.updateSpaceType;
      this.worldID = props.URLS.ID;
      this.audioUrl = props.URLS.addAudio;
      this.worldCoordinatesUrl = props.URLS.saveWorldCoordinates;
      this.worldCoordinates = { lat: props.URLS.lat, lng: props.URLS.lng }
      this.videoUrl = props.URLS.addVideo;

      this.user = props.URLS.userData;
      this.subscriptionPlan = props.URLS.subscriptionPlan;
      window.subscriptionPlan = this.subscriptionPlan;
      this.ownerSubscriptionPlan = props.URLS.ownerSubscriptionPlan;
      window.ownerSubscriptionPlan = this.ownerSubscriptionPlan;
      this.numberOfPremiumWorlds = props.URLS.numberOfPremiumWorlds;
      this.splashLogo = props.URLS.splashLogo;
      this.totalPremiumWorldsFromSubscription = this.SubscriptionPlan?.customer?.total_premium_spaces || 0;
      this.ownerPremiumWorldsFromSubscription = this.ownerSubscriptionPlan?.customer?.total_premium_spaces || 0;

      this.isDraft = Boolean(props.URLS.isDraft);

      this.ownerId = props.URLS.userId;
      this.ownerWPId = props.URLS.wpId;
      this.ownerAvatarURL = props.URLS.avatarUrl || './textures/profile.png';

      this.ownerAvatarTexture = this.textureLoaderSilent.load(this.ownerAvatarURL);

      this.lastCameraQuaternion = null;
      this.openSidebar = !(this.isMobile || $(".navbar-holder").width() < 1050);
      this.editElementStates = {};

      this.services = new VRServices();
      this.services.addEventListener('objectsUpdated', this.updateDB);
      this.model.addEventListener(SCENE_EVENTS.SCENE_EDIT_DATA_CHANGED, () => {
        this.updateDB();
        this.publishChanges();
        this.updateDB();
      });

      this.socket = new RoomEditSocket({ model: this.model });

      this.model.addEventListener(SCENE_EVENTS.SCENE_SAVED_SUCCESS, () => {
        this._clearEditorDraft();
        $('#publish_changes, #preview_mode').addClass('disabled');
        this._commitPublishedNorthBaselines();
        this.model.info('success', $trans('changes-saved'));
      });

      this.model.addEventListener(SCENE_EVENTS.SCENE_SAVED_ERROR, (error) => {
        $('#publish_changes, #preview_mode').removeClass('disabled');
        const errors = error.data.response.data.errors;
        for (let key in errors) {
          let error = errors[key];
          if (Array.isArray(error) && error.length > 0) {
            error = error[0];
          }
          this.model.alert('error', error);
        }
        this.model.info('error', $trans('error-saving-changes'));
      });

      this.model.addEventListener(SCENE_EVENTS.SPACE_TYPE_CHANGED, () => {
        window.location.reload();
      })

      this._editModeControls();
      this._editButtonsEvents();

      const welcomeScreenActive = this.worldData.hasOwnProperty('welcomeScreen') ? this.worldData.welcomeScreen.hasOwnProperty('show') ? this.worldData.welcomeScreen.show : false : false;
      $("#welcomeScreenActive").prop("checked", welcomeScreenActive);

      const consentScreenActive = this.worldData.consentScreen && this.worldData.consentScreen.show;
      $("#consentScreenActive").prop("checked", !!consentScreenActive);

      const navigationMenuActive = this._isNavigationMenuActive();
      $("#navigationMenuActive").prop("checked", navigationMenuActive);

      if (this.worldData.hasOwnProperty('welcomeScreen')) {
        if (this.worldData.welcomeScreen.videoPath) {
          $("#welcome_screen_video").attr("src", welcomeScreenActive.videoPath);
          $("#welcome_screen_video").addClass("active");
          $("#upload_welcome_screen_video .upload-watermark").addClass("hide");
          $("#removeWelcomeScreenVideo").addClass("active");
        }
      }

      /**
       * UPLOAD IMAGE
       * (dom_element, clickable, temp_url, forceJpg, sliceImage, url, callbackFunction, crop)
       */
      this.model.uploadImage('#newScene', true, this.tempImgUrl, true, true, this.imgUrl, this.createSceneCallbackFunction);
      this.model.uploadImage('#newSceneMobile', true, this.tempImgUrl, true, true, this.imgUrl, this.createSceneCallbackFunction);
      this.model.uploadImage('#css3d', false, this.tempImgUrl, true, true, this.imgUrl, this.updateSphereBGCallbackFunction);
      this.model.uploadImage('.scene_bg_image_upload', true, this.tempImgUrl, true, true, this.imgUrl, this.updateSphereBGCallbackFunction);

      this.model.uploadImage('#upload_world_thumbnail', true, this.tempImgUrl, 'img', false, this.imgUrl, this.updateWorldThumbnailCallbackFunction, { aspectRatio: (16 / 9), width: 420, height: 225 });
      this.model.uploadImage('#upload_world_logo', true, this.tempImgUrl, 'img', false, this.imgUrl, this.updateWorldLogoCallbackFunction, {});
      this.model.uploadImage('#upload_vrai_agent_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.vraiAgentImageCallbackFunction, {});
      this.model.uploadImage('#upload_vrai_agent_image_edit', true, this.tempImgUrl, 'img', false, this.imgUrl, this.vraiAgentImageEditCallbackFunction, {});
      // Squad member image upload zones (pre-allocated slots 0–5)
      for (let _smi = 0; _smi < 6; _smi++) {
        ((mi) => {
          this.model.uploadImage(`#upload_squad_member_image_${mi}`, true, this.tempImgUrl, 'img', false, this.imgUrl, (imageURL) => {
            this.squadMemberImages[mi] = imageURL;
            $(`#squad_member_img_${mi}`).attr('src', imageURL);
            $(`[data-member-index="${mi}"].squad-member-remove-img`).css('display', 'flex');
          }, {});
        })(_smi);
      }
      this.model.uploadImage('#upload_vapi_camera_image_edit', true, this.tempImgUrl, 'img', false, this.imgUrl, this.vapiCameraImageEditCallbackFunction, {});
      this.model.uploadImage('#upload_edit_vapi_library_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.editVapiLibraryImageCallbackFunction, {});
      this.model.uploadImage('#upload_world_splash', true, this.tempImgUrl, 'img', false, this.imgUrl, this.updateWorldSplashCallbackFunction, {});

      this.model.uploadImage('#upload_scene_change_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.sceneChangeImageCallbackFunction);
      this.model.uploadImage('#upload_link_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.linkImageCallbackFunction);
      this.model.uploadImage('#upload_paypal_donation_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.paypalDonationCallbackFunction);
      this.model.uploadImage('.upload_product_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.productCallbackFunction, { aspectRatio: (16 / 9), width: 960, height: 540 });
      this.model.uploadImage('#uploadProfileImage', true, this.tempImgUrl, 'img', false, this.imgUrl, this.uploadProfileCallbackFunction, { aspectRatio: 1, width: 256, height: 256 });
      this.model.uploadImage('#upload_info_element_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.uploadInfoImageCallbackFunction, { aspectRatio: (16 / 9), width: 960, height: 540 });
      this.model.uploadVideo('#upload_info_element_video', true, this.tempImgUrl, 'video', false, this.imgUrl, this.uploadInfoVideoCallbackFunction);
      this.model.uploadAudio('.upload-song', true, this.tempImgUrl, this.audioUrl, this.uploadAmbientMusicCallbackFunction);
      this.model.uploadImage('#upload_embedded_webpage_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.uploadEmbeddedWebpageImageCallbackFunction);

      this.model.uploadImage('#upload_welcome_screen_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.uploadWelcomScreenImageCallbackFunction, { aspectRatio: (16 / 9), width: 960, height: 540 });
      this.model.uploadVideo('#upload_welcome_screen_video', true, this.tempImgUrl, 'video', false, this.imgUrl, this.uploadWelcomScreenVideoCallbackFunction);

      this.model.uploadImage('#upload_video_player_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.videoPlayerImageCallbackFunction);
      this.model.uploadVideo('#upload_video_player_video', '#upload_videoFile_label', '/media/upload-file', 'video', false, 'media/add-image', this.videoPlayerVideoCallbackFunction);
      this.model.uploadAudio('#upload_musicObjectAudio_label', true, this.tempImgUrl, this.audioUrl, this.musicObjectAudioCallbackFunction);

      this.model.uploadVideo('#add-video-from-tools', true, '/media/upload-file', 'video', false, 'media/add-image', (e) => {
        this._add3dObject("videoGallery", null, { url: e })
      }
      );
      const parentElement = document.querySelector("#add-video-from-tools");
      const children = parentElement.children;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        this.model.uploadVideo(child, true, '/media/upload-file', 'video', false, 'media/add-image', (e) => {
          this._add3dObject("videoGallery", null, { url: e });
        });
      }

      this.model.uploadImage('#upload_image_gallery', true, this.tempImgUrl, 'img', false, this.imgUrl, this.imageGalleryImageUploadCallBack, null, {
        acceptedFiles: GALLERY_ACCEPTED_IMAGE_FILES,
        dictInvalidFileType: $trans('gallery-upload-unsupported-file'),
        dictFileTooBig: $trans('gallery-upload-file-too-big'),
        startHandler: (file) => {
          const parent = this._getSelectedImageGallery();
          if (!parent || !file) return;
          file._galleryObject = parent;
          parent.startGalleryUpload(file);
        },
        errorHandler: (file, errorMessage) => {
          this._getSelectedImageGallery(file)?.failGalleryUpload?.(file, errorMessage);
        },
        progressHandler: (file, progress) => {
          this._getSelectedImageGallery(file)?.updateGalleryUploadProgress?.(file, progress);
        },
      });
      this.model.uploadImage('#upload_gallery_preview_image', true, this.tempImgUrl, 'img', false, this.imgUrl, this.galleryPreviewImageCallbackFunction);

      $('input.slider[type=range]').on('input change', (e) => {
        this.updateSliderFill(e.currentTarget);
      });

      // INFO ELEMENT SCENES OPTIONS EVENTS
      this.generateLocationOptions();

      $("#locationButton").on("change", (e) => {
        if ($(e.currentTarget).val() === this.currentScene.id) {
          $("#info-element-button-url").val('');
          $("#locationButton").val($("#locationButton option:first").val());
          $(".locationButton .select-selected").text('');
          this.model.alert('error', $trans('error-link-to-same-location'));
        } else {
          $("#info-element-button-url").val(`id: ${$(e.currentTarget).find('option:selected').val()}`);
        }
      });

      $("#info-element-button-url").on("keyup paste", (e) => {
        $("#locationButton").val($("#locationButton option:first").val());
        $(".locationButton .select-selected").text('');
      });

      if (this.worldData.publicAvailable) {
        $(".change_embed > .select-selected").attr("data-value", "public");
        $(".change_embed > .select-selected").html("Yes");
        $('.change_embed').val('Yes');
      }
      if (this.worldData.embedded) {
        $(".change_embed > .select-selected").attr("data-value", "embeded");
        $(".change_embed > .select-selected").html("Embeded");
        $('.change_embed').val('embeded');
      }
      if (!this.worldData.embedded && !this.worldData.publicAvailable) {
        $(".change_embed > .select-selected").attr("data-value", "private");
        $(".change_embed > .select-selected").html("No");
        $('.change_embed').val('No');
      };

      $(".world_name").val(this.worldData.name);
      $(".world_name").val(this.worldData.name);
      $("#world_description").val(this.worldData.description);
      $("#world_home_url").val(this.worldData.homeURL || "");
      $("#world_updates_url").val(this.worldData.updatesUrl || "");

      if (!this.worldData.userLanguage) {
        this.worldData.userLanguage = "English";
      }
      $("#change_language").val(this.worldData.userLanguage);
      $(".change_language > .select-selected").attr("data-value", this.worldData.userLanguage);
      $(".change_language > .select-selected").html(this.worldData.userLanguage);
      $('.change_language').val(this.worldData.userLanguage);


      // DRAFT MODAL EVENTS
      $("#draft-welcome-modal").toggleClass("is-active", this.isDraft);

      $("#world_name_draft").on("keyup change", (e) => {
        const val = $(e.currentTarget).val();
        $("#world_name").val(val);
        $("#world_name_").val(val);
        this.worldData.name = val;
        this.updateDB();
      });

      $("#tour_mode_edit").on('change', (event) => {
        this.worldData.tourModeAvailable = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#tour_mode_disable_autorotate_edit").on('change', (event) => {
        this.worldData.disableAutorotate = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#hide_language_selection_edit").on('change', (event) => {
        this.worldData.hideLanguageSelection = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#disable_postits_edit").on('change', (event) => {
        this.worldData.disablePostits = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#disable_chat_edit").on('change', (event) => {
        this.worldData.disableChat = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#disable_user_list_edit").on('change', (event) => {
        this.worldData.disableUserList = event.target.checked ? 1 : 0;
        this.updateDB();
      });

      $("#draft_mode_edit").on('change', (event) => {
        if (this.model.config.role !== 'admin_role' && this.model.config.role !== 'Admin') {
          if (!validateRoomItem(this.model.sceneData.space_type, { type: EDITOR_ACTIONS.hide_from_space_browser })) {
            this.model.alert('error', $trans('not-available-in-free-plan'));
            $("#draft_mode_edit").prop("checked", false);
            return;
          }
        }
        this.worldData.is_draft = event.target.checked ? 1 : 0;
        this.updateDB();
      });
      if (this.model.userIsContributor) {
        $("#draft_mode_edit").parent().addClass("disabled");
        $(`[data-lang="draft-mode-name-text"]`).addClass("disabled");
      }
      $("#disable_guest_restrictions_edit").on('change', (event) => {
        if (this.model.config.role !== 'admin_role' && this.model.config.role !== 'Admin') {
          if (!validateRoomItem(this.model.sceneData.space_type, { type: EDITOR_ACTIONS.disable_guest_restrictions })) {
            this.model.alert('error', $trans('not-available-in-free-plan'));
            $("#disable_guest_restrictions_edit").prop("checked", false);
            return;
          }
        }
        this.worldData.disable_guest_restrictions = event.target.checked ? 1 : 0;
        this.updateDB();
      });
      $("#show_coordinates_modal_draft").on("click", () => {
        $("#show_coordinates_modal").trigger("click");
      });

      new editModeEvents();

      $("#add_bagless_room_button").on('click', () => {
        const isEdit = $("#add_bagless_room_button").text() === "Update";
        if (isEdit) {
          const roomName = $("#bagless-room-dropdown-title").text();
          const aspectRatio = $("#bagless_room_preview_image").width() / $("#bagless_room_preview_image").height();
          const url = `/worlds/view?id=${this.model.newBagleesRoomObject.id}&security=${this.model.URLS.securityHash}`;
          const newData = {
            image: {
              url: this.model.newBagleesRoomObject.image,
              aspectRatio
            },
            roomId: this.model.newBagleesRoomObject.id, url, roomName
          }
          this.elementSelected.parent.setDbConfig(newData);
          this.modifyLocalJSON(newData);
          $(".room_connect_holder").removeClass("is-active");

        } else {
          this._add3dObject("baglessRoom");
          $(".room_connect_holder").removeClass("is-active");
        }
      });

      /**
       * LOAD SCENE CHANGE IMAGE
       */
      $("#scene_change_image").on('load', (e) => {
        const imageSizes = e.target.getBoundingClientRect();
        const aspectRatio = imageSizes.width / imageSizes.height;
        $("#scene_change_image_aspect_ratio").val(aspectRatio);
        const imageSrc = $("#scene_change_image").attr('src');
        if (imageSrc.includes('edit_change_scene')) {
          $('#upload_scene_change_image .upload-thumb-removal').hide();
        } else {
          $('#upload_scene_change_image .upload-thumb-removal').show();
        }
        $("#scene_change_update").trigger('click');
      });

      $("#create-sceneChange-settings .scenes_holder, #create-sceneChange-settings .edit_target_scene_container .flx-sb").on('click', (e) => {
        if ($(e.target).closest('#open_scene_target').length) return;
        // Do not re-open the picker while the scenes modal is already open (breaks target_scene selection + Save).
        if ($('.scenes_target_holder').hasClass('is-active')) return;
        $("#open_scene_target").trigger('click');
      });
      $("#open_scene_target").on('click', () => {
        this.showSceneChangeModal('scene');
      });


      // <div class='leave-edit-mode' id='toggleModes' title='Switch to view mode'><i class='fas fa-sign-out-alt'></i></div>
      $(".sidebarContent").append(`
      <div class='leave-edit-mode returnToWordpress' title='Go back to homepage'><i class='fas fa-sign-out-alt fa-flip-horizontal'></i></div>
      `);

      $(document).on('click', '#toggleModes', () => {
        this._promptLeaveEditor('view');
      });

      $(document).on('click', '.returnToWordpress', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this._promptLeaveEditor('home');
      });

      $(".compass").addClass('top');

      /**
       * SCENES GALLERY CONTROLS
       */
      $("#more-scenes-right").on("click", () => {
        const currentMargin = $("#scenes-container").css('margin-left').replace("px", "") * 1;
        const newMargin = currentMargin - 56;

        $("#scenes-container").css({ 'margin-left': `${newMargin}px` });
        $("#more-scenes-left").addClass("visible");

        const dif = $(".bottom-bar-scene").length - 6;
        if (dif > 0) {
          if (Math.abs(newMargin) === dif * 56) {
            $("#more-scenes-right").removeClass("visible");
          }
        }
      });

      $("#more-scenes-left").on("click", () => {
        const currentMargin = $("#scenes-container").css('margin-left').replace("px", "") * 1;
        const newMargin = currentMargin + 56;
        $("#scenes-container").css({ 'margin-left': `${newMargin}px` });
        newMargin === 0 && $("#more-scenes-left").removeClass("visible");
        $("#more-scenes-right").addClass("visible");
      });

      $(".bottom-bar-room-settings").on("click", () => {
        this.deselectElement();
      });

      $(document).on("click", ".bottom-bar-scene", (e) => {
        this.changeScene('.bottom-bar-scene', e);
        $(".settings-menu").removeClass("is-active");
        $("#scene-menu").addClass("is-active");
        $("#openWorldEditor").removeClass("active");
        this.sceneSettings();
        $("#go-back-scenes-menu").addClass("visible"); // $("#go-back-scenes-menu").toggleClass("visible", e.originalEvent===undefined);
        $("#showSceneMenu").trigger("click");

        this.toggleOffset();
      });

      $("#showScenesMenu").on("click", (e) => {
        $(".tab-btn").removeClass("active");
        $(e.currentTarget).addClass("active");
        $(".room_menu").removeClass("visible");
        $(".assets_menu").removeClass("visible");
        $(".scenes_menu").addClass("visible");
        $("#openWorldEditor").removeClass("active");
        this.openSidebar = true;
        $(".room_delete").removeClass("disabled");
        $(".room_delete").eq(this.currentSceneIndex).addClass("disabled");
      });

      $("#showRoomMenu").on("click", (e) => {
        $(".tab-btn").removeClass("active");
        $(e.currentTarget).addClass("active");
        $(".room_menu").addClass("visible");
        $(".assets_menu").removeClass("visible");
        $(".scenes_menu").removeClass("visible");
        $("#openWorldEditor").addClass("active");
      });

      $("#showAssetsMenu").on("click", (e) => {
        $(".tab-btn").removeClass("active");
        $(e.currentTarget).addClass("active");
        $(".room_menu").removeClass("visible");
        $(".scenes_menu").removeClass("visible");
        $(".assets_menu").addClass("visible");
        $("#openWorldEditor").removeClass("active");
        this._renderAiAgentsList();
        this._renderAiTokensList();
      });

      this._vapiAgentTestModal = new VapiAgentTestModal(this);
      this._vapiAgentTestModal.bind();
      $(document).on("click", "#ai_agents_list .ai-agent-test", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $item = $(e.currentTarget).closest(".ai-agent-item");
        this._vapiAgentTestModal.open(this._getTestAgentFromListItem($item));
      });
      $(document).on("click", "#ai_agents_list .ai-agent-edit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $item = $(e.currentTarget).closest(".ai-agent-item");
        const agentId = $item.data("agent-id");
        const sceneIndex = $item.data("scene-index");
        const libraryId = $item.data("library-id");
        if (agentId != null && sceneIndex != null) {
          this._selectAgentFromAssets(agentId, sceneIndex, true);
        } else if (libraryId != null) {
          this._openEditVapiLibraryModal(
            libraryId,
            $item.data("library-name") || '',
            $item.data("library-assistant-id") || '',
            $item.data("library-image") || '',
            $item.data("library-scenario") || '',
            $item.attr("data-library-key-type") || 'missing'
          );
        }
      });
      $(document).on("click", "#ai_agents_list .ai-agent-delete", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $item = $(e.currentTarget).closest(".ai-agent-item");
        const agentId = $item.data("agent-id");
        const sceneIndex = $item.data("scene-index");
        const libraryId = $item.data("library-id");
        if (agentId != null && sceneIndex != null) {
          this._deletePlacedAgentFromAssets(agentId, sceneIndex);
        } else if (libraryId != null) {
          this._deleteVapiLibraryAgent(libraryId);
        }
      });
      $(document).on("change", "#ai_agents_list .ai-agent-lock-checkbox", (e) => {
        e.stopPropagation();
        const agentId = $(e.currentTarget).closest(".ai-agent-item").data("agent-id");
        const sceneIndex = $(e.currentTarget).closest(".ai-agent-item").data("scene-index");
        if (agentId != null && sceneIndex != null) this._toggleAgentLock(agentId, sceneIndex, $(e.currentTarget).prop("checked"));
      });
      $(document).on("click", "#ai_agents_list .ai-agent-lock", (e) => e.stopPropagation());

      $(".assets-ai-tokens-section .add-ai-token").on("click", () => {
        this._openAiTokenModal();
      });
      $("#ai_token_generate").on("click", () => {
        const token = String(Math.floor(1000000 + Math.random() * 9000000));
        $("#ai_token_value").val(token);
      });
      $(".ai_token_holder .modal-background, .ai_token_holder .close-modal").on("click", () => {
        $(".ai_token_holder").removeClass("is-active");
      });
      $("#ai_token_submit").on("click", () => this._saveAiToken(false));
      $("#ai_token_update").on("click", () => this._saveAiToken(true));
      $("#ai_token_default_link_copy").on("click", () => this._copyAiTokenLink($("#ai_token_default_link").val()));
      $(document).on("click", "#ai_tokens_list .ai-token-copy-link", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const token = $(e.currentTarget).closest(".ai-token-item").data("token");
        this._copyAiTokenLink(getAiTokenShareUrl(token));
      });
      $(document).on("click", "#ai_tokens_list .ai-token-test", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._openTestAgentFromToken($(e.currentTarget).closest(".ai-token-item"));
      });
      $(document).on("click", "#ai_tokens_list .ai-token-edit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = $(e.currentTarget).closest(".ai-token-item").data("id");
        const row = this._aiTokensCache?.[id] || this._aiTokensCache?.[String(id)];
        this._openAiTokenModal(row || { id });
      });
      $(document).on("click", "#ai_tokens_list .ai-token-delete", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = $(e.currentTarget).closest(".ai-token-item").data("id");
        this._deleteAiToken(id);
      });

      $("#showSceneMenu").on("click", (e) => {
        $(".tab-btn").removeClass("active");
        $(e.currentTarget).addClass("active");
        $(".scene_menu").addClass("visible");
        $(".elements_menu").removeClass("visible");
        this._renderSceneEventsList();
      });

      $("#showElementsMenu").on("click", (e) => {
        $(".tab-btn").removeClass("active");
        $(e.currentTarget).addClass("active");
        this.elementsGroups();
        $(".elements_menu").addClass("visible");
        $(".scene_menu").removeClass("visible");
        this.ambientSound.isPlaying && this.ambientSound.stop();
      });

      $("#go-back-scenes-menu").on("click", (e) => {
        $("#scene-menu").removeClass("is-active");
        $("#room-scene-menu").addClass("is-active");
        $("#showScenesMenu").trigger("click");
      });
      $(".select-items").addClass("editor");
      const self = this;

      // PREVIEW MODE
      $(document).on('click', '#preview_mode', (e) => {
        this.updateDB();
        const cameraPreservedAngle = this.cameraPreservedAngle(false);
        window.location = $('#virtualRealityContainer').attr('data-open-world-url') + `&rot=${cameraPreservedAngle}&loc=${this.currentScene.id}&mode=preview`;
      });

      const unsavedChangesCond = this._hasUnsavedEditorChanges();

      // $("#toggleModes, #preview_mode").toggleClass('disabled', this.isDraft);
      $("#publish_changes").toggleClass('disabled', !unsavedChangesCond);

      this.mapInitialization();

      this.generateSceneGallery();

      (this.isMobile || $(".navbar-holder").width() < 1050) && $(".settings-menu").removeClass("is-active");
      this.toggleOffset();

      $("#embedded_webpage_image").on('load', (e) => {
        const imageSizes = e.target.getBoundingClientRect();
        const aspectRatio = imageSizes.width / imageSizes.height;
        $("#embedded_webpage_image_aspect_ratio").val(aspectRatio);
      });

      $(document).on('click', '.upload_product_image', function (e) {
        self.currentProductNum = $(e.currentTarget).closest('form').attr('data-order');
      });

      $('#bagless_room_preview_image').on("load", function () {
        if ($(this).hasClass("check-aspect-ratio")) {
          $('#add_bagless_room_button').removeAttr("disabled");
          $(this).removeClass("check-aspect-ratio");
        }
      });

      // $("#publicStage").on("click", (e) => {
      //   if(!$("#publicStage").prop("checked")){
      //     if(!validateAction({role: this.user.role, action: 'publicStage', scenesObj: this.scenes}).state){
      //       e.preventDefault();
      //     }
      //   }
      // });

      $("#publicStage").on("change", (e) => {
        this.scenes[this.currentSceneIndex].publicStage = $(e.target).prop('checked');
        this.updateDB();
      });

      // Product add
      this.currentProductNum = null;

      $(document).on('click', '#add_more_products', function (e) {
        let lastProductNum = parseInt($('#products').find('.product-container').last().attr('data-order'));
        let newNum = parseInt(lastProductNum) + 1;
        let product = addNewProduct(newNum);
        $(product).appendTo('#products');
        let items = getSortedProducts('.product-container', 'data-order');
        updateDataOrder(items);

        // Initialize Quill editor for new product
        const editorSelector = '#product_description' + newNum + '_editor';
        initQuillEditor(editorSelector);

        let upImage = $(".product-container[data-order=" + newNum + "] .upload_product_image")[0];
        self.model.uploadImage(upImage, true, self.tempImgUrl, 'img', false, self.imgUrl, self.productCallbackFunction, { aspectRatio: (16 / 9), width: 960, height: 540 });
      });


      /**
       * Animate
       */
      this.tick();
      if (this.countItemsInScene(SCENE_OBJECT_TYPES.screenStream) >= 1) {
        $(".add-screen").addClass("disabled");
      }
      ///UI if is premium space
      if (this.model.sceneData.space_type === 'premium') {
        $("#freeSpaceContainer").remove();
        $("#downgradeToFree").on("click", () => {
          $(".space-select-modal").each(function () {
            $(this).hide();
            $(this).removeClass("is-active");
            $(this).removeClass("visible");
          });
          showSpaceDowngradeModal(() => {
            this.updateSpaceType('public');
          })
        });
      } else {
        $("#premiumSpaceContainer").remove();
        $("#upgradeToPremium").on("click", () => {
          $(".space-select-modal").each(function () {
            $(this).hide();
            $(this).removeClass("is-active");
            $(this).removeClass("visible");
          });
          showSpaceUpgradeModal(() => {
            checkPlanAndCreatePremiumSpace(() => {
              this.updateSpaceType('premium');
            })
          })
        });
      }

      const isAdmin = this.model.config?.role === 'admin_role' || this.model.config?.role === 'Admin';
      const hasAdminPlan = this.model.config?.subscriptionPlan?.plan?.code === 'admin';
      const hasCustomLogo = isAdmin || hasAdminPlan || this.model.config?.subscriptionPlan?.plan?.features?.[FEATURE_NAMES.CUSTOM_LOGO]?.availability;
      if (!hasCustomLogo) {
        $(".roomLogoHolder").remove();
      }

      if (this.totalPremiumWorldsFromSubscription === UNLIMITED) {
        $('#buyPremiumSpaces').hide();
      } else {
        $('#buyPremiumSpaces').show();
      }
      if (this.ownerPremiumWorldsFromSubscription === UNLIMITED) {
        $("#premiumWorldsCount").html(`${this.numberOfPremiumWorlds}/<span data-lang="unlimited-text">Unlimited</span>`);
      } else {
        $("#premiumWorldsCount").text(`${this.numberOfPremiumWorlds}/${this.ownerPremiumWorldsFromSubscription}`);
      }

      $("#buyPremiumSpaces").on("click", () => {
        window.showBuyNewPremiumSpacesModal && window.showBuyNewPremiumSpacesModal();
      });
      ///TEMP until new UI
      $(".confirm-modal .confirm-close").css("color", "black");
      $(".confirm-modal .confirm-cancel").css("color", "black");

    }
  }

  _applyValidateAction = (payload) => {
    return validateAction({ role: this.user.role, subscriptionPlan: this.subscriptionPlan, ...payload })
  }

  _isAdminUser = () => {
    const role = this.model?.config?.role;
    return role === 'admin_role' || role === 'Admin';
  }

  _canManageVapiComponents = () => {
    if (this._isAdminUser()) return true;
    this.model.alert?.('error', 'Only admin can create/add VAPI Component to a space');
    return false;
  }

  /**
   * IMAGE UPLOAD CALLBACK FUNCTIONS
   */
  createSceneCallbackFunction = (imageURL) => {
    const { state, limit } = this._applyValidateAction({ scenesObj: this.scenes, action: 'locations' }); // TODO: would be nice to run this validation before uploading the image; I've tried inside uploadImage method but the container init for dropzone failed
    if (!state) {
      this.model.hideLoading()
      this.model.alert('error', `${$trans('error-max-locations-reached')}: ${limit}`);
      return;
    }

    const element = generate_template('room', { unique_id: uuidv4(), publicName: `${this.worldData.name} - scene ${this.scenes.length + 1}`, imgSrc: imageURL });
    this.scenes.push(element);
    if (element?.id && this.model) {
      this.model._sceneNorthOriginalById = this.model._sceneNorthOriginalById || {};
      this.model._sceneNorthOriginalById[element.id] = 0;
    }
    const extension = element.background.mediumPath.split('.');
    const ext = `.${extension[extension.length - 1]}`;
    let thumb = element.background.mediumPath.replace(ext, `_thumb${ext}`);
    $(".roomsEditor").append(this.room_btn_template(this.scenes.length - 1, element.publicName, thumb, element.objects.length, element.id));
    this.updateDB();
    this.generateSceneGallery(false);
    $("#scenes_upload").removeClass("uploading");
    this.generateLocationOptions();
  }

  updateSphereBGCallbackFunction = (imageURL) => {
    const thumb = getImgThumb(imageURL);
    $('#scene_image').attr('src', thumb);
    this.currentScene.background.mediumPath = imageURL;
    this.currentScene.background.sliceImage = true;
    this.scenes[this.currentSceneIndex] = this.currentScene;
    this._syncModelCurrentScene();

    this.model.showLoading()
    this.textureLoaderSilent.load(imageURL, (texture) => {
      this.model.hideLoading()
      this._updateSphereTexture(texture);
      const cached = this.visitedRoomsTextures.find(room => room.id === this.currentScene.id);
      if (cached) {
        cached.texture = texture;
      } else {
        this.visitedRoomsTextures.push({ id: this.currentScene.id, texture });
      }
      const fullImageUrl = imageURL;
      const $roomPreview = $(`.preview_image:eq(${this.currentSceneIndex})`);
      const $sceneGalleryPreview = $(`.scene_gallery_preview_image:eq(${this.currentSceneIndex})`);
      const attachThumbnailFallback = ($img) => {
        $img.off('error.editorThumbFallback').on('error.editorThumbFallback', function () {
          const currentSrc = String($(this).attr('src') || '');
          if (currentSrc !== fullImageUrl) {
            $(this).attr('src', fullImageUrl);
          }
        });
      };

      attachThumbnailFallback($roomPreview);
      attachThumbnailFallback($sceneGalleryPreview);
      $roomPreview.attr('src', thumb);
      $sceneGalleryPreview.attr('src', thumb);

      this._syncEditModeSphereForBackgroundTiles();
      this.updateDB();
    }, (err) => {
      this.model.hideLoading()
    });
  }

  _syncModelCurrentScene() {
    if (!this.currentScene?.id) {
      return;
    }
    this.model.currentScene = this.model.scenes[this.currentScene.id] || this.currentScene;
    this.model.roomLocation = this.currentScene.id;
  }

  _syncEditModeSphereForBackgroundTiles() {
    const vrSphere = this.sphereController?.vrSpheres?.[this.currentScene.id];
    if (!vrSphere) {
      return;
    }
    vrSphere.url = `${String(this.currentScene.background.mediumPath).split('.')[0]}`;
    for (const segment of vrSphere.sphereSegments) {
      segment.mesh.visible = false;
      segment.loaded = false;
      segment.mesh.material.map = null;
      segment.mesh.material.needsUpdate = true;
    }
    vrSphere.tileMaterials = {};
    vrSphere.setInitRotation(0);
    this.sphereController.currentSphere = vrSphere;
    this._applyEditModeSphereTileStreaming();
    this.sphereController.updateSphereSegments();
  }

  updateWorldThumbnailCallbackFunction = (imageURL) => {
    $('.room_thumbnail').attr('src', imageURL);
    this.worldData.previewBackgroundImage.mediumPath = imageURL;
    this.updateDB();
  }

  updateWorldLogoCallbackFunction = (imageURL) => {
    $('.room_logo').attr('src', imageURL);
    this.worldData.customLogo = imageURL;
    this.updateDB();
  }

  vraiAgentImageCallbackFunction = (imageURL) => {
    $('.vrai_agent_holder .vrai_agent_image').attr('src', imageURL);
    this.vraiAgentImageUrl = imageURL;
    $('#removeVraiAgentImage').addClass('active');
  }

  vraiAgentImageEditCallbackFunction = (imageURL) => {
    $('#vrai_agent_image_edit').attr('src', imageURL);
    if (isVraiAgentParent(this.elementSelected?.parent)) {
      const parent = this.elementSelected.parent;
      const newData = { agent_image: imageURL };
      parent.setDbConfig(newData);
      this.modifyLocalJSON(newData);
      this.updateJSON(this.elementSelected);
      this.updateDB();
      if (parent.setAgentImage) parent.setAgentImage(imageURL);
    }
    $('#removeVraiAgentImageEdit').addClass('active');
  }

  vapiCameraImageEditCallbackFunction = (imageURL) => {
    $('#vapi_camera_image_edit').attr('src', imageURL);
    this.vapiCameraImageUrl = imageURL;
    const cameraComp = this.elementSelected?.parent?.name === 'vapiUserCamera'
      ? this.elementSelected.parent
      : this.elementSelected?.name === 'vapiUserCamera'
        ? this.elementSelected
        : null;
    if (cameraComp) {
      const newData = { imageUrl: imageURL };
      cameraComp.setDbConfig?.(newData);
      this.modifyLocalJSON(newData);
      this.updateJSON(this.elementSelected);
      this.updateDB();
    }
    $('#removeVapiCameraImageEdit').addClass('active');
  }

  editVapiLibraryImageCallbackFunction = (imageURL) => {
    $('#edit_vapi_library_image').attr('src', imageURL);
    this.editVapiLibraryImageUrl = imageURL;
    $('#removeEditVapiLibraryImage').addClass('active');
  }

  updateWorldSplashCallbackFunction = (imageURL) => {
    $('.room_splash').attr('src', imageURL);
    this.worldData.splashImage = imageURL;
    this.updateDB();
  }

  linkImageCallbackFunction = (imageURL) => {
    $("#link_image").attr("src", imageURL);
  }

  sceneChangeImageCallbackFunction = (imageURL) => {
    $("#scene_change_image").attr("src", imageURL);
    $("#scene_change_update").trigger('click');
  }

  videoPlayerImageCallbackFunction = (imageURL) => {
    $("#video_player_image").attr("src", imageURL);
    this._syncVideoPlayerPlaceholderRemoveBtn();

    if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
      const parent = this.elementSelected.parent;

      const img = new Image();
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        $("#video_player_image_aspect_ratio").val(aspectRatio);

        if (isVideoBackgroundType(parent.name)) {
          parent.placeholderImage = imageURL;
          parent.updateMeshTexture(() => {
            this.autoSaveVideoPlayer();
          });
        } else {
          parent.videoPlayerImage = imageURL;

          if (!parent.useIcon) {
            parent.setGeometry(imageURL, aspectRatio, true);
            parent.updateMeshTexture(() => {
              this.autoSaveVideoPlayer();
            }, true);
          } else {
            this.autoSaveVideoPlayer();
          }
        }
      };
      img.src = imageURL;
    }
  }

  videoPlayerVideoCallbackFunction = (videoURL, metadata) => {
    // Store video URL
    $("#video_player_url").val(videoURL);

    // Hide placeholder, show thumbnail
    $("#video_placeholder_text").hide();
    $("#video_thumbnail").show();

    // Display video info with title attribute for full filename
    const filename = metadata.name || videoURL.split('/').pop();
    $("#video_filename").text(filename).attr('title', filename);

    // Display file size
    if (metadata.size) {
      const sizeMB = (metadata.size / 1024 / 1024).toFixed(2);
      $("#video_filesize").text(sizeMB + ' MB');
    } else {
      $("#video_filesize").text('-');
    }

    // Store and display dimensions
    if (metadata.width && metadata.height) {
      // Store raw values as data attributes
      $("#video_dimension").data('width', metadata.width);
      $("#video_dimension").data('height', metadata.height);
      $("#video_dimension").data('ratio', (metadata.width / metadata.height).toFixed(4));
      // Display formatted text
      $("#video_dimension").text(metadata.width + ' x ' + metadata.height + 'px');
    } else {
      $("#video_dimension").removeData('width height ratio');
      $("#video_dimension").text('-');
    }

    // Set thumbnail if available from metadata
    if (metadata.thumbnail) {
      $("#video_thumbnail").attr('src', metadata.thumbnail);
    }

    // Enable play button
    $("#video_play_btn").prop('disabled', false);

    if (/\.webm(\?|#|$)/i.test(videoURL)) {
      if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
        $("#video_player_transparent_background").prop('checked', true);
      }
    }

    // Auto-save after setting all info
    if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
      const parent = this.elementSelected.parent;
      if (isVideoBackgroundType(parent.name)) {
        if (metadata.thumbnail) {
          parent.videoThumbnail = metadata.thumbnail;
        }
        if (videoURL) {
          const videoWidth = metadata.width || $("#video_dimension").data('width') || null;
          const videoHeight = metadata.height || $("#video_dimension").data('height') || null;
          parent.setVideoUrl(videoURL, null, videoWidth, videoHeight);
        }
      }
      this.autoSaveVideoPlayer();
    }
  }

  _getMusicObjectInstance() {
    if (!this.elementSelected || this._getSelectedEventObjectType() !== 'vrMusicObject') {
      return null;
    }
    return this._resolveEditableObject(this.elementSelected);
  }

  musicObjectAudioCallbackFunction = (audioURL) => {
    $("#music_object_audio_url").val(audioURL);
    const filename = audioURL.split('/').pop() || '';
    $("#music_object_audio_filename").text(filename).attr('title', filename);
    if (this._getMusicObjectInstance()) {
      this.autoSaveMusicObject();
    }
  }

  _setMusicPreviewPlaying = (isPlaying) => {
    $("#music_object_play_preview").toggleClass("hidden", !!isPlaying);
    $("#music_object_stop_preview").toggleClass("hidden", !isPlaying);
  }

  _stopMusicObjectPreview = () => {
    const musicObj = this._getMusicObjectInstance();
    if (!musicObj) {
      this._setMusicPreviewPlaying(false);
      return;
    }
    musicObj.stopPlaying?.();
    this._setMusicPreviewPlaying(false);
  }

  paypalDonationCallbackFunction = (imageURL) => {
    $("#paypal_donation_image").attr("src", imageURL);
    $("#paypal_donation_image").addClass('active');
  }
  _getSelectedImageGallery = (file) => {
    if (file?._galleryObject?.name === 'imageGallery') return file._galleryObject;
    const parent = this.elementSelected?.parent;
    return parent?.name === 'imageGallery' ? parent : null;
  }

  imageGalleryImageUploadCallBack = (res, file) => {
    const parent = this._getSelectedImageGallery(file);
    if (parent?.completeGalleryUpload) {
      parent.completeGalleryUpload(res, file);
      return;
    }
    parent?.addTempImage?.(res);
  }

  galleryPreviewImageCallbackFunction = (imageURL) => {
    const parent = this.elementSelected?.parent;
    if (!parent || parent.name !== 'imageGallery') return;

    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      $('#gallery_preview_image').attr('src', imageURL);
      $('#gallery_preview_image_aspect_ratio').val(aspectRatio);
      $('#removeGalleryPreviewImage').show();

      parent.setUseIcon(false);
      parent.dbConfig.previewImage = { url: imageURL, aspectRatio };
      parent.updateMeshTexture(() => {
        this.modifyLocalJSON(parent.getDbConfig());
      }, true);
      this._syncImageGalleryEditIndicator(parent);
    };
    img.src = imageURL;
  }

  uploadProfileCallbackFunction = (imageURL) => {
    $("#profile_image").attr("src", imageURL);
  }

  productCallbackFunction = (imageURL) => {
    if (this.currentProductNum) {
      $(".product-container[data-order=" + this.currentProductNum + "] .upload_product_image .default_image").attr('src', imageURL);
      $(".product-container[data-order=" + this.currentProductNum + "] input[name=product_image]").val(imageURL);
    }
  }

  uploadInfoImageCallbackFunction = (imageURL) => {
    $("#upload_info_element_image .upload-watermark").addClass("hide");
    $("#removeInfoElementImage").addClass("active");
    $("#info_element_image").attr("src", imageURL);
    $("#removeInfoElementVideo").trigger("click");
  }

  uploadInfoVideoCallbackFunction = (videoURL) => {
    $("#upload_info_element_video .upload-watermark").addClass("hide");
    $("#removeInfoElementVideo").addClass("active");
    $("#info_element_video").addClass("active");
    $("#info_element_video").attr("src", videoURL);
    $("#removeInfoElementImage").trigger("click");
  }

  uploadWelcomScreenImageCallbackFunction = (imageURL) => {
    $("#upload_welcome_screen_image .upload-watermark").addClass("hide");
    $("#removeWelcomeScreenImage").addClass("active");
    $("#welcome_screen_image").attr("src", imageURL);
    $("#removeWelcomeScreenVideo").trigger("click");
  }

  uploadEmbeddedWebpageImageCallbackFunction = (imageURL) => {
    $("#upload_embedded_webpage_image .upload-watermark").addClass("hide");
    $("#removeEmbeddedWebpageImage").addClass("active");
    $("#embedded_webpage_image").attr("src", imageURL);
  }

  uploadWelcomScreenVideoCallbackFunction = (videoURL) => {
    $("#upload_welcome_screen_video .upload-watermark").addClass("hide");
    $("#removeWelcomeScreenVideo").addClass("active");
    $("#welcome_screen_video").addClass("active");
    $("#welcome_screen_video").attr("src", videoURL);
    $("#removeWelcomeScreenImage").trigger("click");
  }

  uploadAmbientMusicCallbackFunction = (audioURL) => {
    const index = $("#scene_settings_id").val();
    this.scenes[index].ambientAudio.url = audioURL;
    this.scenes[index].ambientAudio.volume = $("#ambient_volume").val();
    $('#song-url').text(audioURL.replace("virtualRealityFiles/", ""));
    $('.audio_details_holder').addClass('visible');
    $('.audio_settings_holder').addClass('visible');
    this.loadAndPlayAmbientSound(this.scenes[index].ambientAudio, $("#toggleAmbientSound").prop("checked"));
    this.updateDB();
  }

  hideRemoveSongBtn = () => {
    $('#song-url').text('');
    this.ambientSound.isPlaying && this.ambientSound.stop();
    $('.audio_details_holder').removeClass('visible');
    $('.audio_settings_holder').removeClass('visible');
  }

  _rememberSceneNorth = (scene = this.currentScene) => {
    if (!scene?.id || !this.model) {
      return;
    }
    const rot = Number(scene.sceneRotationY);
    if (!Number.isFinite(rot)) {
      return;
    }
    this.model._sceneNorthById = this.model._sceneNorthById || {};
    this.model._sceneNorthById[scene.id] = rot;
  }

  _markNorthCompassOverride = (scene = this.currentScene) => {
    if (!scene?.id || !this.model) {
      return;
    }
    this.model._sceneNorthCompassOverrideById = this.model._sceneNorthCompassOverrideById || {};
    this.model._sceneNorthCompassOverrideById[scene.id] = true;
  }

  _isNorthCompassOverridden = (sceneId) => {
    return !!(sceneId && this.model?._sceneNorthCompassOverrideById?.[sceneId]);
  }

  _getOriginalSceneNorth = (sceneId) => {
    if (!sceneId || !this.model?._sceneNorthOriginalById) {
      return 0;
    }
    const rot = Number(this.model._sceneNorthOriginalById[sceneId]);
    return Number.isFinite(rot) ? rot : 0;
  }

  _getEffectiveNorthForScene = (scene) => {
    if (!scene?.id) {
      return Number.isFinite(Number(scene?.sceneRotationY)) ? Number(scene.sceneRotationY) : 0;
    }
    if (this._isNorthCompassOverridden(scene.id)) {
      const overridden = Number(this.model?._sceneNorthById?.[scene.id] ?? scene.sceneRotationY);
      return Number.isFinite(overridden) ? overridden : 0;
    }
    return this._getOriginalSceneNorth(scene.id);
  }

  _applyNorthForPublish = () => {
    if (!Array.isArray(this.scenes)) {
      return;
    }
    for (const scene of this.scenes) {
      if (!scene) continue;
      scene.sceneRotationY = this._getEffectiveNorthForScene(scene);
      if (this.currentScene?.id === scene.id) {
        this.currentScene.sceneRotationY = scene.sceneRotationY;
      }
      const modelScene = this.model?.sceneData?.scenes?.find((s) => s?.id === scene.id);
      if (modelScene) {
        modelScene.sceneRotationY = scene.sceneRotationY;
      }
    }
  }

  _commitPublishedNorthBaselines = () => {
    if (!Array.isArray(this.scenes) || !this.model) {
      return;
    }
    this.model._sceneNorthOriginalById = this.model._sceneNorthOriginalById || {};
    this.model._sceneNorthCompassOverrideById = this.model._sceneNorthCompassOverrideById || {};
    for (const scene of this.scenes) {
      if (!scene?.id) continue;
      const rot = Number(scene.sceneRotationY);
      this.model._sceneNorthOriginalById[scene.id] = Number.isFinite(rot) ? rot : 0;
      delete this.model._sceneNorthCompassOverrideById[scene.id];
    }
  }

  _preserveSceneRotationY = () => {
    if (this.currentSceneIndex == null || !this.currentScene || !Array.isArray(this.scenes)) {
      return;
    }
    const scene = this.scenes[this.currentSceneIndex];
    if (!scene) {
      return;
    }
    const rot = this._getEffectiveNorthForScene(scene);

    scene.sceneRotationY = rot;
    this.currentScene.sceneRotationY = rot;
    const modelScene = this.model?.sceneData?.scenes?.[this.currentSceneIndex];
    if (modelScene) {
      modelScene.sceneRotationY = rot;
    }
  }

  _normalizeScenesForSave = () => {
    this._preserveSceneRotationY();
    if (!Array.isArray(this.scenes)) {
      return;
    }
    for (const scene of this.scenes) {
      if (!scene) continue;
      const rot = Number(scene.sceneRotationY);
      scene.sceneRotationY = Number.isFinite(rot) ? rot : 0;
    }
  }

  _serializeForSceneJson = (obj) => {
    if (obj == null || typeof obj !== 'object') {
      return obj;
    }
    if (obj.isVector3 === true) {
      return { x: obj.x, y: obj.y, z: obj.z ?? 0 };
    }
    if (Array.isArray(obj)) {
      return obj.map((item) => this._serializeForSceneJson(item));
    }
    const out = {};
    for (const [key, val] of Object.entries(obj)) {
      if (val && typeof val === 'object' && val.isVector3 === true) {
        out[key] = { x: val.x, y: val.y, z: val.z ?? 0 };
      } else if (val && typeof val === 'object' && !Array.isArray(val)) {
        out[key] = this._serializeForSceneJson(val);
      } else {
        out[key] = val;
      }
    }
    return out;
  }

  _flushPendingSceneRotation = () => {
    if (!this.currentScene || !roomSlider || !sliderContainer?.classList.contains('visible')) {
      return;
    }
    this.currentScene.sceneRotationY = degrees_to_radians(roomSlider.value);
    this.scenes[this.currentSceneIndex] = this.currentScene;
    this._markNorthCompassOverride(this.currentScene);
    this._rememberSceneNorth(this.currentScene);
  }

  /**
   * Reset scene rotation after editing the geographical orientation
   */
  resetSceneRotation() {
    this._flushPendingSceneRotation();
    sliderContainer.classList.remove("visible");

    // $(".buttons-holder").addClass('visible');
    this.pivot.rotation.y = this.pivotLastRotation;

    if (this.lastCameraQuaternion !== null) {
      const last = this.lastCameraQuaternion;
      const start = this.camera.quaternion.clone();
      const cam = this.camera;
      gsap.to({}, {
        duration: .5,
        ease: Expo.easeOut,
        onStart: () => {
          this.roomGroup.rotation.y = 0;
        },
        onUpdate: function () {
          cam.quaternion.copy(start).slerp(last, this.ratio);
        },
        onComplete: () => {
          this.needleOffset = radians_to_degrees(this.currentScene.sceneRotationY);
          this.setControlsUpdate(true);
          this.lastCameraQuaternion = null;
        }
      });
    }
  }

  _hexFromColor(str) {
    if (!str || typeof str !== 'string') return '#000000';
    const m = str.match(/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/);
    if (m) return str;
    const rgb = str.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
    if (rgb) {
      const r = parseInt(rgb[1], 10).toString(16).padStart(2, '0');
      const g = parseInt(rgb[2], 10).toString(16).padStart(2, '0');
      const b = parseInt(rgb[3], 10).toString(16).padStart(2, '0');
      return `#${r}${g}${b}`;
    }
    return '#000000';
  }

  _parseBgColor(str) {
    if (!str || typeof str !== 'string') return { hex: '#000000', alpha: 100 };
    if (str.toLowerCase() === 'transparent') return { hex: '#000000', alpha: 0 };
    const hexM = str.match(/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/);
    if (hexM) return { hex: str, alpha: 100 };
    const rgbaM = str.match(/rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\)/);
    if (rgbaM) {
      const r = parseInt(rgbaM[1], 10).toString(16).padStart(2, '0');
      const g = parseInt(rgbaM[2], 10).toString(16).padStart(2, '0');
      const b = parseInt(rgbaM[3], 10).toString(16).padStart(2, '0');
      const alpha = rgbaM[4] != null ? Math.round(parseFloat(rgbaM[4]) * 100) : 100;
      return { hex: `#${r}${g}${b}`, alpha: Math.min(100, Math.max(0, alpha)) };
    }
    return { hex: '#000000', alpha: 100 };
  }

  _buildBgColor(hexVal, alphaVal) {
    const parsedAlpha = parseInt(alphaVal, 10);
    const alpha = Number.isFinite(parsedAlpha) ? parsedAlpha : 100;
    if (alpha <= 0) return 'transparent';
    if (alpha >= 100) return hexVal || 'transparent';
    let hex = hexVal || '#000000';
    const shortM = hex.match(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/);
    if (shortM) hex = '#' + shortM[1] + shortM[1] + shortM[2] + shortM[2] + shortM[3] + shortM[3];
    const m = hex.match(/^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/);
    if (!m) return hexVal || 'transparent';
    const r = parseInt(m[1], 16);
    const g = parseInt(m[2], 16);
    const b = parseInt(m[3], 16);
    return `rgba(${r},${g},${b},${alpha / 100})`;
  }


  /**
   * EDIT MODE DRAG / SCALE CONTROLS
   */
  _editModeControls() {
    // DRAG OBJECTS
    // DragControls captures the `_objects` array reference in a closure, so we pass a
    // mutable array and later mutate it (instead of trying to set `dragControls.objects`).
    this._editDragTargets = [];
    const dragControls = new EditDragControls(this._editDragTargets, this.camera, this.css3DRenderer.domElement);
    this.dragControls = dragControls;
    this._syncEditDragTargets?.();

    let startPosition = null;
    let endPosition = null;
    let selectedRootAtPointerDown = null;

    const getRoot3DObject = (eventObject) => {
      if (!eventObject) return null;

      // CSS3D VAPI components may be selected as component instance, anchor mesh, or mesh with userData refs.
      const fromUserData =
        eventObject?.userData?.vraiAgentChair ||
        eventObject?.userData?.vraiAgentCamera ||
        eventObject?.userData?.vraiAgentTranscription ||
        eventObject?.userData?.vraiAgentButton;
      if (fromUserData) return fromUserData;

      if (eventObject.anchor?.userData?.vraiAgentChair) return eventObject.anchor.userData.vraiAgentChair;
      if (isVraiAgentParent(eventObject)) return eventObject;
      if (isVraiAgentParent(eventObject.parent)) return eventObject.parent;

      if (eventObject.parent?.parent instanceof VRObject3D) {
        return eventObject.parent.parent;
      }
      if (eventObject.parent instanceof VRObject3D) {
        return eventObject.parent;
      }
      return eventObject;
    }

    const isCss3DResizableObject = (eventObject) => {
      const root = getRoot3DObject(eventObject);
      const t = root?.type || root?.name;
      return t === 'vraiAgent' || t === 'vapiUserCamera' || t === 'vapiTranscription' || t === 'vapiButton';
    }

    const isInfoElementObject = (eventObject, rootObject = null) => {
      const root = rootObject || getRoot3DObject(eventObject);
      const t = root?.type || root?.name;
      return t === 'infoElement';
    }

    // Indicator-only objects (default icon, no custom image) don't use size/distance.
    const isIndicatorOnlyObject = (eventObject, rootObject = null) => {
      const root = rootObject || getRoot3DObject(eventObject);
      const t = root?.type || root?.name;
      if (t === 'infoElement' && !root?.customIcon) return true;
      if ((t === 'embeddedWebpage' || t === 'sceneChange' || t === 'webLink' || t === 'videoPlayer') && (root?.useIcon || !root?.customIcon)) return true;
      return false;
    }

    const shouldShowDistanceControl = (eventObject, rootObject = null) => {
      const root = rootObject || getRoot3DObject(eventObject);
      return !isCss3DResizableObject(root) && !isInfoElementObject(root, root) && !isIndicatorOnlyObject(root, root);
    }

    const shouldShowSizeControl = (eventObject, rootObject = null) => {
      const root = rootObject || getRoot3DObject(eventObject);
      return !isInfoElementObject(root, root) && !isIndicatorOnlyObject(root, root);
    }

    const placeVapiComponentSharedSettings = (inVapiComponentGroup) => {
      const home = document.getElementById('object_settings_shared_home');
      const slot = document.getElementById('vrai_component_shared_settings');
      if (!home || !slot) return;
      const sizeEl = document.querySelector('.size-range-holder');
      const hideEl = document.querySelector('.hide-on-start-settings');
      const promptEl = document.querySelector('.prompt-transcript-modal-settings');
      const linkedEl = document.getElementById('vrai_show_agent_settings');
      if (inVapiComponentGroup) {
        // Order: Size, Hide on start, Prompt transcript, Linked agent
        [sizeEl, hideEl, promptEl, linkedEl].filter(Boolean).forEach((el) => slot.appendChild(el));
      } else {
        [sizeEl, hideEl].filter(Boolean).forEach((el) => home.appendChild(el));
        [promptEl, linkedEl].filter(Boolean).forEach((el) => slot.appendChild(el));
      }
    };
    this._placeVapiComponentSharedSettings = placeVapiComponentSharedSettings;

    const normalizeSizeRangeAttributes = () => {
      if (!sizeRange) return;
      sizeRange.min = `${SIZE_RANGE_LIMITS.min}`;
      sizeRange.max = `${SIZE_RANGE_LIMITS.max}`;
      sizeRange.step = `${SIZE_RANGE_LIMITS.step}`;
    }
    const clampSizeValue = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return 1;
      return Math.min(SIZE_RANGE_LIMITS.max, Math.max(SIZE_RANGE_LIMITS.min, n));
    }
    const preferPerspectiveIntersections = (intersections = []) => {
      if (!Array.isArray(intersections) || intersections.length < 2) return intersections;
      const priorities = {
        topLeft: 0,
        topRight: 0,
        bottomRight: 0,
        bottomLeft: 0,
        centerHandle: 1,
      };
      return [...intersections].sort((a, b) => {
        const pa = priorities[a?.object?.name] ?? 2;
        const pb = priorities[b?.object?.name] ?? 2;
        if (pa !== pb) return pa - pb;
        return (a?.distance ?? Number.POSITIVE_INFINITY) - (b?.distance ?? Number.POSITIVE_INFINITY);
      });
    }

    const getMeshSizeForSelection = (eventObject, rootObject = null) => {
      const root = rootObject || getRoot3DObject(eventObject);
      const rootUserScale = Number(root?._userScale);
      const dbSize = Number(root?.dbConfig?.size ?? root?.dbConfig?.scale);
      const selectedScale = Number(eventObject?.scale?.x);
      const rootScale = Number(root?.mesh?.scale?.x);
      if (Number.isFinite(rootUserScale) && rootUserScale > 0) return rootUserScale;
      if (Number.isFinite(dbSize) && dbSize > 0) return dbSize;
      if (Number.isFinite(selectedScale) && selectedScale > 0) return selectedScale;
      if (Number.isFinite(rootScale) && rootScale > 0) return rootScale;
      return 1;
    }

    const refreshSizeDistanceControls = (eventObject = this.elementSelected) => {
      if (!eventObject) {
        rangeHolder.classList.remove('visible');
        sizeRangeHolder.classList.remove('visible');
        return;
      }
      const rootObject = getRoot3DObject(eventObject);
      const parent = rootObject || eventObject?.parent;
      if (parent?.getLimits && rootObject?.objConfig?.isResizable) {
        rangeHolder.classList.toggle('visible', shouldShowDistanceControl(eventObject, rootObject));
        sizeRangeHolder.classList.toggle('visible', shouldShowSizeControl(eventObject, rootObject));
        const elementLimits = parent.getLimits();
        if (shouldShowDistanceControl(eventObject, rootObject)) {
          distanceRange.setAttribute('min', elementLimits.min * 1 - 1);
          distanceRange.setAttribute('max', elementLimits.max * 1 + 1);
          distanceRange.value = elementLimits.distance;
        }
        if (shouldShowSizeControl(eventObject, rootObject)) {
          sizeRange.value = clampSizeValue(getMeshSizeForSelection(eventObject, rootObject));
        }
      } else {
        rangeHolder.classList.remove('visible');
        sizeRangeHolder.classList.remove('visible');
      }
    }
    this._refreshSizeDistanceControls = refreshSizeDistanceControls;

    normalizeSizeRangeAttributes();

    // Record what was selected at pointer-down time, so "click-to-select" doesn't
    // immediately become a drag in the same gesture.
    this.css3DRenderer.domElement.addEventListener('pointerdown', () => {
      this._syncEditDragTargets?.();
      selectedRootAtPointerDown = this.elementSelected ? getRoot3DObject(this.elementSelected) : null;
    }, { passive: true, capture: true });

    // Change cursor on hover
    dragControls.addEventListener('hoveron', (event) => {
      if (arePerspectiveElements(event.object)) {
        this.css3DRenderer.domElement.style.cursor = 'pointer';
      }
    });

    dragControls.addEventListener('hoveroff', (event) => {
      this.css3DRenderer.domElement.style.cursor = 'auto';
    });

    dragControls.addEventListener('dragstart', (event) => {
      if (
        notDraggableItems(event.object)
        || event.object.visible === false
        || this._isEditElementLocked(event.object)
        || !this._isEditElementVisible(event.object)
      ) {
        dragControls.cancelPendingDrag();
        this.controls.enabled = true;
        return;
      }

      const root = getRoot3DObject(event.object);
      // Objects with dragOnlyWhenSelected (e.g. web link, image gallery): first pointerdown
      // should select on click, not drag. Require the same root as elementSelected at pointerdown.
      if (root?.objConfig?.dragOnlyWhenSelected) {
        const priorRoot = selectedRootAtPointerDown;
        if (!priorRoot || root !== priorRoot) {
          dragControls.cancelPendingDrag();
          this.controls.enabled = true;
          return;
        }
      }

      this.controls.enabled = false;
      this.roomGroup.rotation.y = 0;
      // Ensure parent world matrix is current (fixes first-drag jump on loaded objects)
      if (event.object.parent) event.object.parent.updateMatrixWorld(true);
      // Store the start position
      startPosition = event.object.position.clone();
    });

    dragControls.addEventListener('drag', (event) => {
      if (
        notDraggableItems(event.object)
        || this._isEditElementLocked(event.object)
        || !this._isEditElementVisible(event.object)
      ) {
        return;
      }
      if (arePerspectiveElements(event.object)) {
        const currentPosition = event.object.position.clone();
        const vrObject = event.object.parent.parent;
        if (vrObject?.updateMeshCorner) {
          vrObject.updateMeshCorner(event.object.name, currentPosition);
        }
        return;
      }
      const { min, max } = event.object.parent.getLimits();
      event.object.position.clampLength(min, max);
      event.object.rotation.copy(this.camera.rotation);
      event.object.lookAt(this.camera.position);

      if (event.object.parent.name === "youtube" || event.object.parent.name === "iframeAgent" || isVraiAgentParent(event.object.parent) || event.object.parent.name === "vapiUserCamera") {
        event.object.parent.updatePoster && event.object.parent.updatePoster();
      }
      // if (event.object.name === "topLeft" || event.object.name === "topRight" || event.object.name === "bottomRight" || event.object.name === "bottomLeft") {
      //   const vrObject = event.object.parent.parent;

      // }
    });

    dragControls.addEventListener('dragend', (event) => {
      endPosition = event.object.position.clone();
      // Calculate and log the difference
      if (
        event.object.visible === false
        || notDraggableItems(event.object)
        || this._isEditElementLocked(event.object)
        || !this._isEditElementVisible(event.object)
      ) {
        this.controls.enabled = true;
        return;
      }
      if (arePerspectiveElements(event.object)) {
        this.controls.enabled = true;
        const vrObject = event.object.parent.parent;
        const name = event.object.name;
        if (isVideoPlayerType(vrObject?.name) && typeof vrObject.getPerspectiveSavePayload === 'function') {
          vrObject.syncPerspectiveToDbConfig?.();
          this.modifyLocalJSON(vrObject.getPerspectiveSavePayload());
          return;
        }
        const conf = vrObject?.getDbConfig?.();
        if (conf) {
          this.modifyLocalJSON({ [name]: conf[name] });
        }
        this.updateJSON(event.object.parent);
      } else {
        this.controls.enabled = true;
        event.object.rotation.copy(this.camera.rotation);
        event.object.lookAt(this.camera.position);
        event.object.parent.setDistance && event.object.parent.setDistance(event.object.position.length());
        event.object.parent.resetRotations && event.object.parent.resetRotations();
        event.object.parent.updatePoster && event.object.parent.updatePoster();
        this.updateJSON(event.object);
        // Select and open properties panel (youtube, iframeAgent, vraiAgent, vapiUserCamera)
        this.elementSelected = event.object;
        event.object.parent.showObjectMenu && event.object.parent.showObjectMenu();
        if (event.object.parent.name === "youtube" || event.object.parent.name === "iframeAgent" || isVraiAgentParent(event.object.parent) || event.object.parent.name === "vapiUserCamera") {
          event.object.material.opacity = 0;
          event.object.parent.toggleSelect && event.object.parent.toggleSelect();
        }
        const rootObj = getRoot3DObject(event.object);
        if (rootObj?.objConfig?.isResizable) {
          rangeHolder.classList.toggle('visible', shouldShowDistanceControl(event.object, rootObj));
          sizeRangeHolder.classList.toggle('visible', shouldShowSizeControl(event.object, rootObj));
          if (shouldShowSizeControl(event.object, rootObj)) {
            sizeRange.value = clampSizeValue(getMeshSizeForSelection(event.object, rootObj));
          }
        } else {
          rangeHolder.classList.remove('visible');
          sizeRangeHolder.classList.remove('visible');
        }
        if (rootObj?.objConfig?.isRotatable) {
          rotateXRangeHolder?.classList.add('visible');
          rotateYRangeHolder?.classList.add('visible');
        } else {
          rotateXRangeHolder?.classList.remove('visible');
          rotateYRangeHolder?.classList.remove('visible');
        }
        const limits = event.object.parent.getLimits?.() || rootObj?.getLimits?.();
        if (limits && shouldShowDistanceControl(event.object, rootObj)) {
          distanceRange.setAttribute('min', limits.min * 1 - 1);
          distanceRange.setAttribute('max', limits.max * 1 + 1);
          distanceRange.value = limits.distance;
        }
        const rot = event.object.parent.getAxisRotations?.() || rootObj?.getAxisRotations?.();
        if (rot) {
          if (rotateXRange) rotateXRange.value = rot.rotateX;
          if (rotateYRange) rotateYRange.value = rot.rotateY;
          $('.slider').trigger('change');
        }
        $(editElement).trigger("click");
      }


    });

    // CLICK EVENT
    css3DContainer.addEventListener("click", (event) => {

      event.preventDefault();

      // Clicks on CSS3D components (e.g. VRVapiChairWithCSS3D): ray never hits, resolve from DOM
      const interactiveEl = this.getAllowedCss3dInteractiveTarget(event.target)?.closest?.('[data-css3d-interactive][data-id]');
      if (interactiveEl) {
        const css3dIntersect = this.getSceneObjectFromCss3dClick(interactiveEl);
        if (css3dIntersect && css3dIntersect.object && (css3dIntersect.object.type === 'vraiAgent' || css3dIntersect.object.type === 'vapiUserCamera' || css3dIntersect.object.type === 'vapiTranscription' || css3dIntersect.object.type === 'vapiButton' || css3dIntersect.object.type === 'iframeElement' || css3dIntersect.object.type === 'timerElement' || css3dIntersect.object.type === 'inputFieldGuess' || css3dIntersect.object.type === 'inputField' || isVraiAgentParent(css3dIntersect.object))) {
          let sel = css3dIntersect.object;
          if (this._isEditElementLocked(sel)) return;
          const agentId = sel?.type === 'vraiAgent' ? (sel.id ?? sel.getId?.()) : (sel?.dbConfig?.vapiAgentId ?? sel?.getDbConfig?.()?.vapiAgentId);
          if (agentId) {
            const chairObj = this.currentScene?.objects?.find(o => o.type === 'vraiAgent' && (String(o.id) === String(agentId) || String(o.unique_id) === String(agentId)));
            if (chairObj?.lockedInEdit) return;
          }
          if (sel?.userData?.vraiAgentCamera) sel = sel.userData.vraiAgentCamera;
          if (sel?.userData?.vraiAgentChair) sel = sel.userData.vraiAgentChair;
          if (sel?.userData?.vraiAgentTranscription) sel = sel.userData.vraiAgentTranscription;
          if (sel?.userData?.vraiAgentButton) sel = sel.userData.vraiAgentButton;
          if (this.elementSelected !== null) {
            if (this.elementSelected.material) this.elementSelected.material.opacity = 0;
            if (this.elementSelected.parent && this.elementSelected.parent.toggleSelect) this.elementSelected.parent.toggleSelect();
            if (this.elementSelected.parent && this.elementSelected.parent.onDeselect) this.elementSelected.parent.onDeselect();
          }
          this.elementSelected = sel;
          console.log('[scene element click]', {
            mode: 'edit',
            source: 'css3d',
            type: sel?.type,
            name: sel?.name,
            id: sel?.id ?? sel?.getId?.(),
            action: describeEditCss3dClickAction(sel?.type),
          });
          $("#elementSelected").val(sel.id || sel.getId?.());
          rangeHolder.classList.remove('visible');
          sizeRangeHolder.classList.remove('visible');
          if (sel.getLimits) {
            const elementLimits = sel.getLimits();
            distanceRange.setAttribute('min', elementLimits.min * 1 - 1);
            distanceRange.setAttribute('max', elementLimits.max * 1 + 1);
            distanceRange.value = elementLimits.distance;
          }
          if (sel.getAxisRotations) {
            const { rotateX, rotateY } = sel.getAxisRotations();
            rotateXRangeHolder?.classList.add('visible');
            rotateYRangeHolder?.classList.add('visible');
            if (rotateXRange) rotateXRange.value = rotateX;
            if (rotateYRange) rotateYRange.value = rotateY;
          }
          sel.toggleSelect && sel.toggleSelect();
          sel.showObjectMenu && sel.showObjectMenu();
          if (sel.onSelect) sel.onSelect();
          if (sel.type === 'vraiAgent' || isVraiAgentParent(sel)) {
            let data = sel.getDbConfig ? sel.getDbConfig() : (sel.dbConfig || {});
            const sceneObj = this.currentScene?.objects?.find(el => el.id === (sel.getId?.() ?? sel.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            const agentImg = data.agent_image && !data.agent_image.includes('empty') ? data.agent_image : './textures/empty.png';
            $('#vrai_agent_image_edit').attr('src', agentImg);
            $('#removeVraiAgentImageEdit').toggleClass('active', !!data.agent_image);
          }
          if (sel.type === 'iframeElement') {
            let data = sel.getDbConfig ? sel.getDbConfig() : (sel.dbConfig || {});
            const sceneObj = this.currentScene?.objects?.find(el => el.id === (sel.getId?.() ?? sel.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            $('#iframe_value_edit').val(data.iframe_value || '');
            this._populateIframeDimensions && this._populateIframeDimensions(data);
          }
          if (sel.type === 'timerElement') {
            let data = sel.getDbConfig ? sel.getDbConfig() : (sel.dbConfig || {});
            const sceneObj = this.currentScene?.objects?.find(el => el.id === (sel.getId?.() ?? sel.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            $('#timer_preset_edit').val(data.timePreset || '0:10:0');
          }
          if (sel.type === 'inputFieldGuess') {
            let data = sel.getDbConfig ? sel.getDbConfig() : (sel.dbConfig || {});
            const sceneObj = this.currentScene?.objects?.find(el => el.id === (sel.getId?.() ?? sel.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            if (inputFieldGuessTimePresetEdit) inputFieldGuessTimePresetEdit.value = data.timePreset || '';
            if (inputFieldGuessAutocloseTrueEdit) inputFieldGuessAutocloseTrueEdit.checked = !!data.autocloseOnTrue;
            if (inputFieldGuessAutocloseFalseEdit) inputFieldGuessAutocloseFalseEdit.checked = !!data.autocloseOnFalse;
          }
          if (sel.type === 'inputField') {
            let data = sel.getDbConfig ? sel.getDbConfig() : (sel.dbConfig || {});
            const sceneObj = this.currentScene?.objects?.find(el => el.id === (sel.getId?.() ?? sel.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            this._fillInputFieldSettings(data);
          }
          $(".object-menu").removeClass("edit");
          $(editElement).trigger("click");
          $('.slider').trigger('change');
          this.resetSceneRotation();
          return;
        }
      }

      let intersect = this._ray_tracing(event, this.objectsInScene);
      intersect = intersect.filter(i => {
        if (this._isEditElementLocked(i.object)) return false;
        if (!this._isEditElementVisible(i.object)) return false;
        if (i.object?.visible === false) return false;
        const comp = i.object?.userData?.vraiAgentChair || i.object?.userData?.vraiAgentCamera || i.object?.userData?.vraiAgentTranscription || i.object?.userData?.vraiAgentButton;
        if (!comp) return true;
        const agentId = comp.type === 'vraiAgent' ? (comp.id ?? comp.getId?.()) : (comp.dbConfig?.vapiAgentId ?? comp.getDbConfig?.()?.vapiAgentId);
        if (!agentId) return true;
        const chairObj = this.currentScene?.objects?.find(o => o.type === 'vraiAgent' && (String(o.id) === String(agentId) || String(o.unique_id) === String(agentId)));
        return !chairObj?.lockedInEdit;
      });
      intersect = preferPerspectiveIntersections(intersect);

      if (intersect.length === 0) {
        rangeHolder.classList.remove('visible');
        sizeRangeHolder.classList.remove('visible');
        rotateXRangeHolder?.classList.remove('visible');
        rotateYRangeHolder?.classList.remove('visible');
        $(".rotateY-holder .object-action .custom-scene-icon").addClass('hidden');
        $(".edit_scenes_target_container .custom-scene-icon, .edit_target_scene_container.custom-scene-icon").addClass("hidden");

        this.deselectElement();

      } else {


        if (intersect[0].object.visible) {
          if (this.elementSelected !== null) {
            if (this.elementSelected.parent.name === "youtube" || this.elementSelected.parent.name === "iframeAgent" || isVraiAgentParent(this.elementSelected.parent) || this.elementSelected.parent.name === "vapiUserCamera") {
              if (this.elementSelected.material) this.elementSelected.material.opacity = 0;
              this.elementSelected.parent.toggleSelect && this.elementSelected.parent.toggleSelect();
            } else if (this.elementSelected.material) {
              this.elementSelected.material.opacity = 1;
            }
            this.deselectElement();
          }

          this.elementSelected = intersect[0].object;
          if (this.elementSelected?.userData?.vraiAgentCamera) this.elementSelected = this.elementSelected.userData.vraiAgentCamera;
          if (this.elementSelected?.userData?.vraiAgentChair) this.elementSelected = this.elementSelected.userData.vraiAgentChair;
          if (this.elementSelected?.userData?.vraiAgentTranscription) this.elementSelected = this.elementSelected.userData.vraiAgentTranscription;
          if (this.elementSelected?.userData?.vrIframeElement) this.elementSelected = this.elementSelected.userData.vrIframeElement;
          const rootObject = getRoot3DObject(this.elementSelected)
          if (rootObject?.objConfig?.isResizable) {
            rangeHolder.classList.toggle('visible', shouldShowDistanceControl(this.elementSelected, rootObject));
            sizeRangeHolder.classList.toggle('visible', shouldShowSizeControl(this.elementSelected, rootObject));
            if (shouldShowSizeControl(this.elementSelected, rootObject)) {
              sizeRange.value = clampSizeValue(getMeshSizeForSelection(this.elementSelected, rootObject));
            }
          } else {
            rangeHolder.classList.remove('visible');
            sizeRangeHolder.classList.remove('visible');
          }
          if (rootObject?.objConfig?.isRotatable) {
            rotateXRangeHolder?.classList.add('visible');
            rotateYRangeHolder?.classList.add('visible');
          } else {
            rotateXRangeHolder?.classList.remove('visible');
            rotateYRangeHolder?.classList.remove('visible');
          }
          if (arePerspectiveElements(this.elementSelected)) {
            this.elementSelected = this.elementSelected.parent;
          }
          if (isVraiAgentComponentMesh(this.elementSelected) && this.elementSelected.type === 'vraiAgentComponent') {
            this.elementSelected = this.elementSelected.parent;
          }
          if (this.elementSelected?.showObjectMenu) {
            this.elementSelected.showObjectMenu();
          } else if (this.elementSelected.parent.showObjectMenu) {
            this.elementSelected.parent.showObjectMenu();
          }
          if (this.elementSelected.parent.parent && this.elementSelected.parent.parent.showObjectMenu) {
            this.elementSelected.parent.parent.showObjectMenu();
          }

          if (this.elementSelected.parent.name === SCENE_OBJECT_TYPES.videoGallery) {
            videoLoopEdit.checked = false;
            if (this.elementSelected.parent.dbConfig.autoplay === "2")
              videoLoopEdit.checked = true;
          }
          if (this.elementSelected.parent.name === SCENE_OBJECT_TYPES.videoGallery && videoTransparentEdit) {
            videoTransparentEdit.checked = this.elementSelected.parent.dbConfig.transparentBackground === true;
          }

          if (this.elementSelected.parent.name === "sceneChange") {
            $(".rotateY-holder .object-action .custom-scene-icon").removeClass('hidden');
            $(".edit_scenes_target_container .custom-scene-icon, .edit_target_scene_container.custom-scene-icon").removeClass("hidden");
          }
          if (this.elementSelected.parent.name === "youtube" || this.elementSelected.parent.name === "iframeAgent" || isVraiAgentParent(this.elementSelected.parent) || this.elementSelected.parent.name === "vapiUserCamera") {
            if (this.elementSelected.material) this.elementSelected.material.opacity = 0;
            this.elementSelected.parent.toggleSelect && this.elementSelected.parent.toggleSelect();
          } else if (this.elementSelected.material) {
            this.elementSelected.material.opacity = .5;
          }

          // Call onSelect if the newly selected object has this method
          if (this.elementSelected.parent.onSelect) {
            this.elementSelected.parent.onSelect();
          }

          // Ensure iframe edit UI is populated as soon as iframeAgent is selected
          if (this.elementSelected.parent.name === 'iframeAgent') {
            const ghost = this.elementSelected.parent;
            let data = ghost.getDbConfig ? ghost.getDbConfig() : (ghost.dbConfig || {});
            if (!data.iframe_value) {
              const sceneObj = this.currentScene.objects.find(el => el.id === ghost.getId());
              if (sceneObj) data = { ...data, ...sceneObj };
            }
            $('#iframe_value_edit').val(data.iframe_value || '');
            this._populateIframeDimensions && this._populateIframeDimensions(data);
          }
          if (this.elementSelected.type === 'iframeElement') {
            const iframeComp = this.elementSelected;
            let data = iframeComp.getDbConfig ? iframeComp.getDbConfig() : (iframeComp.dbConfig || {});
            const sceneObj = this.currentScene.objects.find(el => el.id === (iframeComp.getId?.() ?? iframeComp.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            $('#iframe_value_edit').val(data.iframe_value || '');
            this._populateIframeDimensions && this._populateIframeDimensions(data);
          }
          if (this.elementSelected.type === 'timerElement') {
            const timerComp = this.elementSelected;
            let data = timerComp.getDbConfig ? timerComp.getDbConfig() : (timerComp.dbConfig || {});
            const sceneObj = this.currentScene.objects.find(el => el.id === (timerComp.getId?.() ?? timerComp.id));
            if (sceneObj) data = { ...data, ...sceneObj };
            $('#timer_preset_edit').val(data.timePreset || '0:10:0');
          }
          if (isVraiAgentParent(this.elementSelected.parent)) {
            const ghost = this.elementSelected.parent;
            let data = ghost.getDbConfig ? ghost.getDbConfig() : (ghost.dbConfig || {});
            const sceneObj = this.currentScene.objects.find(el => el.id === ghost.getId());
            if (sceneObj) data = { ...data, ...sceneObj };
            const agentImg = data.agent_image && !data.agent_image.includes('empty') ? data.agent_image : './textures/empty.png';
            $('#vrai_agent_image_edit').attr('src', agentImg);
            $('#removeVraiAgentImageEdit').toggleClass('active', !!data.agent_image);
            this._updateVraiAgentChairsVisibility();
          }

          $(".object-menu").removeClass("edit");

          {
            const ed = this.elementSelected;
            console.log('[scene element click]', {
              mode: 'edit',
              source: 'raytrace',
              type: ed?.type,
              name: ed?.name,
              id: ed?.id ?? ed?.getId?.(),
              parentName: ed?.parent?.name,
              action: describeEditRaytraceClickAction(ed?.parent?.name, ed?.type),
            });
          }

          $(editElement).trigger("click");

          const elementLimits = this.elementSelected.parent.getLimits();
          distanceRange.setAttribute('min', elementLimits.min * 1 - 1);
          distanceRange.setAttribute('max', elementLimits.max * 1 + 1);
          distanceRange.value = elementLimits.distance;

          const { rotateX, rotateY } = this.elementSelected.parent.getAxisRotations(); //TODO
          if (rotateXRange) rotateXRange.value = rotateX;
          if (rotateYRange) rotateYRange.value = rotateY;
          $('.slider').trigger('change');

        }
      }
      this.resetSceneRotation();
    });

    /***
     * Scale elements
     */
    //   - - - - MOUSE WHEEL - - - -
    // Selected object: wheel adjusts size or distance (capture + preventDefault blocks camera zoom).
    // Nothing selected: wheel zooms the camera via OrbitControls.
    document.addEventListener('wheel', (e) => {
      if (!this.elementSelected || $('.modal').hasClass('is-active')) return;
      if (e.target.closest('.object-settings-tab-panel.active')) return;

      const rootObject = getRoot3DObject(this.elementSelected);

      if (rootObject?.objConfig?.isResizable && shouldShowSizeControl(this.elementSelected, rootObject) && sizeRange) {
        const currentSize = parseFloat(sizeRange.value);
        const fallbackSize = Number(getMeshSizeForSelection(this.elementSelected, rootObject)) || 1;
        const baseSize = Number.isFinite(currentSize) ? currentSize : fallbackSize;
        const sizeStep = parseFloat(sizeRange.step) || 0.05;
        let nextSize = baseSize + (e.deltaY < 0 ? sizeStep : (e.deltaY > 0 ? -sizeStep : 0));
        if (e.deltaY === 0) return;

        const min = parseFloat(sizeRange.min);
        const max = parseFloat(sizeRange.max);
        if (Number.isFinite(min)) nextSize = Math.max(min, nextSize);
        if (Number.isFinite(max)) nextSize = Math.min(max, nextSize);

        e.preventDefault();
        e.stopPropagation();
        sizeRange.value = `${nextSize}`;
        sizeRange.dispatchEvent(new Event('input'));
        $(sizeRange).trigger('change');
        return;
      }

      if (shouldShowDistanceControl(this.elementSelected, rootObject) && distanceRange) {
        const step = 30;
        const currentVal = parseInt(distanceRange.value, 10);
        if (!Number.isFinite(currentVal) || e.deltaY === 0) return;

        e.preventDefault();
        e.stopPropagation();
        distanceRange.value = e.deltaY < 0 ? currentVal + step : currentVal - step;
        distanceRange.dispatchEvent(new Event('input'));
        $(distanceRange).trigger('change');
      }
    }, { passive: false, capture: true });

    //   - - - - SLIDER - - - -
    let scaleSliderDebounce;
    distanceRange.addEventListener("input", (e) => {
      let objPos = this.elementSelected.position;
      let newVal = parseInt(distanceRange.value);
      const elementLimits = this.elementSelected.parent.getLimits();

      objPos.clampLength(elementLimits.min, elementLimits.max);

      if (newVal >= elementLimits.min && newVal <= elementLimits.max) {

        const isYoutube = this.elementSelected.parent.name === "youtube" ? true : false;
        const isVraiOrIframe = this.elementSelected.parent.name === "iframeAgent" || isVraiAgentParent(this.elementSelected.parent) || this.elementSelected.parent.name === "vapiUserCamera";
        const isScreenShare = this.elementSelected.parent.name === "screenStream" ? true : false;
        const normalizedDistance = (newVal - elementLimits.min) / (elementLimits.max - elementLimits.min);

        (isYoutube || isVraiOrIframe) && this.elementSelected.parent.updatePoster && this.elementSelected.parent.updatePoster();

        if (isYoutube || isVraiOrIframe || isScreenShare) {
          if (normalizedDistance >= .5) {
            let scale = 1 - normalizedDistance + 0.5;
            this.elementSelected.scale.set(scale, scale, scale);
          } else {
            this.elementSelected.scale.set(1, 1, 1);
          }
        }
        objPos.setLength(newVal);
        this.elementSelected.parent.setDistance(objPos.length());

        isYoutube && this.elementSelected.parent.updatePoster();

        clearTimeout(scaleSliderDebounce);
        scaleSliderDebounce = setTimeout(() => {
          this.updateJSON(this.elementSelected);
        }, 500);
      }
      $(distanceRange).trigger('change');
    });

    let sizeSliderDebounce;
    sizeRange?.addEventListener("input", () => {
      if (!this.elementSelected) return;
      const rootObject = getRoot3DObject(this.elementSelected);
      if (!rootObject?.objConfig?.isResizable) return;

      const newSize = parseFloat(sizeRange.value);
      if (!Number.isFinite(newSize) || newSize <= 0) return;

      const parentObj = this.elementSelected.parent;
      const sizeTarget = parentObj?.setSize ? parentObj : (rootObject?.setSize ? rootObject : null);
      if (sizeTarget?.setSize) {
        sizeTarget.setSize(newSize);
      } else if (this.elementSelected?.scale) {
        this.elementSelected.scale.set(newSize, newSize, newSize);
      }

      parentObj?.updatePoster && parentObj.updatePoster();

      clearTimeout(sizeSliderDebounce);
      sizeSliderDebounce = setTimeout(() => {
        this.updateJSON(this.elementSelected);
      }, 300);

      $(sizeRange).trigger('change');
    });


    rotateXRange?.addEventListener("input", () => {
      if (!this.elementSelected?.parent?.setAxisRotations) return;
      const newVal = parseInt(rotateXRange.value);
      this.elementSelected.parent.setAxisRotations('x', newVal);
      this.updateJSON(this.elementSelected);
    });

    rotateYRange?.addEventListener("input", () => {
      if (!this.elementSelected?.parent?.setAxisRotations) return;
      const newVal = parseInt(rotateYRange.value);
      this.elementSelected.parent.setAxisRotations('y', newVal);
      this.updateJSON(this.elementSelected);
    });


    resetBtn.addEventListener("click", () => {
      const parent = this._resolveEditableObject(this.elementSelected) || this.elementSelected?.parent;
      if (!parent?.resetPerspective) return;
      parent.resetPerspective();
      if (isVideoPlayerType(parent.name)) {
        this.autoSaveVideoPlayer();
      } else {
        this.modifyLocalJSON(parent.dbConfig);
      }
      this.updateJSON(this.elementSelected);
    });

    videoLoopEdit.addEventListener("change", (e) => {
      const isChecked = e.target.checked ? "2" : "1";
      this.elementSelected && this.elementSelected.parent.changeAutoLoop(isChecked);
      this.modifyLocalJSON(this.elementSelected.parent.dbConfig)
      this.updateJSON(this.elementSelected);
    });

    inputFieldGuessTimePresetEdit?.addEventListener("blur", () => {
      if (!this.elementSelected || this.elementSelected.type !== 'inputFieldGuess') return;
      const timePreset = normalizeOptionalTimePreset(inputFieldGuessTimePresetEdit.value);
      inputFieldGuessTimePresetEdit.value = timePreset;
      this.elementSelected.setDbConfig({ timePreset });
      this.modifyLocalJSON({ timePreset });
      this.updateJSON(this.elementSelected.anchor, null);
    });

    inputFieldGuessTimePresetEdit?.addEventListener("change", () => {
      if (!this.elementSelected || this.elementSelected.type !== 'inputFieldGuess') return;
      const timePreset = normalizeOptionalTimePreset(inputFieldGuessTimePresetEdit.value);
      inputFieldGuessTimePresetEdit.value = timePreset;
      this.elementSelected.setDbConfig({ timePreset });
      this.modifyLocalJSON({ timePreset });
      this.updateJSON(this.elementSelected.anchor, null);
    });

    inputFieldGuessAutocloseTrueEdit?.addEventListener("change", (e) => {
      if (!this.elementSelected || this.elementSelected.type !== 'inputFieldGuess') return;
      const autocloseOnTrue = !!e.target.checked;
      this.elementSelected.setDbConfig({ autocloseOnTrue });
      this.modifyLocalJSON({ autocloseOnTrue });
    });

    inputFieldGuessAutocloseFalseEdit?.addEventListener("change", (e) => {
      if (!this.elementSelected || this.elementSelected.type !== 'inputFieldGuess') return;
      const autocloseOnFalse = !!e.target.checked;
      this.elementSelected.setDbConfig({ autocloseOnFalse });
      this.modifyLocalJSON({ autocloseOnFalse });
    });

    const persistInputFieldSetting = (patch) => {
      if (!this.elementSelected || this.elementSelected.type !== 'inputField') return;
      this.elementSelected.setDbConfig(patch);
      this.modifyLocalJSON(patch);
      if (this.elementSelected.anchor) this.updateJSON(this.elementSelected.anchor, null);
    };
    inputFieldValidationEdit?.addEventListener("change", () => {
      persistInputFieldSetting({ validation: inputFieldValidationEdit.value || 'required' });
      const isMin = inputFieldValidationEdit.value === 'minLength';
      document.querySelector('#input_field_min_length_row')?.classList.toggle('hidden', !isMin);
    });
    inputFieldMinLengthEdit?.addEventListener("change", () => {
      persistInputFieldSetting({ minLength: Math.max(1, parseInt(inputFieldMinLengthEdit.value, 10) || 1) });
    });
    inputFieldKeyEdit?.addEventListener("blur", () => {
      persistInputFieldSetting({ fieldKey: inputFieldKeyEdit.value || '' });
    });
    inputFieldFunnelStepEdit?.addEventListener("blur", () => {
      persistInputFieldSetting({ funnelStep: inputFieldFunnelStepEdit.value || '' });
    });
    inputFieldAutocloseEdit?.addEventListener("change", (e) => {
      persistInputFieldSetting({ autocloseOnSubmit: !!e.target.checked });
    });

    videoTransparentEdit?.addEventListener("change", (e) => {
      if (!this.elementSelected || this.elementSelected.parent.name !== SCENE_OBJECT_TYPES.videoGallery) return;
      this.elementSelected.parent.changeTransparentBackground(e.target.checked);
      this.modifyLocalJSON(this.elementSelected.parent.dbConfig);
      this.updateJSON(this.elementSelected);
    });
    infoElementDescriptionAdvertisementLinks.addEventListener("change", (e) => {
      const isChecked = e.target.checked ? "1" : "0";
      this.elementSelected && (this.elementSelected.parent.dbConfig.advertisementLinks = isChecked);
      this.modifyLocalJSON(this.elementSelected.parent.dbConfig);
      this.updateJSON(this.elementSelected);
    });

    /**
     * Interaction settings sidebar
     */
    // Navigate between scenes
    $(document).on('click', '.go_to_scene', (e) => {
      $(`.room_options`).removeClass('active');
      const index = $(e.currentTarget).index(".go_to_scene");
      $(".bottom-bar-scene").eq(index).trigger("click");
    });

    $(document).on('click', '.room', (e) => {
      if ($(e.target).is("span") || $(e.target).is("input")) {
        return true;
      }
      $(`.room_options`).removeClass('active');
      const index = $(e.currentTarget).index(".room");
      $(".bottom-bar-scene").eq(index).trigger("click");
    });

    // Make scene the landing scene - home
    $(document).on('click', '.landing_room', (e) => {
      e.stopPropagation();
      const instance = e.currentTarget;
      const index = $('.landing_room').index(instance);

      $('.room_img').removeClass('home');
      $(`.room_img:eq(${index})`).addClass('home');

      // Place the selected element on the first array position
      const element = this.scenes[index];
      this.scenes.splice(index, 1);
      this.scenes.splice(0, 0, element);

      $(`.room:eq(${index})`).insertBefore('.room:eq(0)');
      $(`.room_options`).removeClass('active');

      // Update DB
      this.updateDB();

      this.generateSceneGallery(false);
    });


    $("#setAsHomeScene").on("click", () => {
      const index = this.currentSceneIndex;

      // Place the selected element on the first array position
      const element = this.scenes[index];
      this.scenes.splice(index, 1);
      this.scenes.splice(0, 0, element);

      this.currentSceneIndex = 0;

      this.updateLocInsideURL();

      // Update DB
      this.updateDB();
      this.generateSceneGallery();

      $("#setAsHomeSceneContainer").addClass("disabled");

    });

    // LOCATION PAYMENT EVENTS
    // $("#locationWithPayment").on("click", (e) => {
    //   if(!$("#locationWithPayment").prop("checked")){
    //     if(!validateAction({role: this.user.role, action: 'paidLocation', scenesObj: this.scenes}).state){
    //       e.preventDefault();
    //     }
    //   }
    // });

    $("#locationWithPayment").on("change", (e) => {
      const index = this.currentSceneIndex;

      if (!this.currentScene.hasOwnProperty("locationWithPayment")) {
        this.currentScene.locationWithPayment = {}
      }

      this.currentScene.locationWithPayment.state = $(e.currentTarget).prop("checked");
      this.scenes[index] = this.currentScene;

      // Update DB
      this.updateDB();
    });

    $("#edit_paid_location").on("click", () => {
      let cond = false;
      if (this.currentScene.hasOwnProperty("locationWithPayment")) {
        cond = Object.keys(this.currentScene.locationWithPayment).length > 1;
      }

      const withPayment = this.currentScene.locationWithPayment || {};

      $("#location-price").val(cond ? withPayment.price : "");

      const currencyCond = cond ? withPayment.hasOwnProperty('currency') ? withPayment.currency : 'eur' : 'eur';
      $("#location-payment-currency").val(currencyCond);
      const currencyText = $("#location-payment-currency option:selected").text();
      $("#location-payment-currency").siblings(".select-selected").text(currencyText);

      $("#payment-from-date").val(cond ? withPayment.duration.hasOwnProperty('fromDate') ? withPayment.duration.fromDate.replace(" ", "T") : "" : "");
      $("#payment-until-date").val(cond ? withPayment.duration.untilDate.replace(" ", "T") : "");
      $("#payment-days").val(cond ? withPayment.duration.days : "");
      $("#payment_description").val(cond ? withPayment.description : "");

      $("#payment-setup-modal").addClass("is-active");
    });

    $(".duration-interval").on("input keyup", function () {
      $("#payment-days").val("");
    });

    $("#payment-days").on("keyup", function () {
      $(".duration-interval").val("");
    });

    $("#update-payment").on("click", () => {
      const price = $("#location-price").val();
      const currency = $("#location-payment-currency").val();
      const fromDate = $("#payment-from-date").val();
      const untilDate = $("#payment-until-date").val();
      const days = $("#payment-days").val();
      const description = $("#payment_description").val();

      if ((fromDate && !untilDate) || (!fromDate && untilDate)) {
        this.model.alert('error', $trans('error-both-dates'));
        return;
      }

      const data = {
        state: $("#locationWithPayment").prop("checked"),
        price,
        currency,
        duration: { fromDate, untilDate, days },
        description
      }

      this.currentScene.locationWithPayment = data;
      this.scenes[this.currentSceneIndex] = this.currentScene;

      // Update DB
      this.updateDB();

      $("#payment-setup-modal").removeClass("is-active");
    });

    // Remove scene
    $(document).on('click', '.room_delete', (e) => {
      e.stopPropagation();

      this.model.confirm($trans('confirm-remove-scene'), () => {
        const instance = e.currentTarget;
        const index = $('.room_delete').index(instance);

        if (index !== this.currentSceneIndex) {
          this.scenes.splice(index, 1);
          $(`.room:eq(${index})`).remove();

          // Make the first scene the landing scene
          $('.room_img').removeClass('active');
          $('.room_img:eq(0)').addClass('active');

          // Update index - if needed
          if (index < this.currentSceneIndex) {
            this.currentSceneIndex -= 1;
          }

          // Update DB
          this.updateDB();

          this.generateSceneGallery(false);

          this.generateLocationOptions();

        } else {
          this.model.alert('error', $trans('error-delete-current-scene'))
        }
        $(`.room_options`).removeClass('active');
      });
    });

    $("#delete_scene").on("click", () => {
      this.model.alert('error', $trans('error-delete-current-scene'))
    });

    $("#duplicate_scene").on("click", () => {
      this.duplicateScene(this.currentSceneIndex);
    });

    // Remove multiple scenes
    $("#delete_scenes").on("click", () => {
      const scenes = $('.roomsEditor').find('input[type=checkbox]:checked');
      const scenesIds = [];
      let doNotDelete = false;

      scenes.each((i, el) => {
        const id = $(el).parent().parent().data('scene');
        scenesIds.push(id);
        const index = $(el)[0].id.replace("select_scene_", "");
        if (index == this.currentSceneIndex) {
          doNotDelete = true;
        }
      });

      if (doNotDelete) {
        this.model.alert('error', $trans('error-delete-current-scene'));
        return;
      }

      let elements = 0;

      this.scenes.forEach(scene => {
        for (let x = 0; x < scenesIds.length; x++) {
          if (scene.id === scenesIds[x]) {
            elements += scene.objects.length;
            break;
          }
        }
      });


      this.model.confirm(`${$trans('confirm-delete')} ${scenes.length} ${scenes.length === 1 ? $trans('scene-text') : $trans('scenes-text')}? ${$trans('confirm-you-will-delete')} ${elements} ${elements === 1 ? $trans('element-text') : $trans('elements-text')} ${$trans('from-text')} ${scenes.length === 1 ? $trans('this-scene') : $trans('these-scenes')}.`, () => {
        let indexesDif = 0;

        for (let i = this.scenes.length - 1; i >= 0; i--) {
          for (let x = 0; x < scenesIds.length; x++) {
            if (this.scenes[i].id === scenesIds[x]) {
              this.scenes.splice(i, 1);
              if (i < this.currentSceneIndex) {
                indexesDif++;
              }
              break;
            }
          }
        }

        // Update index - if needed
        if (indexesDif) {
          this.currentSceneIndex -= indexesDif;
        }

        this.updateDB();
        this.generateSceneGallery();

        $("#select_all_scenes").prop("checked", false);
        $("#scenes_options").toggleClass("visible", false);

      }, { header: true, title: `Delete ${scenes.length} ${scenes.length === 1 ? 'scene' : 'scenes'}?` });
    });

    // Duplicate scene
    $(document).on('click', '.room_copy', (e) => {
      e.stopPropagation();
      const instance = e.currentTarget;
      const index = $('.room_copy').index(instance);
      this.duplicateScene(index);
    });

    // Duplicate multiple scenes
    $("#duplicate_scenes").on("click", () => {
      const scenes = $('.roomsEditor').find('input[type=checkbox]:checked');
      const scenesIds = [];
      const scenesIndexes = [];

      const { state, limit } = this._applyValidateAction({ scenesObj: this.scenes, action: 'locations', extraLocations: scenes.length - 1 });
      if (!state) {
        this.model.alert('error', `${$trans('error-max-locations-reached')}: ${limit}`);
        return;
      }

      scenes.each((i, el) => {
        const id = $(el).parent().parent().data('scene');
        scenesIds.push(id);
        scenesIndexes.push($(el)[0].id.replace("select_scene_", ""));
      });

      let elements = 0;

      this.scenes.forEach(scene => {
        for (let x = 0; x < scenesIds.length; x++) {
          if (scene.id === scenesIds[x]) {
            elements += scene.objects.length;
            break;
          }
        }
      });

      this.model.confirm(`${$trans('confirm-duplicate')} ${scenes.length} ${scenes.length === 1 ? $trans('scene-text') : $trans('scenes-text')}? ${$trans('confirm-you-will-duplicate')} ${elements} ${elements === 1 ? $trans('element-text') : $trans('elements-text')} ${$trans('from-text')} ${scenes.length === 1 ? $trans('this-scene') : $trans('these-scenes')}.`, () => {

        for (let x = 0; x < scenesIndexes.length; x++) {
          const index = scenesIndexes[x];
          const publicName = this.scenes[index].publicName + ' Copy';

          const cloneElement = JSON.parse(JSON.stringify(this.scenes[index]));
          const element = { ...cloneElement, id: uuidv4(), publicName };

          const newObjects = [];

          for (let x = 0; x < element.objects.length; x++) {
            newObjects.push({ ...element.objects[x], id: uuidv4() });
          }

          element.objects = newObjects;
          this.scenes.push(element);
        }

        this.updateDB();
        this.generateSceneGallery();

        $("#select_all_scenes").prop("checked", false);
        $("#scenes_options").toggleClass("visible", false);

      }, { header: true, title: `Duplicate ${scenes.length} ${scenes.length === 1 ? 'scene' : 'scenes'}?` });
    });

    // Edit scene name
    $(document).on('click focus', '.room_name', (e) => {
      e.stopPropagation();
    });
    $(document).on('blur', '.room_name', (e) => {
      e.stopPropagation();
      const instance = e.currentTarget;
      const index = $('.room_name').index(instance);
      this.scenes[index].publicName = instance.value;

      // Update DB
      this.updateDB();
    });

    // Scenes more actions menu
    $(document).on("click", () => { $(".room_options").removeClass("active"); });
    $(document).on("click", ".more_room_info", (e) => {
      e.stopPropagation();
      const index = $(e.currentTarget).index(".more_room_info");
      $(".room_options").removeClass("active top");
      $(".room_options").eq(index).addClass("active");
      const cond = e.pageY + $(".room_options").eq(index)[0].clientHeight > window.innerHeight;
      $(".room_options").eq(index).toggleClass("top", cond);
    });

    $("#close-room-scene-menu").on("click", () => {
      $("#room-scene-menu").removeClass("is-active");
      $("#openWorldEditor").removeClass("active");
      this.toggleOffset();
      this.openSidebar = false;
    });

    $("#close-scene-menu").on("click", () => {
      $("#scene-menu").removeClass("is-active");
      $(".bottom-bar-scene").removeClass("selected");
      this.ambientSound.isPlaying && this.ambientSound.stop();
      this.toggleOffset();
    });

    // Select scenes checkbox events
    $(document).on("change", ".dropdown_available_checkbox", (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log(e)
    })
    // Select scenes checkbox events
    $(document).on("change", ".selected_scenes", () => {
      let allUncheck = true;
      $(".selected_scenes").each(el => {
        const cond = $(".selected_scenes").eq(el).prop("checked");
        if (cond) {
          allUncheck = false;
        }
        $(".room").eq(el).toggleClass("highlight", cond);
      });
      $("#select_all_scenes").prop("checked", !allUncheck);
      $("#scenes_options").toggleClass("visible", !allUncheck);
      $("#scenes_upload").toggleClass("visible", allUncheck);
    });

    $("#select_all_scenes").on("change", function () {
      $(".selected_scenes").prop("checked", $(this).prop('checked'));
      $("#scenes_options").toggleClass("visible", $(this).prop('checked'));
      $(".room").toggleClass("highlight", $(this).prop('checked'));
      $("#scenes_upload").toggleClass("visible", !$(this).prop('checked'));
    });

    $(document).on("click", ".room > .customCheckbox", (e) => {
      e.stopPropagation();
    });

    $("#scenes_upload").addClass("visible");

    // Search scene
    $("#search_scene").on("keyup", (e) => {
      const value = $(e.currentTarget).val().toLowerCase();
      $(".room_name").filter(function (i) {
        $(".room").eq(i).toggleClass("hidden", !($(this).val().toLowerCase().indexOf(value) > -1));
      });
    });

    // Adjust ambient volume
    $('#ambient_volume').on("input", (e) => {
      const val = e.target.value;
      this.ambientSound.isPlaying && this.ambientSound.setVolume(val);
      $("#ambient_volume_txt").text(`${Math.ceil(val * 100 / $("#ambient_volume").prop('max'))}%`);

      if (this.scenes[this.currentSceneIndex].ambientAudio.hasOwnProperty('url')) {
        if (this.scenes[this.currentSceneIndex].ambientAudio.url) {
          this.scenes[this.currentSceneIndex].ambientAudio.volume = val;
          this.updateDB();
        }
      }
    });

    $("#toggleAmbientSound").on("change", (e) => {
      (this.ambientSound.isPlaying && !$(e.target).prop('checked')) && this.ambientSound.stop();
      $(e.target).prop('checked') && this.ambientSound.play();
    });


    $("#scene_public_name").on("keyup change", (e) => {
      const publicName = $(e.currentTarget).val();
      if (publicName === "") {
        this.model.alert('error', $trans('error-enter-scene-name'));
        return;
      }

      $(".scene_name").val(publicName);
      $(`.room_name:eq(${this.currentSceneIndex})`).val(publicName);
      this.scenes[this.currentSceneIndex].publicName = publicName;
      this.updateDB();
    });

    /**
     * SORT ROOMS INSIDE SIDEBAR - DRAG & DROP
     */
    let roomDragStartIndex = 0;
    let roomDragEndIndex = 0;

    $(document).on('dragstart', '.room', (e) => {
      roomDragStartIndex = $(e.currentTarget).index('.room');
    });

    $(document).on('dragover', '.room', (e) => {
      e.preventDefault();
      const _this = e.currentTarget;
      $(_this).addClass('dragover');
    });

    $(document).on('drop', '.room', (e) => {
      roomDragEndIndex = $(e.currentTarget).index('.room');
      $(e.currentTarget).removeClass('dragover');

      if (roomDragStartIndex !== roomDragEndIndex) {

        // SLIDE SCENES
        const element = this.scenes[roomDragStartIndex];
        this.scenes.splice(roomDragStartIndex, 1);
        this.scenes.splice(roomDragEndIndex, 0, element);
        // SLIDE ELEMENTS - Update current scene index - if needed
        if (roomDragStartIndex < this.currentSceneIndex && roomDragEndIndex >= this.currentSceneIndex) {
          $(`.room:eq(${roomDragStartIndex})`).insertAfter(`.room:eq(${roomDragEndIndex})`);
          this.currentSceneIndex -= 1;

        } else if (roomDragStartIndex === this.currentSceneIndex) {
          if (roomDragEndIndex < this.currentSceneIndex) {
            $(`.room:eq(${roomDragStartIndex})`).insertBefore(`.room:eq(${roomDragEndIndex})`);
          } else {
            $(`.room:eq(${roomDragStartIndex})`).insertAfter(`.room:eq(${roomDragEndIndex})`);
          }
          this.currentSceneIndex = roomDragEndIndex;

        } else if (roomDragStartIndex > this.currentSceneIndex && roomDragEndIndex <= this.currentSceneIndex) {
          $(`.room:eq(${roomDragStartIndex})`).insertBefore(`.room:eq(${roomDragEndIndex})`);
          this.currentSceneIndex += 1;

        } else if ((roomDragStartIndex > this.currentSceneIndex && roomDragEndIndex > this.currentSceneIndex) || (roomDragStartIndex < this.currentSceneIndex && roomDragEndIndex < this.currentSceneIndex)) {
          if (roomDragStartIndex < roomDragEndIndex) {
            $(`.room:eq(${roomDragStartIndex})`).insertAfter(`.room:eq(${roomDragEndIndex})`);
          } else {
            $(`.room:eq(${roomDragStartIndex})`).insertBefore(`.room:eq(${roomDragEndIndex})`);
          }
        }
        this.updateLocInsideURL();
        // Make the first scene the landing scene
        $('.room_img').removeClass('home');
        $('.room_img:eq(0)').addClass('home');

        // UpdateDB
        this.updateDB();

        this.generateSceneGallery(false);

      } // else is the same position, no update needed

    });

    $(document).on('dragleave', '.room', (e) => {
      $(e.currentTarget).removeClass('dragover');
    });

    /**
     * Elements menu events
     */
    $("#select_all_elements").on("change", function () {
      $(".selected_elements").prop("checked", $(this).prop('checked'));
      $(".group-element").toggleClass("selected", $(this).prop('checked'));
      $(".group-btn").toggleClass("selected", $(this).prop('checked'));
      $(".group_checkbox").prop("checked", $(this).prop('checked'));
      $("#elements_options").toggleClass("visible", $(this).prop('checked'));
    });

    $("#delete_elements").on("click", () => {
      const els = $(".selected_elements:checked");

      this.model.confirm(`${$trans('confirm-remove')} ${els.length} ${els.length === 1 ? $trans('element-text') : $trans('elements-text')}?`, () => {
        const arr = [];
        $(els).each((ind, el) => {
          const meshId = $(el).data('id');
          const mesh = this._getElementMeshByMenuId?.(meshId)
            || this.objectsInScene.find((m) => m.uuid === meshId);
          if (mesh) arr.push(mesh);
        });
        this.removeElementsFromScene(arr);
      });
    });

    $(document).on("click", ".delete-element", (e) => {
      e.stopPropagation();
      const meshId = $(e.currentTarget).data('id');
      const mesh = this._getElementMeshByMenuId?.(meshId)
        || this.objectsInScene.find((el) => el.uuid === meshId);
      if (!mesh) return;
      this.elementSelected = mesh;
      $(removeElement).trigger("click");
    });

    $("#showSelectElements").on('change', function () {
      $(".element-group").toggleClass('select-element', $(this).prop('checked'));
    });

    $("#cancel_select_elements").on('click', () => {
      this.resetElementsMenu()
    });

    $(document).on("change", ".group_checkbox", (e) => {
      const cond = $(e.currentTarget).prop("checked");
      $(e.currentTarget).parent().parent().parent().toggleClass("selected", cond);
      $(e.currentTarget).parent().parent().parent().siblings(".group-elements").find("input[type='checkbox']").prop("checked", cond);
      $(e.currentTarget).parent().parent().parent().siblings(".group-elements").find(".group-element").toggleClass("selected", cond);
      this.toggleCheckboxOptions();
    });

    $(document).on("change", ".selected_elements", (e) => {
      const cond = $(e.currentTarget).prop("checked");
      $(e.currentTarget).parent().parent().toggleClass("selected", cond);
      this.toggleCheckboxOptions();
    });

    $(document).on("change", ".include_in_dropdown_checkbox", (e) => {
      const cond = $(e.currentTarget).prop("checked");
      $(e.currentTarget).parent().parent().toggleClass("selected", cond);
      const dataId = e.target.getAttribute("data-id");
      Object.keys(this.model.scenes).forEach(sceneId => {
        if (dataId === sceneId) {
          this.model.scenes[sceneId].includeInDropDown = cond;
        }
      })
      this.updateDB();
      e.preventDefault();
      e.stopPropagation();
    });

    $(document).on("click", ".group-element", (e) => {
      // Lock/visibility icons use their own handler with stopPropagation; guard anyway so the row
      // handler never rotates or toggles bulk-select when clicking those controls.
      if ($(e.target).closest('.group-element-control').length) return;
      const $row = $(e.currentTarget);
      const meshId = $row.data('id');
      const inSelectMode = $row.closest('.element-group').hasClass('select-element');
      const clickEl = e.target.nodeType === Node.TEXT_NODE ? e.target.parentElement : e.target;
      const onTitle = clickEl && $(clickEl).closest('.element-title').length > 0;
      // In bulk-select mode, row clicks toggle the checkbox — except the title, which still frames the object in 3D.
      if (inSelectMode && !onTitle) {
        this.delegateCheckbox(e);
      } else {
        this.rotateToElement(meshId);
      }
    });

    $(document).on("click", ".group-element-control", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $row = $(e.currentTarget).closest(".group-element");
      const meshId = $row.data("id");
      if (!meshId) return;
      const mesh = this._getElementMeshByMenuId?.(meshId)
        || this.objectsInScene.find((el) => el.uuid === meshId)
        || null;
      if (!mesh) return;
      const action = $(e.currentTarget).data("action");
      const state = this._getEditElementState(mesh);
      if (action === "lock") {
        this._setEditElementLock(meshId, !state.locked);
      } else if (action === "visibility") {
        this._setEditElementVisibility(meshId, state.visible === false);
      }
    });

    $(document).on("click", ".group-visibility-control", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $group = $(e.currentTarget).closest(".element-group");
      if (!$group.length) return;
      const meshIds = $group.find(".group-elements .group-element").map((_, el) => $(el).data("id")).get();
      if (!meshIds.length) return;
      const shouldShow = meshIds.some((id) => {
        const mesh = this._getElementMeshByMenuId?.(id);
        return this._getEditElementState(mesh).visible === false;
      });
      meshIds.forEach((id) => this._setEditElementVisibility(id, shouldShow));
      this._syncElementGroupControls($group);
    });

    $(document).on("click", ".group-btn", (e) => {
      if ($(e.currentTarget).hasClass("single")) {
        if ($(e.currentTarget).parent().hasClass("select-element")) {
          this.delegateCheckbox(e);
        } else {
          this.rotateToElement($(e.currentTarget).data('id'));
        }
      } else {
        $(e.currentTarget).parent().toggleClass("open");
      }
    });

    /**
     * World editor events
     */
    // Toggle public available status
    $('#change_embed').on('change', (e) => {
      if (this.model.config.role !== 'admin_role' && this.model.config.role !== 'Admin') {
        if (!validateRoomItem(this.model.sceneData.space_type, { type: EDITOR_ACTIONS.public_space }) && e.target.value !== "private") {
          this.model.alert('error', $trans('not-available-in-free-plan'));
          $(".change_embed > .select-selected").attr("data-value", "private");
          $(".change_embed > .select-selected").html("No");
          $('.change_embed').val('No');
          return;
        }
      }

      $("#change_embed > .select-selected").attr("data-value", e.target.value);
      this.worldData.publicAvailable = 0;
      this.worldData.embedded = 0;
      if (e.target.value === "public") {
        this.worldData.publicAvailable = 1;
      }
      if (e.target.value === "embeded") {
        this.worldData.embedded = 1;
      }
      this.updateDB();
    });

    $('#change_scene_icon').on('change', (e) => {
      const value = e.target.value;
      const data = this.elementSelected.parent.getDbConfig();
      data.customIcon = value;
      this.elementSelected.parent.setDbConfig(data);
      this.modifyLocalJSON(data);
      this.updateJSON(this.elementSelected);
      this._syncSceneChangeEditIndicator(this.elementSelected.parent);
      this.updateDB();
    });
    $('#target_scene_edit-right-navbar').on('change', (e) => {
      const value = e.target.value;
      const data = this.elementSelected.parent.getDbConfig();
      data.goToSceneId = value;
      this.createSceneChangeTarget(value);
      this.elementSelected.parent.setDbConfig(data);
      this.modifyLocalJSON(data);
      this.updateJSON(this.elementSelected);
      this.updateDB();
    });

    $("#worldPublicAvailable").on('change', (event) => {
      this.worldData.publicAvailable = event.target.checked ? 1 : 0;
      this.updateDB();
    });
    $("#embededPageEnabled").on('change', (event) => {
      this.worldData.embedded = event.target.checked ? 1 : 0;
      this.updateDB();
    });

    $("#sceneLocked").on('change', (event) => {
      const index = $("#scene_settings_id").val();
      this.scenes[index].locked = false;
      if (event.target.checked) {
        this.scenes[index].locked = true;
      }
      this.updateDB();
    });

    // Remove thumbnail image
    $("#removeWorldThumbnail").on('click', () => {
      this.model.confirm($trans('confirm-delete-world-thumbnail'), () => {
        $(".room_thumbnail").attr('src', './textures/empty.png');
        this.worldData.previewBackgroundImage.mediumPath = './textures/empty.png';
        this.updateDB();
      });
    });

    // Remove logo image
    $("#removeWorldLogo").on('click', () => {
      this.model.confirm($trans('confirm-delete-world-thumbnail'), () => {
        $(".room_logo").attr('src', './textures/empty.png');
        this.worldData.customLogo = './textures/empty.png';
        this.updateDB();
      });
    });

    // Remove splash image (reset to default logo)
    $("#removeWorldSplash").on('click', () => {
      this.model.confirm($trans('confirm-delete-world-thumbnail'), () => {
        $(".room_splash").attr('src', '/textures/logo.png');
        this.worldData.splashImage = '/textures/logo.png';
        this.updateDB();
      });
    });

    // Sync world name
    $('#world_name').on('keyup change', (e) => {
      const val = $(e.currentTarget).val();
      $("#world_name_").val(val);
      this.worldData.name = val;
      this.updateDB();
    });
    // Sync language
    $('#change_language').on('change', (e) => {
      const val = $(e.currentTarget).val();
      this.worldData.userLanguage = val;
      this.updateDB();
    });

    // Sync home URL
    $('#world_home_url').on('keyup change', (e) => {
      const val = $(e.currentTarget).val();
      this.worldData.homeURL = val;
      this.updateDB();
    });

    // Sync updates URL for Version modal button
    $('#world_updates_url').on('keyup change', (e) => {
      const val = $(e.currentTarget).val();
      this.worldData.updatesUrl = val;
      this.updateDB();
    });

    // World description
    let worldDescriptionDebounce;
    $("#world_description").on("keyup change", (e) => {
      clearTimeout(worldDescriptionDebounce);

      worldDescriptionDebounce = setTimeout(() => {
        this.worldData.description = $(e.currentTarget).val();
        this.updateDB();
      }, 200);
    });

    // WELCOME SCREEN
    $("#edit_welcome_screen").on("click", () => {
      if (this.worldData.hasOwnProperty('welcomeScreen')) {
        // Initialize Quill editor if not already initialized
        if (!this.welcomeScreenQuill) {
          this.welcomeScreenQuill = initQuillEditor("#welcome-screen-description1", {
            modules: {
              toolbar: [
                ['bold', 'italic', 'underline'], ['link'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['clean']
              ]
            },
            placeholder: 'Enter description...'
          });
        }

        // Set content
        setQuillContent("#welcome-screen-description1", this.worldData.welcomeScreen.description1 || '');

        $("#welcome_screen_image").attr("src", this.worldData.welcomeScreen.hasOwnProperty('imagePath') ? this.worldData.welcomeScreen.imagePath || './textures/empty.png' : './textures/empty.png');
        $("#welcome_screen_video").attr("src", this.worldData.welcomeScreen.hasOwnProperty('videoPath') ? this.worldData.welcomeScreen.videoPath || '#' : '#');

        const imageCond = !$("#welcome_screen_image").attr("src").includes('/empty.png');
        const videoCond = $("#welcome_screen_video").attr("src") !== '#';

        $("#upload_welcome_screen_image .upload-watermark").toggleClass("hide", imageCond);
        $("#upload_welcome_screen_video .upload-watermark").toggleClass("hide", videoCond);
        $("#welcome_screen_video").parent().toggleClass("active", videoCond);

        $("#removeWelcomeScreenImage").toggleClass("active", imageCond);
        $("#removeWelcomeScreenVideo").toggleClass("active", videoCond);
      }
      $("#welcome-screen-modal").addClass("is-active");
    });

    $("#update-welcome-screen").on("click", () => {
      const description1 = getQuillContent("#welcome-screen-description1");
      const imagePath = $("#welcome_screen_image").attr("src");
      const videoPath = $("#welcome_screen_video").attr("src");

      if (this.worldData.hasOwnProperty('welcomeScreen')) {
        this.worldData.welcomeScreen.description1 = description1;
        this.worldData.welcomeScreen.imagePath = imagePath.includes("/empty.png") ? '' : imagePath;
        this.worldData.welcomeScreen.videoPath = videoPath === "#" ? '' : videoPath;
      } else {
        this.worldData.welcomeScreen = {
          description1,
          imagePath: imagePath.includes("/empty.png") ? '' : imagePath,
          videoPath: videoPath === "#" ? '' : videoPath
        };
      }

      this.updateDB();
      $("#welcome-screen-modal").removeClass("is-active");
    });

    $("#welcomeScreenActive").on("change", (e) => {
      if (this.model.config.role !== 'admin_role' && this.model.config.role !== 'Admin') {
        if (!validateRoomItem(this.model.sceneData.space_type, { type: EDITOR_ACTIONS.welcome_screen })) {
          this.model.alert('error', $trans('not-available-in-free-plan'));
          $("#welcomeScreenActive").prop("checked", false);
          return;
        }
      }
      const show = $(e.currentTarget).prop('checked');
      if (this.worldData.hasOwnProperty('welcomeScreen')) {
        this.worldData.welcomeScreen.show = show;
      } else {
        this.worldData.welcomeScreen = { show }
      }
      this.updateDB();
    });

    // CONSENT SCREEN (view mode blocking modal; text + revision stored in world JSON)
    $("#edit_consent_screen").on("click", () => {
      if (!this.consentScreenQuill) {
        this.consentScreenQuill = initQuillEditor("#consent-screen-description1", {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'], ['link'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['clean']
            ]
          },
          placeholder: 'Enter consent text...'
        });
      }
      const title = (this.worldData.consentScreen && this.worldData.consentScreen.title)
        ? this.worldData.consentScreen.title
        : 'Before you enter';
      const desc = (this.worldData.consentScreen && this.worldData.consentScreen.description)
        ? this.worldData.consentScreen.description
        : '<p>Please confirm that you agree before entering this space.</p>';
      $("#consent-screen-title").val(title);
      setQuillContent("#consent-screen-description1", desc);
      $("#consent-screen-modal").addClass("is-active");
    });

    $("#update-consent-screen").on("click", () => {
      const title = ($("#consent-screen-title").val() || '').trim();
      const description = getQuillContent("#consent-screen-description1");
      const safeTitle = title || 'Before you enter';
      const prev = (this.worldData.consentScreen && this.worldData.consentScreen.description) ? this.worldData.consentScreen.description : '';
      const prevTitle = (this.worldData.consentScreen && this.worldData.consentScreen.title)
        ? this.worldData.consentScreen.title
        : 'Before you enter';
      if (!this.worldData.consentScreen) {
        this.worldData.consentScreen = {
          show: true,
          revision: 1,
          title: safeTitle,
          description,
        };
      } else {
        if (description !== prev || safeTitle !== prevTitle) {
          this.worldData.consentScreen.revision = (this.worldData.consentScreen.revision || 1) + 1;
        }
        this.worldData.consentScreen.title = safeTitle;
        this.worldData.consentScreen.description = description;
      }
      this.updateDB();
      $("#consent-screen-modal").removeClass("is-active");
    });

    $("#consentScreenActive").on("change", (e) => {
      const show = $(e.currentTarget).prop('checked');
      if (show) {
        if (!this.worldData.consentScreen) {
          this.worldData.consentScreen = {
            show: true,
            revision: 1,
            title: 'Before you enter',
            description: '<p>Please confirm that you agree before entering this space.</p>',
          };
        } else {
          this.worldData.consentScreen.show = true;
        }
      } else if (this.worldData.consentScreen) {
        this.worldData.consentScreen.show = false;
      }
      this.updateDB();
    });

    // NAVIGATION MENU
    $("#edit_navigation_menu").on("click", () => {
      this._openNavigationMenuEditor();
    });

    $("#cancel-navigation-menu, #cancel-navigation-menu-close").on("click", () => {
      this._closeNavigationMenuEditor(false);
    });

    $("#navigation-menu-modal > .modal-background").on("click", () => {
      this._closeNavigationMenuEditor(false);
    });

    $("#save-navigation-menu").on("click", () => {
      this._closeNavigationMenuEditor(true);
    });

    $("#navigation_menu_modal_active").on("change", (e) => {
      if (!this._navigationMenuDraft) return;
      this._navigationMenuDraft.show = $(e.currentTarget).prop('checked');
    });

    $("#add-navigation-menu-entry").on("click", () => {
      this._openNavigationMenuEntryEditor(null);
    });

    $("#navigation_menu_entry_type").on("change", () => {
      this._syncNavigationMenuEntryTypeFields();
    });

    $("#save-navigation-menu-entry").on("click", () => {
      this._saveNavigationMenuEntryEditor();
    });

    $(document).on('click', '#navigation-menu-items .navigation-menu-item__visibility', (e) => {
      e.stopPropagation();
      const id = $(e.currentTarget).closest('.navigation-menu-item').data('id');
      const item = this._findNavigationMenuDraftItem(id);
      if (!item) return;
      item.visible = item.visible === false;
      this._renderNavigationMenuItems();
    });

    $(document).on('click', '#navigation-menu-items .navigation-menu-item__edit', (e) => {
      e.stopPropagation();
      const id = $(e.currentTarget).closest('.navigation-menu-item').data('id');
      this._openNavigationMenuEntryEditor(id);
    });

    $(document).on('click', '#navigation-menu-items .navigation-menu-item__delete', (e) => {
      e.stopPropagation();
      const id = String($(e.currentTarget).closest('.navigation-menu-item').data('id'));
      if (!this._navigationMenuDraft?.items) return;
      this._navigationMenuDraft.items = this._navigationMenuDraft.items.filter((item) => String(item.id) !== id);
      this._renderNavigationMenuItems();
    });

    let navMenuDragStartIndex = 0;
    $(document).on('dragstart', '#navigation-menu-items .navigation-menu-item', (e) => {
      navMenuDragStartIndex = $(e.currentTarget).index();
      e.originalEvent.dataTransfer.effectAllowed = 'move';
    });
    $(document).on('dragover', '#navigation-menu-items .navigation-menu-item', (e) => {
      e.preventDefault();
      $(e.currentTarget).addClass('dragover');
    });
    $(document).on('dragleave', '#navigation-menu-items .navigation-menu-item', (e) => {
      $(e.currentTarget).removeClass('dragover');
    });
    $(document).on('drop', '#navigation-menu-items .navigation-menu-item', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      $target.removeClass('dragover');
      const endIndex = $target.index();
      if (!this._navigationMenuDraft?.items || navMenuDragStartIndex === endIndex) return;
      const [moved] = this._navigationMenuDraft.items.splice(navMenuDragStartIndex, 1);
      this._navigationMenuDraft.items.splice(endIndex, 0, moved);
      this._renderNavigationMenuItems();
    });

    $("#navigationMenuActive").on("change", (e) => {
      this.worldData.navigationMenu = e.target.checked ? 1 : 0;
      if (!Array.isArray(this.worldData.navigationMenuItems)) {
        this.worldData.navigationMenuItems = [];
      }
      this.updateDB();
    });

    $("#removeWelcomeScreenImage").on("click", () => {
      $("#welcome_screen_image").attr("src", "textures/empty.png");
      $("#upload_welcome_screen_image .upload-watermark").removeClass("hide");
      $("#removeWelcomeScreenImage").removeClass("active");
    });

    $("#removeWelcomeScreenVideo").on("click", () => {
      $("#welcome_screen_video").attr("src", "#");
      $("#welcome_screen_video").removeClass("active");
      $("#upload_welcome_screen_video .upload-watermark").removeClass("hide");
      $("#removeWelcomeScreenVideo").removeClass("active");
    });

    $("#removeInfoElementImage").on("click", () => {
      $("#info_element_image").attr("src", "textures/empty.png");
      $("#upload_info_element_image .upload-watermark").removeClass("hide");
      $("#removeInfoElementImage").removeClass("active");
    });

    $("#removeInfoElementVideo").on("click", () => {
      $("#info_element_video").attr("src", "#");
      $("#info_element_video").removeClass("active");
      $("#upload_info_element_video .upload-watermark").removeClass("hide");
      $("#removeInfoElementVideo").removeClass("active");
    });

    $("#removeEmbeddedWebpageImage").on("click", () => {
      $("#embedded_webpage_image_aspect_ratio").val("1");
      $("#embedded_webpage_image").attr("src", "textures/empty.png");
      $("#upload_embedded_webpage_image .upload-watermark").removeClass("hide");
      $("#removeEmbeddedWebpageImage").removeClass("active");
      $("#use_embedded_webpage_icon").prop('checked', true);
      this.toggleEmbeddedWebpageIcon();
    });

    // EVENTS ON LABELS FOR UPLOAD
    $("#upload_image_label").on("click", () => { $(".upload_world_thumbnail").trigger("click"); })
    $("#upload_logo_label").on("click", () => { $("#upload_world_logo").trigger("click"); })
    $("#upload_vrai_agent_image_label").on("click", () => { $("#upload_vrai_agent_image").trigger("click"); })
    $("#upload_vrai_agent_image_edit_label").on("click", () => { $("#upload_vrai_agent_image_edit").trigger("click"); })
    $("#upload_vapi_camera_image_edit_label").on("click", () => { $("#upload_vapi_camera_image_edit").trigger("click"); })
    $("#upload_edit_vapi_library_image_label").on("click", () => { $("#upload_edit_vapi_library_image").trigger("click"); })

    $("#removeVraiAgentImage").on("click", (e) => {
      e.stopPropagation();
      $('.vrai_agent_holder .vrai_agent_image').attr('src', './textures/empty.png');
      this.vraiAgentImageUrl = '';
      $('#removeVraiAgentImage').removeClass('active');
    });
    $("#removeVraiAgentImageEdit").on("click", (e) => {
      e.stopPropagation();
      $('#vrai_agent_image_edit').attr('src', './textures/empty.png');
      if (isVraiAgentParent(this.elementSelected?.parent)) {
        const parent = this.elementSelected.parent;
        const newData = { agent_image: '' };
        parent.setDbConfig(newData);
        this.modifyLocalJSON(newData);
        this.updateJSON(this.elementSelected);
        this.updateDB();
        if (parent.setAgentImage) parent.setAgentImage('');
      }
      $('#removeVraiAgentImageEdit').removeClass('active');
    });
    $("#removeVapiCameraImageEdit").on("click", (e) => {
      e.stopPropagation();
      $('#vapi_camera_image_edit').attr('src', './textures/empty.png');
      this.vapiCameraImageUrl = '';
      const cameraComp = this.elementSelected?.parent?.name === 'vapiUserCamera'
        ? this.elementSelected.parent
        : this.elementSelected?.name === 'vapiUserCamera'
          ? this.elementSelected
          : null;
      if (cameraComp) {
        const newData = { imageUrl: '' };
        cameraComp.setDbConfig?.(newData);
        this.modifyLocalJSON(newData);
        this.updateJSON(this.elementSelected);
        this.updateDB();
      }
      $('#removeVapiCameraImageEdit').removeClass('active');
    });
    $("#removeEditVapiLibraryImage").on("click", (e) => {
      e.stopPropagation();
      $('#edit_vapi_library_image').attr('src', './textures/empty.png');
      this.editVapiLibraryImageUrl = '';
      $('#removeEditVapiLibraryImage').removeClass('active');
    });
    $("#upload_splash_label").on("click", () => { $("#upload_world_splash").trigger("click"); })
    $("#upload_scene_bg_label").on("click", () => { $(".scene_bg_image_upload").trigger("click"); })
    $("#upload_sceneChangeImage_label").on("click", () => { $("#upload_scene_change_image").trigger("click"); })
    $("#upload_linkImage_label").on("click", () => { $("#upload_link_image").trigger("click"); })
    $("#upload_profile_image_label").on("click", () => { $("#uploadProfileImage").trigger("click"); })
    $("#upload_info_element_label").on("click", () => { $("#upload_info_element_image").trigger("click"); })
    $("#upload_info_element_video_label").on("click", () => { $("#upload_info_element_video").trigger("click"); })
    $("#upload_welcome_screen_image_label").on("click", () => { $("#upload_welcome_screen_image").trigger("click"); })
    $("#upload_welcome_screen_video_label").on("click", () => { $("#upload_welcome_screen_video").trigger("click"); })
    $("#upload_embedded_webpage_label").on("click", () => { $("#upload_embedded_webpage_image").trigger("click"); })

    //Products
    $(document).on('click', '.product-delete', function (e) {
      const countCurrentProducts = $("#products").children().length;
      const product = $(e.currentTarget).parent();
      e.preventDefault();
      if (countCurrentProducts > 1) {
        let removeNum = product.attr('data-order');
        product.remove();
        let items = getSortedProducts('.product-container', 'data-order');
        updateDataOrder(items);
      } else {
        //keep 1 but delete values
        emptyProductValues(product);
      }
    });

    $("#edit_products_modal").on("click", () => {
      this.showProductsModal('edit', this.elementSelected.parent.getDbConfig())
    });

    $("#shop_submit").on("click", () => {
      // if(!validateFormData($('#products')[0])){
      //   //return; //TODO on change
      //   // tinymce.get("info-element-description1").getContent()
      // }
      if ($('.shop_holder').hasClass('edit')) {
        let products = document.getElementById('products');
        let productsData = getFormData(products);
        let config = { 'products': productsData };
        this.elementSelected.parent.setDbConfig(config);
        this.modifyLocalJSON(config);

      } else {
        this._add3dObject('shopLink');
      }

      $(".shop_holder").removeClass("is-active");
    });

    // Update tooltip
    $("#customTooltip").on("keyup change", (e) => {
      if (!this.elementSelected) {
        return;
      }

      const tooltip = e.target.value || getTooltipByType(this.elementSelected.type);
      this.elementSelected.parent.setDbConfig({ tooltip });
      this.modifyLocalJSON({ tooltip });
    });

    // Hide on start
    $("#hide_on_start_edit").on("change", (e) => {
      if (!this.elementSelected) return;
      const hideOnStart = !!e.target.checked;
      const parent = this.elementSelected.parent;
      parent.setDbConfig && parent.setDbConfig({ hideOnStart });
      this.modifyLocalJSON({ hideOnStart });
    });

    $("#show_drag_corners_edit").on("change", (e) => {
      if (!this.elementSelected) return;
      const parent = this.elementSelected.parent;
      if (parent.name !== 'vrInvisibleAction') return;
      const showDragCorners = !!e.target.checked;
      parent.setDbConfig({ showDragCorners });
      parent.applyShowDragCornersSetting && parent.applyShowDragCornersSetting();
      this.modifyLocalJSON({ showDragCorners });
    });

    // VRAI agent: optional modal to edit message before sending as transcript (action buttons)
    $("#prompt_transcript_modal_edit").on("change", (e) => {
      if (!this.elementSelected) return;
      if (!isVraiAgentParent(this.elementSelected.parent)) return;
      const promptTranscriptModal = !!e.target.checked;
      const parent = this.elementSelected.parent;
      parent.setDbConfig && parent.setDbConfig({ promptTranscriptModal });
      this.modifyLocalJSON({ promptTranscriptModal });
    });

    // Component name
    $("#component_name_edit").on("keyup change", (e) => {
      if (!this.elementSelected) return;
      this._applyComponentNameChange((e.target.value || '').trim());
    });


    /**
     * Show room slider
     */
    showRoomSlider.addEventListener("click", () => {
      const startOrientation = this.camera.quaternion.clone();
      this.lastCameraQuaternion = startOrientation;
      const targetOrientation = this.initialCameraPosition;
      const cam = this.camera;
      this.pivotLastRotation = this.pivot.rotation.y;
      this.pivot.rotation.y = 0;

      // $(".buttons-holder").removeClass('visible');

      gsap.to({}, {
        duration: .5,
        ease: Expo.easeOut,
        onStart: () => {
          this.setControlsUpdate(false);
        },
        onUpdate: function () {
          cam.quaternion.copy(startOrientation).slerp(targetOrientation, this.ratio);
        },
        onComplete: () => {
        }
      });

      roomSlider.value = radians_to_degrees(this.currentScene.sceneRotationY);

      this.roomGroup.rotation.y = this.currentScene.sceneRotationY;
      sliderContainer.classList.add("visible");

      this.needleOffset = 0;
      $("#compass-needle").css({ transform: `translate(-50%, -50%) rotate(0deg)` });
    });


    /**
     * Rotate & update room entry point
     */
    roomSlider.addEventListener("input", () => {
      const rotation = degrees_to_radians(roomSlider.value);
      this.roomGroup.rotation.y = rotation;
      this.currentScene.sceneRotationY = rotation;
      this.scenes[this.currentSceneIndex] = this.currentScene;
      this.needleOffset = roomSlider.value;
      this.needleOffset = 0;
      $("#compass-needle").css({ transform: `translate(-50%, -50%) rotate(0deg)` });
    });

    roomSlider.addEventListener("change", () => {
      this.currentScene.sceneRotationY = degrees_to_radians(roomSlider.value);
      this.scenes[this.currentSceneIndex] = this.currentScene;
      this._markNorthCompassOverride(this.currentScene);
      this._rememberSceneNorth(this.currentScene);
      this.updateDB();
    });


    /***
     * Edit element properties
     */
    editElement.addEventListener("click", () => {

      const editableTarget = this._resolveEditableObject(this.elementSelected) || this.elementSelected;
      let parent = this.elementSelected.parent || this.elementSelected;
      // vapiTranscription / vapiUserCamera keep their own settings groups (accordion);
      // linked chair is resolved inside the shared vrai-agent-settings panel.
      // When clicking poster/mesh of iframe or youtube, resolve type from parent so settings and data apply
      const elementType = this._resolveElementSettingsType(parent, editableTarget);
      let data = this._getEditableComponentConfig(editableTarget);
      if (elementType === 'iframeAgent' && !data.iframe_value) {
        const sceneObj = this.currentScene.objects.find(el => el.id === parent.getId());
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      if (elementType === 'iframeElement' && !data.iframe_value) {
        const sceneObj = this.currentScene.objects.find(el => el.id === (parent.getId?.() ?? parent.id));
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      if (elementType === 'timerElement') {
        const sceneObj = this.currentScene.objects.find(el => el.id === (parent.getId?.() ?? parent.id));
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      if (elementType === 'inputFieldGuess') {
        const sceneObj = this.currentScene.objects.find(el => el.id === (parent.getId?.() ?? parent.id));
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      if (elementType === 'inputField') {
        const sceneObj = this.currentScene.objects.find(el => el.id === (parent.getId?.() ?? parent.id));
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      if (elementType === 'vraiAgent') {
        const chair = this._getSelectedVraiAgentChairForAgentSettings()
          || (isVraiAgentParent(parent) ? parent : null);
        if (chair) parent = chair;
        const sceneObj = this.currentScene.objects.find(el => el.id === (parent.getId?.() ?? parent.id));
        if (sceneObj) data = { ...data, ...sceneObj };
      }
      $('#products-edit').hide();
      $(".object-menu").addClass("edit");

      // Populate scale, rotateX, rotateY for object-settings-tab-panel (shared across elements)
      const getRoot = (obj) => {
        if (obj?.parent?.parent instanceof VRObject3D) return obj.parent.parent;
        if (obj?.parent instanceof VRObject3D) return obj.parent;
        return obj;
      };
      const rootObject = getRoot(this.elementSelected);
      if (parent?.getLimits && rootObject?.objConfig?.isResizable) {
        rangeHolder.classList.toggle('visible', shouldShowDistanceControl(this.elementSelected, rootObject));
        sizeRangeHolder.classList.toggle('visible', shouldShowSizeControl(this.elementSelected, rootObject));
        const elementLimits = parent.getLimits();
        if (shouldShowDistanceControl(this.elementSelected, rootObject)) {
          distanceRange.setAttribute('min', elementLimits.min * 1 - 1);
          distanceRange.setAttribute('max', elementLimits.max * 1 + 1);
          distanceRange.value = elementLimits.distance;
        }
        if (shouldShowSizeControl(this.elementSelected, rootObject)) {
          sizeRange.value = clampSizeValue(getMeshSizeForSelection(this.elementSelected, rootObject));
        }
      } else {
        rangeHolder.classList.remove('visible');
        sizeRangeHolder.classList.remove('visible');
      }
      if (parent?.getAxisRotations && rootObject?.objConfig?.isRotatable) {
        rotateXRangeHolder?.classList.add('visible');
        rotateYRangeHolder?.classList.add('visible');
        const { rotateX, rotateY } = parent.getAxisRotations();
        if (rotateXRange) rotateXRange.value = rotateX;
        if (rotateYRange) rotateYRange.value = rotateY;
      } else {
        rotateXRangeHolder?.classList.remove('visible');
        rotateYRangeHolder?.classList.remove('visible');
      }
      $('.slider').trigger('change');

      const editableSceneObj = this._findSceneObjectForComponent(editableTarget);
      const headerName = (elementType === 'vraiAgent' || elementType === 'vapiUserCamera' || elementType === 'vapiTranscription' || elementType === 'vapiButton')
        ? (this._getComponentDisplayName(elementType, editableSceneObj || data)
          || this.elementSelected.groupDetails?.editTitle
          || '')
        : ((data.name && String(data.name).trim()) ? data.name : (this.elementSelected.groupDetails?.editTitle || ''));
      $('.object-menu .object-name').text(headerName);

      const tooltipComponentType = elementType || this.elementSelected?.type;
      const defaultTooltip = tooltipComponentType === 'vraiAgent'
        ? (data.chairName || ((typeof $trans !== 'undefined' && $trans('vrai-agent-text')) || 'AI Agent'))
        : getTooltipByType(tooltipComponentType);
      const tooltip = data.tooltip || defaultTooltip;
      $("#customTooltip").val(tooltip);
      $('#hide_on_start_edit').prop('checked', !!data.hideOnStart);
      $('#show_drag_corners_edit').prop('checked', data.showDragCorners !== false);
      $('.prompt-transcript-modal-settings').addClass('hidden');
      $('#prompt_transcript_modal_edit').prop('checked', !!data.promptTranscriptModal);
      $('#component_name_edit').val(this._getComponentOwnName(data, elementType));
      if (data.customIcon) {
        $("#change_scene_icon").val(data.customIcon);
        $(".change_scene_icon > .select-selected").attr("data-value", data.customIcon);
        $(".change_scene_icon > .select-selected span").html(data.customIcon);
      }
      if (data.goToSceneId) {
        var $dropdown = $("#target_scene_edit-right-navbar");
        $dropdown.empty(); // Clear existing options
        $.each(this.model.scenes, function (key, value) {
          $dropdown.append(
            $("<option>", {
              value: key,
              text: value.publicName || value.name
            })
          );
        });
        $dropdown.val(data.goToSceneId);
      }
      $("#customTooltip").closest('.tooltip-settings').toggleClass('hidden', tooltip === '' && tooltipComponentType !== 'vraiAgent');
      $(".perspective-settings").addClass('hidden');
      $(".vr-invisible-action-drag-corners-settings").addClass('hidden');
      $(".video-loop, .video-transparent").addClass('hidden');
      $(".iframe-agent-settings").removeClass('is-active').addClass('hidden');
      $(".timer-element-settings").removeClass('is-active').addClass('hidden');
      $(".input-field-guess-settings").removeClass('is-active').addClass('hidden');
      $(".input-field-settings").removeClass('is-active').addClass('hidden');
      $(".vrai-agent-settings").removeClass('is-active').addClass('hidden');
      $('.component-name-settings, .hide-on-start-settings').removeClass('hidden');
      $('.info-settings-section').addClass('hidden');
      this._placeVapiComponentSharedSettings?.(false);
      // Reset link-only panel visibility so other object types don't inherit it.
      $(".object-settings-tab-settings .link-obj-settings").hide();
      // Reset media-specific settings visibility so they only appear for matching object types.
      $("#create-videoPlayer-settings, #create-musicObject-settings").hide();

      switch (elementType) {
        case 'sceneChange':
          $(".tooltip-settings, .perspective-settings, .video-loop, .video-transparent, .iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showEditInformationButton();
          this.showSceneChangeModal('edit', data);
          break;
        case 'youtube':
          $(".tooltip-settings, .perspective-settings, .video-loop, .video-transparent, .iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showVideoModal('edit', data);
          break;
        case 'iframeAgent':
          $(".object-menu").addClass("edit");
          $(".tooltip-settings, .perspective-settings, .video-loop, .video-transparent").addClass('hidden');
          $(".vrai-agent-settings").addClass('hidden');
          $(".iframe-agent-settings").removeClass('hidden').addClass('is-active');
          $('#iframe_value_edit').val(data.iframe_value || '');
          this._populateIframeDimensions(data);
          break;
        case 'iframeElement':
          $(".object-menu").addClass("edit");
          $(".tooltip-settings, .video-loop, .video-transparent, .vrai-agent-settings, .timer-element-settings").addClass('hidden');
          $(".iframe-agent-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings").removeClass('hidden');
          $('#iframe_value_edit').val(data.iframe_value || '');
          this._populateIframeDimensions(data);
          break;
        case 'timerElement':
          $(".object-menu").addClass("edit");
          $(".tooltip-settings, .video-loop, .video-transparent, .vrai-agent-settings, .iframe-agent-settings, .input-field-guess-settings, .input-field-settings").addClass('hidden');
          $(".timer-element-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings").removeClass('hidden');
          $('#timer_preset_edit').val(data.timePreset || '0:10:0');
          break;
        case 'inputFieldGuess':
          $(".object-menu").addClass("edit");
          $(".tooltip-settings, .video-loop, .video-transparent, .vrai-agent-settings, .iframe-agent-settings, .timer-element-settings, .input-field-settings").addClass('hidden');
          $(".input-field-guess-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings").removeClass('hidden');
          $(".object-menu .flx-sb:has(#show_edit_modal)").removeClass('hidden');
          if (inputFieldGuessTimePresetEdit) inputFieldGuessTimePresetEdit.value = data.timePreset || '';
          if (inputFieldGuessAutocloseTrueEdit) inputFieldGuessAutocloseTrueEdit.checked = !!data.autocloseOnTrue;
          if (inputFieldGuessAutocloseFalseEdit) inputFieldGuessAutocloseFalseEdit.checked = !!data.autocloseOnFalse;
          this.showEditInformationButton();
          break;
        case 'inputField':
          $(".object-menu").addClass("edit");
          $(".tooltip-settings, .video-loop, .video-transparent, .vrai-agent-settings, .iframe-agent-settings, .timer-element-settings, .input-field-guess-settings").addClass('hidden');
          $(".input-field-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings").removeClass('hidden');
          $(".object-menu .flx-sb:has(#show_edit_modal)").removeClass('hidden');
          this._fillInputFieldSettings(data);
          this.showEditInformationButton();
          break;
        case 'vapiButton': {
          $(".object-menu").addClass("edit");
          $(".vrai-agent-settings").removeClass('hidden').addClass('is-active');
          $(".tooltip-settings, .video-loop, .video-transparent, .iframe-agent-settings").addClass('hidden');
          $(".perspective-settings:not(.vrai-agent-perspective), .object-menu .flx-sb:has(#show_edit_modal)").addClass('hidden');
          $('#vrai_show_agent_settings').removeClass('hidden');
          $('.vrai-agent-perspective').removeClass('hidden');
          this._syncVapiComponentAgentSettingsPanel(parent);
          this._populateVapiSettingsGroups(parent, 'vraiAgent');
          break;
        }
        case 'vapiTranscription': {
          $(".object-menu").addClass("edit");
          $(".vrai-agent-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings:not(.vrai-agent-perspective), .tooltip-settings, .video-loop, .video-transparent, .iframe-agent-settings, .object-menu .flx-sb:has(#show_edit_modal)").addClass('hidden');
          $('#vrai_show_agent_settings').removeClass('hidden');
          $('.vrai-agent-perspective').removeClass('hidden');
          this._syncVapiComponentAgentSettingsPanel(parent);
          this._populateVapiSettingsGroups(parent, 'vapiTranscription');
          break;
        }
        case 'vapiUserCamera': {
          $(".object-menu").addClass("edit");
          $(".vrai-agent-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings:not(.vrai-agent-perspective), .tooltip-settings, .video-loop, .video-transparent, .iframe-agent-settings, .object-menu .flx-sb:has(#show_edit_modal)").addClass('hidden');
          $('#vrai_show_agent_settings').removeClass('hidden');
          $('.vrai-agent-perspective').removeClass('hidden');
          this._syncVapiComponentAgentSettingsPanel(parent);
          this._populateVapiSettingsGroups(parent, 'vapiUserCamera');
          break;
        }
        case 'vraiAgent':
          $(".object-menu").addClass("edit");
          $('.prompt-transcript-modal-settings').removeClass('hidden');
          $(".vrai-agent-settings").removeClass('hidden').addClass('is-active');
          $(".perspective-settings:not(.vrai-agent-perspective), .video-loop, .video-transparent, .iframe-agent-settings, .object-menu .flx-sb:has(#show_edit_modal)").addClass('hidden');
          $(".tooltip-settings").removeClass('hidden');
          $('#vrai_show_agent_settings').removeClass('hidden');
          $('.vrai-agent-perspective').removeClass('hidden');
          {
            const chairForLinked = this._getSelectedVraiAgentChairForAgentSettings()
              || (isVraiAgentParent(parent) ? parent : null);
            if (chairForLinked) this._syncVraiAgentChairLinkedAgentPanel(chairForLinked);
          }
          this._syncVraiChairLibraryFields(parent, data);
          this._populateVapiSettingsGroups(parent, 'vraiAgent');
          break;
        case 'webLink':
          this.showLinkModal('edit', data);
          $(".object-settings-tab-settings .link-obj-settings").show();
          $(".perspective-settings").toggleClass('hidden', !!parent.useIcon || !parent.customIcon);
          $('.info-settings-section').addClass('hidden');
          break;

        case 'shopLink':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $('.info-settings-section').addClass('hidden');
          $('#products-edit').show();
          break;
        case 'baglessRoom':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showEditInformationButton();
          break;

        case 'profile':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showEditInformationButton();
          break;

        case 'payPalDonation':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showEditInformationButton();
          break;

        case 'screenStream':
          $(".tooltip-settings, .perspective-settings, .video-loop, .video-transparent, .iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showScreenShareModal('edit', data)
          break;

        case 'infoElement':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          this.showEditInformationButton();
          break;
        case 'vrInvisibleAction':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".video-loop, .video-transparent").addClass('hidden');
          $(".perspective-settings").removeClass('hidden');
          $(".vr-invisible-action-drag-corners-settings").removeClass('hidden');
          this.showEditInformationButton();
          break;

        case 'embeddedWebpage':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".perspective-settings").toggleClass('hidden', !!parent.useIcon || !parent.customIcon);
          this.showEditInformationButton();
          break;
        case 'imageGallery':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".video-loop").addClass('hidden');
          $(".perspective-settings").toggleClass('hidden', !!parent.useIcon || !parent.customIcon);
          $(".object-menu .flx-sb:has(#show_edit_modal)").removeClass('hidden');
          this.showEditInformationButton();
          break;
        case 'videoPlayer':
        case 'videoPlayerWebGL':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".video-loop, .video-transparent").addClass('hidden');
          $(".perspective-settings").toggleClass(
            'hidden',
            elementType === 'videoPlayer' && (!!parent.useIcon || !parent.customIcon)
          );
          $('.info-settings-section').addClass('hidden');
          this.showVideoPlayerSettings(data);
          break;
        case 'vrMusicObject':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".video-loop, .video-transparent").addClass('hidden');
          $(".perspective-settings").addClass('hidden');
          $(".tooltip-settings").removeClass('hidden');
          $('.component-name-settings, .hide-on-start-settings, .info-settings-section').addClass('hidden');
          rangeHolder.classList.remove('visible');
          sizeRangeHolder.classList.remove('visible');
          this.showMusicObjectSettings(data);
          break;
        case 'videoGallery':
          $(".iframe-agent-settings, .vrai-agent-settings").addClass('hidden');
          $(".perspective-settings").removeClass('hidden');
          $(".video-loop, .video-transparent").removeClass('hidden');
          if (videoLoopEdit) {
            videoLoopEdit.checked = data.autoplay === "2";
          }
          if (videoTransparentEdit) {
            videoTransparentEdit.checked = data.transparentBackground === true;
          }
          $(".object-menu .flx-sb:has(#show_edit_modal)").removeClass('hidden');
          this.showEditInformationButton();
          break;
      }

      this._updateObjectEventsVisibility();

    });

    $("#show_edit_modal").on("click", () => {
      const parent = this.elementSelected.parent;
      const selectedType = this.elementSelected.type || parent?.name;
      switch (selectedType) {
        case 'sceneChange':
          this.showSceneChangeModal('scene');
          break;
        case 'infoElement': parent.showEditModal(); break;
        case 'inputFieldGuess': {
          const guess = this.elementSelected?.type === 'inputFieldGuess' ? this.elementSelected : parent;
          guess?.showEditModal?.();
          break;
        }
        case 'inputField': {
          const input = this.elementSelected?.type === 'inputField' ? this.elementSelected : parent;
          input?.showEditModal?.();
          break;
        }
        case 'baglessRoom':
          $("#bagless-room-dropdown-title").text(parent.dbConfig.roomName || $trans('select-scene-text'));
          $('#add_bagless_room_button').attr("disabled", true);
          $('#add_bagless_room_button').text($trans('update-text'));
          $('#add_bagless_room_button').attr("data-lang", "update-text");
          $('#bagless_room_preview_image').attr("src", getImgThumb(parent.dbConfig.image.url));
          $('#bagless_room_preview_image')(generateImageWithThumbNormalCallbackAndCustomErrorCallback(data.data.senderAvatarUrl, data.data.senderAvatarUrl, id));
          this.showBaglessConnectModal();
          break;
        case 'payPalDonation': this.showPayPalDonationModal('edit', parent.dbConfig); break;
        case 'embeddedWebpage': parent.showEditModal(); this.toggleEmbeddedWebpageIcon(); break;
        case 'profile': this.showProfileModal('edit', parent.getDbConfig()); break;
        case 'imageGallery': this.showViewGalleryModal(parent); break;
      }
    });

    /***
     * Remove element from scene
     */
    $('.remove_element, .delete-object').on('click', () => {
      if (!this.elementSelected) return;
      let parent = this.getRoot3DObjectForDelete(this.elementSelected) || this.elementSelected.parent;
      if (parent?.userData?.vraiAgentCamera) parent = parent.userData.vraiAgentCamera;
      if (parent?.userData?.vraiAgentChair) parent = parent.userData.vraiAgentChair;
      if (parent?.userData?.vraiAgentTranscription) parent = parent.userData.vraiAgentTranscription;
      if (parent?.userData?.vraiAgentButton) parent = parent.userData.vraiAgentButton;
      if (parent?.userData?.vrIframeElement) parent = parent.userData.vrIframeElement;
      if (parent?.userData?.vrTimerElement) parent = parent.userData.vrTimerElement;
      if (parent?.userData?.vrInputFieldGuess) parent = parent.userData.vrInputFieldGuess;
      if (parent?.userData?.vrInputField) parent = parent.userData.vrInputField;
      if (!parent || typeof parent.getId !== 'function') return;

      const objectId = String(parent.getId());
      const eventsCount = (this.model.worldEvents || []).filter(
        (e) => String(e.source_object_id) === objectId || String(e.target_object_id) === objectId
      ).length;

      let msg = $trans('confirm-remove-element');
      if (eventsCount > 0) {
        msg += ` ${$trans('confirm-remove-element-has-actions')} ${eventsCount} ${eventsCount === 1 ? $trans('action-text') : $trans('actions-text')} ${$trans('confirm-remove-element-will-be-deleted')}.`;
      }

      this.model.confirm(msg, () => {
        const doRemove = () => {
          this.removeElementFromScene();
          if (this.countItemsInScene(SCENE_OBJECT_TYPES.screenStream) >= 1) {
            $(".add-screen").addClass("disabled");
          } else {
            $(".add-screen").removeClass("disabled");
          }
        };
        if (this.worldID && eventsCount > 0) {
          this.model.worldFetcher.deleteEventsByObjectId(this.worldID, objectId, () => {
            this.model.worldEvents = (this.model.worldEvents || []).filter(
              (e) => String(e.source_object_id) !== objectId && String(e.target_object_id) !== objectId
            );
            doRemove();
          }, () => {
            doRemove();
          });
        } else {
          doRemove();
        }
      });
    });

    // Open world editor
    $("#openWorldEditor").on('click', () => {
      $(".settings-menu").removeClass("is-active");
      $('#room-scene-menu').addClass('is-active');
      $('#openWorldEditor').addClass('active');
      $('.bottom-bar-scene').removeClass('selected');
      $("#showRoomMenu").trigger("click");
      this.ambientSound.isPlaying && this.ambientSound.stop();
      this.toggleOffset();
    });

    // Remove ambient song
    $("#remove-song").on('click', () => {
      this.model.confirm($trans('confirm-remove-ambient-song'), () => {
        const index = $("#scene_settings_id").val();
        this.scenes[index].ambientAudio.url = '';
        this.updateDB();
        this.hideRemoveSongBtn();
        // TODO - remove also the physical file
      });
    });

    // COMPASS CONTROLS
    $(".compass").on('click', () => {
      this.saveNorthPosition();
    });

    // PUBLISH CHANGES
    $(document).on('click', '#publish_changes', (e) => {
      this.publishChanges({ isPublishing: true });
    });


    $("#publishAndView").on("click", () => {
      const destination = this._leaveEditorDestination || 'view';
      if (!this.publishChanges({ isPublishing: true })) return;
      this._leaveEditorTo(destination);
    });

    // DISCARD CHANGES
    $("#discard_changes").on("click", () => {
      this._leaveEditorTo(this._leaveEditorDestination || 'view');
    });

    // DYNAMIC PROFILE AVATAR
    $("#dynamicProfileAvatar").on("change", (e) => {
      $("#profile_image_upload_container").toggleClass('disabled', $(e.currentTarget).prop('checked'));
    });

  }

  saveNorthPosition = () => {
    this.setNeedleOffset();
    const needleAngle = Number($("#compass-needle").attr('data-currentRotation'));
    if (!Number.isFinite(needleAngle)) {
      return;
    }

    this.model.info('success', $trans('success-entry-point-saved'));
    this.currentScene.sceneRotationY = degrees_to_radians(needleAngle);
    this._markNorthCompassOverride(this.currentScene);
    this._rememberSceneNorth(this.currentScene);
    this._preserveSceneRotationY();
    this.scenes[this.currentSceneIndex] = this.currentScene;
    this.updateDB();
  }

  setNeedleOffset = () => {
    const needleTransform = $("#compass-needle").css("transform");
    let values = needleTransform.split('(')[1];
    values = values.split(')')[0];
    values = values.split(',');
    const a = values[0];
    const b = values[1];
    let angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));

    if (angle < 0)
      angle = 360 + angle;

    const invertedAngle = 360 - angle + this.needleOffset;
    this.needleOffset = invertedAngle;
  }


  _editButtonsEvents() {

    // ADD CHAIR
    $('.add-chair').on('click', () => {
      this._add3dObject('guestSeat');
    });

    // ADD SCREEN
    $('.add-screen').on('click', () => {
      this.showScreenShareModal();
    });

    $('#save-screenStream-settings').on('click', () => {
      let whoCanStream = $('#create-screen-settings input[name="whoCanStream"]:checked').val();
      if ($('.add_screen_holder').hasClass('is-active')) {
        $('.add_screen_holder').removeClass('is-active');
        this._add3dObject('screenStream');
        if (this.countItemsInScene(SCENE_OBJECT_TYPES.screenStream) >= 1) {
          $(".add-screen").addClass("disabled");
        }
      } else {
        let config = { 'whoCanStream': whoCanStream };
        this.elementSelected.parent.setDbConfig(config);
        this.modifyLocalJSON(config);
        // MODIFY LOCAL JSON AND CALL UPDATE FUNCTION
        // for (let x = 0; x < this.currentScene.objects.length; x++) {
        //   const el = this.currentScene.objects[x];
        //   if (el.id === this.elementSelected.parent.unique_id) {
        //     this.currentScene.objects[x].whoCanStream = whoCanStream;
        //     this.scenes[this.currentSceneIndex] = this.currentScene;
        //     this.updateDB();
        //   }
        // }
      }
    });

    // ADD PROFILE
    $('.add-profile').on('click', () => {
      this.showProfileModal();
    });

    // ADD SCENE CHANGE

    $("#scene_change_submit").on('click', () => {
      this._add3dObject('sceneChange');
    });

    $('.add-scene-change').on('click', () => {
      this.showSceneChangeModal();
    });

    $("#save_sceneChange_target").on("click", () => {
      const parent = this._resolveEditableObject(this.elementSelected) || this.elementSelected?.parent;
      if (!parent) return;

      const $activeTarget = $(".target_scene.active").first();
      const sceneID = $activeTarget.length
        ? ($activeTarget.find('.roomID').val() || $activeTarget.find('input[type="hidden"]').val())
        : this.currentScene.id;

      parent.setTargetRoomId(sceneID);
      parent.setDbConfig({ ...parent.getDbConfig(), goToSceneId: sceneID });
      this.modifyLocalJSON({ goToSceneId: sceneID });

      $(".scenes_target_holder").removeClass("is-active sceneChangeTarget");
      const data = this.model.getObjectDataByID(false, parent.unique_id);
      this.showSceneChangeModal('edit', data);
    });

    $("#use_scene_change_icon").on('change', () => {
      this.toggleSceneChangeIcon();
      if (this.elementSelected?.parent?.name === 'sceneChange' && !$('.scenes_target_holder').hasClass('is-active')) {
        $("#scene_change_update").trigger('click');
      }
    });

    $("#removeSceneChangeThumbnail").on('click', () => {
      $('#scene_change_image').attr('src', './textures/icons/edit_change_scene.png');
      $('#scene_change_image_aspect_ratio').val(1);
      $("#use_scene_change_icon").prop('checked', true);
      this.toggleSceneChangeIcon();
      if (!$('.scenes_target_holder').hasClass('is-active')) {
        $("#scene_change_update").trigger('click');
      }
    });

    $("#scene_change_update").on("click", () => {

      if ($('.scenes_target_holder').hasClass('is-active')) { return; }
      const parent = this.elementSelected?.parent;
      if (!parent || parent.name !== 'sceneChange') return;
      const src = $("#scene_change_image").attr("src");
      const aspectRatio = $("#scene_change_image_aspect_ratio").val();
      const useIcon = $("#use_scene_change_icon").is(':checked');
      const isDefaultImage = !src || src.includes('edit_change_scene');
      const preservedUrl = parent.getCustomImageUrl?.() || parent.dbConfig?.image?.url || '';
      const hasPreservedImage = preservedUrl && !String(preservedUrl).includes('edit_change_scene');
      const imageUrl = useIcon
        ? (hasPreservedImage ? preservedUrl : '')
        : (isDefaultImage ? '' : src);

      const $activeTarget = $(".target_scene.active").first();
      const sceneID = $activeTarget.length
        ? ($activeTarget.find('.roomID').val() || $activeTarget.find('input[type="hidden"]').val())
        : this.currentScene.id;

      parent.setTargetRoomId(sceneID);
      parent.setUseIcon?.(useIcon);
      parent.setDbConfig({
        ...parent.getDbConfig(),
        goToSceneId: sceneID,
        useIcon,
        image: { url: imageUrl, aspectRatio },
      });
      this._syncSceneChangeEditIndicator(parent);
      this.modifyLocalJSON({ useIcon, image: { url: imageUrl, aspectRatio }, goToSceneId: sceneID });

      this._refreshSizeDistanceControls?.(this.elementSelected);

      $(".scenes_target_holder").removeClass("is-active");
    });

    /**
     * Update goToSceneId
     */
    $(document).on('click', '.target_scene', (e) => {
      $('.target_scene').removeClass('active');
      $(e.currentTarget).addClass('active');
    });

    // ADD / UPDATE LINK
    $('.add-link').on('click', () => {
      this.showLinkModal();
    });

    // VIDEO PLAYER EVENTS - Auto-save like sceneChange
    $("#video_player_title").on('input', () => {
      if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
        this.autoSaveVideoPlayer();
      }
    });

    $("#use_video_icon").on('change', () => {
      this.toggleVideoPlayerIcon();
      if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
        this.autoSaveVideoPlayer();
      }
    });

    $("#video_player_autoplay").on('change', () => {
      if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
        const parent = this.elementSelected.parent;
        parent._sceneVideoLoadedUrl = null;
        parent.setDbConfig({ autoplay: $("#video_player_autoplay").is(':checked') });
        this.autoSaveVideoPlayer();
      }
    });

    $("#video_player_play_loop").on('change', () => {
      if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
        const parent = this.elementSelected.parent;
        parent.setDbConfig({ playLoop: $("#video_player_play_loop").is(':checked') });
        this.autoSaveVideoPlayer();
      }
    });

    $("#video_player_play_on_click").on('change', () => {
      if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
        const parent = this.elementSelected.parent;
        parent.setDbConfig({ playOnClick: $("#video_player_play_on_click").is(':checked') });
        this.autoSaveVideoPlayer();
      }
    });

    $("#video_player_transparent_background").on('change', () => {
      if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
        const parent = this.elementSelected.parent;
        parent.setDbConfig({ transparentBackground: $("#video_player_transparent_background").is(':checked') });
        this.autoSaveVideoPlayer();
      }
    });

    // Video upload is now handled by uploadVideo in videoPlayerVideoCallbackFunction
    // No need for manual change event handler

    $("#video_play_btn").on('click', () => {
      // Check if video player object is selected
      if (!this.elementSelected || !isVideoPlayerType(this.elementSelected.parent.name)) {
        this.model.alert("error", "No video player object selected");
        return;
      }

      const videoPlayer = this.elementSelected.parent;
      const videoUrl = $("#video_player_url").val();
      const videoTitle = $("#video_player_title").val();

      // Check if video URL exists
      if (!videoUrl) {
        this.model.alert("error", $trans('no-video-uploaded-yet'));
        return;
      }

      // Set video URL and title
      videoPlayer.setVideoUrl(videoUrl, videoTitle);

      // Open modal and play video
      videoPlayer.openModal();
    });

    $("#video_player_submit").on('click', () => {
      // TODO: Implement video player creation
      this._add3dObject('videoPlayer');
      $(".video-player-modal").removeClass("is-active");
    });

    $("#music_object_name").on('input', () => {
      if (this._getMusicObjectInstance()) {
        this.autoSaveMusicObject();
      }
    });

    $("#music_object_play_preview").on('click', () => {
      const musicObj = this._getMusicObjectInstance();
      if (!musicObj) {
        this.model.alert("error", "No music object selected");
        return;
      }
      const audioUrl = $("#music_object_audio_url").val();
      if (!audioUrl) {
        this.model.alert("error", $trans('no-audio-uploaded-yet'));
        return;
      }
      musicObj.playOnce?.();
      const audioEl = musicObj.audioEl;
      this._setMusicPreviewPlaying(true);
      if (audioEl) {
        if (this._musicPreviewEndedHandler) {
          audioEl.removeEventListener('ended', this._musicPreviewEndedHandler);
        }
        this._musicPreviewEndedHandler = () => {
          this._setMusicPreviewPlaying(false);
        };
        audioEl.addEventListener('ended', this._musicPreviewEndedHandler, { once: true });
      }
    });
    $("#music_object_stop_preview").on('click', () => {
      this._stopMusicObjectPreview();
    });
    $("#upload_musicObjectAudio_label").on('click', (e) => {
      e.preventDefault();
    });

    $(".video-player-modal .close-modal").on('click', () => {
      $(".video-player-modal").removeClass("is-active");
    });

    $('#upload_videoPlayerImage_label').on('click', () => {
      $('#upload_video_player_image').trigger('click');
    });

    $("#video_player_image").on('load', () => {
      this._syncVideoPlayerPlaceholderRemoveBtn();
    });

    $("#removeVideoPlayerPlaceholderImage").on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      const defaultSrc = '/textures/icons/edit_play_video.png';
      $("#video_player_image").attr('src', defaultSrc);
      $("#video_player_image_aspect_ratio").val('1');
      this._syncVideoPlayerPlaceholderRemoveBtn();

      if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
        const parent = this.elementSelected.parent;
        if (isVideoBackgroundType(parent.name)) {
          parent.clearPlaceholderImage(() => {
            this.autoSaveVideoPlayer();
          });
        } else {
          parent.videoPlayerImage = null;
          parent.updateMeshTexture(() => {
            this.autoSaveVideoPlayer();
          });
        }
      }
    });

    $("#use_link_icon").on('change', () => {
      this.toggleLinkIcon();
      if (this.elementSelected?.parent?.name === 'webLink' && !$('.link_holder').hasClass('is-active')) {
        $("#link_update").trigger('click');
      }
    });

    //LOAD LINK IMAGE
    $("#link_image").on('load', (e) => {
      const imageSizes = e.target.getBoundingClientRect();
      const aspectRatio = imageSizes.width / imageSizes.height;
      $("#link_image_aspect_ratio").val(aspectRatio);
      let imageSrc = $("#link_image").attr('src');
      if (imageSrc.includes('webLinkHotSpot.png')) {
        $('#upload_link_image .upload-thumb-removal').hide();
      } else {
        $('#upload_link_image .upload-thumb-removal').show();
      }
      $(".link_submit").removeClass("inactive");
      $("#link_update").trigger('click');
      if (this.elementSelected?.parent?.name === 'webLink' && !this.elementSelected.parent.useIcon) {
        this.elementSelected.parent.showDragHandles();
      }
    });
    //Remove link image
    $("#removeLinkThumbnail").on('click', (e) => {
      $('#link_image').attr('src', './textures/webLinkHotSpot.png');
      $('#link_image_aspect_ratio').val(1);
      $("#use_link_icon").prop('checked', true);
      this.toggleLinkIcon();
      if (!$('.link_holder').hasClass('is-active')) {
        this.elementSelected.parent.setDefaultTexture($('#link_image').attr('src'));
        $("#link_update").trigger('click');
      }
    });
    $('#link_url, #openLinkInNewWindow').on('change', () => {
      if (this?.elementSelected?.parent?.dbConfig?.image?.url) {
        this.elementSelected.parent.dbConfig.image.url = $("#link_url").val();
      }
      $("#link_update").trigger("click");
    });


    //Edit link hidden button
    $("#link_update").on("click", (e) => {
      if ($('.link_holder').hasClass('is-active')) { return }
      const parent = this.elementSelected.parent;
      const src = $("#link_image").attr("src");
      const aspectRatio = $("#link_image_aspect_ratio").val();
      const linkPath = $("#link_url").val();
      const openNewWindow = $("#openLinkInNewWindow").prop('checked');
      const useIcon = $("#use_link_icon").is(':checked');
      const isDefaultImage = !src || src.includes('webLinkHotSpot');
      const preservedUrl = parent.getCustomImageUrl?.() || parent.dbConfig?.image?.url || '';
      const hasPreservedImage = preservedUrl && !String(preservedUrl).includes('webLinkHotSpot');
      const imageUrl = useIcon
        ? (hasPreservedImage ? preservedUrl : '')
        : (isDefaultImage ? '' : src);
      const linkName = $("#link_component_name").val()?.trim() || undefined;
      const cornerSource = useIcon ? parent.dbConfig : parent.perspectivePosition;
      let config = {
        useIcon,
        'image': {
          'url': imageUrl,
          'aspectRatio': aspectRatio
        },
        'openNewWindow': openNewWindow,
        'url': linkPath,
        "topLeft": cornerSource["topLeft"]?.clone?.() || cornerSource["topLeft"],
        "topRight": cornerSource["topRight"]?.clone?.() || cornerSource["topRight"],
        "bottomRight": cornerSource["bottomRight"]?.clone?.() || cornerSource["bottomRight"],
        "bottomLeft": cornerSource["bottomLeft"]?.clone?.() || cornerSource["bottomLeft"],
      };
      if (linkName !== undefined) config.name = linkName;

      parent.setUseIcon?.(useIcon);
      parent.setDbConfig(config);
      this._syncWebLinkEditIndicator(parent);
      this.modifyLocalJSON(config);

      $(".perspective-settings").toggleClass('hidden', useIcon);
      this._refreshSizeDistanceControls?.(this.elementSelected);

      $(".link_holder").removeClass("is-active");
    });
    //Add ink btn
    $("#link_submit").on("click", () => {
      this._add3dObject('webLink');
      $(".link_holder").removeClass("is-active");
    });

    $('#create-screen-settings .radio-button input[type="radio"]').on('change', (e) => {
      if (e.target.checked) {
        if (!$('.add_screen_holder').hasClass('is-active')) {
          $('#save-screenStream-settings').trigger('click');
          if (this.countItemsInScene(SCENE_OBJECT_TYPES.screenStream) >= 1) {
            $(".add-screen").addClass("disabled");
          }
        }
      }
    });


    // show modal bagless room connect
    $('.add-bagless-room').on('click', () => {
      $("#bagless-room-dropdown-title").text($trans('select-scene-text'))
      $('#add_bagless_room_button').attr("disabled", true);
      $('#add_bagless_room_button').text($trans('add-text'));
      $('#add_bagless_room_button').attr("data-lang", "add-text");
      $('#bagless_room_preview_image').attr("src", "./textures/empty.png");
      this.showBaglessConnectModal();
    });

    $("#use_embedded_webpage_icon").on('change', () => {
      this.toggleEmbeddedWebpageIcon();
    });

    $("#use_gallery_icon").on('change', () => {
      this.toggleGalleryIcon();
    });

    $("#gallery_autoplay").on('change', () => {
      this._syncGalleryDurationRow();
      const parent = this.elementSelected?.parent;
      if (!parent || parent.name !== 'imageGallery') return;
      this._applyGalleryPlaybackSettings(parent);
      this.modifyLocalJSON(parent.getDbConfig());
    });

    $("#gallery_next_image_duration").on('change blur', () => {
      const parent = this.elementSelected?.parent;
      if (!parent || parent.name !== 'imageGallery') return;
      this._applyGalleryPlaybackSettings(parent);
      this.modifyLocalJSON(parent.getDbConfig());
    });

    $('#gallery_preview_custom_image .upload_image_label').on('click', (e) => {
      e.preventDefault();
      $('#upload_gallery_preview_image').trigger('click');
    });

    $("#removeGalleryPreviewImage").on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      const parent = this.elementSelected?.parent;
      if (!parent || parent.name !== 'imageGallery') return;
      parent.dbConfig.previewImage = { url: '', aspectRatio: 1 };
      const coverUrl = getGalleryCoverUrl(parent.getDbConfig()) || GALLERY_DEFAULT_ICON_PATH;
      $("#gallery_preview_image").attr('src', coverUrl);
      $("#removeGalleryPreviewImage").hide();
      if (!parent.useIcon) {
        parent.updateMeshTexture(() => {
          this.modifyLocalJSON(parent.getDbConfig());
        }, true);
      } else {
        this.modifyLocalJSON(parent.getDbConfig());
      }
    });

    $(".add-embedded-webpage").on("click", () => {
      $("#embedded-webpage-modal").removeClass("edit");

      $("#removeEmbeddedWebpageImage").trigger("click");
      $("#embedded-webpage-iframe-url").val("");
      $("#use_embedded_webpage_icon").prop('checked', true);
      $("#embedded-webpage-modal .modal-header-title").text($trans('add-embedded-webpage'));
      $("#embedded-webpage-modal .modal-header-title").attr('data-lang', 'add-embedded-webpage');
      this.toggleEmbeddedWebpageIcon();

      $("#embedded-webpage-modal").addClass("is-active");
    });

    $(".add-image-gallery").on("click", () => {
      //reset values
      $('#perspective_top_left-y').val(256) //
      $('#perspective_top_left-y').attr('min', 0);     // Set new minimum
      $('#perspective_top_left-y').attr('max', 512);

      $('#perspective_top_left-x').val(-256);
      $('#perspective_top_left-x').attr('min', -512);
      $('#perspective_top_left-x').attr('max', 0);

      $('#perspective_top_right-y').val(256);
      $('#perspective_top_right-y').attr('min', 0);
      $('#perspective_top_right-y').attr('max', 512);

      $('#perspective_top_right-x').val(256)
      $('#perspective_top_right-x').attr('min', 0);
      $('#perspective_top_right-x').attr('max', 512);

      $('#perspective_bottom_right-y').val(-256)
      $('#perspective_bottom_right-y').attr('min', -512);
      $('#perspective_bottom_right-y').attr('max', 0);

      $('#perspective_bottom_right-x').val(256)
      $('#perspective_bottom_right-x').attr('min', 0);
      $('#perspective_bottom_right-x').attr('max', 512);

      $('#perspective_bottom_left-y').val(-256)
      $('#perspective_bottom_left-y').attr('min', -512);
      $('#perspective_bottom_left-y').attr('max', 0);

      $('#perspective_bottom_left-x').attr('min', -512);
      $('#perspective_bottom_left-x').attr('max', 0);
      $('#perspective_bottom_left-x').val(-256)

      this._add3dObject('imageGallery');
    });

    $(".add-video-player").on("click", () => {
      this._add3dObject('videoPlayer');
    });

    $(".add-video-player-webgl").on("click", () => {
      this._add3dObject('videoPlayerWebGL');
    });

    $(".add-vr-music-object").on("click", () => {
      this._add3dObject('vrMusicObject');
    });

    $(".add-vr-invisible-action, .add-invisible-action, .add-vrInvisibleAction").on("click", () => {
      this._add3dObject('vrInvisibleAction');
    });

    $("#add-embedded-webpage-element").on("click", () => {
      this._add3dObject('embeddedWebpage');
    });

    $(".add-info-element").on("click", () => {
      $("#info-element-title").val('');
      $("#info-element-description1").html('');
      $("#info-element-button-text").val('');
      $("#info-element-button-url").val('');
      $("#info_element_image").attr('src', 'textures/empty.png');
      $("#upload_info_element_image .upload-watermark").removeClass("hide");
      $("#removeInfoElementImage").removeClass("active");
      $("#locationButton").val($("#locationButton option:first").val());
      $(".locationButton .select-selected").text('');

      // Initialize Quill editor if not already initialized
      if (!this.infoElementQuill) {
        this.infoElementQuill = initQuillEditor("#info-element-description1", {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'link'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['clean']
            ]
          },
          placeholder: 'Enter description...'
        });
      } else {
        setQuillContent("#info-element-description1", '');
      }

      $("#info-element-modal").addClass("is-active");
      $(".info-element-modal").removeClass("edit");
    });

    $("#add-info-element").on("click", () => {
      this._add3dObject('infoElement');
    });

    $("#update-info-element").on("click", () => {
      const formData = this.validateInfoForm();

      if (formData.error) {
        return;
      }

      const { layout, data } = formData;
      const name = (data?.title || '').trim() || undefined;

      this.elementSelected.parent.setDbConfig({ layout, data, name });
      this.modifyLocalJSON({ layout, data, name });

      $("#info-element-modal").removeClass("is-active");
    });

    $(".add-input-field-guess").on("click", () => {
      $("#input-field-guess-title").val('');
      $("#input-field-guess-body").val('');
      $("#input-field-guess-correct-answer").val('');
      $("#input-field-guess-correct-answer").attr('placeholder', $trans('input-field-guess-answer-placeholder'));
      $("#input-field-guess-modal").addClass("is-active");
      $(".input-field-guess-modal").removeClass("edit");
    });

    $("#add-input-field-guess").on("click", () => {
      const formData = this.validateInputFieldGuessForm();
      if (formData.error) return;

      const unique_id = uuidv4();
      const dir = new Vector3();
      this.camera.getWorldDirection(dir);
      const pos = this.camera.position.clone().addScaledVector(dir, 540);
      const position = { x: pos.x, y: pos.y, z: pos.z };
      const { title, bodyText, correctAnswer } = formData;

      const obj = new VRInputFieldGuess({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position,
        id: unique_id,
        dbConfig: { title, bodyText, timePreset: '', autocloseOnTrue: false, autocloseOnFalse: false },
        editMode: true,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
      });
      const dbConfig = generate_template('inputFieldGuess', { unique_id, title, bodyText, timePreset: '' });
      obj.setDbConfig(dbConfig);
      this.interactionGroup.add(obj.anchor);
      const anchorParent = obj.anchor.parent;
      if (anchorParent) {
        const worldPos = new Vector3(position.x, position.y, position.z);
        anchorParent.worldToLocal(worldPos);
        obj.anchor.position.copy(worldPos);
      }
      this.interactionGroup.updateMatrixWorld(true);
      if (!this.inputFieldGuessElementsInScene) this.inputFieldGuessElementsInScene = [];
      this.inputFieldGuessElementsInScene.push(obj);
      this.updateJSON(obj.anchor, dbConfig);
      distanceRange.value = 0;
      this.objectsInScene.push(obj.mesh);
      this.openSidebar && this.updateElementsInScene();

      if (correctAnswer && this.worldID) {
        this.model.worldFetcher.saveInputFieldGuessAnswer(
          this.worldID,
          unique_id,
          correctAnswer,
          () => { },
          (e) => console.warn('[InputFieldGuess] saveAnswer failed', e)
        );
      }

      $("#input-field-guess-modal").removeClass("is-active");
    });

    $("#update-input-field-guess").on("click", () => {
      const formData = this.validateInputFieldGuessForm();
      if (formData.error) {
        return;
      }

      const { title, bodyText, correctAnswer } = formData;
      const name = title.trim() || undefined;
      const guess = this.elementSelected?.type === 'inputFieldGuess'
        ? this.elementSelected
        : this.elementSelected?.parent;
      const objectId = guess?.getId?.();

      guess?.setDbConfig?.({ title, bodyText, name });
      this.modifyLocalJSON({ title, bodyText, name });
      if (guess?.anchor) this.updateJSON(guess.anchor, null);

      if (correctAnswer && this.worldID && objectId) {
        this.model.worldFetcher.saveInputFieldGuessAnswer(
          this.worldID,
          objectId,
          correctAnswer,
          () => { },
          (e) => console.warn('[InputFieldGuess] saveAnswer failed', e)
        );
      }

      $("#input-field-guess-modal").removeClass("is-active");
    });

    $(".add-input-field").on("click", () => {
      $("#input-field-title").val('');
      $("#input-field-body").val('');
      $("#input-field-placeholder").val('');
      $("#input-field-key").val('');
      $("#input-field-funnel-step").val('');
      $("#input-field-validation").val('required');
      $("#input-field-min-length").val('1');
      $("#input-field-min-length-row").hide();
      $("#input-field-modal").addClass("is-active");
      $(".input-field-modal").removeClass("edit");
    });

    $("#input-field-validation").on("change", () => {
      $("#input-field-min-length-row").toggle($("#input-field-validation").val() === 'minLength');
    });

    $("#add-input-field").on("click", () => {
      const formData = this.validateInputFieldForm();
      if (formData.error) return;

      const unique_id = uuidv4();
      const dir = new Vector3();
      this.camera.getWorldDirection(dir);
      const pos = this.camera.position.clone().addScaledVector(dir, 540);
      const position = { x: pos.x, y: pos.y, z: pos.z };
      const { title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength } = formData;

      const obj = new VRInputField({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position,
        id: unique_id,
        dbConfig: { title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength, autocloseOnSubmit: true },
        editMode: true,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
      });
      const dbConfig = generate_template('inputField', { unique_id, title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength });
      obj.setDbConfig(dbConfig);
      this.interactionGroup.add(obj.anchor);
      const anchorParent = obj.anchor.parent;
      if (anchorParent) {
        const worldPos = new Vector3(position.x, position.y, position.z);
        anchorParent.worldToLocal(worldPos);
        obj.anchor.position.copy(worldPos);
      }
      this.interactionGroup.updateMatrixWorld(true);
      if (!this.inputFieldElementsInScene) this.inputFieldElementsInScene = [];
      this.inputFieldElementsInScene.push(obj);
      this.updateJSON(obj.anchor, dbConfig);
      distanceRange.value = 0;
      this.objectsInScene.push(obj.mesh);
      this.openSidebar && this.updateElementsInScene();

      $("#input-field-modal").removeClass("is-active");
    });

    $("#update-input-field").on("click", () => {
      const formData = this.validateInputFieldForm();
      if (formData.error) return;

      const { title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength } = formData;
      const name = title.trim() || undefined;
      const input = this.elementSelected?.type === 'inputField'
        ? this.elementSelected
        : this.elementSelected?.parent;
      input?.setDbConfig?.({ title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength, name });
      this.modifyLocalJSON({ title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength, name });
      if (input?.anchor) this.updateJSON(input.anchor, null);
      $("#input-field-modal").removeClass("is-active");
    });

    $("#update-embedded-webpage-element").on("click", () => {
      const formData = this.validateEmbeddedWebpage();

      if (formData.error) {
        return;
      }

      const parent = this.elementSelected?.parent;
      if (!parent || parent.name !== 'embeddedWebpage') return;

      const useIcon = formData.useIcon;
      const preservedUrl = parent.getCustomImageUrl?.() || parent.dbConfig?.image?.url || '';
      const hasPreservedImage = preservedUrl && !String(preservedUrl).includes('empty.png');
      const imageUrl = useIcon
        ? (hasPreservedImage ? preservedUrl : '')
        : formData.imageSrc;
      const image = { url: imageUrl, aspectRatio: formData.imageAspectRatio };
      const obj = { iframe: formData.iframe, useIcon, image };

      parent.setUseIcon?.(useIcon);
      parent.setDbConfig(obj);
      this._syncEmbeddedWebpageEditIndicator(parent);
      this.modifyLocalJSON(obj);
      this._refreshSizeDistanceControls?.(this.elementSelected);

      closeTinyMCEMoreMenu();
      $("#embedded-webpage-modal").removeClass("is-active");
    });

    $("#bagless-room-dropdown").on("click", () => {
      $("#bagless-room-dropdown-menu").toggleClass("is-active");
      if ($("#bagless-room-dropdown-menu").hasClass("is-active")) {
        document.querySelector("#search-bagless-room").focus();
      }
    });

    $("#bagless-scene-dropdown").on("click", () => {
      $("#bagless-scene-dropdown-menu").show();
      $("#bagless-scene-dropdown-menu").addClass("is-active");
    });

    // ADD / UPDATE SHOP OFFERS
    $('.add-products').on('click', () => {
      this.showProductsModal();
    });

    $("#profile_submit").on("click", () => {
      this._add3dObject('profile');
      $(".profile_holder").removeClass("is-active");
    });

    $("#profile_update").on("click", () => {
      const parent = this.elementSelected.parent;
      const dynamicProfileAvatar = $("#dynamicProfileAvatar").prop("checked");
      const imagePath = $("#profile_image").attr("src");

      imagePath !== this.ownerAvatarURL && parent.updateTexture(imagePath);
      const configProfile = { avatarImage: { mediumPath: imagePath }, dynamicProfileAvatar };

      parent.setDbConfig({ profile: configProfile });
      this.modifyLocalJSON({ profile: configProfile });

      $(".profile_holder").removeClass("is-active");
    });

    // ADD YOUTUBE VIDEO GHOST
    $('.add-yt-video').on('click', () => {
      this._add3dObject('youtube');
    });

    $("#youtube_id").on("change", () => {
      if ($('.video_holder').hasClass('is-active')) { return }

      let vidId = $('#youtube_id').val();
      if (vidId.length) {
        $('#yt_video_update').trigger('click');
      } else {
        $('#youtube_id').css('box-shadow', '0 2px 2px #e91e1e');
      }
    });

    $('#yt_video_update').on('click', () => {
      let vidId = $('#youtube_id').val();
      if (vidId.length) {
        $('#youtube_id').css('box-shadow', '');

        let yt_id = vidId.replace('https://www.youtube.com/watch?v=', '');
        const parent = this.elementSelected.parent;
        const newData = { "video_id": yt_id }

        parent.setPosterSrc(yt_id);
        parent.setDbConfig(newData);

        this.modifyLocalJSON(newData);

      } else {
        $('#youtube_id').css('box-shadow', '0 2px 2px #e91e1e');
      }

    });

    // ADD IFRAME AGENT
    $('.add-iframe-agent').on('click', () => {
      this._add3dObject('iframeElement');
    });

    // ADD TIMER ELEMENT
    $('.add-timer-element').on('click', () => {
      this._add3dObject('timerElement');
    });

    $(".iframe_holder .modal-background, .iframe_holder .close-modal").on("click", () => {
      $(".iframe_holder").removeClass("is-active");
    });

    $(".timer_holder .modal-background, .timer_holder .close-modal").on("click", () => {
      $(".timer_holder").removeClass("is-active");
    });

    $(".connect_event_holder .modal-background, .connect_event_holder .close-modal").on("click", () => {
      $(".connect_event_holder").removeClass("is-active");
      this._editingConnectEventId = null;
    });

    $(".add_bind_action_holder .modal-background, .add_bind_action_holder .close-modal").on("click", () => {
      $(".add_bind_action_holder").removeClass("is-active");
    });

    $(document).on('click', '.add-bind-action-btn', (e) => {
      e.stopPropagation();
      this._openBindActionModal();
    });

    $('#bind_action_type').on('change', () => {
      const action = $('#bind_action_type').val();
      const targetType = this._getSelectedEventObjectType() || '';
      const isImageGallery = targetType === 'imageGallery';
      if (action === 'showImage' && isImageGallery) {
        $('#bind_action_image_index_panel').show();
        $('#bind_action_command_select_panel').hide();
        $('#bind_action_input_field_panel').hide();
        $('#bind_action_command_select').val('').find('option:not(:first)').remove();
        this._populateBindActionImageIndex();
      } else if (action === 'sendCommand' && targetType === 'vraiAgent') {
        $('#bind_action_image_index_panel').hide();
        $('#bind_action_input_field_panel').hide();
        $('#bind_action_command_select_panel').show();
        this._populateBindActionAgentCommands();
      } else if (action === 'openInputField' && targetType === 'vraiAgent') {
        $('#bind_action_image_index_panel').hide();
        $('#bind_action_command_select_panel').hide();
        $('#bind_action_command_select').val('').find('option:not(:first)').remove();
        this._populateInputFieldSelect($('#bind_action_input_field'));
        $('#bind_action_input_field_panel').show();
      } else {
        $('#bind_action_image_index_panel').hide();
        $('#bind_action_command_select_panel').hide();
        $('#bind_action_input_field_panel').hide();
        $('#bind_action_command_select').val('').find('option:not(:first)').remove();
      }
    });

    $('#bind_action_trigger_component').on('change', () => {
      const opt = $('#bind_action_trigger_component option:selected');
      const triggerType = opt.data('type') || 'webLink';
      this._populateBindActionTriggerEvents(triggerType);
    });

    $('#bind_action_save').on('click', () => {
      const action = $('#bind_action_type').val();
      const triggerId = $('#bind_action_trigger_component').val();
      const triggerEvent = $('#bind_action_trigger_event').val();
      const targetId = this._connectEventSourceId;
      const targetType = this._getSelectedEventObjectType() || 'webLink';
      if (!targetId || !triggerEvent || !triggerId || !action) return;
      const sceneId = this.currentScene?.id || '';
      let actionParams = null;
      if (action === 'showImage') {
        const imageIndex = $('#bind_action_image_index').val();
        if (imageIndex !== '' && imageIndex !== undefined) {
          actionParams = JSON.stringify({ imageIndex: parseInt(imageIndex, 10) });
        }
      } else if (action === 'sendCommand' && targetType === 'vraiAgent') {
        const selectedButtonId = ($('#bind_action_command_select').val() || '').trim();
        const buttons = (this.currentScene?.objects || []).filter((o) =>
          String(o?.type) === 'vapiButton' && String(o?.vapiAgentId) === String(targetId)
        );
        const selectedButton = buttons.find((b) => String(b.id) === String(selectedButtonId));
        if (!selectedButton) {
          this.model.alert?.('error', $trans('connect-event-select-command') || 'Please select a command');
          return;
        }
        const commandText = String(selectedButton.commandText || selectedButton.action || '').trim();
        const commandName = String(selectedButton.commandName || selectedButton.label || selectedButton.name || commandText || '').trim();
        if (!commandText) {
          this.model.alert?.('error', $trans('connect-event-empty-command') || 'Selected command is empty');
          return;
        }
        actionParams = JSON.stringify({ commandButtonId: selectedButton.id, commandName, commandText });
      } else if (action === 'openInputField' && targetType === 'vraiAgent') {
        const selected = this._readInputFieldSelectParams($('#bind_action_input_field'));
        if (!selected) {
          this.model.alert?.('error', $trans('connect-event-select-input-field') || 'Please select an input field');
          return;
        }
        actionParams = JSON.stringify(selected);
      }
      const payload = { worldId: this.worldID, sceneId, sourceObjectId: triggerId, eventType: triggerEvent, targetObjectId: targetId, targetObjectType: targetType || '', action };
      if (actionParams) payload.actionParams = actionParams;
      this.model.worldFetcher.createWorldEvent(
        payload,
        (res) => {
          if (res?.event?.id) {
            this.model.worldEvents = this.model.worldEvents || [];
            const record = { id: res.event.id, world_id: this.worldID, scene_id: sceneId, source_object_id: triggerId, event_type: triggerEvent, target_object_id: targetId, target_object_type: targetType || '', action };
            if (actionParams) record.action_params = actionParams;
            this.model.worldEvents.push(record);
            this._renderObjectEventsList();
            this._renderShowHideItems();
            this._renderSceneEventsList();
            this.updateDB();
          }
          $('.add_bind_action_holder').removeClass('is-active');
        },
        (e) => { this.model.alert?.('error', (e?.response?.data?.error) || 'Failed to add'); }
      );
    });

    $(document).on('click', '.object-settings-tab-events .object-event-show-hide-item .ai-agent-delete', (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
      const $item = $(e.currentTarget).closest('.object-event-show-hide-item');
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      this._deleteWorldEventById(eventId, $item);
    });

    $(document).on('click', '.object-settings-tab-events .object-event-image-action-item .ai-agent-delete', (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
      const $item = $(e.currentTarget).closest('.object-event-image-action-item');
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      this._deleteWorldEventById(eventId, $item);
    });

    $(document).on('click', '.add-object-event', (e) => {
      const eventType = $(e.currentTarget).data('event');
      this._openConnectEventModal(eventType);
    });

    $(document).on('click', '.add-scene-event', (e) => {
      e.stopPropagation();
      this._openSceneConnectEventModal();
    });

    $(document).on('click', '.scene-events-list .object-event-item .ai-agent-edit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const $item = $(e.currentTarget).closest('.object-event-item');
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      this._openEditSceneConnectEventModal(eventId);
    });

    $(document).on('click', '.scene-events-list .object-event-item .ai-agent-delete', (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
      const $item = $(e.currentTarget).closest('.object-event-item');
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      this._deleteWorldEventById(eventId, $item);
    });

    $(document).on('click', '.object-settings-tab-events .object-event-item .ai-agent-edit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const $item = $(e.currentTarget).closest('.object-event-item');
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      const currentEvent = (this.model.worldEvents || []).find((ev) => String(ev.id) === String(eventId));
      const sceneId = this.currentScene?.id || '';
      if (currentEvent && isSceneLevelSource(currentEvent.source_object_id, sceneId)) {
        this._openEditSceneConnectEventModal(eventId);
      } else {
        this._openEditConnectEventModal(eventId);
      }
    });

    $('#connect_event_source_component').on('change', () => {
      const opt = $('#connect_event_source_component option:selected');
      const sourceType = opt.data('type') || 'webLink';
      const sourceId = $('#connect_event_source_component').val();
      this._connectEventSourceId = sourceId;
      this._connectEventSourceType = sourceType;
      this._populateConnectEventTypes(sourceType);
    });

    $('#connect_event_component').on('change', () => {
      this._populateConnectEventActions();
      $('#connect_event_agent_panel').hide();
      $('#connect_event_library_agent').val('');
      $('#connect_event_image_index_panel').hide();
      $('#connect_event_command_panel').hide();
      $('#connect_event_command_select_panel').hide();
      $('#connect_event_command_select').val('').find('option:not(:first)').remove();
      $('#connect_event_command_text').val('');
      $('#connect_event_input_field_panel').hide();
      $('#connect_event_input_field').val('').find('option:not(:first)').remove();
    });

    $('#connect_event_action').on('change', () => {
      const actionId = $('#connect_event_action').val();
      const componentOpt = $('#connect_event_component option:selected');
      const targetType = componentOpt.data('type');
      $('#connect_event_input_field_panel').hide();
      if (actionId === 'switchAgent' && targetType === 'vraiAgent') {
        this._populateConnectEventLibraryAgents();
        $('#connect_event_agent_panel').show();
        $('#connect_event_image_index_panel').hide();
        $('#connect_event_command_panel').hide();
        $('#connect_event_command_select_panel').hide();
        $('#connect_event_command_select').val('').find('option:not(:first)').remove();
        $('#connect_event_command_text').val('');
      } else if (actionId === 'showImage' && targetType === 'imageGallery') {
        $('#connect_event_agent_panel').hide();
        this._populateConnectEventImageIndex();
        $('#connect_event_image_index_panel').show();
        $('#connect_event_command_panel').hide();
        $('#connect_event_command_select_panel').hide();
        $('#connect_event_command_select').val('').find('option:not(:first)').remove();
        $('#connect_event_command_text').val('');
      } else if (actionId === 'sendCommand' && targetType === 'vraiAgent') {
        $('#connect_event_agent_panel').hide();
        $('#connect_event_image_index_panel').hide();
        $('#connect_event_command_panel').hide();
        $('#connect_event_command_select_panel').show();
        const componentId = $('#connect_event_component').val();
        this._populateConnectEventAgentCommands(componentId);
        $('#connect_event_command_text').val('');
      } else if (actionId === 'sendCommand' && (targetType === 'vapiUserCamera' || targetType === 'vapiButton')) {
        $('#connect_event_agent_panel').hide();
        $('#connect_event_image_index_panel').hide();
        $('#connect_event_command_select_panel').hide();
        $('#connect_event_command_select').val('').find('option:not(:first)').remove();
        $('#connect_event_command_panel').show();
        const componentId = $('#connect_event_component').val();
        const targetObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(componentId));
        $('#connect_event_command_text').val(targetObj?.commandText || targetObj?.action || '');
      } else if (actionId === 'openInputField' && targetType === 'vraiAgent') {
        $('#connect_event_agent_panel').hide();
        $('#connect_event_image_index_panel').hide();
        $('#connect_event_command_panel').hide();
        $('#connect_event_command_select_panel').hide();
        $('#connect_event_command_select').val('').find('option:not(:first)').remove();
        $('#connect_event_command_text').val('');
        this._populateInputFieldSelect($('#connect_event_input_field'));
        $('#connect_event_input_field_panel').show();
      } else {
        $('#connect_event_agent_panel').hide();
        $('#connect_event_image_index_panel').hide();
        $('#connect_event_command_panel').hide();
        $('#connect_event_command_select_panel').hide();
        $('#connect_event_command_select').val('').find('option:not(:first)').remove();
        $('#connect_event_command_text').val('');
      }
    });

    $('#connect_event_submit').on('click', () => {
      const componentId = $('#connect_event_component').val();
      const actionId = $('#connect_event_action').val();
      const eventType = $('#connect_event_type').val();
      const sourceId = $('#connect_event_source_component').val() || this._connectEventSourceId;
      if (!componentId || !actionId || !eventType || !sourceId) return;
      const componentOpt = $('#connect_event_component option:selected');
      const targetType = componentOpt.data('type');
      const sceneId = this.currentScene?.id || '';

      let actionParams = null;
      if (actionId === 'switchAgent' && targetType === 'vraiAgent') {
        const libraryId = $('#connect_event_library_agent').val();
        const fullConfig = this._connectEventLibraryConfigs?.[libraryId] || this._connectEventLibraryConfigs?.[String(libraryId)];
        const agentName = $('#connect_event_library_agent option:selected').text();
        if (!fullConfig?.VAPI_ASSISTANT_ID) {
          this.model.alert?.('error', $trans('connect-event-select-agent') || 'Please select an AI agent from your library');
          return;
        }
        const libIdNum = parseInt(libraryId, 10);
        actionParams = JSON.stringify({
          ...fullConfig,
          name: agentName,
          libraryId: libIdNum,
          vapiLibraryId: libIdNum,
        });
      } else if (actionId === 'showImage' && targetType === 'imageGallery') {
        const imageIndex = $('#connect_event_image_index').val();
        if (imageIndex !== '' && imageIndex !== undefined) {
          actionParams = JSON.stringify({ imageIndex: parseInt(imageIndex, 10) });
        }
      } else if (actionId === 'sendCommand' && targetType === 'vraiAgent') {
        const selectedButtonId = ($('#connect_event_command_select').val() || '').trim();
        const buttons = (this.currentScene?.objects || []).filter((o) => String(o?.type) === 'vapiButton' && String(o?.vapiAgentId) === String(componentId));
        const selectedButton = buttons.find((b) => String(b.id) === String(selectedButtonId));
        if (!selectedButton) {
          this.model.alert?.('error', $trans('connect-event-select-command') || 'Please select a command');
          return;
        }
        const commandText = String(selectedButton.commandText || selectedButton.action || '').trim();
        const commandName = String(selectedButton.commandName || selectedButton.label || selectedButton.name || commandText || '').trim();
        if (!commandText) {
          this.model.alert?.('error', $trans('connect-event-empty-command') || 'Selected command is empty');
          return;
        }
        actionParams = JSON.stringify({ commandButtonId: selectedButton.id, commandName, commandText });
      } else if (actionId === 'sendCommand' && (targetType === 'vapiUserCamera' || targetType === 'vapiButton')) {
        const commandText = ($('#connect_event_command_text').val() || '').trim();
        const targetObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(componentId));
        const commandName = String(targetObj?.commandName || targetObj?.label || targetObj?.chairName || targetObj?.name || '').trim();
        if (commandText) actionParams = JSON.stringify({ commandName, commandText });
      } else if (actionId === 'openInputField' && targetType === 'vraiAgent') {
        const selected = this._readInputFieldSelectParams($('#connect_event_input_field'));
        if (!selected) {
          this.model.alert?.('error', $trans('connect-event-select-input-field') || 'Please select an input field');
          return;
        }
        actionParams = JSON.stringify(selected);
      }

      const eventPayload = { worldId: this.worldID, sceneId, sourceObjectId: sourceId, eventType: eventType || 'click', targetObjectId: componentId, targetObjectType: targetType, action: actionId };
      if (actionParams) eventPayload.actionParams = actionParams;
      const editingEventId = this._editingConnectEventId;
      this.model.worldFetcher.createWorldEvent(
        eventPayload,
        (res) => {
          if (res?.event?.id) {
            const eventData = {
              id: res.event.id,
              world_id: this.worldID,
              scene_id: sceneId,
              source_object_id: sourceId,
              event_type: eventType || 'click',
              target_object_id: componentId,
              target_object_type: targetType,
              action: actionId,
              action_params: actionParams,
            };
            const applyLocalUpdate = () => {
              this.model.worldEvents = this.model.worldEvents || [];
              this.model.worldEvents.push(eventData);
              this._renderObjectEventsList();
              this._renderSceneEventsList();
              this._editingConnectEventId = null;
              $('.connect_event_holder').removeClass('is-active');
              this.updateDB();
            };
            if (editingEventId) {
              this.model.worldFetcher.deleteWorldEvent(
                this.worldID,
                editingEventId,
                () => {
                  this.model.worldEvents = (this.model.worldEvents || []).filter((ev) => String(ev.id) !== String(editingEventId));
                  applyLocalUpdate();
                },
                (err) => {
                  // Roll back newly created replacement event if old one cannot be removed.
                  this.model.worldFetcher.deleteWorldEvent(this.worldID, res.event.id, () => { }, () => { });
                  this.model.alert?.('error', err?.response?.data?.error || 'Failed to update event');
                }
              );
              return;
            }
            applyLocalUpdate();
          }
        },
        (e) => {
          this.model.alert?.('error', (e?.response?.data?.error) || 'Failed to add event');
        }
      );
    });

    $(document).on('click', '.object-settings-tab-events .object-event-item .ai-agent-delete', (e) => {
      e.stopPropagation();
      const $item = $(e.currentTarget).closest('.object-event-item');
      if ($item.hasClass('object-event-show-hide-item') || $item.hasClass('object-event-image-action-item')) return;
      const eventId = parseInt($item.data('event-id'), 10) || $item.data('event-id');
      if (!eventId) return;
      this._deleteWorldEventById(eventId, $item);
    });

    $(".select_vapi_agent_holder .modal-background, .select_vapi_agent_holder .close-modal").on("click", () => {
      $(".select_vapi_agent_holder").removeClass("is-active");
    });

    $('#vapi_agent_create_new').on('click', () => {
      if (!this._canManageVapiComponents()) return;
      $('.select_vapi_agent_holder').removeClass('is-active');
      this._vapiAgentCreateFromSelect = true;
      $('.vrai_agent_holder').addClass('is-active');
    });

    $(document).on('click', '#toolbox .add-vapi-agent, .mini-tools-menu .add-vapi-agent', () => {
      if (!this._canManageVapiComponents()) return;
      this._vapiAddMode = 'toolbox';
      $('.vrai_agent_type_holder').addClass('is-active');
    });

    $('.assets-ai-agents-section .add-vapi-agent').on('click', () => {
      if (!this._canManageVapiComponents()) return;
      this._vapiAddMode = 'assets';
      $('.vrai_agent_type_holder').addClass('is-active');
    });

    // Type selection modal close
    $('.vrai_agent_type_holder .modal-background, .vrai_agent_type_holder .close-modal').on('click', () => {
      $('.vrai_agent_type_holder').removeClass('is-active');
    });

    // Type: Agent chosen
    $('#vrai_type_choose_agent').on('click', () => {
      $('.vrai_agent_type_holder').removeClass('is-active');
      if (this._vapiAddMode === 'toolbox') {
        this._openSelectVapiAgentModal();
      } else {
        // Assets panel — directly open create modal
        this._vapiAgentCreateFromSelect = false;
        $('#vrai_agent_chair_name').val('');
        $('#vrai_agent_chair_scenario').val('');
        $('#vrai_agent_assistant_id').val('');
        $('#vrai_agent_private_key').val('');
        $('.vrai_agent_holder .vrai_agent_image').attr('src', './textures/empty.png');
        this.vraiAgentImageUrl = '';
        $('#removeVraiAgentImage').removeClass('active');
        $('#vrai_agent_submit').show();
        $('#vrai_agent_update').hide();
        $('.vrai_agent_holder').addClass('is-active');
      }
    });

    // Type: Squad chosen
    $('#vrai_type_choose_squad').on('click', () => {
      $('.vrai_agent_type_holder').removeClass('is-active');
      this._openSquadCreateModal();
    });

    $(".vrai_agent_holder .modal-background, .vrai_agent_holder .close-modal").on("click", () => {
      $(".vrai_agent_holder").removeClass("is-active");
    });

    // Squad modal close
    $('.vrai_squad_holder .modal-background, .vrai_squad_holder .close-modal').on('click', () => {
      $('.vrai_squad_holder').removeClass('is-active');
    });

    // Squad: add member button
    $(document).on('click', '#squad_add_member', () => {
      if (this.squadActiveMembers >= 6) return;
      const nextSlot = $(`.squad-member-slot[data-member-index="${this.squadActiveMembers}"]`);
      nextSlot.css('display', 'flex').removeClass('squad-member-hidden');
      this.squadActiveMembers++;
      if (this.squadActiveMembers >= 6) {
        $('#squad_add_member').prop('disabled', true).css('opacity', '0.4');
      }
    });

    // Squad: remove member slot
    $(document).on('click', '.squad-member-remove-btn', (e) => {
      const mi = parseInt($(e.currentTarget).data('member-index'), 10);
      $(`.squad-member-slot[data-member-index="${mi}"]`).css('display', 'none').addClass('squad-member-hidden');
      $(`#squad_member_name_${mi}`).val('');
      $(`#squad_member_scenario_${mi}`).val('');
      $(`#squad_member_img_${mi}`).attr('src', './textures/empty.png');
      this.squadMemberImages[mi] = '';
      this.squadActiveMembers = Math.max(1, this.squadActiveMembers - 1);
      $('#squad_add_member').prop('disabled', false).css('opacity', '1');
    });

    // Squad: remove member image
    $(document).on('click', '.squad-member-remove-img', (e) => {
      e.stopPropagation();
      const mi = parseInt($(e.currentTarget).data('member-index'), 10);
      $(`#squad_member_img_${mi}`).attr('src', './textures/empty.png');
      this.squadMemberImages[mi] = '';
      $(e.currentTarget).hide();
    });

    // Squad: custom variables JSON validation
    $(document).on('input', '#squad_custom_variables', () => {
      const val = $('#squad_custom_variables').val().trim();
      const errEl = $('#squad_custom_variables_error');
      if (!val) { errEl.hide(); return; }
      try { JSON.parse(val); errEl.hide(); } catch (e) { errEl.show(); }
    });

    // Squad: submit
    $('#squad_agent_submit').on('click', () => {
      if (!this._canManageVapiComponents()) return;
      const squadName = $('#squad_agent_name').val().trim();
      const squadId = $('#squad_vapi_squad_id').val().trim();
      const privateKey = $('#squad_vapi_private_key').val().trim();
      if (!squadId || !privateKey) {
        this.model.alert && this.model.alert('error', ($trans && $trans('vrai-agent-required-fields')) || 'Squad ID and a private API key are required');
        return;
      }
      const customVarsRaw = $('#squad_custom_variables').val().trim();
      let squadCustomVariables = null;
      if (customVarsRaw) {
        try { squadCustomVariables = JSON.parse(customVarsRaw); }
        catch (e) {
          this.model.alert && this.model.alert('error', 'Custom variables JSON is invalid. Please fix the syntax.');
          return;
        }
      }
      // Collect visible member slots
      const squadMembers = [];
      let firstMemberImage = '';
      for (let mi = 0; mi < 6; mi++) {
        const slot = $(`.squad-member-slot[data-member-index="${mi}"]`);
        if (slot.css('display') === 'none' || slot.hasClass('squad-member-hidden')) continue;
        const name = $(`#squad_member_name_${mi}`).val().trim();
        const scenario = $(`#squad_member_scenario_${mi}`).val().trim();
        const image = this.squadMemberImages[mi] || '';
        if (!firstMemberImage && image) firstMemberImage = image;
        squadMembers.push({ name: name || `Agent ${mi + 1}`, scenario, image });
      }
      const agentConfig = { isSquad: true, VAPI_SQUAD_ID: squadId, squadMembers };
      if (squadCustomVariables) agentConfig.squadCustomVariables = squadCustomVariables;

      const onCreated = (libraryId) => {
        if (this._vapiAgentCreateFromSelect && libraryId) {
          this._placeVapiAgentFromLibrary(libraryId);
        }
        $('.vrai_squad_holder').removeClass('is-active');
        this._resetSquadModal();
        this._vapiAgentCreateFromSelect = false;
        this._renderAiAgentsList();
      };
      this.model.worldFetcher.createVapiLibraryAgent(
        this.worldID,
        squadName || 'AI Squad',
        '',
        squadId,
        privateKey,
        firstMemberImage || '',
        (res) => { onCreated(res?.agent?.id || null); },
        (e) => { console.warn('[VAPI] createSquad failed', e); this.model.alert && this.model.alert('error', e?.response?.data?.error || 'Failed to create squad'); },
        agentConfig
      );
    });

    $(".edit_vapi_library_agent_holder .modal-background, .edit_vapi_library_agent_holder .close-modal").on("click", () => {
      $(".edit_vapi_library_agent_holder").removeClass("is-active");
    });

    $('#edit_vapi_library_submit').on('click', () => {
      const libraryId = parseInt($('#edit_vapi_library_id').val(), 10);
      const name = $('#edit_vapi_library_name').val().trim();
      const chairScenario = $('#edit_vapi_library_scenario').val().trim();
      const assistantId = $('#edit_vapi_library_assistant_id').val().trim();
      const agentImage = this.editVapiLibraryImageUrl || '';
      const privateKey = $('#edit_vapi_library_private_key').val().trim();
      if (!libraryId) return;
      if (!this.editVapiLibraryHasPrivateKey && !privateKey) {
        this.model.alert?.('error', $trans('vapi-library-key-missing') || 'No private key is saved. Paste one so calls can start.');
        return;
      }
      if (!assistantId) {
        this.model.alert?.('error', $trans('vrai-agent-required-fields') || 'Assistant ID is required');
        return;
      }
      this.model.worldFetcher.updateVapiLibraryAgent(
        this.worldID,
        libraryId,
        name || 'AI Agent',
        chairScenario,
        agentImage,
        assistantId,
        () => {
          $('#vrai_agent_chair_name_edit').val(name || '');
          $('#vrai_agent_chair_scenario_edit').val(chairScenario || '');
          const patch = {
            chairName: name || undefined,
            chairScenario: chairScenario || undefined,
            VAPI_ASSISTANT_ID: assistantId,
          };
          if (agentImage) patch.agent_image = agentImage;
          this._applyLibraryPatchToPlacedChairs(libraryId, patch);
          const chair = this._getSelectedVraiAgentChairForAgentSettings();
          if (chair && String((chair.getDbConfig?.() || chair.dbConfig || {}).vapiLibraryId) === String(libraryId)) {
            this._syncVraiChairLibraryFields(chair, { ...(chair.getDbConfig?.() || chair.dbConfig), ...patch });
          }
          $('#edit_vapi_library_private_key').val('');
          $('.edit_vapi_library_agent_holder').removeClass('is-active');
          this._renderAiAgentsList();
        },
        (e) => {
          this.model.alert?.('error', (e?.response?.data?.error) || 'Failed to update agent');
        },
        privateKey
      );
    });

    $('#vrai_agent_submit').on('click', () => {
      if (!this._canManageVapiComponents()) return;
      const assistantId = $('#vrai_agent_assistant_id').val().trim();
      const privateKey = $('#vrai_agent_private_key').val().trim();
      if (!assistantId || !privateKey) {
        this.model.alert && this.model.alert('error', $trans('vrai-agent-required-fields') || 'Assistant ID and a private API key are required');
        return;
      }
      const chairName = $('#vrai_agent_chair_name').val().trim();
      const chairScenario = $('#vrai_agent_chair_scenario').val().trim();
      const agentImage = this.vraiAgentImageUrl || '';

      const onCreated = (libraryId) => {
        if (this._vapiAgentCreateFromSelect && libraryId) {
          this._placeVapiAgentFromLibrary(libraryId);
        }
        $('.vrai_agent_holder').removeClass('is-active');
        $('#vrai_agent_assistant_id').val('');
        $('#vrai_agent_private_key').val('');
        $('#vrai_agent_chair_name').val('');
        $('#vrai_agent_chair_scenario').val('');
        $('.vrai_agent_holder .vrai_agent_image').attr('src', './textures/empty.png');
        this.vraiAgentImageUrl = '';
        $('#removeVraiAgentImage').removeClass('active');
        this._vapiAgentCreateFromSelect = false;
        this._renderAiAgentsList();
      };

      this.model.worldFetcher.createVapiLibraryAgent(
        this.worldID,
        chairName || 'AI Agent',
        chairScenario,
        assistantId,
        privateKey,
        this.vraiAgentImageUrl || '',
        (res) => {
          if (res && res.agent && res.agent.id) {
            onCreated(res.agent.id);
          } else {
            onCreated(null);
          }
        },
        (e) => {
          console.warn('[VAPI] createLibraryAgent failed', e);
          this.model.alert && this.model.alert('error', (e?.response?.data?.error) || 'Failed to save agent');
        },
        null
      );
    });



    $(document).on('click', '.vrai-settings-group-btn', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const groupType = $(e.currentTarget).data('vapi-group')
        || $(e.currentTarget).closest('.vrai-settings-group').data('vapi-group');
      if (!groupType) return;
      const $group = $(e.currentTarget).closest('.vrai-settings-group');
      if ($group.hasClass('is-unavailable')) return;
      const willOpen = !$group.hasClass('open');
      this._selectVapiSettingsGroup(groupType, { forceOpen: willOpen, allowCollapse: !willOpen });
    });

    $(document).on('click', '.vrai-prompt-expand-btn', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $(e.currentTarget).closest('.vrai-prompt-expand').toggleClass('open');
    });

    let _vapiRoomPromptSaveTimer = null;
    const saveVapiRoomPrompt = ({ trim = false, debounce = false } = {}) => {
      const chair = this._getChairForVapiSettingsGroups?.();
      if (!chair) return;
      let vapiRoomPrompt = $('#vrai_agent_room_prompt_edit').val() || '';
      if (trim) vapiRoomPrompt = vapiRoomPrompt.trim();
      chair.setDbConfig?.({ vapiRoomPrompt });
      const chairId = chair.getId?.() ?? chair.id;
      const sceneObj = this._findAgentSceneObject?.(chairId);
      if (sceneObj) {
        sceneObj.vapiRoomPrompt = vapiRoomPrompt;
        this.scenes[this.currentSceneIndex] = this.currentScene;
      }
      if (debounce) {
        clearTimeout(_vapiRoomPromptSaveTimer);
        _vapiRoomPromptSaveTimer = setTimeout(() => this.updateDB(), 400);
      } else {
        this.updateDB();
      }
    };
    $('#vrai_agent_room_prompt_edit').on('input', () => saveVapiRoomPrompt({ debounce: true }));
    $('#vrai_agent_room_prompt_edit').on('blur change', () => saveVapiRoomPrompt({ trim: true }));

    $('#vrai_component_agent_select').on('change', () => {
      if ($('#vrai_component_agent_select').prop('disabled')) return;
      const nextAgentId = $('#vrai_component_agent_select').val();
      const comp = this._getSelectedVapiComponentForAgentSettings();
      if (comp) {
        this._switchVapiComponentAgent(comp, nextAgentId);
        return;
      }
      const chair = this._getSelectedVraiAgentChairForAgentSettings();
      if (chair) this._switchVraiChairLibraryAgent(chair, nextAgentId);
    });

    $('#vrai_component_agent_edit_asset_btn').on('click', () => {
      const vapiComp = this._getSelectedVapiComponentForAgentSettings();
      if (vapiComp) {
        this._openLinkedAgentAssetFromComponent(vapiComp);
        return;
      }
      const chair = this._getSelectedVraiAgentChairForAgentSettings();
      this._openLibraryAssetForChair(chair);
    });

    $('#vrai_agent_update').on('click', () => {
      const parent = this._getSelectedVraiAgentChairForAgentSettings();
      if (!parent) return;
      const agentImageSrc = $('#vrai_agent_image_edit').attr('src') || '';
      const agentImage = (agentImageSrc && !agentImageSrc.includes('empty.png')) ? agentImageSrc : '';
      const libId = parent.dbConfig?.vapiLibraryId;
      let chairName; let chairScenario;
      if (libId) {
        chairName = $('#vrai_agent_chair_name_edit').val().trim() || $('#edit_vapi_library_name').val().trim();
        chairScenario = $('#vrai_agent_chair_scenario_edit').val().trim() || $('#edit_vapi_library_scenario').val().trim();
      } else {
        chairName = $('#vrai_agent_chair_name_edit').val().trim();
        chairScenario = $('#vrai_agent_chair_scenario_edit').val().trim();
      }
      const chairNameSize = parseFloat($('#vrai_chair_name_size').val()) || 0.75;
      const chairScenarioSize = parseFloat($('#vrai_chair_scenario_size').val()) || 0.65;
      const chairIndicatorSize = parseFloat($('#vrai_chair_indicator_size').val()) || 44;
      const chairStatusSize = parseFloat($('#vrai_chair_status_size').val()) || 0.85;
      const indicatorOffsetX = parseInt($('#vrai_chair_indicator_offset_x').val(), 10) || 0;
      const indicatorOffsetY = parseInt($('#vrai_chair_indicator_offset_y').val(), 10) || 0;
      const chairSize = parseFloat($('#size_range').val()) || parent.dbConfig?.size || 1;
      const newData = {
        chairName: chairName || undefined,
        chairScenario: chairScenario || undefined,
        chairNameSize,
        chairScenarioSize,
        chairIndicatorSize,
        chairStatusSize,
        size: chairSize,
        indicatorOffsetX,
        indicatorOffsetY,
        promptTranscriptModal: $('#prompt_transcript_modal_edit').prop('checked'),
        vapiRoomPrompt: ($('#vrai_agent_room_prompt_edit').val() || '').trim(),
        components: {
          chair: { ...(parent.dbConfig?.components?.chair || {}), active: true },
          camera: {
            ...(parent.dbConfig?.components?.camera || {}),
            active: $('#vrai_component_camera').prop('checked'),
            showUserAvatar: $('#vrai_component_show_user_avatar').prop('checked')
          },
          transcription: { ...(parent.dbConfig?.components?.transcription || {}), active: $('#vrai_component_transcription').prop('checked') }
        }
      };
      if (agentImage !== undefined) newData.agent_image = agentImage;
      parent.setDbConfig(newData);
      this.elementSelected = parent;
      this.modifyLocalJSON(newData);
      const chairIdForCam = parent.getId?.() ?? parent.id;
      const camAfterUpdate = this.vraiAgentCameras?.find(c => String(c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === String(chairIdForCam));
      camAfterUpdate?.refreshUserAvatarFallback?.();
    });


    $('#vrai_agent_chair_name_edit, #vrai_agent_chair_scenario_edit').on('blur change', () => {
      const parent = this._getSelectedVraiAgentChairForAgentSettings();
      if (!parent) return;
      if (parent.dbConfig?.vapiLibraryId) return;
      const chairName = $('#vrai_agent_chair_name_edit').val().trim();
      const chairScenario = $('#vrai_agent_chair_scenario_edit').val().trim();
      const newData = { chairName: chairName || undefined, chairScenario: chairScenario || undefined };
      parent.setDbConfig(newData);
      this.elementSelected = parent;
      this.modifyLocalJSON(newData);
    });

    $('#vrai_chair_name_size, #vrai_chair_scenario_size, #vrai_chair_indicator_size, #vrai_chair_status_size').on('input change', () => {
      const nameSize = parseFloat($('#vrai_chair_name_size').val()) || 0.75;
      const scenarioSize = parseFloat($('#vrai_chair_scenario_size').val()) || 0.65;
      const indicatorSize = parseFloat($('#vrai_chair_indicator_size').val()) || 44;
      const statusSize = parseFloat($('#vrai_chair_status_size').val()) || 0.85;
      $('#vrai_chair_name_size_val').text(nameSize);
      $('#vrai_chair_scenario_size_val').text(scenarioSize);
      $('#vrai_chair_indicator_size_val').text(indicatorSize);
      $('#vrai_chair_status_size_val').text(statusSize);
      const parent = this._getSelectedVraiAgentChairForAgentSettings();
      if (!parent) return;
      const newData = { chairNameSize: nameSize, chairScenarioSize: scenarioSize, chairIndicatorSize: indicatorSize, chairStatusSize: statusSize };
      parent.setDbConfig(newData);
      this.elementSelected = parent;
      this.modifyLocalJSON(newData);
      this.updateJSON(parent);
      this.updateDB();
    });

    $('#vrai_chair_indicator_offset_x, #vrai_chair_indicator_offset_y').on('input change', () => {
      const offsetX = parseInt($('#vrai_chair_indicator_offset_x').val(), 10) || 0;
      const offsetY = parseInt($('#vrai_chair_indicator_offset_y').val(), 10) || 0;
      $('#vrai_chair_indicator_offset_x_val').text(offsetX);
      $('#vrai_chair_indicator_offset_y_val').text(offsetY);
      const parent = this._getSelectedVraiAgentChairForAgentSettings();
      if (!parent) return;
      const newData = { indicatorOffsetX: offsetX, indicatorOffsetY: offsetY };
      parent.setDbConfig(newData);
      this.elementSelected = parent;
      this.modifyLocalJSON(newData);
      this.updateJSON(parent);
      this.updateDB();
    });

    const saveVraiComponentToggles = () => {
      if (!isVraiAgentParent(this.elementSelected?.parent)) return;
      const parent = this.elementSelected.parent;
      const chairId = parent.getId();
      const cameraEnabled = $('#vrai_component_camera').prop('checked');
      const transcriptionEnabled = $('#vrai_component_transcription').prop('checked');
      const showUserAvatar = $('#vrai_component_show_user_avatar').prop('checked');
      const components = {
        chair: { ...(parent.dbConfig?.components?.chair || {}), active: true },
        camera: { ...(parent.dbConfig?.components?.camera || {}), active: cameraEnabled, showUserAvatar },
        transcription: { ...(parent.dbConfig?.components?.transcription || {}), active: transcriptionEnabled }
      };
      parent.setDbConfig({ components });
      this.modifyLocalJSON({ components });

      if (cameraEnabled) {
        const existingCamera = this.currentScene.objects.find(o => o.type === 'vapiUserCamera' && o.vapiAgentId === chairId);
        if (!existingCamera) {
          const unique_id = uuidv4();
          const dir = new Vector3();
          this.camera.getWorldDirection(dir);
          const pos = this.camera.position.clone().addScaledVector(dir, 700);
          const position = { x: pos.x, y: pos.y, z: pos.z };
          const obj = new VRVapiCameraWithCSS3D({
            model: this.model,
            camera: this.camera,
            controls: this.controls,
            raycaster: this.raycaster,
            position,
            id: unique_id,
            dbConfig: { vapiAgentId: chairId },
            editMode: true,
            sizes: this.sizes,
            viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
          });
          obj.setDbConfig({ vapiAgentId: chairId });
          const dbConfig = generate_template('vapiUserCamera', { unique_id, vapiAgentId: chairId });
          dbConfig.x = position.x;
          dbConfig.y = position.y;
          dbConfig.z = position.z;
          this.interactionGroup.add(obj.anchor);
          const anchorParent = obj.anchor.parent;
          if (anchorParent) {
            const worldPos = new Vector3(position.x, position.y, position.z);
            anchorParent.worldToLocal(worldPos);
            obj.anchor.position.copy(worldPos);
          }
          // VRVapiCameraWithCSS3D now renders as CSS3DObject in scene.
          this.interactionGroup.updateMatrixWorld(true);
          if (this.vraiAgentCameras) this.vraiAgentCameras.push(obj);
          if (obj.mesh) this.objectsInScene.push(obj.mesh);
          this.currentScene.objects.push(dbConfig);
          this.updateDB();
          this.openSidebar && this.updateElementsInScene();
          ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
        }
      } else {
        const toRemove = this.currentScene.objects.filter(o => o.type === 'vapiUserCamera' && o.vapiAgentId === chairId);
        toRemove.forEach((sceneObj) => {
          const cam = this.vraiAgentCameras?.find(c => (c.id || c.getId?.()) === sceneObj.id);
          if (cam) {
            this._indicatorDomCache?.delete(cam.elementClass);
            this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== cam.anchor);
            cam.destroy?.();
            if (cam.anchor?.parent) cam.anchor.parent.remove(cam.anchor);
            this.vraiAgentCameras = this.vraiAgentCameras.filter(c => c !== cam);
            this.objectsInScene = this.objectsInScene.filter(el => el !== cam.mesh);
          }
          const cssEl = document.querySelector(`[data-id='vapi_camera2_${sceneObj.id}']`);
          cssEl?.remove?.();
          this.currentScene.objects = this.currentScene.objects.filter(o => o.id !== sceneObj.id);
        });
        this.updateDB();
        this.openSidebar && this.updateElementsInScene();
        ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
      }

      if (transcriptionEnabled) {
        const existingTranscription = this.currentScene.objects.find(o => o.type === 'vapiTranscription' && o.vapiAgentId === chairId);
        if (!existingTranscription) {
          const unique_id = uuidv4();
          const dir = new Vector3();
          this.camera.getWorldDirection(dir);
          const pos = this.camera.position.clone().addScaledVector(dir, 650);
          const position = { x: pos.x, y: pos.y, z: pos.z };
          const userColor = $('#transcription_color_user_hex').val?.()?.trim() || $('#transcription_color_user').val?.() || '#7dd3fc';
          const userRoleColor = $('#transcription_color_user_role_hex').val?.()?.trim() || $('#transcription_color_user_role').val?.() || '#ffffff';
          const aiColor = $('#transcription_color_ai_hex').val?.()?.trim() || $('#transcription_color_ai').val?.() || '#00d4aa';
          const aiRoleColor = $('#transcription_color_ai_role_hex').val?.()?.trim() || $('#transcription_color_ai_role').val?.() || '#00d4aa';
          const bgHex = $('#transcription_color_bg_hex').val?.()?.trim() || $('#transcription_color_bg').val?.() || 'transparent';
          const bgAlpha = $('#transcription_color_bg_alpha').val?.();
          const bgColor = (bgHex.toLowerCase() === 'transparent' && parseInt(bgAlpha, 10) <= 0) ? 'transparent' : this._buildBgColor(this._hexFromColor(bgHex), bgAlpha);
          const preset = $('#transcription_preset').val?.() || 'landscape';
          const width = $('#transcription_width').val?.()?.trim();
          const height = $('#transcription_height').val?.()?.trim();
          const sizeProps = { transcriptionPreset: preset };
          if (width) sizeProps.transcriptionWidth = parseInt(width, 10);
          else sizeProps.transcriptionWidth = undefined;
          if (height) sizeProps.transcriptionHeight = parseInt(height, 10);
          else sizeProps.transcriptionHeight = undefined;
          const colors = { transcriptionUserColor: userColor, transcriptionUserRoleColor: userRoleColor, transcriptionAIColor: aiColor, transcriptionAIRoleColor: aiRoleColor, transcriptionBackgroundColor: bgColor, ...sizeProps };
          const obj = new VRVapiTranscriptionWithCSS3D({
            model: this.model,
            camera: this.camera,
            controls: this.controls,
            raycaster: this.raycaster,
            position,
            id: unique_id,
            dbConfig: { vapiAgentId: chairId, ...colors },
            editMode: true,
            sizes: this.sizes,
            viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
          });
          obj.setDbConfig({ vapiAgentId: chairId, ...colors });
          const dbConfig = generate_template('vapiTranscription', { unique_id, vapiAgentId: chairId, ...colors });
          dbConfig.x = position.x;
          dbConfig.y = position.y;
          dbConfig.z = position.z;
          this.interactionGroup.add(obj.anchor);
          const anchorParent = obj.anchor.parent;
          if (anchorParent) {
            const worldPos = new Vector3(position.x, position.y, position.z);
            anchorParent.worldToLocal(worldPos);
            obj.anchor.position.copy(worldPos);
          }
          // VRVapiTranscriptionWithCSS3D now renders as CSS3DObject in scene.
          this.interactionGroup.updateMatrixWorld(true);
          if (this.vraiAgentTranscriptions) this.vraiAgentTranscriptions.push(obj);
          if (obj.mesh) this.objectsInScene.push(obj.mesh);
          this.currentScene.objects.push(dbConfig);
          this.updateDB();
          this.openSidebar && this.updateElementsInScene();
          ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
        }
      } else {
        const toRemove = this.currentScene.objects.filter(o => o.type === 'vapiTranscription' && o.vapiAgentId === chairId);
        toRemove.forEach((sceneObj) => {
          const tr = this.vraiAgentTranscriptions?.find(t => (t.id || t.getId?.()) === sceneObj.id);
          if (tr) {
            this._indicatorDomCache?.delete(tr.elementClass);
            this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== tr.anchor);
            tr.destroy?.();
            if (tr.anchor?.parent) tr.anchor.parent.remove(tr.anchor);
            this.vraiAgentTranscriptions = this.vraiAgentTranscriptions.filter(t => t !== tr);
            this.objectsInScene = this.objectsInScene.filter(el => el !== tr.mesh);
          }
          const cssEl = document.querySelector(`[data-id='vapi_transcription2_${sceneObj.id}']`);
          cssEl?.remove?.();
          this.currentScene.objects = this.currentScene.objects.filter(o => o.id !== sceneObj.id);
        });
        this.updateDB();
        this.openSidebar && this.updateElementsInScene();
        ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
      }

      const camRefresh = this.vraiAgentCameras?.find(c => String(c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === String(chairId));
      camRefresh?.refreshUserAvatarFallback?.();
      this.updateJSON(this.elementSelected);
      this.updateDB();
    };
    $('#vrai_component_camera, #vrai_component_transcription, #vrai_component_show_user_avatar').on('change', () => {
      saveVraiComponentToggles();
      this._syncVapiSettingsGroupAvailability();
    });

    const getSelectedChairForTranscriptionSettings = () => {
      if (isVraiAgentParent(this.elementSelected?.parent)) return this.elementSelected.parent;
      if (isVraiAgentParent(this.elementSelected)) return this.elementSelected;
      const selectedVapiComp = this._getSelectedVapiComponentForAgentSettings?.();
      if (selectedVapiComp) return this._getVapiComponentLinkedChair(selectedVapiComp);
      return this._getSelectedVraiAgentChairForAgentSettings?.() || null;
    };

    const saveTranscriptionColors = () => {
      const chair = getSelectedChairForTranscriptionSettings();
      if (!chair) return;
      const chairId = chair.getId?.() ?? chair.id;
      const transcriptionObj = this.currentScene?.objects?.find(o => o.type === 'vapiTranscription' && o.vapiAgentId === chairId);
      if (!transcriptionObj) return;
      const userColor = $('#transcription_color_user_hex').val().trim() || $('#transcription_color_user').val();
      const userRoleColor = $('#transcription_color_user_role_hex').val().trim() || $('#transcription_color_user_role').val();
      const aiColor = $('#transcription_color_ai_hex').val().trim() || $('#transcription_color_ai').val();
      const aiRoleColor = $('#transcription_color_ai_role_hex').val().trim() || $('#transcription_color_ai_role').val();
      const bgHex = $('#transcription_color_bg_hex').val().trim() || $('#transcription_color_bg').val();
      const bgAlpha = $('#transcription_color_bg_alpha').val();
      const bgColor = (bgHex.toLowerCase() === 'transparent' && parseInt(bgAlpha, 10) <= 0) ? 'transparent' : this._buildBgColor(this._hexFromColor(bgHex), bgAlpha);
      const preset = $('#transcription_preset').val?.() || 'landscape';
      const width = $('#transcription_width').val?.()?.trim();
      const height = $('#transcription_height').val?.()?.trim();
      const sizeProps = { transcriptionPreset: preset };
      if (width) sizeProps.transcriptionWidth = parseInt(width, 10);
      else sizeProps.transcriptionWidth = undefined;
      if (height) sizeProps.transcriptionHeight = parseInt(height, 10);
      else sizeProps.transcriptionHeight = undefined;
      const colors = { transcriptionUserColor: userColor, transcriptionUserRoleColor: userRoleColor, transcriptionAIColor: aiColor, transcriptionAIRoleColor: aiRoleColor, transcriptionBackgroundColor: bgColor, ...sizeProps };
      Object.assign(transcriptionObj, colors);
      const tr = this.vraiAgentTranscriptions?.find(t => (t.id || t.getId?.()) === transcriptionObj.id);
      if (tr) {
        tr.setDbConfig?.(colors);
        tr.applyTranscriptionStyles?.();
      }
      this.updateDB();
    };

    $('#transcription_color_user, #transcription_color_user_role, #transcription_color_ai, #transcription_color_ai_role').on('input', function () {
      const hex = $(this).val();
      $(this).siblings('input[type="text"]').val(hex);
      saveTranscriptionColors();
    });
    $('#transcription_color_user_hex, #transcription_color_user_role_hex, #transcription_color_ai_hex, #transcription_color_ai_role_hex').on('blur change', function () {
      const val = $(this).val().trim();
      const $color = $(this).siblings('input[type="color"]');
      if (/^#[0-9a-fA-F]{6}$/.test(val)) $color.val(val);
      saveTranscriptionColors();
    });
    $('#transcription_color_bg_hex').on('blur change', function () {
      const val = $(this).val().trim();
      const $color = $(this).siblings('input[type="color"]');
      const parsed = this._parseBgColor(val);
      $color.val(parsed.hex);
      $('#transcription_color_bg_alpha').val(parsed.alpha);
      $('#transcription_bg_alpha_label').text(parsed.alpha + '%');
      saveTranscriptionColors();
    }.bind(this));
    $('#transcription_color_bg').on('input', function () {
      const hex = $(this).val();
      $('#transcription_color_bg_hex').val(hex);
      saveTranscriptionColors();
    });
    $('#transcription_color_bg_alpha').on('input change', function () {
      const alpha = $(this).val();
      $('#transcription_bg_alpha_label').text(alpha + '%');
      saveTranscriptionColors();
    });
    $('#transcription_preset').on('change', function () {
      const preset = $(this).val();
      const dims = preset === 'portrait' ? { width: 280, height: 400 } : { width: 400, height: 220 };
      $('#transcription_width').val(dims.width);
      $('#transcription_height').val(dims.height);
    });
    $('#transcription_preset, #transcription_width, #transcription_height').on('change blur', saveTranscriptionColors);

    const getSelectedVapiCameraComponent = () => {
      if (this.elementSelected?.parent?.name === 'vapiUserCamera') return this.elementSelected.parent;
      if (this.elementSelected?.name === 'vapiUserCamera') return this.elementSelected;
      return null;
    };

    const saveVapiCameraSettings = (partial = {}) => {
      const cameraComp = getSelectedVapiCameraComponent();
      if (!cameraComp) return;
      cameraComp.setDbConfig?.(partial);
      this.modifyLocalJSON(partial);
      this.updateJSON(this.elementSelected);
      this.updateDB();
    };

    $('#vrai_user_camera_size').on('input change', () => {
      const size = parseFloat($('#vrai_user_camera_size').val()) || 1;
      $('#vrai_user_camera_size_val').text(size);
      saveVapiCameraSettings({ size });
    });

    let _vapiCameraCommandSaveTimer = null;
    $('#vrai_user_camera_command_text').on('input blur change', (e) => {
      const commandText = ($('#vrai_user_camera_command_text').val() || '').trim();
      const cameraComp = getSelectedVapiCameraComponent();
      if (!cameraComp) return;
      cameraComp.setDbConfig?.({ commandText });
      this.modifyLocalJSON({ commandText });
      this.updateJSON(this.elementSelected);
      if (e.type === 'input') {
        clearTimeout(_vapiCameraCommandSaveTimer);
        _vapiCameraCommandSaveTimer = setTimeout(() => this.updateDB(), 400);
      } else {
        this.updateDB();
      }
    });

    $('#reset-vrai-perspective').on('click', () => {
      if (!isVraiAgentParent(this.elementSelected?.parent)) return;
      const parent = this.elementSelected.parent;
      const chairId = parent.getId?.() ?? parent.id;
      if (parent.resetPerspective) parent.resetPerspective();
      const tr = this.vraiAgentTranscriptions?.find(t => (t.id || t.getId?.()) && (t.dbConfig?.vapiAgentId ?? t.getDbConfig?.()?.vapiAgentId) === chairId);
      const cam = this.vraiAgentCameras?.find(c => (c.id || c.getId?.()) && (c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === chairId);
      const buttons = (this.vraiAgentButtons || []).filter(b => (b.id || b.getId?.()) && (b.dbConfig?.vapiAgentId ?? b.getDbConfig?.()?.vapiAgentId) === chairId);
      if (tr?.resetPerspective) tr.resetPerspective();
      if (cam?.resetPerspective) cam.resetPerspective();
      buttons.forEach(btn => btn?.resetPerspective?.());
      const conf = parent.getDbConfig ? parent.getDbConfig() : parent.dbConfig;
      this.modifyLocalJSON({ components: conf?.components });
      const transcriptionObj = this.currentScene?.objects?.find(o => o.type === 'vapiTranscription' && o.vapiAgentId === chairId);
      const cameraObj = this.currentScene?.objects?.find(o => o.type === 'vapiUserCamera' && o.vapiAgentId === chairId);
      const buttonObjs = this.currentScene?.objects?.filter(o => o.type === 'vapiButton' && o.vapiAgentId === chairId) || [];
      if (transcriptionObj && tr) Object.assign(transcriptionObj, { perspectiveOffsets: tr.dbConfig?.perspectiveOffsets });
      if (cameraObj && cam) Object.assign(cameraObj, { perspectiveOffsets: cam.dbConfig?.perspectiveOffsets });
      buttonObjs.forEach((obj) => {
        const btn = buttons.find(b => String(b.id || b.getId?.()) === String(obj.id));
        if (btn) Object.assign(obj, { perspectiveOffsets: btn.dbConfig?.perspectiveOffsets });
      });
      this.updateJSON(this.elementSelected);
      this.updateDB();
    });

    this._renderVraiButtonsList = (chairId) => {
      const $list = $('#vrai_agent_buttons_list');
      $list.empty();
      if (!chairId) return;
      const buttons = this.currentScene?.objects?.filter(o => o.type === 'vapiButton' && o.vapiAgentId === chairId) || [];
      const labelLabel = (typeof $trans !== 'undefined' && $trans('vapi-command-name')) ? $trans('vapi-command-name') : 'Command name';
      const actionLabel = (typeof $trans !== 'undefined' && $trans('vapi-command-text')) ? $trans('vapi-command-text') : 'Command';
      const commandNamePlaceholder = (typeof $trans !== 'undefined' && $trans('vapi-command-name')) ? $trans('vapi-command-name') : 'Command name';
      const commandTextPlaceholder = (typeof $trans !== 'undefined' && $trans('vapi-command-text-placeholder')) ? $trans('vapi-command-text-placeholder') : 'Text to send to VAPI';
      const removeLabel = (typeof $trans !== 'undefined' && $trans('remove-text')) ? $trans('remove-text') : 'Remove';
      buttons.forEach((sceneObj, idx) => {
        const bid = sceneObj.id || sceneObj.unique_id || '';
        if (!bid) return;
        const labelVal = (sceneObj.commandName || sceneObj.label || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        const actionVal = (sceneObj.commandText || sceneObj.action || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        const row = $(`
          <div class="vrai-button-row flx-sb" data-button-id="${bid}">
            <label class="lbl-small">${labelLabel}</label>
            <input type="text" class="input input-small vrai-button-label" placeholder="${commandNamePlaceholder}" value="${labelVal}" />
            <label class="lbl-small">${actionLabel}</label>
            <div class="vrai-button-row-actions">
              <textarea class="input input-small vrai-button-action" rows="2" placeholder="${commandTextPlaceholder}">${actionVal}</textarea>
              <button type="button" class="vrai-button-remove material-icons-outlined" title="${removeLabel}">delete</button>
            </div>
          </div>
        `);
        $list.append(row);
      });
      if (this.model?.customSelect?.refresh) this.model.customSelect.refresh();
    };

    $('#vrai_add_button').on('click', () => {
      const parent = this.elementSelected?.parent || this.elementSelected;
      if (!isVraiAgentParent(parent)) return;
      const chairId = parent.getId?.() ?? parent.id;
      const unique_id = uuidv4();
      const dir = new Vector3();
      this.camera.getWorldDirection(dir);
      const pos = this.camera.position.clone().addScaledVector(dir, 450);
      const position = { x: pos.x, y: pos.y, z: pos.z };
      const obj = new VRVapiButtonWithCSS3D({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position,
        id: unique_id,
        dbConfig: { vapiAgentId: chairId, commandName: ((typeof $trans !== 'undefined' && $trans('vapi-command-text')) ? $trans('vapi-command-text') : 'Command'), commandText: '', label: '', action: '', imageUrl: '', perspectiveOffsets: null },
        editMode: true,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
      });
      obj.setDbConfig({ vapiAgentId: chairId, commandName: ((typeof $trans !== 'undefined' && $trans('vapi-command-text')) ? $trans('vapi-command-text') : 'Command'), commandText: '', label: '', action: '', icon: '', imageUrl: '', perspectiveOffsets: null });
      const dbConfig = generate_template('vapiButton', { unique_id, vapiAgentId: chairId, commandName: ((typeof $trans !== 'undefined' && $trans('vapi-command-text')) ? $trans('vapi-command-text') : 'Command'), commandText: '', label: '', action: '', icon: '', imageUrl: '', perspectiveOffsets: null });
      dbConfig.x = position.x;
      dbConfig.y = position.y;
      dbConfig.z = position.z;
      this.interactionGroup.add(obj.anchor);
      const anchorParent = obj.anchor.parent;
      if (anchorParent) {
        const worldPos = new Vector3(position.x, position.y, position.z);
        anchorParent.worldToLocal(worldPos);
        obj.anchor.position.copy(worldPos);
      }
      let layer = document.getElementById('vapi-buttons-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.id = 'vapi-buttons-layer';
        layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:0;';
        const webgl = document.querySelector('#webgl');
        if (webgl?.parentNode) webgl.parentNode.insertBefore(layer, webgl);
        else document.body.appendChild(layer);
      }
      layer.appendChild(obj.dom);
      this.indicatorsArray.push({ mesh: obj.anchor, element: obj.elementClass });
      if (this.vraiAgentButtons) this.vraiAgentButtons.push(obj);
      this.currentScene.objects.push(dbConfig);
      this.updateDB();
      this._renderVraiButtonsList(chairId);
      this.openSidebar && this.updateElementsInScene();
    });

    let _vraiButtonLabelSaveTimer = null;
    let _vraiButtonActionSaveTimer = null;
    $('#vrai_agent_buttons_list').on('input blur change', '.vrai-button-label', function (e) {
      const target = (e && e.target) ? e.target : (typeof this !== 'undefined' && this && this.nodeType) ? this : null;
      if (!target || !target.nodeType) return;
      const $row = $(target).closest('.vrai-button-row');
      if (!$row.length) return;
      const buttonId = $row.attr('data-button-id') || $row.data('button-id');
      if (!buttonId || typeof buttonId !== 'string') return;
      const label = ($(target).val() || '').trim();
      const sceneObj = this.currentScene?.objects?.find(o => o.type === 'vapiButton' && o.id === buttonId);
      if (!sceneObj) return;
      sceneObj.commandName = label;
      // Keep legacy key for backward compatibility with older consumers.
      sceneObj.label = label;
      const btn = this.vraiAgentButtons?.find(b => (b.id || b.getId?.()) === buttonId);
      if (btn) btn.setDbConfig({ commandName: label, label });
      if (e.type === 'input') {
        clearTimeout(_vraiButtonLabelSaveTimer);
        _vraiButtonLabelSaveTimer = setTimeout(() => this.updateDB(), 400);
      } else {
        this.updateDB();
      }
    }.bind(this));

    $('#vrai_agent_buttons_list').on('change', '.vrai-button-icon', function (e) {
      const target = (e && e.target) ? e.target : (typeof this !== 'undefined' && this && this.nodeType) ? this : null;
      if (!target || !target.nodeType) return;
      const $row = $(target).closest('.vrai-button-row');
      if (!$row.length) return;
      const buttonId = $row.attr('data-button-id') || $row.data('button-id');
      if (!buttonId || typeof buttonId !== 'string') return;
      const icon = ($(target).val() || '').trim();
      const sceneObj = this.currentScene?.objects?.find(o => o.type === 'vapiButton' && o.id === buttonId);
      if (!sceneObj) return;
      sceneObj.icon = icon;
      const btn = this.vraiAgentButtons?.find(b => (b.id || b.getId?.()) === buttonId);
      if (btn) btn.setDbConfig({ icon });
      this.updateDB();
    }.bind(this));

    $('#vrai_agent_buttons_list').on('input blur change', '.vrai-button-action', function (e) {
      const target = (e && e.target) ? e.target : (typeof this !== 'undefined' && this && this.nodeType) ? this : null;
      if (!target || !target.nodeType) return;
      const $row = $(target).closest('.vrai-button-row');
      if (!$row.length) return;
      const buttonId = $row.attr('data-button-id') || $row.data('button-id');
      if (!buttonId || typeof buttonId !== 'string') return;
      const action = ($(target).val() || '').trim();
      const sceneObj = this.currentScene?.objects?.find(o => o.type === 'vapiButton' && o.id === buttonId);
      if (!sceneObj) return;
      sceneObj.commandText = action;
      // Keep legacy key for backward compatibility with older consumers.
      sceneObj.action = action;
      const btn = this.vraiAgentButtons?.find(b => (b.id || b.getId?.()) === buttonId);
      if (btn) btn.setDbConfig({ commandText: action, action });
      if (e.type === 'input') {
        clearTimeout(_vraiButtonActionSaveTimer);
        _vraiButtonActionSaveTimer = setTimeout(() => this.updateDB(), 400);
      } else {
        this.updateDB();
      }
    }.bind(this));

    $('#vrai_agent_buttons_list').on('click', '.vrai-button-remove', function (e) {
      e.preventDefault();
      const $row = $(e.currentTarget).closest('.vrai-button-row');
      const buttonId = $row.data('button-id');
      const sceneObj = this.currentScene?.objects?.find(o => o.type === 'vapiButton' && o.id === buttonId);
      if (!sceneObj) return;
      const btn = this.vraiAgentButtons?.find(b => (b.id || b.getId?.()) === buttonId);
      if (btn) {
        this._indicatorDomCache?.delete(btn.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== btn.anchor);
        btn.destroy?.();
        if (btn.anchor?.parent) btn.anchor.parent.remove(btn.anchor);
        this.vraiAgentButtons = this.vraiAgentButtons.filter(b => b !== btn);
      }
      document.querySelector(`[data-id='vapi_button2_${buttonId}']`)?.remove?.();
      this.currentScene.objects = this.currentScene.objects.filter(o => o.id !== buttonId);
      this.updateDB();
      const chairId = this.elementSelected?.getId?.() ?? this.elementSelected?.id;
      if (chairId) this._renderVraiButtonsList(chairId);
      this.openSidebar && this.updateElementsInScene();
    }.bind(this));

    const escapeAiEventAttr = (value) => String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    this._getSelectedVraiChairForAiEvents = () => {
      const parent = this.elementSelected?.parent || this.elementSelected;
      if (!isVraiAgentParent(parent) && parent?.type !== 'vraiAgent') return null;
      return parent;
    };

    this._getChairAiEventsList = (chair) => {
      if (!chair) return [];
      const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
      const sceneObj = this._findAgentSceneObject(chair.getId?.() ?? chair.id);
      const fromScene = Array.isArray(sceneObj?.aiEvents) ? sceneObj.aiEvents : null;
      return getAiEventsFromConfig({ aiEvents: fromScene ?? cfg.aiEvents });
    };

    this._persistChairAiEvents = (chair, aiEvents, options = {}) => {
      if (!chair) return;
      const {
        rerenderList = true,
        refreshEventControls = true,
      } = options;
      const normalized = normalizeAiEvents(aiEvents);
      chair.setDbConfig?.({ aiEvents: normalized });
      if (chair.dbConfig) chair.dbConfig.aiEvents = normalized;
      const chairId = chair.getId?.() ?? chair.id;
      const sceneObj = this._findAgentSceneObject(chairId);
      if (sceneObj) {
        sceneObj.aiEvents = normalized;
        this.scenes[this.currentSceneIndex] = this.currentScene;
        this.updateDB();
      }
      if (rerenderList) this._renderVraiAiEventsList?.(chairId);
      if (refreshEventControls && this._getSelectedEventObjectType() === 'vraiAgent') {
        this._renderObjectEventTypeControls('vraiAgent');
        this._renderObjectEventsList();
      }
    };

    this._renderVraiAiEventsList = (chairId) => {
      const $list = $('#vrai_agent_ai_events_list');
      if (!$list.length) return;
      $list.empty();
      if (!chairId) return;
      const chair = this.vraiAgentChairs?.find((c) => String(c.getId?.() ?? c.id) === String(chairId))
        || this._findAgentSceneObject(chairId);
      const events = this._getChairAiEventsList(chair) || getAiEventsFromConfig(this._findAgentSceneObject(chairId) || {});
      const nameLabel = (typeof $trans !== 'undefined' && $trans('vrai-ai-event-name')) || 'Event name';
      const whenLabel = (typeof $trans !== 'undefined' && $trans('vrai-ai-event-when')) || 'When to call';
      const namePlaceholder = (typeof $trans !== 'undefined' && $trans('vrai-ai-event-name-placeholder')) || 'e.g. lookAtChair';
      const whenPlaceholder = (typeof $trans !== 'undefined' && $trans('vrai-ai-event-when-placeholder')) || 'when the user asks…';
      const connectLabel = (typeof $trans !== 'undefined' && $trans('vrai-ai-event-connect')) || 'Connect';
      const removeLabel = (typeof $trans !== 'undefined' && $trans('remove-text')) || 'Remove';
      events.forEach((ev) => {
        const row = $(`
          <div class="vrai-ai-event-row" data-ai-event-id="${escapeAiEventAttr(ev.id)}" data-ai-event-name="${escapeAiEventAttr(ev.name)}">
            <label class="lbl-small">${nameLabel}</label>
            <input type="text" class="input input-small vrai-ai-event-name" placeholder="${escapeAiEventAttr(namePlaceholder)}" value="${escapeAiEventAttr(ev.name)}" />
            <label class="lbl-small">${whenLabel}</label>
            <textarea class="input input-small vrai-ai-event-when" rows="2" placeholder="${escapeAiEventAttr(whenPlaceholder)}">${escapeAiEventAttr(ev.whenToCall)}</textarea>
            <div class="vrai-ai-event-row-actions flx-sb" style="gap:8px;margin-top:4px;">
              <button type="button" class="buttn secondary vrai-ai-event-connect" data-lang="vrai-ai-event-connect">${connectLabel}</button>
              <button type="button" class="vrai-ai-event-remove material-icons-outlined" title="${escapeAiEventAttr(removeLabel)}">delete</button>
            </div>
          </div>
        `);
        $list.append(row);
      });
    };

    $('#vrai_add_ai_event').on('click', () => {
      const chair = this._getSelectedVraiChairForAiEvents();
      if (!chair) return;
      const existing = this._getChairAiEventsList(chair);
      let base = 'lookAtTarget';
      let name = base;
      let n = 2;
      const used = new Set(existing.map((e) => e.name));
      while (used.has(name)) {
        name = `${base}${n}`;
        n += 1;
      }
      const next = [
        ...existing,
        {
          id: uuidv4(),
          name,
          whenToCall: '',
          label: name,
        },
      ];
      this._persistChairAiEvents(chair, next);
    });

    let _vraiAiEventSaveTimer = null;
    const saveAiEventRowEdits = (rowEl, { immediate = false, finalizeName = false } = {}) => {
      const chair = this._getSelectedVraiChairForAiEvents();
      if (!chair || !rowEl) return;
      const $row = $(rowEl).closest('.vrai-ai-event-row');
      if (!$row.length) return;
      const eventId = String($row.attr('data-ai-event-id') || '');
      const rawName = ($row.find('.vrai-ai-event-name').val() || '').trim();
      const whenToCall = ($row.find('.vrai-ai-event-when').val() || '');
      const existing = this._getChairAiEventsList(chair);
      const apply = () => {
        const prev = existing.find((e) => String(e.id) === eventId);
        if (!prev) return;

        // While typing, keep the previous slug so focus is not stolen by re-render/validation.
        let name = prev.name;
        if (finalizeName) {
          name = slugifyAiEventName(rawName);
          if (!name) {
            this.model.alert?.('error', $trans('vrai-ai-event-name-required') || 'Enter an event name (letters, numbers, underscore).');
            $row.find('.vrai-ai-event-name').val(prev.name);
            return;
          }
          if (existing.some((e) => e.name === name && String(e.id) !== eventId)) {
            this.model.alert?.('error', $trans('vrai-ai-event-name-duplicate') || 'An AI event with this name already exists.');
            $row.find('.vrai-ai-event-name').val(prev.name);
            return;
          }
        }

        const prevName = prev.name;
        const next = existing.map((e) => {
          if (String(e.id) !== eventId) return e;
          return { ...e, name, whenToCall: String(whenToCall).trim(), label: name };
        });
        $row.attr('data-ai-event-name', name);
        if (finalizeName) $row.find('.vrai-ai-event-name').val(name);

        // Never rebuild the list while editing — that steals focus from the textarea/input.
        this._persistChairAiEvents(chair, next, {
          rerenderList: false,
          refreshEventControls: finalizeName && prevName !== name,
        });

        if (finalizeName && prevName && prevName !== name) {
          const chairId = String(chair.getId?.() ?? chair.id);
          const sceneId = String(this.currentScene?.id || '');
          const toMigrate = (this.model.worldEvents || []).filter((ev) =>
            String(ev.scene_id) === sceneId
            && String(ev.source_object_id) === chairId
            && String(ev.event_type) === prevName
          );
          toMigrate.forEach((ev) => {
            const payload = {
              worldId: this.worldID,
              sceneId,
              sourceObjectId: chairId,
              eventType: name,
              targetObjectId: ev.target_object_id,
              targetObjectType: ev.target_object_type,
              action: ev.action,
            };
            if (ev.action_params) payload.actionParams = ev.action_params;
            this.model.worldFetcher.createWorldEvent(payload, (res) => {
              if (res?.event?.id) {
                this.model.worldEvents = (this.model.worldEvents || []).filter(
                  (e) => String(e.id) !== String(ev.id)
                );
                this.model.worldEvents.push({
                  id: res.event.id,
                  world_id: this.worldID,
                  scene_id: sceneId,
                  source_object_id: chairId,
                  event_type: name,
                  target_object_id: ev.target_object_id,
                  target_object_type: ev.target_object_type,
                  action: ev.action,
                  action_params: ev.action_params,
                });
                this.model.worldFetcher.deleteWorldEvent(this.worldID, ev.id, () => {
                  this._renderObjectEventsList();
                  this._renderSceneEventsList();
                }, () => {
                  this._renderObjectEventsList();
                  this._renderSceneEventsList();
                });
              }
            }, () => {});
          });
        }
      };
      if (immediate) {
        clearTimeout(_vraiAiEventSaveTimer);
        apply();
      } else {
        clearTimeout(_vraiAiEventSaveTimer);
        _vraiAiEventSaveTimer = setTimeout(apply, 400);
      }
    };

    $('#vrai_agent_ai_events_list').on('input', '.vrai-ai-event-when', (e) => {
      saveAiEventRowEdits(e.currentTarget, { immediate: false, finalizeName: false });
    });
    $('#vrai_agent_ai_events_list').on('blur change', '.vrai-ai-event-when', (e) => {
      saveAiEventRowEdits(e.currentTarget, { immediate: true, finalizeName: false });
    });
    $('#vrai_agent_ai_events_list').on('input', '.vrai-ai-event-name', (e) => {
      // Debounced draft save without renaming slug / re-render.
      saveAiEventRowEdits(e.currentTarget, { immediate: false, finalizeName: false });
    });
    $('#vrai_agent_ai_events_list').on('blur change', '.vrai-ai-event-name', (e) => {
      saveAiEventRowEdits(e.currentTarget, { immediate: true, finalizeName: true });
    });

    $('#vrai_agent_ai_events_list').on('click', '.vrai-ai-event-remove', (e) => {
      e.preventDefault();
      const chair = this._getSelectedVraiChairForAiEvents();
      if (!chair) return;
      const $row = $(e.currentTarget).closest('.vrai-ai-event-row');
      const eventId = String($row.attr('data-ai-event-id') || '');
      const eventName = String($row.attr('data-ai-event-name') || '');
      const next = this._getChairAiEventsList(chair).filter((ev) => String(ev.id) !== eventId);
      this._persistChairAiEvents(chair, next);
      // Drop worldEvents that used this AI event as source event_type for this chair.
      if (eventName) {
        const chairId = String(chair.getId?.() ?? chair.id);
        const sceneId = String(this.currentScene?.id || '');
        const toDelete = (this.model.worldEvents || []).filter((ev) =>
          String(ev.scene_id) === sceneId
          && String(ev.source_object_id) === chairId
          && String(ev.event_type) === eventName
        );
        toDelete.forEach((ev) => {
          this.model.worldFetcher.deleteWorldEvent(this.worldID, ev.id, () => {
            this.model.worldEvents = (this.model.worldEvents || []).filter(
              (e) => String(e.id) !== String(ev.id)
            );
            this._renderObjectEventsList();
            this._renderSceneEventsList();
          }, () => {});
        });
      }
    });

    $('#vrai_agent_ai_events_list').on('click', '.vrai-ai-event-connect', (e) => {
      e.preventDefault();
      const chair = this._getSelectedVraiChairForAiEvents();
      if (!chair) return;
      const $row = $(e.currentTarget).closest('.vrai-ai-event-row');
      const eventName = String($row.attr('data-ai-event-name') || $row.find('.vrai-ai-event-name').val() || '').trim();
      const name = slugifyAiEventName(eventName);
      if (!name) {
        this.model.alert?.('error', $trans('vrai-ai-event-name-required') || 'Enter an event name (letters, numbers, underscore).');
        return;
      }
      this._openConnectEventModal(name, {
        sourceObjectId: chair.getId?.() ?? chair.id,
        sourceObjectType: 'vraiAgent',
      });
    });

    $('#iframe_value_edit').on('blur change', () => {
      const ctx = this._getIframeDimensionEditTarget?.();
      if (!ctx) return;
      const { target, isIframeElement } = ctx;
      const iframeValue = $('#iframe_value_edit').val().trim();
      const newData = { iframe_value: iframeValue };
      target.setIframeValue && target.setIframeValue(iframeValue);
      target.setDbConfig && target.setDbConfig(newData);
      this.modifyLocalJSON(newData);
      this.updateJSON(isIframeElement ? target.anchor : this.elementSelected);
      this.updateDB();
    });

    const previewIframeDimensions = (persist = true) => {
      const ctx = this._getIframeDimensionEditTarget();
      if (!ctx) return;
      const { target, isIframeElement } = ctx;
      const newData = this._readIframeDimensionFormData();
      target.setDbConfig?.(newData);
      if (!persist) return;
      this.modifyLocalJSON(newData);
      this.updateJSON(isIframeElement ? target.anchor : this.elementSelected);
      this.updateDB();
    };

    $('#iframe_width_enabled, #iframe_height_enabled').on('change', function () {
      const isWidth = this.id === 'iframe_width_enabled';
      $(`#iframe_${isWidth ? 'width' : 'height'}_value`).prop('disabled', !$(this).prop('checked'));
      $(`#iframe_${isWidth ? 'width' : 'height'}_unit`).prop('disabled', !$(this).prop('checked'));
      previewIframeDimensions(true);
    });

    $('#iframe_width_value, #iframe_height_value').on('input', () => previewIframeDimensions(false));
    $('#iframe_width_value, #iframe_width_unit, #iframe_height_value, #iframe_height_unit').on('change blur', () => previewIframeDimensions(true));

    $('#iframe_agent_update').on('click', () => {
      const iframeValue = $('#iframe_value').val().trim();
      if (iframeValue.length) {
        const isIframeElement = this.elementSelected?.type === 'iframeElement';
        const parent = isIframeElement ? this.elementSelected : this.elementSelected.parent;
        const newData = { iframe_value: iframeValue };
        parent.setIframeValue && parent.setIframeValue(iframeValue);
        parent.setDbConfig && parent.setDbConfig(newData);
        this.modifyLocalJSON(newData);
      }
    });


    $('#iframe_agent_submit').on('click', () => {
      const iframeValue = $('#iframe_value').val().trim();
      if (iframeValue.length) {
        const unique_id = uuidv4();
        const dir = new Vector3();
        this.camera.getWorldDirection(dir);
        const pos = this.camera.position.clone().addScaledVector(dir, 540);
        const position = { x: pos.x, y: pos.y, z: pos.z };
        const obj = new VRIframeElement({
          model: this.model,
          camera: this.camera,
          controls: this.controls,
          raycaster: this.raycaster,
          position,
          id: unique_id,
          dbConfig: { iframe_value: iframeValue },
          editMode: true,
          sizes: this.sizes,
          viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
        });
        const dbConfig = generate_template('iframeElement', { unique_id, iframe_value: iframeValue });
        obj.setDbConfig(dbConfig);
        this.interactionGroup.add(obj.anchor);
        const anchorParent = obj.anchor.parent;
        if (anchorParent) {
          const worldPos = new Vector3(position.x, position.y, position.z);
          anchorParent.worldToLocal(worldPos);
          obj.anchor.position.copy(worldPos);
        }
        this.interactionGroup.updateMatrixWorld(true);
        if (!this.iframeElementsInScene) this.iframeElementsInScene = [];
        this.iframeElementsInScene.push(obj);
        this.updateJSON(obj.anchor, dbConfig);
        distanceRange.value = 0;
        this.objectsInScene.push(obj.mesh);
        this.openSidebar && this.updateElementsInScene();
        $('.iframe_holder').removeClass('is-active');
        $('#iframe_value').val(DEFAULT_IFRAME_EMBED);
      }
    });

    $('#timer_preset_edit').on('blur change', () => {
      if (this.elementSelected?.type !== 'timerElement') return;
      const timePreset = normalizeTimePreset($('#timer_preset_edit').val());
      $('#timer_preset_edit').val(timePreset);
      const newData = { timePreset };
      this.elementSelected.setDbConfig && this.elementSelected.setDbConfig(newData);
      this.modifyLocalJSON(newData);
      this.updateJSON(this.elementSelected.anchor);
      this.updateDB();
    });

    $('#timer_element_submit').on('click', () => {
      const timePreset = normalizeTimePreset($('#timer_preset_value').val());
      const unique_id = uuidv4();
      const dir = new Vector3();
      this.camera.getWorldDirection(dir);
      const pos = this.camera.position.clone().addScaledVector(dir, 540);
      const position = { x: pos.x, y: pos.y, z: pos.z };
      const obj = new VRTimerElement({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position,
        id: unique_id,
        dbConfig: { timePreset },
        editMode: true,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
      });
      const dbConfig = generate_template('timerElement', { unique_id, timePreset });
      obj.setDbConfig(dbConfig);
      this.interactionGroup.add(obj.anchor);
      const anchorParent = obj.anchor.parent;
      if (anchorParent) {
        const worldPos = new Vector3(position.x, position.y, position.z);
        anchorParent.worldToLocal(worldPos);
        obj.anchor.position.copy(worldPos);
      }
      this.interactionGroup.updateMatrixWorld(true);
      if (!this.timerElementsInScene) this.timerElementsInScene = [];
      this.timerElementsInScene.push(obj);
      this.updateJSON(obj.anchor, dbConfig);
      distanceRange.value = 0;
      this.objectsInScene.push(obj.mesh);
      this.openSidebar && this.updateElementsInScene();
      $('.timer_holder').removeClass('is-active');
      $('#timer_preset_value').val('0:10:0');
    });

    $('#yt_video_submit').on('click', () => {
      if (this.model.config.role !== 'admin_role' && this.model.config.role !== 'Admin') {
        if (!validateRoomItem(this.model.sceneData.space_type, { type: EDITOR_ACTIONS.youtube_element })) {
          this.model.alert('error', $trans('not-available-in-free-plan'));
        }
      }
      let vidId = $('#youtube_id').val();
      if (vidId.length) {
        $('#youtube_id').css('box-shadow', '');
        let yt_id = vidId.replace('https://www.youtube.com/watch?v=', '');
        let obj = null;
        const id = this.objectsInScene.length;
        const unique_id = uuidv4();

        obj = new VRYoutubeGhostObject(id, this.camera, yt_id, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setPosterSrc(yt_id);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        this.updateJSON(obj.mesh, generate_template('youtube', { unique_id, yt_id }));

        distanceRange.value = 0;
        obj !== null && this.objectsInScene.push(obj.mesh);

        this.openSidebar && this.updateElementsInScene();
        $('.video_holder').removeClass('is-active');
      } else {
        $('#youtube_id').css('box-shadow', '0 2px 2px #e91e1e');
      }

    });

    // ADD CHESS GAME
    $('.add-chess-game').on('click', () => {
      this._add3dObject('chessGame');
    });

    // ADD PAYPAL DONATION
    $('.add-paypal-donate').on('click', () => {
      // this.showPayPalDonationModal();
    });
    // TOUR MODE SCREEN SHARE
    $('.add-tour-screenshare').on('click', () => {
      this._add3dObject('tourScreenShare');
    });

    $("#paypal_donation_submit").on('click', () => {
      // this._add3dObject('payPalDonation');
    });

    $("#paypal_donation_update").on('click', () => {
      const parent = this.elementSelected.parent;
      const src = $("#paypal_donation_image").attr("src");
      const aspectRatio = $("#paypal_donation_image_aspect_ratio").val();
      const donationDescription = tinymce.get("paypal_donation_text").getContent();
      const donationURL = $("#paypal_donation_url").val();
      let customIcon = false;

      if (!donationURL.includes('paypal.com/donate/') || !donationURL) {
        this.model.alert('error', $trans('error-paypal-url'));
        return;
      }

      if (!src.includes('banner_placeholder.png')) {
        customIcon = true;
      }

      customIcon && parent.setGeometry(src, aspectRatio, true);

      const newData = { "image": { "url": customIcon ? src : '', aspectRatio }, donationURL, donationDescription }
      parent.setDbConfig(newData);
      this.modifyLocalJSON(newData);

      closeTinyMCEMoreMenu();

      $(".paypal_donation_holder").removeClass("is-active");

    });

    //LOAD PAYPAL DONATION IMAGE
    $("#paypal_donation_image").on('load', function (e) {
      const imageSizes = e.target.getBoundingClientRect();
      const aspectRatio = imageSizes.width / imageSizes.height;
      $("#paypal_donation_image_aspect_ratio").val(aspectRatio);
      $(".paypal_donation_submit").removeClass("inactive");
      let imageSrc = $("#paypal_donation_image").attr('src');
      if (imageSrc.includes('banner_placeholder.png')) {
        $('#upload_paypal_donation_image .upload-thumb-removal').hide();
      } else {
        $('#upload_paypal_donation_image .upload-thumb-removal').show();
      }
    });

    $("#upload_paypal_donation_image").on('click', () => { // same thing must be done for drag & drop event
      $(".paypal_donation_submit").addClass("inactive");
    });

    $("#removePaypalThumbnail").on('click', (e) => {
      $('#paypal_donation_image').attr('src', './textures/banner_placeholder.png');
      $('#paypal_donation_image_aspect_ratio').val(1);
      if (!$('.paypal_donation_holder').hasClass('is-active')) {
        this.elementSelected.parent.setDefaultTexture($('#paypal_donation_image').attr('src'));
      }
    });
  }


  /**
   * BUILD SCENES MENU CONTENT
   */
  //TODO move outside ModeEdit, remove all callbacks, UI, create as separate Class
  room_btn_template(index, name, image, elements, sceneId) {
    const cls = index == this.currentSceneIndex ? index ? 'room_img active' : 'room_img home active' : index ? 'room_img' : 'room_img home';

    return `
  <div class='room' draggable='true' data-scene='${sceneId}'>
    <span class='material-icons-outlined md-18 room_drag' title='${$trans('drag-scene-title')}' data-lang="drag-scene-title">drag_indicator</span>

    <div class='customCheckbox'>
      <input type='checkbox' class='selected_scenes' id='select_scene_${index}'/>
      <label for='select_scene_${index}'>
        <span class='material-icons-outlined md-18 box_uncheck'>check_box_outline_blank</span>
        <span class='material-icons md-18 box_check'>check_box</span>
      </label>
    </div>
        
    <div class='${cls}'>
      <div class='img_wrapper'>
        <img src='${image}' onError='this.src = generateThumbnail(this.src);' class='preview_image' loading='lazy' />
      </div>
      <div class='scene_index'>${index + 1}</div>
      <div class="home-indicator"><span class="material-icons md-14">home</span></div>
    </div>
    
    <div class='room_info'>
      <input type='text' class='room_name' value='${name}' title='${$trans('edit-scene-name-title')}' data-lang="edit-scene-name-title" />
      <div class='room_elements'>${elements} ${elements === 1 ? $trans('element-text') : $trans('elements-text')}</div>
      <div class="dropdown_available">
        ${custom_checkbox(sceneId, "include_in_dropdown_checkbox")}
        <div class='room_elements centered' data-lang="drop-down-available-text" >Dropdown available</div>
      </div>
    </div>
    
    <span class='material-icons-outlined md-18 box_check more_room_info'>more_horiz</span>

    <div class='room_options'>
      <div class='go_to_scene' data-lang="go-to-scene-text">${$trans('go-to-scene-text')}</div>
      <div class='landing_room' data-lang="set-home-text">${$trans('set-home-text')}</div> 
      <div class='room_copy' data-lang="duplicate-text">${$trans('duplicate-text')}</div>
      <div class='${index === this.currentSceneIndex ? 'room_delete disabled' : 'room_delete'}' data-lang="delete-text">${$trans('delete-text')}</div>   
    </div>
  </div>
  `;
  }

  generateSceneGallery = (withRoomGallery = true) => {
    $('#scenes-container').html("");
    $("#scenes-container").css({ 'margin-left': `0px` });
    $("#more-scenes-left").removeClass("visible");

    withRoomGallery && $(".roomsEditor").html("");

    for (let x = 0; x < this.scenes.length; x++) {

      const room = this.scenes[x];
      const extension = room.background.mediumPath.split('.');
      const ext = `.${extension[extension.length - 1]}`;
      let thumb = room.background.mediumPath.replace(ext, `_thumb${ext}`);
      const sceneId = room.id;

      withRoomGallery && $(".roomsEditor").append(this.room_btn_template(x, room.publicName, thumb, room.objects.length, sceneId));
      $(`.include_in_dropdown_checkbox[data-id="${room.id}"]`).prop("checked", room.includeInDropDown);
      !withRoomGallery && this.updateSceneCounter();

      $("#scenes-container").append(`
        <div class='${this.currentSceneIndex !== x ? 'bottom-bar-item bottom-bar-scene' : 'bottom-bar-item bottom-bar-scene active'}' data-scene='${sceneId}'>
            ${x === 0 ? '<div class="home-indicator"><span class="material-icons md-14">home</span></div>' : ''}
            <div class='img_wrapper'>
              <img src='${thumb}' onError='this.src = this.src.includes("_thumb") ? "${thumb.replace('_thumb.', '.')}" : "./textures/empty.png"' class='scene_gallery_preview_image' loading='lazy' />
            </div>
            <div class="overlay">
            <span class='material-icons-outlined'>settings</span>
          </div>
        </div>
      `);
    }

    $("#more-scenes-right").toggleClass("visible", this.scenes.length > 6);
    $(".bottom-bar-room-settings").toggleClass("fix-size", this.scenes.length > 6);
    $("#scene-menu").hasClass("is-active") && $("#showSceneMenu").hasClass("active") && $(".bottom-bar-scene:eq(0)").addClass("selected");
  }


  /**
   * ADD 3D OBJECTS
   */
  async _add3dObject(name, position = null, tempData) {
    this.deselectElement();

    console.log('add3dObject', name, position, tempData, this.subscriptionPlan, this.user);
    if (window.baglessTrack) {
      window.baglessTrack(this.model.config, "User added a 3D object in editor", { data: { name, position, tempData } })
    }

    const { state, limit } = this._applyValidateAction({ scenes: this.scenes, action: name });

    ////TODO FIX
    // if (!state) {
    //   this.model.alert('error', `${$trans('error-max-limit-reached')}: ${limit}`);
    //   return;
    // }

    let obj = null;
    const id = this.objectsInScene.length;
    const unique_id = uuidv4();
    const defaultDistance = 300;
    const chairDefaultDistance = 420;
    const whoCanStream = $('#create-screen-settings input[name="whoCanStream"]:checked').val();

    let src = $("#link_image").attr("src");
    let aspectRatio = '';
    let linkPath = $("#link_url").val();
    let openNewWindow = $("#openLinkInNewWindow").prop('checked');

    let isCustomIcon = false;
    let finalTexture = '';
    let imageSrc = '';
    let imageAspectRatio = '';
    let objDbData = '';
    let formData = '';
    let image;

    switch (name) {
      case 'guestSeat':
        obj = new VRChairObject(id, this.camera, this.emptySeatTexture, null, null, null, this.model);
        objDbData = generate_template('guestSeat', { unique_id, defaultDistance: chairDefaultDistance });
        obj.setId(unique_id);
        obj.setDistance(chairDefaultDistance);
        obj.setDbConfig(objDbData);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);

        this.updateJSON(obj.mesh, objDbData);
        break;
      case 'videoGallery':
        const { url } = tempData;
        obj = new VRVideoGallery(id, this.camera, this.emptySeatTexture, null, null, null, this.model);
        objDbData = generate_template('videoGallery', { unique_id, defaultDistance, url });
        if (/\.webm(\?|#|$)/i.test(url)) {
          objDbData.transparentBackground = true;
        }
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setDbConfig(objDbData, true, (newDbData) => {
          this.updateJSON(obj.mesh, newDbData);
        });
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        break;

      case 'profile':
        const dynamicProfileAvatar = $("#dynamicProfileAvatar").prop('checked');
        const imagePath = $("#profile_image").attr("src");

        finalTexture = this.ownerAvatarTexture;

        if (imagePath !== this.ownerAvatarURL) {
          finalTexture = this.textureLoaderSilent.load(imagePath);
        }

        objDbData = generate_template('profile', { unique_id, userName: this.model.config.userName, defaultDistance, userId: this.ownerId, wpId: this.ownerWPId, avatarURL: imagePath, dynamicProfileAvatar });


        obj = new VRProfileObject(id, this.camera, finalTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setDbConfig(objDbData);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);

        this.updateJSON(obj.mesh, objDbData);
        break;

      case 'sceneChange': {
        imageSrc = $("#scene_change_image").attr("src");
        aspectRatio = $("#scene_change_image_aspect_ratio").val();
        finalTexture = emptyTexture;
        const useIcon = $("#use_scene_change_icon").is(':checked');
        const hasCustomSrc = imageSrc && !imageSrc.includes('edit_change_scene');

        if (!useIcon && hasCustomSrc) {
          finalTexture = await this.textureLoaderSilent.load(imageSrc);
        }
        const targetSceneId = $(".target_scene.active").length ? $(".target_scene.active")[0].children[0].value : this.currentScene.id;
        objDbData = generate_template('sceneChange', {
          unique_id,
          defaultDistance,
          targetSceneId,
          imageSrc: hasCustomSrc ? imageSrc : '',
          aspectRatio: hasCustomSrc ? aspectRatio : '',
          useIcon,
        });
        obj = new VRSceneChangeObject(id, this.camera, finalTexture, null, null, null, this.model);
        obj.setId(unique_id);
        // obj.setDistance(defaultDistance);
        obj.setDbConfig(objDbData);
        obj.addMenuPosition();
        obj.setTargetRoomId(targetSceneId); //should be added because of separate call in showSceneChangeModal 'scene' without data

        if (useIcon) {
          this._attachSceneChangeIndicator(obj);
        } else if (hasCustomSrc) {
          obj.setGeometry(imageSrc, aspectRatio);
        }
        this.interactionGroup.add(obj);

        this.updateJSON(obj.mesh, objDbData);

        $(".scenes_target_holder").removeClass("is-active");

        break;
      }

      case 'shopLink':

        let products = document.getElementById('products');
        let productsData = getFormData(products);
        objDbData = generate_template('shopLink', { unique_id, defaultDistance, productsData });
        obj = new VRShopObject(id, this.camera, this.shopLinkTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setDbConfig(objDbData);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);

        this.updateJSON(obj.mesh, objDbData);
        break;

      case 'webLink':
        aspectRatio = $("#link_image_aspect_ratio").val();
        finalTexture = emptyTexture;
        const linkName = $("#link_component_name").val()?.trim() || undefined;
        const useIcon = $("#use_link_icon").is(':checked');
        const hasCustomSrc = src && !src.includes('webLinkHotSpot');

        if (!useIcon && hasCustomSrc) {
          finalTexture = await this.textureLoaderSilent.load(src);
          isCustomIcon = true;
        }

        obj = new VRLinkObject(id, this.camera, finalTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setLink(linkPath);
        const webLinkConfig = {
          useIcon,
          "image": { "url": hasCustomSrc ? src : '', "aspectRatio": aspectRatio },
          openNewWindow,
        };
        if (linkName) webLinkConfig.name = linkName;
        obj.setDbConfig(webLinkConfig);
        obj.addMenuPosition();

        if (!useIcon && isCustomIcon) {
          obj.setGeometry(src, aspectRatio);
        } else {
          this._attachWebLinkIndicator(obj);
        }

        this.interactionGroup.add(obj);

        const webLinkTemplate = generate_template('webLink', {
          unique_id,
          defaultDistance,
          linkPath,
          useIcon,
          "imageSrc": hasCustomSrc ? src : '',
          "aspectRatio": aspectRatio,
          openNewWindow,
        });
        if (linkName) webLinkTemplate.name = linkName;
        this.updateJSON(obj.mesh, webLinkTemplate);
        break;

      case 'baglessRoom':

        src = `/worlds/view?id=${this.model.newBagleesRoomObject.id}&security=${this.model.URLS.securityHash}`;

        const imageUrl = this.model.newBagleesRoomObject.image;
        finalTexture = this.textureLoaderSilent.load(imageUrl);
        aspectRatio = $("#bagless_room_preview_image").width() / $("#bagless_room_preview_image").height();

        const roomName = $("#bagless-room-dropdown-title").text();

        obj = new VRBaglessRoomObject(id, this.camera, finalTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setLink(src);
        obj.setDbConfig({ "image": { "url": imageUrl, aspectRatio }, roomId: this.model.newBagleesRoomObject.id, roomName, "rotateY": 0, openNewWindow: false }, true);
        obj.addMenuPosition();
        obj.setGeometry(imageUrl, aspectRatio);
        this.interactionGroup.add(obj);
        this.updateJSON(obj.mesh, generate_template('baglessRoom', { roomId: this.model.newBagleesRoomObject.id, roomName, unique_id, defaultDistance, linkPath: src, imageSrc: imageUrl, aspectRatio, openNewWindow: false }));

        break;

      case 'youtube':
        this.showVideoModal();
        break;

      case 'iframeAgent':
        this.showIframeModal();
        break;

      case 'iframeElement':
        this.showIframeModal();
        break;

      case 'timerElement':
        this.showTimerModal();
        break;

      case 'vraiAgent':
        this.showVraiAgentModal();
        break;

      case 'screenStream':
        obj = new VRStreamScreenObject(id, this.camera, this.screenShareTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        this.updateJSON(obj.mesh, generate_template('screenStream', { unique_id, whoCanStream }));
        break;

      case 'chessGame':
        obj = new VRChessObject(id, this.camera, chessTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        this.updateJSON(obj.mesh, generate_template('chessGame', { unique_id, defaultDistance }));
        break;

      case 'payPalDonation':

        imageSrc = $("#paypal_donation_image").attr('src');
        imageAspectRatio = $("#paypal_donation_image_aspect_ratio").val();
        const donationDescription = $("#paypal_donation_text").val();
        const donationURL = $("#paypal_donation_url").val();

        if (!donationURL.includes('paypal.com/donate/') || !donationURL) {
          this.model.alert('error', $trans('error-paypal-url'));
          return;
        }

        finalTexture = paypalDonateTexture;

        if (!imageSrc.includes('banner_placeholder.png')) {
          finalTexture = await this.textureLoaderSilent.load(imageSrc);
          isCustomIcon = true;
        }

        obj = new VRPayPalDonationObject(id, this.camera, finalTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        // obj.mesh.parent.userData = { data: { "url": isCustomIcon ? imageSrc : '', "aspectRatio": imageAspectRatio }, donationDescription, donationURL };

        obj.setDbConfig({ "image": { "url": isCustomIcon ? imageSrc : '', "aspectRatio": imageAspectRatio }, donationDescription, donationURL });
        obj.addMenuPosition();

        isCustomIcon && obj.setGeometry(imageSrc, imageAspectRatio);

        this.interactionGroup.add(obj);

        this.updateJSON(obj.mesh, generate_template('payPalDonation', { unique_id, defaultDistance, donationURL, donationDescription, "imageSrc": isCustomIcon ? imageSrc : '', "aspectRatio": imageAspectRatio }));

        closeTinyMCEMoreMenu();

        $(".paypal_donation_holder").removeClass("is-active");

        break;

      case 'infoElement':
        formData = this.validateInfoForm();
        if (formData.error) {
          return;
        }
        const { layout, data } = formData;
        const name = (data?.title || '').trim() || undefined;
        obj = new VRInfoElement(id, this.camera, emptyTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.setDbConfig({ layout, data, name });
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        this._attachInfoElementIndicator(obj);
        this.updateJSON(obj.mesh, generate_template('infoElement', { unique_id, defaultDistance, layout, data }));
        closeTinyMCEMoreMenu();
        $("#info-element-modal").removeClass("is-active");
        break;

      case 'embeddedWebpage': {
        formData = this.validateEmbeddedWebpage();
        if (formData.error) {
          return;
        }
        const useIcon = formData.useIcon;
        const hasCustomSrc = !!formData.imageSrc;
        obj = new VREmbeddedWebpageObject(id, this.camera, emptyTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        image = { url: hasCustomSrc ? formData.imageSrc : '', aspectRatio: formData.imageAspectRatio };
        obj.setDbConfig({ iframe: formData.iframe, useIcon, image });
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        if (useIcon) {
          this._attachEmbeddedWebpageIndicator(obj);
        }
        this.updateJSON(obj.mesh, generate_template('embeddedWebpage', { unique_id, defaultDistance, iframe: formData.iframe, image, useIcon }));
        closeTinyMCEMoreMenu();
        $("#embedded-webpage-modal").removeClass("is-active");
        break;
      }
      case 'tourScreenShare':
        obj = new VRTourScreenShare(id, this.camera, tourModeScreenShareTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        this.updateJSON(obj.mesh, generate_template('tourScreenShare', { unique_id, whoCanStream }));
        break;
      case 'imageGallery': {
        obj = new VRImageGallery(id, this.camera, imageGallery, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        const dbConfig = generate_template('imageGallery', { unique_id, defaultDistance })
        this.updateJSON(obj.mesh, dbConfig);
        obj.setDbConfig(dbConfig);
        if (obj.useIcon) {
          this._attachImageGalleryIndicator(obj);
        } else {
          obj.addDragPoints();
        }
        break;
      }
      case 'videoPlayer': {
        obj = new VRVideoPlayer(id, this.camera, emptyTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        const dbConfig = generate_template('videoPlayer', { unique_id })
        this.updateJSON(obj.mesh, dbConfig);
        obj.setDbConfig(dbConfig);
        if (obj.useIcon) {
          this._attachVideoPlayerIndicator(obj);
        } else {
          obj.addDragPoints();
        }
        break;
      }
      case 'videoPlayerWebGL': {
        obj = new VRVideoPlayerWebGL(id, this.camera, videoPlayer, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        const dbConfig = generate_template('videoPlayerWebGL', { unique_id })
        obj.setDbConfig(dbConfig);
        this.updateJSON(obj.mesh, dbConfig);
        if (obj.model.editMode) {
          obj.ensurePerspectiveDragPoints?.();
        }
        break;
      }
      case 'vrInvisibleAction': {
        obj = new VRInvisibleAction(id, this.camera, null, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        const dbConfig = generate_template('vrInvisibleAction', { unique_id, defaultDistance });
        this.updateJSON(obj.mesh, dbConfig);
        obj.setDbConfig(dbConfig);
        obj.addDragPoints();
        break;
      }
      case 'vrMusicObject': {
        obj = new VRMusicObject(id, this.camera, musicObjectTexture, null, null, null, this.model);
        obj.setId(unique_id);
        obj.setDistance(defaultDistance);
        obj.addMenuPosition();
        this.interactionGroup.add(obj);
        const dbConfig = generate_template('vrMusicObject', { unique_id, defaultDistance });
        this.updateJSON(obj.mesh, dbConfig);
        obj.dbConfig = dbConfig;
        break;
      }
    }

    distanceRange.value = 0;
    obj !== null && this.objectsInScene.push(obj.mesh);

    this.openSidebar && this.updateElementsInScene();
    ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
  }

  updateElementsInScene() {
    const nr = this.currentScene.objects.length;
    $(`.room_elements:eq(${this.currentSceneIndex})`).text(`${nr} ${nr === 1 ? $trans('element-text') : $trans('elements-text')}`);
  }

  updateJSON = (obj, jsonObj = null) => {
    const chair = obj?.userData?.vraiAgentChair || obj?.anchor?.userData?.vraiAgentChair;
    let cam = obj?.userData?.vraiAgentCamera || obj?.anchor?.userData?.vraiAgentCamera;
    let tr = obj?.userData?.vraiAgentTranscription || obj?.anchor?.userData?.vraiAgentTranscription;
    let btn = obj?.userData?.vraiAgentButton || obj?.anchor?.userData?.vraiAgentButton;
    let iframeEl = obj?.userData?.vrIframeElement || obj?.anchor?.userData?.vrIframeElement;
    let timerEl = obj?.userData?.vrTimerElement || obj?.anchor?.userData?.vrTimerElement;
    let guessEl = obj?.userData?.vrInputFieldGuess || obj?.anchor?.userData?.vrInputFieldGuess;
    let inputEl = obj?.userData?.vrInputField || obj?.anchor?.userData?.vrInputField;
    const posMesh = (cam?.anchor) ? cam.anchor : (tr?.anchor) ? tr.anchor : (btn?.anchor) ? btn.anchor : (iframeEl?.anchor) ? iframeEl.anchor : (timerEl?.anchor) ? timerEl.anchor : (guessEl?.anchor) ? guessEl.anchor : (inputEl?.anchor) ? inputEl.anchor : (chair?.anchor) ? chair.anchor : null;
    const updateObj = posMesh || (chair || cam || tr || btn || iframeEl || timerEl || guessEl || inputEl) ? obj : (obj && obj.parent?.vraiAgentRoot) ? obj.parent.vraiAgentRoot.mesh : obj;
    if (!updateObj) return;
    let pos = new Vector3();
    const posSource = posMesh || (chair?.anchor) || (cam?.anchor) || (tr?.anchor) || (btn?.anchor) || (typeof updateObj?.getWorldPosition === 'function' ? updateObj : null);
    if (posSource?.getWorldPosition) {
      posSource.getWorldPosition(pos);
      if (this.roomGroup) {
        this.roomGroup.updateMatrixWorld(true);
        this.roomGroup.worldToLocal(pos);
      }
    }

    const css3dComp = chair || cam || tr || btn || iframeEl || timerEl || guessEl || inputEl;
    const parent = css3dComp || updateObj.parent;
    const scale = (posMesh || updateObj).scale;
    const { distance } = (parent && parent.getLimits) ? parent.getLimits() : { distance: 300 };
    const rot = (parent && parent.getAxisRotations) ? parent.getAxisRotations('radians') : { rotateX: 0, rotateY: 0 };
    const dbSize = Number(
      chair?.dbConfig?.size ??
      cam?.dbConfig?.size ??
      tr?.dbConfig?.size ??
      btn?.dbConfig?.size ??
      iframeEl?.dbConfig?.size ??
      timerEl?.dbConfig?.size ??
      guessEl?.dbConfig?.size ??
      inputEl?.dbConfig?.size ??
      parent?.dbConfig?.size ??
      parent?.dbConfig?.scale
    );
    const persistedSize = Number.isFinite(dbSize) && dbSize > 0 ? dbSize : scale.x;

    let found = false;
    const matchId = css3dComp?.getId?.() ?? (parent && parent.getId ? parent.getId() : null);

    if (jsonObj === null) {
      for (let x = 0; x < this.currentScene.objects.length; x++) {
        const el = this.currentScene.objects[x];
        if (matchId != null && el.id === matchId) {
          el.x = pos.x;
          el.y = pos.y;
          el.z = pos.z;
          el.size = persistedSize;
          el.scale = persistedSize;
          el.distance = distance;
          el.rotateX = rot.rotateX;
          el.rotateY = rot.rotateY;
          found = true;
          // Sync camera/transcription position into Chair's components so publish has correct state
          if (cam && el.vapiAgentId && el.type === 'vapiUserCamera') {
            const chairObj = this.currentScene.objects.find(o => o.id === el.vapiAgentId && o.type === 'vraiAgent');
            if (chairObj) {
              chairObj.components = chairObj.components || {};
              chairObj.components.camera = { ...(chairObj.components.camera || {}), position: { x: pos.x, y: pos.y, z: pos.z } };
            }
          }
          if (el.type === 'vapiTranscription' && el.vapiAgentId) {
            const chairObj = this.currentScene.objects.find(o => o.id === el.vapiAgentId && o.type === 'vraiAgent');
            if (chairObj) {
              chairObj.components = chairObj.components || {};
              chairObj.components.transcription = { ...(chairObj.components.transcription || {}), position: { x: pos.x, y: pos.y, z: pos.z } };
            }
          }
          // Update component dbConfig so it stays in sync
          if (chair) {
            chair.setDbConfig?.({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
            if (chair.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = chair.dbConfig.perspectiveOffsets;
          }
          if (cam) {
            cam.dbConfig = { ...cam.dbConfig, x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY };
            if (cam.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = cam.dbConfig.perspectiveOffsets;
          }
          if (tr) {
            tr.dbConfig = { ...tr.dbConfig, x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY };
            if (tr.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = tr.dbConfig.perspectiveOffsets;
          }
          if (btn) {
            btn.dbConfig = { ...btn.dbConfig, x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY };
          }
          if (iframeEl) {
            iframeEl.setDbConfig?.({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
            if (iframeEl.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = iframeEl.dbConfig.perspectiveOffsets;
            if (iframeEl.dbConfig?.iframe_value) el.iframe_value = iframeEl.dbConfig.iframe_value;
            if (iframeEl.dbConfig?.iframe_width_enabled !== undefined) el.iframe_width_enabled = iframeEl.dbConfig.iframe_width_enabled;
            if (iframeEl.dbConfig?.iframe_width !== undefined) el.iframe_width = iframeEl.dbConfig.iframe_width;
            if (iframeEl.dbConfig?.iframe_height_enabled !== undefined) el.iframe_height_enabled = iframeEl.dbConfig.iframe_height_enabled;
            if (iframeEl.dbConfig?.iframe_height !== undefined) el.iframe_height = iframeEl.dbConfig.iframe_height;
          }
          if (timerEl) {
            timerEl.setDbConfig?.({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
            if (timerEl.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = timerEl.dbConfig.perspectiveOffsets;
            if (timerEl.dbConfig?.timePreset) el.timePreset = timerEl.dbConfig.timePreset;
          }
          if (guessEl) {
            guessEl.setDbConfig?.({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
            if (guessEl.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = guessEl.dbConfig.perspectiveOffsets;
            if (guessEl.dbConfig?.title) el.title = guessEl.dbConfig.title;
          }
          if (inputEl) {
            inputEl.setDbConfig?.({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
            if (inputEl.dbConfig?.perspectiveOffsets) el.perspectiveOffsets = inputEl.dbConfig.perspectiveOffsets;
            if (inputEl.dbConfig?.title) el.title = inputEl.dbConfig.title;
            if (inputEl.dbConfig?.fieldKey) el.fieldKey = inputEl.dbConfig.fieldKey;
          }
          if (parent?.setDbConfig && !css3dComp) {
            parent.setDbConfig({ x: pos.x, y: pos.y, z: pos.z, size: persistedSize, scale: persistedSize, distance, rotateX: rot.rotateX, rotateY: rot.rotateY });
          }
          break;
        }
      }
    }

    if (!found && jsonObj) {
      jsonObj.x = pos.x;
      jsonObj.y = pos.y;
      jsonObj.z = pos.z;
      jsonObj.size = persistedSize;
      jsonObj.scale = persistedSize;
      this.currentScene.objects.push(jsonObj);
    }

    if (found || jsonObj) {
      this.scenes[this.currentSceneIndex] = this.currentScene;
      this.openSidebar && this.updateElementsInScene();
    }
    this._preserveSceneRotationY();
    this.updateDB();
  }

  _applyLocalStorageDraftToMemory = () => {
    const raw = localStorage.getItem(`publish_${this.worldID}`);
    if (!raw) {
      return false;
    }
    try {
      const draft = JSON.parse(raw);
      if (!Array.isArray(draft?.scenes)) {
        return false;
      }
      this.scenes = draft.scenes;
      this.worldData = { ...this.worldData, ...draft, scenes: draft.scenes };
      if (this.model?.sceneData) {
        this.model.sceneData = { ...this.model.sceneData, ...draft, scenes: draft.scenes };
      }
      const idx = this.currentSceneIndex ?? 0;
      if (this.scenes[idx]) {
        this.currentScene = this.scenes[idx];
      }
      this.model._sceneNorthById = this.model._sceneNorthById || {};
      for (const scene of this.scenes) {
        const rot = Number(scene?.sceneRotationY);
        if (scene?.id && Number.isFinite(rot)) {
          this.model._sceneNorthById[scene.id] = rot;
        }
      }
      return true;
    } catch (_) {
      return false;
    }
  }

  _normalizeNavigationMenuItems(items) {
    if (!Array.isArray(items)) return [];
    return items.map((item, index) => ({
      id: item?.id != null ? String(item.id) : `nav-${Date.now()}-${index}`,
      name: String(item?.name || '').trim() || `Nav Point ${index + 1}`,
      type: item?.type === 'url' ? 'url' : 'room',
      target: item?.target != null ? String(item.target) : '',
      visible: item?.visible !== false,
    }));
  }

  _isNavigationMenuActive(value = this.worldData.navigationMenu) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return value.show === true || value.show === 1;
    }
    return value === 1 || value === true || String(value) === '1';
  }

  _getNavigationMenuItems() {
    if (Array.isArray(this.worldData.navigationMenuItems)) {
      return this.worldData.navigationMenuItems;
    }
    // Migrate legacy shape: navigationMenu.items
    if (this.worldData.navigationMenu && Array.isArray(this.worldData.navigationMenu.items)) {
      return this.worldData.navigationMenu.items;
    }
    return [];
  }

  _cloneNavigationMenuDraft() {
    return {
      show: this._isNavigationMenuActive(),
      items: this._normalizeNavigationMenuItems(this._getNavigationMenuItems()),
    };
  }

  _findNavigationMenuDraftItem(id) {
    return (this._navigationMenuDraft?.items || []).find((item) => String(item.id) === String(id)) || null;
  }

  _getNavigationSceneName(sceneId) {
    const scene = (this.scenes || []).find((s) => String(s.id) === String(sceneId));
    if (!scene) return null;
    return scene.publicName || scene.name || String(sceneId);
  }

  _escapeNavigationHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _openNavigationMenuEditor() {
    this._navigationMenuDraft = this._cloneNavigationMenuDraft();
    $("#navigation_menu_modal_active").prop('checked', !!this._navigationMenuDraft.show);
    this._renderNavigationMenuItems();
    $("#navigation-menu-modal").addClass("is-active");
  }

  _closeNavigationMenuEditor(save) {
    if (save && this._navigationMenuDraft) {
      this.worldData.navigationMenu = this._navigationMenuDraft.show ? 1 : 0;
      this.worldData.navigationMenuItems = this._normalizeNavigationMenuItems(this._navigationMenuDraft.items);
      $("#navigationMenuActive").prop('checked', !!this._navigationMenuDraft.show);
      this.updateDB();
    }
    this._navigationMenuDraft = null;
    this._editingNavigationMenuEntryId = null;
    $("#navigation-menu-modal").removeClass("is-active");
    $("#navigation-menu-entry-modal").removeClass("is-active");
  }

  _renderNavigationMenuItems() {
    const $list = $("#navigation-menu-items");
    if (!$list.length) return;
    $list.empty();
    const items = this._navigationMenuDraft?.items || [];
    items.forEach((item) => {
      const isUrl = item.type === 'url';
      const typeLabel = isUrl
        ? ($trans('navigation-menu-type-url') || 'URL')
        : ($trans('navigation-menu-type-room') || 'Room');
      let targetLabel = '';
      let isMissing = false;
      if (isUrl) {
        targetLabel = item.target || '';
      } else {
        const sceneName = this._getNavigationSceneName(item.target);
        if (sceneName) {
          targetLabel = sceneName;
        } else {
          isMissing = true;
          targetLabel = $trans('navigation-menu-room-missing') || 'Room missing';
        }
      }
      const visible = item.visible !== false;
      const visibilityIcon = visible ? 'visibility' : 'visibility_off';
      const missingIcon = isMissing
        ? `<span class="material-icons-outlined">warning</span>`
        : '';
      $list.append(`
        <div class="navigation-menu-item${isMissing ? ' is-missing' : ''}" draggable="true" data-id="${this._escapeNavigationHtml(item.id)}">
          <span class="material-icons-outlined md-18 room_drag navigation-menu-item__drag">drag_indicator</span>
          <span class="navigation-menu-item__name" title="${this._escapeNavigationHtml(item.name)}">${this._escapeNavigationHtml(item.name)}</span>
          <span class="navigation-menu-item__type">${this._escapeNavigationHtml(typeLabel)}</span>
          <span class="navigation-menu-item__target" title="${this._escapeNavigationHtml(targetLabel)}">${missingIcon}<span>${this._escapeNavigationHtml(targetLabel)}</span></span>
          <div class="navigation-menu-item__actions">
            <span class="material-icons-outlined md-18 navigation-menu-item__visibility" title="${visible ? 'Hide' : 'Show'}">${visibilityIcon}</span>
            <span class="material-icons-outlined md-18 navigation-menu-item__edit" title="${$trans('edit-text') || 'Edit'}">edit</span>
            <span class="material-icons-outlined md-18 navigation-menu-item__delete" title="${$trans('delete-text') || 'Delete'}">delete</span>
          </div>
        </div>
      `);
    });
  }

  _populateNavigationMenuRoomOptions(selectedId = '') {
    const $select = $("#navigation_menu_entry_room");
    $select.empty();
    (this.scenes || []).forEach((scene) => {
      const label = scene.publicName || scene.name || scene.id;
      const selected = String(scene.id) === String(selectedId) ? ' selected' : '';
      $select.append(`<option value="${this._escapeNavigationHtml(scene.id)}"${selected}>${this._escapeNavigationHtml(label)}</option>`);
    });
  }

  _syncNavigationMenuEntryTypeFields() {
    const type = $("#navigation_menu_entry_type").val();
    const isUrl = type === 'url';
    $("#navigation-menu-entry-room-section").toggleClass('hidden', isUrl);
    $("#navigation-menu-entry-url-section").toggleClass('hidden', !isUrl);
  }

  _openNavigationMenuEntryEditor(entryId = null) {
    if (!this._navigationMenuDraft) {
      this._navigationMenuDraft = this._cloneNavigationMenuDraft();
    }
    this._editingNavigationMenuEntryId = entryId;
    const item = entryId ? this._findNavigationMenuDraftItem(entryId) : null;
    const defaultRoomId = this.scenes?.[0]?.id || '';
    $("#navigation-menu-entry-name").val(item?.name || '');
    $("#navigation_menu_entry_type").val(item?.type === 'url' ? 'url' : 'room');
    this._populateNavigationMenuRoomOptions(item?.type === 'room' ? (item.target || defaultRoomId) : defaultRoomId);
    $("#navigation-menu-entry-url").val(item?.type === 'url' ? (item.target || '') : '');
    $("#navigation_menu_entry_visible").prop('checked', item ? item.visible !== false : true);
    this._syncNavigationMenuEntryTypeFields();
    $("#navigation-menu-entry-modal").addClass("is-active");
  }

  _saveNavigationMenuEntryEditor() {
    if (!this._navigationMenuDraft) return;
    const name = ($("#navigation-menu-entry-name").val() || '').trim();
    const type = $("#navigation_menu_entry_type").val() === 'url' ? 'url' : 'room';
    const target = type === 'url'
      ? ($("#navigation-menu-entry-url").val() || '').trim()
      : ($("#navigation_menu_entry_room").val() || '');
    const visible = $("#navigation_menu_entry_visible").prop('checked');
    const safeName = name || (type === 'url' ? 'URL' : ($trans('navigation-menu-type-room') || 'Room'));
    const existing = this._editingNavigationMenuEntryId
      ? this._findNavigationMenuDraftItem(this._editingNavigationMenuEntryId)
      : null;
    if (existing) {
      existing.name = safeName;
      existing.type = type;
      existing.target = target;
      existing.visible = visible;
    } else {
      this._navigationMenuDraft.items.push({
        id: `nav-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
        name: safeName,
        type,
        target,
        visible,
      });
    }
    this._editingNavigationMenuEntryId = null;
    $("#navigation-menu-entry-modal").removeClass("is-active");
    this._renderNavigationMenuItems();
  }

  getStringifiedWorldData = () => {
    this._flushPendingSceneRotation();
    this._applyNorthForPublish();
    this._normalizeScenesForSave();
    this.worldData.version = 3;
    this.worldData.scenes = this.scenes;
    this.worldData.hasOwnProperty('test') && (delete this.worldData.test);
    this.worldData.hasOwnProperty('worldsCanEnter') && (delete this.worldData.worldsCanEnter);
    this.worldData.hasOwnProperty('is_publishing') && (delete this.worldData.is_publishing);
    const data = JSON.stringify(this.worldData);
    return data;
  }

  _hasUnsavedEditorChanges = () => localStorage.getItem(`publish_${this.worldID}`) !== null;

  _clearEditorDraft = () => {
    this.model.clearEditorPublishDraft();
  }

  _leaveEditorTo = (destination = 'view') => {
    $('.confirm-footer').removeClass('leaveEditMode');
    this._clearEditorDraft();
    if (destination === 'home') {
      window.location.assign(window.origin);
      return;
    }
    const cameraPreservedAngle = this.cameraPreservedAngle(false);
    const loc = this.currentScene?.id || '';
    window.location = $('#virtualRealityContainer').attr('data-open-world-url') + `&rot=${cameraPreservedAngle}&loc=${loc}`;
  }

  _promptLeaveEditor = (destination = 'view', { confirmIfClean = false } = {}) => {
    this._leaveEditorDestination = destination;
    if (!this._hasUnsavedEditorChanges()) {
      if (destination === 'home' && confirmIfClean) {
        this._confirmExitHome();
        return;
      }
      this._leaveEditorTo(destination);
      return;
    }
    $('.confirm-footer').addClass('leaveEditMode');
    this.model.confirm(
      $trans('confirm-leaving-without-publishing'),
      null,
      {},
      () => { $('.confirm-footer').removeClass('leaveEditMode'); }
    );
  }

  _confirmExitHome = () => {
    this.model.confirm($trans('exit-app-confirm'), () => {
      if (this.model.customBack) {
        window.close();
        return;
      }
      window.location.assign(window.origin);
    }, {
      confirmBtnTxt: $trans('exit-text'),
      cancelBtnTxt: $trans('cancel-text'),
      modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
      modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
      modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
    });
  }

  _onExitAppClick = () => {
    this._promptLeaveEditor('home', { confirmIfClean: true });
  }

  updateDB = () => {
    localStorage.setItem(`publish_${this.worldID}`, this.getStringifiedWorldData());
    localStorage.setItem('last_edited_time', new Date().getTime());
    $('#publish_changes').removeClass('disabled');
    // $('#toggleModes, #preview_mode, #toggleModes').toggleClass('disabled', this.isDraft);
  }

  updateSpaceType = (spaceType) => {
    const data = {
      space_type: spaceType
    }
    let updateSpaceTypeUrl = this.updateSpaceTypeUrl.replace(encodeURIComponent('{{ID}}'), encodeURIComponent(this.worldID + ''));
    this.model.updateSpaceType({ url: updateSpaceTypeUrl, data });

  }

  _findEmptyImageGalleries() {
    const liveImagesById = new Map();
    (this.filtered3DObjects?.imageGallery || []).forEach((comp) => {
      const id = String(comp.id || comp.dbConfig?.id || '');
      if (!id) return;
      liveImagesById.set(id, comp.imageItems || comp.images || comp.dbConfig?.images);
    });
    const empty = [];
    const seen = new Set();
    const consider = (id, images, obj) => {
      const key = id || `anon-${empty.length}`;
      if (seen.has(key)) return;
      if (galleryHasImages(images)) return;
      seen.add(key);
      empty.push(obj);
    };
    (this.scenes || []).forEach((scene) => {
      (scene.objects || []).forEach((obj) => {
        if (obj?.type !== 'imageGallery') return;
        const id = String(obj.id || obj.unique_id || '');
        const images = (id && liveImagesById.has(id)) ? liveImagesById.get(id) : obj.images;
        consider(id, images, obj);
      });
    });
    (this.filtered3DObjects?.imageGallery || []).forEach((comp) => {
      const id = String(comp.id || comp.dbConfig?.id || '');
      consider(id, liveImagesById.get(id) || comp.imageItems, comp);
    });
    return empty;
  }

  publishChanges = ({ isDraft = false, isPublishing = false, initSave = false } = {}) => {
    if (isPublishing && this._findEmptyImageGalleries().length) {
      this.model.alert(
        'error',
        $trans('gallery-at-least-one-image', {}, 'At least one image is required to publish.')
      );
      return false;
    }
    this._applyLocalStorageDraftToMemory();
    const worldData = JSON.parse(this.getStringifiedWorldData());
    worldData.is_publishing = isPublishing ? 1 : 0;
    const data = JSON.stringify(worldData);
    let updateWorldURL = this.updateWorld.replace(encodeURIComponent('{{ID}}'), encodeURIComponent(this.worldID + ''));
    this.model.saveSceneData({ url: updateWorldURL, data }, initSave);
    if (window.baglessTrack) {
      window.baglessTrack(this.model.config, "User published changes", { worldData })
    }
    !initSave && this.socket.enviromentChanged(this.worldID, this.model.config.userId);
    return true;
  }

  showBaglessConnectModal = (e) => {
    $("#bagless-room-dropdown-menu").removeClass("is-active");
    $(".room_connect_holder").addClass("is-active");
  };

  showLinkModal = (event = 'add', data) => {
    $(".link_holder .modal-data").append($(".link-obj-settings"));
    // Reset display after .hide() from populateObjectSettings (selector was under tab-settings;
    // moving the node to the modal does not clear jQuery's display:none).
    $(".link_holder .link-obj-settings").show();
    if (event === 'add') {
      // add
      $("#link_submit").show();
      $("#link_url").val("");
      $("#link_update").hide();
      $("#link_image").attr("src", "./textures/webLinkHotSpot.png");
      $("#link_image_aspect_ratio").val("");
      $("#openLinkInNewWindow").prop('checked', false);
      $("#link_component_name").val("");
      $("#use_link_icon").prop('checked', true);
      $(".link_holder").addClass("is-active");
    } else {
      // edit
      let src = "./textures/webLinkHotSpot.png";
      let aspect = "1";

      if (data.hasOwnProperty("image")) {
        src = data.image.url === "" ? src : data.image.url;
        aspect = data.image.aspectRatio;
      }
      const hasImage = !!(data.image?.url);
      const useIcon = data.useIcon !== undefined ? data.useIcon === true : !hasImage;
      $("#use_link_icon").prop('checked', useIcon);
      $("#link_image_aspect_ratio").val(aspect);
      $("#link_image").attr('src', src);
      $("#link_url").val(data.url);
      $("#openLinkInNewWindow").prop('checked', data.openNewWindow);
      $("#link_component_name").val(data.name || "");
      $(".object-settings-tab-settings").append($(".link_holder .link-obj-settings"));
      $(".link-obj-settings .webLink").show();
    }
    this.toggleLinkIcon();
  }

  toggleLinkIcon = () => {
    const parent = this.elementSelected?.parent;
    const useIcon = $("#use_link_icon").is(':checked');
    if (useIcon) {
      $("#link_icon_display").show();
      $("#link_custom_image").hide();
    } else {
      $("#link_icon_display").hide();
      $("#link_custom_image").show();
      const savedUrl = parent?.getCustomImageUrl?.() || parent?.dbConfig?.image?.url;
      if (savedUrl && !String(savedUrl).includes('webLinkHotSpot')) {
        $("#link_image").attr('src', savedUrl);
      }
    }

    if (parent?.name === 'webLink') {
      parent.setUseIcon?.(useIcon);
      this._syncWebLinkEditIndicator(parent);
    }
  }

  _syncWebLinkEditIndicator = (parent) => {
    if (!parent || parent.name !== 'webLink' || !parent.mesh) return;
    const indicatorMode = typeof parent.isIndicatorMode === 'function'
      ? parent.isIndicatorMode()
      : (!!parent.useIcon || !parent.customIcon);
    if (indicatorMode) {
      this._attachWebLinkIndicator(parent);
    } else {
      this._removeObjectIndicator(parent.mesh);
    }
    $(".perspective-settings").toggleClass('hidden', indicatorMode);
    this._refreshSizeDistanceControls?.(this.elementSelected);
  }

  _getIframeDimensionEditTarget = () => {
    const iframeComp = this._resolveEditableObject(this.elementSelected);
    if (iframeComp?.dom && typeof iframeComp.setDbConfig === 'function') {
      return { target: iframeComp, isIframeElement: true };
    }
    const parent = this.elementSelected?.parent;
    if (parent?.name === 'iframeAgent' && typeof parent.setDbConfig === 'function') {
      return { target: parent, isIframeElement: false };
    }
    return null;
  };

  _readIframeDimensionFormData = () => {
    const newData = {};
    if ($('#iframe_width_enabled').prop('checked')) {
      const val = $('#iframe_width_value').val();
      const unit = $('#iframe_width_unit').val() || 'px';
      newData.iframe_width_enabled = true;
      newData.iframe_width = (val !== '' ? val : '480') + unit;
    } else {
      newData.iframe_width_enabled = false;
      newData.iframe_width = '';
    }
    if ($('#iframe_height_enabled').prop('checked')) {
      const val = $('#iframe_height_value').val();
      const unit = $('#iframe_height_unit').val() || 'px';
      newData.iframe_height_enabled = true;
      newData.iframe_height = (val !== '' ? val : '480') + unit;
    } else {
      newData.iframe_height_enabled = false;
      newData.iframe_height = '';
    }
    return newData;
  };

  _populateIframeDimensions = (data) => {
    const parseDim = (str) => {
      if (!str || typeof str !== 'string') return { value: '480', unit: 'px' };
      const m = str.match(/^(\d+(?:\.\d+)?)(px|%)$/);
      if (m) return { value: m[1], unit: m[2] };
      return { value: '480', unit: 'px' };
    };
    const widthEnabled = !!data.iframe_width_enabled;
    const heightEnabled = !!data.iframe_height_enabled;
    const widthParsed = parseDim(data.iframe_width);
    const heightParsed = parseDim(data.iframe_height);
    $('#iframe_width_enabled').prop('checked', widthEnabled);
    $('#iframe_width_value').val(widthParsed.value).prop('disabled', !widthEnabled);
    $('#iframe_width_unit').val(widthParsed.unit).prop('disabled', !widthEnabled);
    $('#iframe_height_enabled').prop('checked', heightEnabled);
    $('#iframe_height_value').val(heightParsed.value).prop('disabled', !heightEnabled);
    $('#iframe_height_unit').val(heightParsed.unit).prop('disabled', !heightEnabled);
  };

  showIframeModal = (event = 'add', data) => {
    $(".iframe_holder .modal-data").append($("#create-iframe-settings"));
    if (event === 'add') {
      $('#iframe_value').val(DEFAULT_IFRAME_EMBED);
      $('.iframe_holder').addClass('is-active');
    } else {
      $(".object-settings-tab-settings").append($("#create-iframe-settings"));
      $('#iframe_value').val(data.iframe_value || DEFAULT_IFRAME_EMBED);
      $('.object-menu').addClass('is-active');
    }
  };

  showTimerModal = () => {
    $('#timer_preset_value').val('0:10:0');
    $('.timer_holder').addClass('is-active');
  };

  showVraiAgentModal = () => {
    $('#vrai_agent_assistant_id').val('');
    $('#vrai_agent_private_key').val('');
    $('#vrai_agent_submit').show();
    $('#vrai_agent_update').hide();
    $('.vrai_agent_holder').addClass('is-active');
  }

  _openSquadCreateModal = () => {
    this._vapiAgentCreateFromSelect = (this._vapiAddMode === 'toolbox');
    this._resetSquadModal();
    $('.vrai_squad_holder').addClass('is-active');
  }

  _resetSquadModal = () => {
    $('#squad_agent_name').val('');
    $('#squad_vapi_squad_id').val('');
    $('#squad_vapi_private_key').val('');
    $('#squad_custom_variables').val('');
    $('#squad_custom_variables_error').hide();
    this.squadMemberImages = ['', '', '', '', '', ''];
    this.squadActiveMembers = 1;
    for (let mi = 0; mi < 6; mi++) {
      $(`#squad_member_name_${mi}`).val('');
      $(`#squad_member_scenario_${mi}`).val('');
      $(`#squad_member_img_${mi}`).attr('src', './textures/empty.png');
      if (mi === 0) {
        $(`.squad-member-slot[data-member-index="0"]`).css('display', 'flex').removeClass('squad-member-hidden');
      } else {
        $(`.squad-member-slot[data-member-index="${mi}"]`).css('display', 'none').addClass('squad-member-hidden');
      }
    }
    $('#squad_add_member').prop('disabled', false).css('opacity', '1');
  }

  showVideoModal = (event = 'add', data) => {
    $(".video_holder .modal-data").append($("#create-youtube-settings"));
    $('#youtube_id').css('box-shadow', '');
    if (event === 'add') {
      // add
      $('#youtube_id').val('');
      $('.video_holder').addClass('is-active');
    } else {
      // edit

      $(".object-settings-tab-settings").append($("#create-youtube-settings"));
      $('#youtube_id').val(data.video_id);
      $('.object-menu').addClass('is-active');
    }
  }

  createSceneChangeTarget = (objTargetId) => {
    // let objTargetId = this.elementSelected.parent.getTargetId();
    $('.scenes').html("");

    for (let scene of this.scenes) {
      const id = scene.id;
      const name = scene.publicName;
      const imagePath = scene.background.mediumPath;

      const extension = imagePath.split('.');
      const ext = `.${extension[extension.length - 1]}`;
      let thumb = imagePath.replace(ext, `_thumb${ext}`);

      $('.scenes').append(`
      <div class='${id === objTargetId ? 'target_scene active' : 'target_scene'}'>
        <input type='hidden' class='roomID' value='${id}' />
        <img src='${thumb}' onError='this.src = this.src.includes("_thumb") ? "${imagePath}" : "./textures/empty.png"' />
        <div class='targetSceneName' title='Scene ID: ${id}'>${name}</div>
      </div>
    `);
    }

  }

  showScreenShareModal = (event = 'add', data) => {

    $(".add_screen_holder .modal-data").append($("#create-screen-settings"));
    let radios = $('#create-screen-settings .radio-button input[type="radio"]');
    radios.each(function () {
      if (data) {
        if ($(this).val() === data.whoCanStream) {
          $(this).prop('checked', true);
        }
      } else {
        if ($(this).val() === 'everyone') {
          $(this).prop('checked', true);
        }
      }
    });

    if (event === 'add') {
      $(".add_screen_holder").addClass("is-active");
    } else {
      $(".object-settings-tab-settings").append($("#create-screen-settings"));
    }

  }

  showSceneChangeModal = (event = 'add', data) => {
    let objTargetId = '';
    $(".scenes_target_holder .modal-data").append($("#create-sceneChange-settings"));
    $(".scenes_target_holder").removeClass("sceneChangeTarget"); //controls buttons visibility

    if (event === 'add') {
      this.elementSelected = null;
      $('.object-menu').removeClass('is-active edit');
      $("#scene_change_image").attr("src", "./textures/icons/edit_change_scene.png");
      $("#scene_change_image_aspect_ratio").val("1");
      $("#use_scene_change_icon").prop('checked', true);
      this.toggleSceneChangeIcon();
      this.createSceneChangeTarget(objTargetId);
      $(".scenes_target_holder").addClass("is-active");
    }
    if (event === 'edit') {
      if (!$('.object-menu').hasClass('is-active')) {
        $('.object-menu').addClass('is-active'); //going back to edit element object-menu after changing scene target in modal
      } else {
        if (data.hasOwnProperty('image')) {
          $("#scene_change_image").attr('src', data.image.url || './textures/icons/edit_change_scene.png');
        }
      }
      const hasImage = !!(data.image?.url);
      const useIcon = data.useIcon !== undefined ? data.useIcon === true : !hasImage;
      $("#use_scene_change_icon").prop('checked', useIcon);
      this.toggleSceneChangeIcon();
      $(".object-settings-tab-settings").append($("#create-sceneChange-settings"));
      // objTargetId = this.elementSelected.parent.getTargetId();
      this.createSceneChangeTarget(data.goToSceneId);
    }
    if (event === 'scene') { //modal only for changing scene target
      $('.object-menu').removeClass('is-active edit');
      $(".scenes_target_holder").addClass("sceneChangeTarget");
      $("#create-sceneChange-settings .upload-data").hide();
      objTargetId = this.elementSelected.parent.getTargetId();
      this.createSceneChangeTarget(objTargetId);
      $(".scenes_target_holder").addClass("is-active");
    }


  }

  toggleSceneChangeIcon = () => {
    const parent = this.elementSelected?.parent;
    const useIcon = $("#use_scene_change_icon").is(':checked');
    if (useIcon) {
      $("#scene_change_icon_display").show();
      $("#scene_change_custom_image").hide();
    } else {
      $("#scene_change_icon_display").hide();
      $("#scene_change_custom_image").show();
      const savedUrl = parent?.getCustomImageUrl?.() || parent?.dbConfig?.image?.url;
      if (savedUrl && !String(savedUrl).includes('edit_change_scene')) {
        $("#scene_change_image").attr('src', savedUrl);
      }
    }

    if (parent?.name === 'sceneChange') {
      parent.setUseIcon?.(useIcon);
      this._syncSceneChangeEditIndicator(parent);
    }
  }

  _syncSceneChangeEditIndicator = (parent) => {
    if (!parent || parent.name !== 'sceneChange' || !parent.mesh) return;
    const indicatorMode = typeof parent.isIndicatorMode === 'function'
      ? parent.isIndicatorMode()
      : (!!parent.useIcon || !parent.customIcon);
    if (indicatorMode) {
      this._attachSceneChangeIndicator(parent);
    } else {
      this._removeObjectIndicator(parent.mesh);
    }
    this._refreshSizeDistanceControls?.(this.elementSelected);
  }

  toggleEmbeddedWebpageIcon = () => {
    const parent = this.elementSelected?.parent;
    const useIcon = $("#use_embedded_webpage_icon").is(':checked');
    if (useIcon) {
      $("#embedded_webpage_icon_display").show();
      $("#embedded_webpage_custom_image").hide();
    } else {
      $("#embedded_webpage_icon_display").hide();
      $("#embedded_webpage_custom_image").show();
      const savedUrl = parent?.getCustomImageUrl?.() || parent?.dbConfig?.image?.url;
      if (savedUrl && !String(savedUrl).includes('empty.png')) {
        $("#embedded_webpage_image").attr('src', savedUrl);
        $("#upload_embedded_webpage_image .upload-watermark").addClass("hide");
        $("#removeEmbeddedWebpageImage").addClass("active");
      }
    }

    if (parent?.name === 'embeddedWebpage' && $("#embedded-webpage-modal").hasClass('edit')) {
      parent.setUseIcon?.(useIcon);
      this._syncEmbeddedWebpageEditIndicator(parent);
    }
  }

  _syncEmbeddedWebpageEditIndicator = (parent) => {
    if (!parent || parent.name !== 'embeddedWebpage' || !parent.mesh) return;
    const indicatorMode = typeof parent.isIndicatorMode === 'function'
      ? parent.isIndicatorMode()
      : (!!parent.useIcon || !parent.customIcon);
    if (indicatorMode) {
      this._attachEmbeddedWebpageIndicator(parent);
    } else {
      this._removeObjectIndicator(parent.mesh);
    }
    $(".perspective-settings").toggleClass('hidden', indicatorMode);
    this._refreshSizeDistanceControls?.(this.elementSelected);
  }

  showProfileModal = (event = 'add', data) => {
    if (event === 'add') {
      // add
      $("#profile_holder_title").text($trans('add-profile'));
      $("#profile_holder_title").data('data-lang', 'add-profile');
      $("#profile_image").attr("src", this.ownerAvatarURL);
      $("#dynamicProfileAvatar").prop("checked", true);
      $("#profile_image_upload_container").toggleClass('disabled', true);
      $("#profile_submit").show();
      $("#profile_update").hide();

    } else {
      // edit
      $("#profile_holder_title").text($trans('update-profile'));
      $("#profile_holder_title").data('data-lang', 'update-profile');
      $("#profile_image").attr("src", data.profile.avatarImage.mediumPath);
      $("#dynamicProfileAvatar").prop("checked", data.profile.dynamicProfileAvatar);
      $("#profile_image_upload_container").toggleClass('disabled', data.profile.dynamicProfileAvatar);
      $("#profile_submit").hide();
      $("#profile_update").show();
    }
    $(".profile_holder").addClass("is-active");

  }

  showPayPalDonationModal = (event = 'add', data) => {
    if (event === 'add') {
      $("#paypal_donation_image").attr('src', './textures/banner_placeholder.png');
      $("#paypal_donation_image").removeClass('active');
      $("#paypal_donation_image_aspect_ratio").val("");
      tinymce.get("paypal_donation_text").setContent("");
      $("#paypal_donation_url").val("");
      $(".donation-title").text($trans('add-paypal-donation'));
      $(".donation-title").attr("data-lang", "add-paypal-donation");
      $("#paypal_donation_submit").show();
      $("#paypal_donation_update").hide();
    } else {
      $(".donation-title").text($trans('edit-paypal-donation'));
      $(".donation-title").attr("data-lang", "edit-paypal-donation");
      $("#paypal_donation_image").attr('src', data.image.url ? data.image.url : './textures/banner_placeholder.png');
      $("#paypal_donation_image").toggleClass('active', data.image.url !== '');
      $("#paypal_donation_image_aspect_ratio").val(data.image.aspectRatio);
      tinymce.get("paypal_donation_text").setContent(data.donationDescription);
      $("#paypal_donation_url").val(data.donationURL);
      $("#paypal_donation_update").show();
      $("#paypal_donation_submit").hide();
    }

    $(".paypal_donation_holder").addClass("is-active");
  }

  showViewGalleryModal = (parent) => {
    const config = parent.getDbConfig();
    const useIcon = config.useIcon === true;
    $("#use_gallery_icon").prop('checked', useIcon);
    this.toggleGalleryIconDisplay();

    const previewAssetUrl = getGalleryPreviewAssetUrl(config);
    const previewSrc = previewAssetUrl || getGalleryCoverUrl(config) || GALLERY_DEFAULT_ICON_PATH;
    $("#gallery_preview_image").attr('src', previewSrc);
    $("#gallery_preview_image_aspect_ratio").val(config.previewImage?.aspectRatio || 1);
    $("#removeGalleryPreviewImage").toggle(!!previewAssetUrl);

    const isAutoplay = config.galleryMode === GALLERY_MODE.AUTOPLAY;
    $("#gallery_autoplay").prop('checked', isAutoplay);
    $("#gallery_next_image_duration").val(normalizeNextImageDuration(config.nextImageDuration));
    this._syncGalleryDurationRow();

    parent.createUITemplates();
    $(".view_gallery_modal_edit").addClass("is-active");
    $("#view_gallery_submit").off("click");
    $("#view_gallery_submit").on("click", () => {
      this._applyGalleryPlaybackSettings(parent);
      let config = parent.getDbConfig();
      this.model.showLoading();
      if (config.useIcon) {
        this._syncImageGalleryEditIndicator(parent);
        this.modifyLocalJSON(config);
        $(".view_gallery_modal_edit").removeClass("is-active");
        this.model.hideLoading();
        return;
      }
      const coverUrl = getGalleryCoverUrl(config);
      if (coverUrl) {
        parent.setAvatarImage(coverUrl, () => {
          parent.resetPerspective();
          config = parent.getDbConfig();
          this.modifyLocalJSON(config);
          $(".view_gallery_modal_edit").removeClass("is-active");
          this.model.hideLoading();
        }, true);

      } else {
        this.model.hideLoading();
        $(".view_gallery_modal_edit").removeClass("is-active");
      }

    });

  }

  toggleGalleryIconDisplay = () => {
    const useIcon = $("#use_gallery_icon").is(':checked');
    if (useIcon) {
      $("#gallery_icon_display").show();
      $("#gallery_preview_custom_image").hide();
    } else {
      $("#gallery_icon_display").hide();
      $("#gallery_preview_custom_image").show();
    }
  }

  toggleGalleryIcon = () => {
    this.toggleGalleryIconDisplay();
    const parent = this.elementSelected?.parent;
    if (!parent || parent.name !== 'imageGallery') return;
    const useIcon = $("#use_gallery_icon").is(':checked');
    parent.setUseIcon(useIcon);
    this._syncImageGalleryEditIndicator(parent);
    this.modifyLocalJSON(parent.getDbConfig());
  }

  _syncGalleryDurationRow = () => {
    const isAutoplay = $("#gallery_autoplay").is(':checked');
    $("#gallery_next_image_duration_row").toggle(isAutoplay);
    $("#gallery_next_image_duration").prop('required', isAutoplay);
  }

  _applyGalleryPlaybackSettings = (parent) => {
    if (!parent || parent.name !== 'imageGallery') return;
    const galleryMode = $("#gallery_autoplay").is(':checked') ? GALLERY_MODE.AUTOPLAY : GALLERY_MODE.STATIC;
    const nextImageDuration = normalizeNextImageDuration($("#gallery_next_image_duration").val());
    $("#gallery_next_image_duration").val(nextImageDuration);
    parent.dbConfig = persistGalleryConfig({
      ...parent.getDbConfig(),
      galleryMode,
      nextImageDuration,
    });
  }

  _syncImageGalleryEditIndicator = (parent) => {
    if (!parent || parent.name !== 'imageGallery' || !parent.mesh) return;
    const indicatorMode = typeof parent.isIndicatorMode === 'function'
      ? parent.isIndicatorMode()
      : (!!parent.useIcon || !parent.customIcon);
    if (indicatorMode) {
      this._attachImageGalleryIndicator(parent);
    } else {
      this._removeObjectIndicator(parent.mesh);
    }
    $(".perspective-settings").toggleClass('hidden', indicatorMode);
    this._refreshSizeDistanceControls?.(this.elementSelected);
  }

  showVideoPlayerSettings = (data) => {
    // Move video player settings to sidebar
    $(".object-settings-tab-settings").append($("#create-videoPlayer-settings"));
    $("#create-videoPlayer-settings").show();

    const isVideoBackground = isVideoBackgroundType(this.elementSelected?.parent?.name);

    // Populate form with existing data
    if (data) {
      $("#video_player_title").val(data.videoTitle || '');
      $("#video_player_url").val(data.videoUrl || '');
      $("#use_video_icon").prop('checked', isVideoBackground ? false : data.useIcon !== false);
      $("#video_player_autoplay").prop('checked', data.autoplay === true || data.autoplay === '2');
      $("#video_player_play_loop").prop('checked', data.playLoop !== false && data.playLoop !== 'false' && data.playLoop !== '0');
      $("#video_player_play_on_click").prop('checked', data.playOnClick !== false && data.playOnClick !== 'false' && data.playOnClick !== '0');
      $("#video_player_transparent_background").prop('checked', data.transparentBackground === true);

      const previewImage = isVideoBackground
        ? (data.placeholderImage || '/textures/icons/edit_play_video.png')
        : (data.customImage || '/textures/icons/edit_play_video.png');
      $("#video_player_image").attr('src', previewImage);
      this._syncVideoPlayerPlaceholderRemoveBtn();

      // Update video info if available
      if (data.videoFilename) {
        // Hide placeholder, show thumbnail and info
        $("#video_placeholder_text").hide();
        $("#video_thumbnail").show().attr('src', data.videoThumbnail || '');
        $("#video_filename").text(data.videoFilename);
        $("#video_filesize").text(data.videoFilesize || '');

        // Restore dimension data
        if (data.videoWidth && data.videoHeight) {
          $("#video_dimension").data('width', data.videoWidth);
          $("#video_dimension").data('height', data.videoHeight);
          $("#video_dimension").data('ratio', data.videoRatio);
        }
        $("#video_dimension").text(data.videoDimension || '');

        $("#video_play_btn").prop('disabled', false);
      } else {
        // Show placeholder, hide thumbnail
        $("#video_placeholder_text").show();
        $("#video_thumbnail").hide().attr('src', '');
        $("#video_filename").text('');
        $("#video_filesize").text('');
        $("#video_dimension").text('').removeData('width height ratio');
        $("#video_play_btn").prop('disabled', true);
      }
    }

    // Show/hide icon or custom image based on toggle
    if (isVideoBackground) {
      this.toggleVideoPlayer3dPlacement();
    } else {
      this.toggleVideoPlayerClassicSettings();
    }
    this.toggleVideoPlayerIcon();
    this._syncVideoPlayerPlaceholderRemoveBtn();
  }

  _syncVideoPlayerPlaceholderRemoveBtn = () => {
    const src = $("#video_player_image").attr('src') || '';
    const isDefault = !src || src.includes('edit_play_video.png');
    $("#removeVideoPlayerPlaceholderImage").toggle(!isDefault);
  }

  showMusicObjectSettings = (data) => {
    const $panel = $('.object-settings-tab-settings');
    const $settings = $('#create-musicObject-settings');
    if ($settings.length && !$settings.parent().is($panel)) {
      $panel.append($settings);
    }
    $settings.show();
    $('#music_object_name').val(data?.name || '');
    $('#music_object_audio_url').val(data?.audioUrl || '');
    const filename = data?.audioUrl ? String(data.audioUrl).split('/').pop() : '';
    $('#music_object_audio_filename').text(filename || '');
    const musicParent = this._resolveEditableObject(this.elementSelected);
    const audioEl = musicParent?.audioEl;
    this._setMusicPreviewPlaying(!!(audioEl && !audioEl.paused && !audioEl.ended));
  }

  autoSaveMusicObject = () => {
    const parent = this._getMusicObjectInstance();
    if (!parent) {
      return;
    }
    const updatedConfig = {
      name: $("#music_object_name").val(),
      audioUrl: $("#music_object_audio_url").val(),
    };
    parent.setDbConfig(updatedConfig);
    this.modifyLocalJSON(updatedConfig);
    this._refreshElementNameDisplays();
  }

  autoSaveVideoPlayer = () => {
    if (!this.elementSelected || !isVideoPlayerType(this.elementSelected.parent.name)) {
      return;
    }

    const parent = this.elementSelected.parent;
    const isVideoBackground = isVideoBackgroundType(parent.name);

    if (isVideoBackground) {
      const imgSrc = $("#video_player_image").attr('src');
      const isDefaultPlaceholder = !imgSrc || imgSrc.includes('edit_play_video.png');
      const updatedConfig = {
        videoTitle: $("#video_player_title").val(),
        videoUrl: $("#video_player_url").val(),
        useIcon: false,
        placeAs3dElement: true,
        customImage: parent.dbConfig.customImage || null,
        placeholderImage: isDefaultPlaceholder ? null : imgSrc,
        customImageAspectRatio: $("#video_player_image_aspect_ratio").val(),
        videoFilename: $("#video_filename").text(),
        videoFilesize: $("#video_filesize").text(),
        videoDimension: $("#video_dimension").text(),
        videoWidth: $("#video_dimension").data('width') || null,
        videoHeight: $("#video_dimension").data('height') || null,
        videoRatio: $("#video_dimension").data('ratio') || null,
        videoThumbnail: $("#video_thumbnail").attr('src'),
        autoplay: $("#video_player_autoplay").is(':checked'),
        playLoop: $("#video_player_play_loop").is(':checked'),
        playOnClick: $("#video_player_play_on_click").is(':checked'),
        transparentBackground: $("#video_player_transparent_background").is(':checked'),
        scene3dPerspectiveApplied: parent.dbConfig.scene3dPerspectiveApplied === true,
      };
      parent.setDbConfig(updatedConfig);

      const perspectivePayload = parent.getPerspectiveSavePayload?.() || {};
      Object.assign(updatedConfig, perspectivePayload);

      this.modifyLocalJSON(updatedConfig);
      this._syncVideoPlayerEditIndicator(parent);
      this._refreshElementNameDisplays();
      return;
    }

    const imgSrc = $("#video_player_image").attr('src') || '';
    const isDefaultImage = !imgSrc || imgSrc.includes('edit_play_video.png');
    const useIcon = $("#use_video_icon").is(':checked');
    const updatedConfig = {
      videoTitle: $("#video_player_title").val(),
      videoUrl: $("#video_player_url").val(),
      useIcon,
      customImage: useIcon
        ? (parent.videoPlayerImage || parent.dbConfig?.customImage || null)
        : (isDefaultImage ? null : imgSrc),
      customImageAspectRatio: $("#video_player_image_aspect_ratio").val(),
      videoFilename: $("#video_filename").text(),
      videoFilesize: $("#video_filesize").text(),
      videoDimension: $("#video_dimension").text(),
      videoWidth: $("#video_dimension").data('width') || null,
      videoHeight: $("#video_dimension").data('height') || null,
      videoRatio: $("#video_dimension").data('ratio') || null,
      videoThumbnail: $("#video_thumbnail").attr('src'),
    };
    parent.setDbConfig(updatedConfig);

    const dbConfig = parent.getDbConfig();
    updatedConfig.original = {};
    ['topLeft', 'topRight', 'bottomRight', 'bottomLeft'].forEach((corner) => {
      updatedConfig[corner] = dbConfig[corner];
      updatedConfig.original[corner] = dbConfig.original[corner];
    });

    this.modifyLocalJSON(updatedConfig);
    this._syncVideoPlayerEditIndicator(parent);
    this._refreshElementNameDisplays();
  }

  toggleVideoPlayerClassicSettings = () => {
    const useIconRow = $("#use_video_icon").closest(".video-player-settings__icon-toggle");
    const iconDisplay = $("#video_icon_display");
    const customImage = $("#video_custom_image");
    const placeholderInfo = $("#video_3d_placeholder_info");
    const autoplayRow = $("#video_3d_autoplay_row");
    const playOnClickRow = $("#video_3d_play_on_click_row");
    const playLoopRow = $("#video_3d_play_loop_row");
    const transparentRow = $("#video_3d_transparent_row");
    const transparentInfo = $("#video_transparent_background_info");

    useIconRow.show();
    placeholderInfo.hide();
    autoplayRow.hide();
    playOnClickRow.hide();
    playLoopRow.hide();
    transparentRow.hide();
    transparentInfo.hide();
  }

  toggleVideoPlayer3dPlacement = () => {
    const useIconRow = $("#use_video_icon").closest(".video-player-settings__icon-toggle");
    const iconDisplay = $("#video_icon_display");
    const customImage = $("#video_custom_image");
    const placeholderInfo = $("#video_3d_placeholder_info");
    const autoplayRow = $("#video_3d_autoplay_row");
    const playOnClickRow = $("#video_3d_play_on_click_row");
    const playLoopRow = $("#video_3d_play_loop_row");
    const transparentRow = $("#video_3d_transparent_row");
    const transparentInfo = $("#video_transparent_background_info");

    useIconRow.hide();
    iconDisplay.hide();
    customImage.show();
    placeholderInfo.show();
    autoplayRow.show();
    playOnClickRow.show();
    playLoopRow.show();
    transparentRow.show();
    transparentInfo.show();

    if (this.elementSelected && isVideoPlayerType(this.elementSelected.parent.name)) {
      const parent = this.elementSelected.parent;
      const previewImage = parent.dbConfig.placeholderImage || '/textures/icons/edit_play_video.png';
      $("#video_player_image").attr('src', previewImage);
      this._syncVideoPlayerPlaceholderRemoveBtn();
      if (parent.model?.editMode) {
        parent.ensurePerspectiveDragPoints();
      }
      this.autoSaveVideoPlayer();
    }
  }

  toggleVideoPlayerIcon = () => {
    if (this.elementSelected && isVideoBackgroundType(this.elementSelected.parent.name)) {
      return;
    }

    const useIcon = $("#use_video_icon").is(':checked');
    const iconDisplay = $("#video_icon_display");
    const customImage = $("#video_custom_image");

    if (useIcon) {
      iconDisplay.show();
      customImage.hide();
    } else {
      iconDisplay.hide();
      customImage.show();
    }

    if (this.elementSelected && this.elementSelected.parent.name === 'videoPlayer') {
      const parent = this.elementSelected.parent;
      parent.setUseIcon(useIcon);
      this._syncVideoPlayerEditIndicator(parent);
    }
  }

  _syncVideoPlayerEditIndicator = (parent) => {
    if (!parent || parent.name !== 'videoPlayer' || !parent.mesh) return;
    const indicatorMode = typeof parent.isIndicatorMode === 'function'
      ? parent.isIndicatorMode()
      : (!!parent.useIcon || !parent.customIcon);
    if (indicatorMode) {
      this._attachVideoPlayerIndicator(parent);
    } else {
      this._removeObjectIndicator(parent.mesh);
    }
    $(".perspective-settings").toggleClass('hidden', indicatorMode);
    this._refreshSizeDistanceControls?.(this.elementSelected);
  }

  showAddVideoModal = (event = 'add', data) => {
    $(".add-video-element-modal").addClass("is-active");
  }
  showProductsModal = (event = 'add', data) => {
    let lastProdNum = parseInt($('#products').find('.product-container').last().attr('data-order'));
    if (lastProdNum > 1) {
      $('.product-container').each((index, element) => {
        if (index > 0) { element.remove(); }
      });
    }
    if (event === 'add') {
      let product = $('#products').find('.product-container').last();
      emptyProductValues(product);
      $('.products-title').text($trans('add-products-text'));
      $('.products-title').attr('data-lang', 'add-products-text');
      $(".shop_holder").addClass("is-active");
      $(".shop_holder").removeClass("edit");
      tinymce.get("product_description1").setContent('');
    } else {
      $('.products-title').text($trans('edit-products-text'));
      $('.products-title').attr('data-lang', 'edit-products-text');
      $(".shop_holder").addClass("is-active edit");
      let products = data.products;
      let total = Object.entries(products).length;
      for (let i = 0; i < total; i++) {
        if (i > 0) {
          $('#add_more_products').trigger('click');
        }
        let num = i + 1;
        const product = products[i];
        $("#product_description" + num).val(product.product_description);
        tinymce.init({
          selector: '#product_description' + num,
          menubar: false,
          height: 200,
        });
        tinymce.get("product_description" + num).setContent(product.product_description);
        $(".product-container[data-order=" + num + "] input[name=product_name]").val(product.product_name);
        $(".product-container[data-order=" + num + "] .upload_product_image .default_image").attr('src', product.product_image);
        $(".product-container[data-order=" + num + "] input[name=product_image]").val(product.product_image);
        $(".product-container[data-order=" + num + "] input[name=product_price]").val(product.product_price);
        $(".product-container[data-order=" + num + "] input[name=product_url]").val(product.product_url);
        $(".product-container[data-order=" + num + "] input[name=product_button_label]").val(product.product_button_label);

      }

    }
  }

  mapInitialization = () => {
    this.map = L.map('leaflet-map-container');

    const updateCoordinates = (latlng, both = true) => {
      $("#room_longitude").val(latlng.lng);
      $("#room_latitude").val(latlng.lat);
      both ? $(".submit_coordinates").addClass("active") : $("#delete_coordinates").addClass('active');
    }

    if (this.worldCoordinates.lat !== null) {
      this.map.setView(this.worldCoordinates, 13);
      updateCoordinates(this.worldCoordinates, false);
      $(".show_coordinates_modal").text($trans('update-text'));
      $(".show_coordinates_modal").attr('data-lang', 'update-text');
      $("#latlng_preview").text(`${(this.worldCoordinates.lng * 1).toFixed(3)}, ${(this.worldCoordinates.lat * 1).toFixed(3)}`);
      $("#roomCoordinatesDetails").addClass('visible');
    } else {
      $(".show_coordinates_modal").text($trans('set-text'));
      $(".show_coordinates_modal").attr('data-lang', 'set-text');
      $("#latlng_preview").text('');
      $("#roomCoordinatesDetails").removeClass('visible');
    }

    this.tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      nowrap: true
    }).addTo(this.map);

    this.positionMarker = new L.marker(null, { draggable: true, riseOnHover: true });

    this.positionMarker.on('dragend', () => {
      const position = this.positionMarker.getLatLng();
      updateCoordinates(position);
    });

    this.map.addEventListener('click', (e) => {
      this.positionMarker.setLatLng(e.latlng).addTo(this.map);
      updateCoordinates(e.latlng);
    });

    $("#show_coordinates_modal").on("click", () => {
      $(".room_coordinates").addClass("is-active");
      this.map.invalidateSize();
      $("#submit_coordinates").removeClass("active");

      // fetch data from DB
      if (this.worldCoordinates.lat !== null) {
        this.positionMarker.setLatLng(this.worldCoordinates).addTo(this.map);
        updateCoordinates(this.worldCoordinates, false);
        this.map.setView(this.worldCoordinates, 13);
      } else { // if data for lat and lng are null, set map view to user location (if the user allow it)
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((latlng) => {
            this.map.setView({ lat: latlng.coords.latitude, lng: latlng.coords.longitude }, 13);
          }, (err) => console.log(err));
        }
      }
    });

    $("#submit_coordinates").on("click", () => {
      const lng = $("#room_longitude").val() * 1;
      const lat = $("#room_latitude").val() * 1;
      this.saveCoordinates({ lat, lng });
      $("#submit_coordinates").removeClass("active");
      $(".show_coordinates_modal").text($trans('update-text'));
      $(".show_coordinates_modal").attr('data-lang', 'update-text');
      $("#latlng_preview").text(`${lng.toFixed(3)}, ${lat.toFixed(3)}`);
      $("#roomCoordinatesDetails").addClass('visible');
    });

    $("#delete_coordinates").on("click", () => {
      $(".submit_coordinates").removeClass("active");
      this.saveCoordinates({ lat: null, lng: null });
      this.map.removeLayer(this.positionMarker);
      $("#room_longitude").val('');
      $("#room_latitude").val('');
      $(".show_coordinates_modal").text($trans('set-text'));
      $(".show_coordinates_modal").attr('data-lang', 'set-text');
      $("#latlng_preview").text('');
      $("#roomCoordinatesDetails").removeClass('visible');
    });

    $("#close-coordinates-modal").on("click", () => {
      $(".room_coordinates").removeClass("is-active");
    });

    this.initWorldVersionDropdown()
  }

  saveCoordinates = (latlng) => {
    this.worldCoordinates = latlng;
    this.model.saveWorldCoordinates({
      url: this.worldCoordinatesUrl,
      worldID: this.worldID,
      latlng
    });
  }

  _buildWorld(texture) {
    Scene3D.prototype._buildWorld.call(this, texture);
    if (this.pendingAgentSelect) {
      const { agentId, openEdit } = this.pendingAgentSelect;
      this.pendingAgentSelect = null;
      const chair = this.vraiAgentChairs?.find(c => String(c.id || c.getId?.()) === String(agentId));
      if (chair) {
        this.deselectElement();
        this.elementSelected = chair;
        $("#elementSelected").val(chair.getId?.() ?? chair.id);
        if (chair.toggleSelect) chair.toggleSelect();
        chair.showObjectMenu?.();
        this._updateVraiAgentChairsVisibility();
        if (openEdit && editElement) editElement.click();
      }
    } else {
      this._updateVraiAgentChairsVisibility();
    }
    this._applyLockedToAllAgents();
    this._applyEditElementStateToScene();
  }

  _toggleAgentLock(agentId, sceneIndex, locked) {
    const objs = this._getAgentSceneObjects(agentId, sceneIndex);
    if (!objs?.chair) return;
    objs.chair.lockedInEdit = !!locked;
    this._updateVraiAgentChairsVisibility();
    this.updateDB();
    this._renderAiAgentsList();
  }

  _applyLockedToAllAgents() {
    this._updateVraiAgentChairsVisibility();
  }

  _getAgentSceneObjects(agentId, sceneIndex) {
    const scene = this.scenes?.[sceneIndex];
    if (!scene?.objects) return null;
    const chair = scene.objects.find(o => o.type === 'vraiAgent' && (o.id === agentId || o.unique_id === agentId));
    if (!chair) return null;
    const sid = String(agentId);
    const camera = scene.objects.find(o => o.type === 'vapiUserCamera' && String(o.vapiAgentId) === sid);
    const transcription = scene.objects.find(o => o.type === 'vapiTranscription' && String(o.vapiAgentId) === sid);
    const buttons = scene.objects.filter(o => o.type === 'vapiButton' && String(o.vapiAgentId) === sid);
    return { chair, camera, transcription, buttons };
  }

  _renderAiAgentsList() {
    const placedAgents = [];
    (this.scenes || []).forEach((scene, sceneIndex) => {
      (scene.objects || []).filter(o => o.type === 'vraiAgent').forEach(obj => {
        placedAgents.push({
          id: obj.id || obj.unique_id,
          chairName: obj.chairName || $trans('vrai-agent-text'),
          sceneIndex,
          locked: !!obj.lockedInEdit,
          isSquad: !!(obj.isSquad),
        });
      });
    });
    const $list = $("#ai_agents_list");
    $list.empty();

    const isOwner = this.model.userIsOwner === true;
    const renderPlaced = () => {
      if (placedAgents.length) {
        $list.append(`<div class="ai-agents-section-label caption_regular" data-lang="ai-agents-in-space">In this space</div>`);
      }
      placedAgents.forEach(({ id, chairName, sceneIndex, locked, isSquad }) => {
        const typeIcon = isSquad
          ? `<span class="material-icons-outlined md-16 ai-agent-type-icon ai-agent-type-squad" title="AI Squad" style="color:#a78bfa;flex-shrink:0;">groups</span>`
          : `<span class="material-icons-outlined md-16 ai-agent-type-icon ai-agent-type-agent" title="AI Agent" style="color:#4a9eff;flex-shrink:0;">smart_toy</span>`;
        $list.append(`
          <div class="ai-agent-item flx-sb ai-agent-placed" data-agent-id="${id}" data-scene-index="${sceneIndex}">
            <div class="ai-agent-lock customCheckbox">
              <input type="checkbox" id="ai-agent-lock-${id}" class="ai-agent-lock-checkbox" ${locked ? 'checked' : ''} />
              <label for="ai-agent-lock-${id}">
                <span class='material-icons-outlined md-18 box_uncheck'>lock_open</span>
                <span class='material-icons-outlined md-18 box_check'>lock</span>
              </label>
            </div>
            ${typeIcon}
            <span class="ai-agent-name">${$('<div>').text(chairName || '').html()}</span>
            <div class="ai-agent-actions">
              <span class="ai-agent-test material-icons-outlined md-18" title="${$trans('test-agent-text', {}, 'Test agent')}">play_arrow</span>
              <span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text')}">edit</span>
              ${isOwner ? `<span class="ai-agent-delete material-icons-outlined md-18" title="${$trans('delete-text') || 'Delete'}">delete</span>` : ''}
            </div>
          </div>
        `);
      });
    };

    const renderLibrary = (libraryAgents) => {
      const agents = libraryAgents || [];
      if (agents.length) {
        $list.append(`<div class="ai-agents-section-label caption_regular" data-lang="ai-agents-your-library">Your library</div>`);
      }
      agents.forEach((a) => {
        const name = a.name || a.vapi_assistant_id || 'AI Agent';
        const fullConfig = buildFullAgentConfigFromLibrary(a);
        const isSquad = !!(fullConfig?.isSquad);
        const chairScenario = (fullConfig?.chairScenario || '').replace(/"/g, '&quot;');
        const agentImage = (a.agent_image || '').replace(/"/g, '&quot;');
        const typeIcon = isSquad
          ? `<span class="material-icons-outlined md-16 ai-agent-type-icon ai-agent-type-squad" title="AI Squad" style="color:#a78bfa;flex-shrink:0;">groups</span>`
          : `<span class="material-icons-outlined md-16 ai-agent-type-icon ai-agent-type-agent" title="AI Agent" style="color:#4a9eff;flex-shrink:0;">smart_toy</span>`;
        $list.append(`
          <div class="ai-agent-item flx-sb ai-agent-library" data-library-id="${a.id}" data-library-name="${$('<div>').text(name).html().replace(/"/g, '&quot;')}" data-library-assistant-id="${(a.vapi_assistant_id || '').replace(/"/g, '&quot;')}" data-library-image="${agentImage}" data-library-scenario="${chairScenario}" data-library-is-squad="${isSquad ? '1' : '0'}" data-library-key-type="${a.keyType === 'private' ? 'private' : 'missing'}">
            ${typeIcon}
            <span class="ai-agent-name">${$('<div>').text(name).html()}</span>
            <div class="ai-agent-actions">
              <span class="ai-agent-test material-icons-outlined md-18" title="${$trans('test-agent-text', {}, 'Test agent')}">play_arrow</span>
              <span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text')}">edit</span>
              <span class="ai-agent-delete material-icons-outlined md-18" title="${$trans('delete-text') || 'Delete'}">delete</span>
            </div>
          </div>
        `);
      });
    };

    if (!placedAgents.length) {
      this.model.worldFetcher.listVapiAgents(
        this.worldID,
        (res) => {
          const libraryAgents = res?.agents || [];
          if (!libraryAgents.length) {
            $list.append(`<div class="ai-agents-empty caption_regular">${$trans('no-vrai-agents-text') || 'No AI agents in this space.'}</div>`);
          } else {
            renderLibrary(libraryAgents);
          }
        },
        () => {
          $list.append(`<div class="ai-agents-empty caption_regular">${$trans('no-vrai-agents-text') || 'No AI agents in this space.'}</div>`);
        }
      );
    } else {
      renderPlaced();
      this.model.worldFetcher.listVapiAgents(this.worldID, (res) => {
        renderLibrary(res?.agents || []);
      }, () => { });
    }
  }

  _copyAiTokenLink(url) {
    copyTextToClipboard(url).then(() => {
      this.model.alert?.('success', $trans('link-copied') || 'Copied to clipboard');
    }).catch(() => {
      this.model.alert?.('error', $trans('copy-failed') || 'Could not copy link');
    });
  }

  _renderAiTokensList() {
    const $list = $("#ai_tokens_list");
    if (!$list.length) return;
    const defaultUrl = getSpaceViewBaseUrl();
    $("#ai_token_default_link").val(defaultUrl);
    const worldId = this.worldID || this.model?.config?.worldId;
    if (!worldId || !this.model?.worldFetcher?.listVapiAiTokens) {
      $list.html(`<div class="ai-tokens-empty caption_regular">${$trans('no-ai-tokens-text') || 'No AI tokens yet.'}</div>`);
      return;
    }
    this.model.worldFetcher.listVapiAiTokens(
      worldId,
      (res) => {
        const tokens = res?.tokens || [];
        if (!tokens.length) {
          $list.html(`<div class="ai-tokens-empty caption_regular">${$trans('no-ai-tokens-text') || 'No AI tokens yet.'}</div>`);
          return;
        }
        $list.empty();
        this._aiTokensCache = {};
        tokens.forEach((row) => {
          this._aiTokensCache[row.id] = row;
          const name = escapeHtml(row.name || row.token || '');
          const token = escapeHtml(row.token || '');
          const calls = Number(row.call_count || 0);
          $list.append(`
            <div class="ai-token-item flx-sb" data-id="${row.id}" data-token="${token}">
              <div class="ai-token-meta">
                <span class="ai-token-name">${name}</span>
                <span class="ai-token-code caption_regular">${token}</span>
              </div>
              <span class="ai-token-calls caption_regular">${calls} ${$trans('ai-token-calls') || 'calls'}</span>
              <div class="ai-token-actions">
                <span class="ai-token-copy-link material-icons-outlined md-18" title="${$trans('ai-token-copy-link') || 'Copy link'}">link</span>
                <span class="ai-token-test material-icons-outlined md-18" title="${$trans('test-agent-text', {}, 'Test agent')}">play_arrow</span>
                <span class="ai-token-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span>
                <span class="ai-token-delete material-icons-outlined md-18" title="${$trans('delete-text') || 'Delete'}">delete</span>
              </div>
            </div>
          `);
        });
      },
      () => {
        $list.html(`<div class="ai-tokens-empty caption_regular">${$trans('no-ai-tokens-text') || 'No AI tokens yet.'}</div>`);
      }
    );
  }

  _openAiTokenModal(row = null) {
    const editing = !!(row && row.id);
    $("#ai_token_edit_id").val(editing ? row.id : '');
    $("#ai_token_name").val(editing ? (row.name || '') : '');
    $("#ai_token_value").val(editing ? (row.token || '') : '');
    $("#ai_token_prompt").val(editing ? (row.prompt || '') : '');
    const title = editing
      ? ($trans('edit-ai-token') || 'Edit AI token')
      : ($trans('add-ai-token') || 'Add AI token');
    $("#ai_token_modal_title").text(title);
    $("#ai_token_submit").toggle(!editing);
    $("#ai_token_update").toggle(editing);
    $(".ai_token_holder").addClass("is-active");
  }

  _saveAiToken(isUpdate) {
    const worldId = this.worldID || this.model?.config?.worldId;
    const name = ($("#ai_token_name").val() || '').trim();
    const token = ($("#ai_token_value").val() || '').trim();
    const prompt = ($("#ai_token_prompt").val() || '').trim();
    if (!name || !prompt) {
      this.model.alert?.('error', $trans('ai-token-required-fields') || 'Name and prompt are required');
      return;
    }
    const onSuccess = () => {
      $(".ai_token_holder").removeClass("is-active");
      this._renderAiTokensList();
    };
    const onError = (e) => {
      this.model.alert?.('error', e?.response?.data?.error || ($trans('ai-token-save-failed') || 'Failed to save token'));
    };
    if (isUpdate) {
      const id = parseInt($("#ai_token_edit_id").val(), 10);
      if (!id) return;
      this.model.worldFetcher.updateVapiAiToken(worldId, { id, name, token, prompt }, onSuccess, onError);
    } else {
      this.model.worldFetcher.createVapiAiToken(worldId, { name, token, prompt }, onSuccess, onError);
    }
  }

  _deleteAiToken(id) {
    if (!id) return;
    const worldId = this.worldID || this.model?.config?.worldId;
    this.model.confirm($trans('ai-token-delete-confirm') || 'Delete this AI token?', () => {
      this.model.worldFetcher.deleteVapiAiToken(
        worldId,
        id,
        () => this._renderAiTokensList(),
        (e) => this.model.alert?.('error', e?.response?.data?.error || ($trans('ai-token-delete-failed') || 'Failed to delete token'))
      );
    });
  }

  _deletePlacedAgentFromAssets(agentId, sceneIndex) {
    if (!this.model.userIsOwner) {
      this.model.alert?.('error', $trans('only-owner-can-delete-agent') || 'Only the space owner can delete agents.');
      return;
    }
    const scene = this.scenes?.[sceneIndex];
    if (!scene?.objects) return;
    const sid = String(agentId);
    const toRemove = scene.objects.filter(o =>
      (o.type === 'vraiAgent' && (String(o.id || o.unique_id) === sid)) ||
      (o.type === 'vapiUserCamera' && String(o.vapiAgentId) === sid) ||
      (o.type === 'vapiTranscription' && String(o.vapiAgentId) === sid) ||
      (o.type === 'vapiButton' && String(o.vapiAgentId) === sid)
    );
    if (!toRemove.length) return;
    if (sceneIndex === this.currentSceneIndex) {
      const chair = this.vraiAgentChairs?.find(c => String(c.id || c.getId?.()) === sid);
      const camera = this.vraiAgentCameras?.find(c => String(c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === sid);
      const transcription = this.vraiAgentTranscriptions?.find(t => String(t.dbConfig?.vapiAgentId ?? t.getDbConfig?.()?.vapiAgentId) === sid);
      const buttons = this.vraiAgentButtons?.filter(b => String(b.dbConfig?.vapiAgentId ?? b.getDbConfig?.()?.vapiAgentId) === sid) || [];
      const anchors = [chair?.anchor, camera?.anchor, transcription?.anchor, ...(buttons || []).map(b => b?.anchor)].filter(Boolean);
      if (anchors.length) this.removeElementsFromScene(anchors);
    } else {
      scene.objects = scene.objects.filter(o => !toRemove.includes(o));
      if (toRemove.some(o => o.type === 'vraiAgent') && this.worldID) {
        this.model.worldFetcher.deleteVapiAgentConfig(this.worldID, agentId, () => { }, (e) => console.warn('[VAPI] deleteConfig failed', e));
      }
      this.updateDB();
      this._renderAiAgentsList();
    }
  }

  _applyLibraryPatchToPlacedChairs(libraryId, patch) {
    if (!libraryId || !patch || !Object.keys(patch).length) return false;
    let updated = false;
    (this.scenes || []).forEach((scene) => {
      (scene.objects || []).forEach((obj) => {
        if (obj.type === 'vraiAgent' && String(obj.vapiLibraryId) === String(libraryId)) {
          Object.assign(obj, patch);
          updated = true;
        }
      });
    });
    (this.vraiAgentChairs || []).forEach((chair) => {
      const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
      if (String(cfg.vapiLibraryId) === String(libraryId)) {
        chair.setDbConfig?.(patch);
        updated = true;
      }
    });
    if (updated) {
      this.scenes[this.currentSceneIndex] = this.currentScene;
      this.updateDB();
    }
    return updated;
  }

  _syncVraiChairLibraryFields(parent, data) {
    const libId = data?.vapiLibraryId;
    const $name = $('#vrai_agent_chair_name_edit');
    const $scen = $('#vrai_agent_chair_scenario_edit');
    const applyFromLibraryRow = (a) => {
      const full = buildFullAgentConfigFromLibrary(a);
      const n = a.name || full.chairName || '';
      const s = full.chairScenario || '';
      $name.val(n);
      $scen.val(s);
      $('#edit_vapi_library_id').val(libId);
      $('#edit_vapi_library_name').val(n);
      $('#edit_vapi_library_scenario').val(s);
      $('#edit_vapi_library_assistant_id').val(a.vapi_assistant_id || '');
      const img = a.agent_image || '';
      const imgSrc = img || './textures/empty.png';
      $('#edit_vapi_library_image').attr('src', imgSrc);
      this.editVapiLibraryImageUrl = img;
      $('#removeEditVapiLibraryImage').toggleClass('active', !!img);
      $name.prop('readonly', true);
      $scen.prop('readonly', true);
    };
    if (!libId) {
      $name.val(data?.chairName || '');
      $scen.val(data?.chairScenario || '');
      $name.prop('readonly', false);
      $scen.prop('readonly', false);
      return;
    }
    const fbPre = buildFullAgentConfigFromLibrary({
      name: data.chairName,
      vapi_assistant_id: data.VAPI_ASSISTANT_ID,
      agent_image: data.agent_image,
      agent_config: data.agent_config
    });
    const preName = data.chairName || fbPre.chairName || '';
    const preScen = data.chairScenario || fbPre.chairScenario || '';
    $name.val(preName);
    $scen.val(preScen);
    $('#edit_vapi_library_id').val(libId);
    $('#edit_vapi_library_name').val(preName);
    $('#edit_vapi_library_scenario').val(preScen);
    $('#edit_vapi_library_assistant_id').val(data.VAPI_ASSISTANT_ID || '');
    $name.prop('readonly', true);
    $scen.prop('readonly', true);
    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const agents = res?.agents || [];
        const a = agents.find((x) => String(x.id) === String(libId));
        if (a) {
          applyFromLibraryRow(a);
        } else {
          const fallback = buildFullAgentConfigFromLibrary({
            name: data.chairName,
            vapi_assistant_id: data.VAPI_ASSISTANT_ID,
            agent_image: data.agent_image,
            agent_config: data.agent_config
          });
          $name.val(data.chairName || fallback.chairName || '');
          $scen.val(fallback.chairScenario || '');
          $('#edit_vapi_library_id').val(libId);
          $('#edit_vapi_library_name').val(data.chairName || fallback.chairName || '');
          $('#edit_vapi_library_scenario').val(fallback.chairScenario || '');
          $('#edit_vapi_library_assistant_id').val(data.VAPI_ASSISTANT_ID || '');
          $name.prop('readonly', true);
          $scen.prop('readonly', true);
        }
      },
      () => {
        const fallback = buildFullAgentConfigFromLibrary({
          name: data.chairName,
          vapi_assistant_id: data.VAPI_ASSISTANT_ID,
          agent_image: data.agent_image,
          agent_config: data.agent_config
        });
        $name.val(data.chairName || fallback.chairName || '');
        $scen.val(fallback.chairScenario || '');
        $('#edit_vapi_library_id').val(libId);
        $('#edit_vapi_library_name').val(data.chairName || fallback.chairName || '');
        $('#edit_vapi_library_scenario').val(fallback.chairScenario || '');
        $('#edit_vapi_library_assistant_id').val(data.VAPI_ASSISTANT_ID || '');
        $name.prop('readonly', true);
        $scen.prop('readonly', true);
      }
    );
  }

  _getSelectedVapiComponentForAgentSettings() {
    const sel = this.elementSelected;
    if (!sel) return null;
    const isVapiComponent = (o) => {
      if (!o) return false;
      const id = o.name || o.type;
      return id === 'vapiUserCamera' || id === 'vapiTranscription' || id === 'vapiButton';
    };
    if (isVapiComponent(sel)) return sel;
    if (isVapiComponent(sel.parent)) return sel.parent;
    let cur = sel.parent;
    for (let i = 0; i < 8 && cur; i++) {
      if (isVapiComponent(cur)) return cur;
      cur = cur.parent;
    }
    return null;
  }

  _getVapiComponentLinkedChair(component) {
    const comp = component || this._getSelectedVapiComponentForAgentSettings();
    const agentId = comp?.dbConfig?.vapiAgentId ?? comp?.getDbConfig?.()?.vapiAgentId;
    if (!agentId) return null;
    return (this.vraiAgentChairs || []).find(c =>
      String(c.id || c.getId?.()) === String(agentId)
    ) || null;
  }

  _getChairForVapiSettingsGroups(seed = null) {
    const isChair = (o) => o && (o.type === 'vraiAgent' || o.name === 'vraiAgent');
    if (seed) {
      // Do not use isVraiAgentParent here — transcription/camera/button also set vraiAgentRoot.
      if (isChair(seed)) return seed;
      const linked = this._getVapiComponentLinkedChair(seed);
      if (linked) return linked;
    }
    return this._getSelectedVraiAgentChairForAgentSettings()
      || this._getVapiComponentLinkedChair()
      || null;
  }

  _getVapiSettingsGroupTarget(groupType, chair = null) {
    const chairInst = this._getChairForVapiSettingsGroups(chair);
    if (!chairInst) return null;
    const chairId = chairInst.getId?.() ?? chairInst.id;
    if (groupType === 'vraiAgent') return chairInst;
    if (groupType === 'vapiTranscription') {
      return (this.vraiAgentTranscriptions || []).find((t) =>
        String(t.dbConfig?.vapiAgentId ?? t.getDbConfig?.()?.vapiAgentId) === String(chairId)
      ) || null;
    }
    if (groupType === 'vapiUserCamera') {
      return (this.vraiAgentCameras || []).find((c) =>
        String(c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === String(chairId)
      ) || null;
    }
    return null;
  }

  _setVapiSettingsGroupOpen(groupType) {
    const $groups = $('.vrai-settings-group');
    if (!$groups.length) return;
    $groups.each((_, el) => {
      const $g = $(el);
      $g.toggleClass('open', $g.data('vapi-group') === groupType);
    });
  }

  _syncVapiSettingsGroupAvailability(chair = null) {
    const chairInst = this._getChairForVapiSettingsGroups(chair);
    const chairId = chairInst?.getId?.() ?? chairInst?.id;
    const hasTranscription = !!(chairId && (this.vraiAgentTranscriptions || []).some((t) =>
      String(t.dbConfig?.vapiAgentId ?? t.getDbConfig?.()?.vapiAgentId) === String(chairId)
    ));
    const hasCamera = !!(chairId && (this.vraiAgentCameras || []).some((c) =>
      String(c.dbConfig?.vapiAgentId ?? c.getDbConfig?.()?.vapiAgentId) === String(chairId)
    ));
    $('.vrai-settings-group[data-vapi-group="vraiAgent"]').toggleClass('is-unavailable', !chairInst);
    $('.vrai-settings-group[data-vapi-group="vapiTranscription"]').toggleClass('is-unavailable', !hasTranscription);
    $('.vrai-settings-group[data-vapi-group="vapiUserCamera"]').toggleClass('is-unavailable', !hasCamera);
  }

  _fillVapiChairSettingsFields(chair) {
    if (!chair) return;
    const data = {
      ...(chair.getDbConfig?.() || chair.dbConfig || {}),
      ...(this.currentScene?.objects?.find((el) => el.id === (chair.getId?.() ?? chair.id)) || {}),
    };
    const chairNameSize = data.chairNameSize || 0.75;
    const chairScenarioSize = data.chairScenarioSize || 0.65;
    const chairIndicatorSize = data.chairIndicatorSize != null ? data.chairIndicatorSize : 44;
    const chairStatusSize = data.chairStatusSize != null ? data.chairStatusSize : 0.85;
    $('#vrai_chair_name_size').val(chairNameSize);
    $('#vrai_chair_name_size_val').text(chairNameSize);
    $('#vrai_chair_scenario_size').val(chairScenarioSize);
    $('#vrai_chair_scenario_size_val').text(chairScenarioSize);
    $('#vrai_chair_indicator_size').val(chairIndicatorSize);
    $('#vrai_chair_indicator_size_val').text(chairIndicatorSize);
    $('#vrai_chair_status_size').val(chairStatusSize);
    $('#vrai_chair_status_size_val').text(chairStatusSize);
    const indicatorOffsetX = Number(data.indicatorOffsetX ?? 0) || 0;
    const indicatorOffsetY = Number(data.indicatorOffsetY ?? 0) || 0;
    $('#vrai_chair_indicator_offset_x').val(indicatorOffsetX);
    $('#vrai_chair_indicator_offset_x_val').text(indicatorOffsetX);
    $('#vrai_chair_indicator_offset_y').val(indicatorOffsetY);
    $('#vrai_chair_indicator_offset_y_val').text(indicatorOffsetY);
    const agentImg = data.agent_image && !String(data.agent_image).includes('empty') ? data.agent_image : './textures/empty.png';
    $('#vrai_agent_image_edit').attr('src', agentImg);
    $('#removeVraiAgentImageEdit').toggleClass('active', !!data.agent_image);
    const comp = data.components || {};
    $('#vrai_component_camera').prop('checked', comp.camera?.active === true);
    $('#vrai_component_show_user_avatar').prop('checked', comp.camera?.showUserAvatar !== false);
    $('#vrai_component_transcription').prop('checked', comp.transcription?.active === true);
    const promptPlaceholder = (typeof $trans !== 'undefined' && $trans('vrai-agent-vapi-prompt-placeholder'))
      || 'e.g. This room is the lobby. Greet visitors and answer questions about the space.';
    $('#vrai_agent_room_prompt_edit').attr('placeholder', promptPlaceholder);
    $('#vrai_agent_room_prompt_edit').val(data.vapiRoomPrompt || '');
    const chairId = chair.getId?.() ?? chair.id;
    this._renderVraiButtonsList?.(chairId);
    this._renderVraiAiEventsList?.(chairId);
    this._syncVraiChairLibraryFields?.(chair, data);
  }

  _fillVapiTranscriptionSettingsFields(transcription, chair = null) {
    const chairInst = chair || this._getChairForVapiSettingsGroups(transcription);
    const chairId = chairInst?.getId?.() ?? chairInst?.id;
    const tSceneObj = chairId
      ? this.currentScene?.objects?.find((o) => o.type === 'vapiTranscription' && o.vapiAgentId === chairId)
      : null;
    const tCfg = transcription?.dbConfig || transcription?.getDbConfig?.() || tSceneObj || {};
    $('#transcription_color_user').val(tCfg.transcriptionUserColor || '#7dd3fc');
    $('#transcription_color_user_hex').val(tCfg.transcriptionUserColor || '#7dd3fc');
    $('#transcription_color_user_role').val(tCfg.transcriptionUserRoleColor || '#ffffff');
    $('#transcription_color_user_role_hex').val(tCfg.transcriptionUserRoleColor || '#ffffff');
    $('#transcription_color_ai').val(tCfg.transcriptionAIColor || '#00d4aa');
    $('#transcription_color_ai_hex').val(tCfg.transcriptionAIColor || '#00d4aa');
    $('#transcription_color_ai_role').val(tCfg.transcriptionAIRoleColor || '#00d4aa');
    $('#transcription_color_ai_role_hex').val(tCfg.transcriptionAIRoleColor || '#00d4aa');
    $('#transcription_color_bg_hex').val(tCfg.transcriptionBackgroundColor || 'transparent');
    $('#transcription_preset').val(tCfg.transcriptionPreset || 'landscape');
    $('#transcription_width').val(tCfg.transcriptionWidth || '');
    $('#transcription_height').val(tCfg.transcriptionHeight || '');
  }

  _fillVapiCameraSettingsFields(camera) {
    const data = camera?.getDbConfig?.() || camera?.dbConfig || {};
    const camSize = Number(data.size ?? data.scale ?? 1) || 1;
    $('#vrai_user_camera_size').val(camSize);
    $('#vrai_user_camera_size_val').text(camSize);
    const camImage = data.imageUrl && !String(data.imageUrl).includes('empty.png') ? data.imageUrl : './textures/empty.png';
    $('#vapi_camera_image_edit').attr('src', camImage);
    $('#removeVapiCameraImageEdit').toggleClass('active', !!data.imageUrl);
    $('#vrai_user_camera_command_text').val(data.commandText || '');
  }

  _populateVapiSettingsGroups(seed, activeGroupType) {
    const chair = this._getChairForVapiSettingsGroups(seed);
    const transcription = this._getVapiSettingsGroupTarget('vapiTranscription', chair);
    const camera = this._getVapiSettingsGroupTarget('vapiUserCamera', chair);
    this._fillVapiChairSettingsFields(chair);
    this._fillVapiTranscriptionSettingsFields(transcription, chair);
    this._fillVapiCameraSettingsFields(camera);
    this._syncVapiSettingsGroupAvailability(chair);
    this._placeVapiComponentSharedSettings?.(activeGroupType === 'vraiAgent');
    if (activeGroupType) {
      this._setVapiSettingsGroupOpen(activeGroupType);
      $('.vrai-settings-group').removeClass('is-selected');
      $(`.vrai-settings-group[data-vapi-group="${activeGroupType}"]`).addClass('is-selected');
    }
  }

  _clearVapiComponentSelectVisual(obj) {
    if (!obj) return;
    if (obj.toggleSelect) obj.toggleSelect();
    else if (obj.parent?.toggleSelect) obj.parent.toggleSelect();
    if (obj.onDeselect) obj.onDeselect();
    else if (obj.parent?.onDeselect) obj.parent.onDeselect();
  }

  _selectVapiSettingsGroup(groupType, options = {}) {
    const {
      forceOpen = true,
      allowCollapse = false,
      targetOverride = null,
    } = options;
    const target = targetOverride || this._getVapiSettingsGroupTarget(groupType);
    if (!target) {
      this._syncVapiSettingsGroupAvailability();
      return null;
    }

    const prev = this.elementSelected;
    const prevRoot = prev?.toggleSelect ? prev : (prev?.parent?.toggleSelect ? prev.parent : prev);
    const nextRoot = target.toggleSelect ? target : (target.parent?.toggleSelect ? target.parent : target);
    if (prevRoot && prevRoot !== nextRoot) {
      this._clearVapiComponentSelectVisual(prevRoot);
    }

    this.elementSelected = target;
    $("#elementSelected").val(target.getId?.() ?? target.id);
    if (prevRoot !== nextRoot) {
      nextRoot?.toggleSelect?.();
      nextRoot?.onSelect?.();
    }

    // Same path as clicking the component in the scene: refresh object-name, Name field, and settings.
    target.showObjectMenu?.();
    if (editElement) {
      $(".object-menu").removeClass("edit");
      $(editElement).trigger("click");
    }

    const $group = $(`.vrai-settings-group[data-vapi-group="${groupType}"]`);
    const shouldOpen = forceOpen || (allowCollapse ? false : true);
    // editElement already populated groups for the selected type; keep accordion state in sync with this click.
    if (!shouldOpen) {
      $('.vrai-settings-group').removeClass('open');
    } else {
      this._setVapiSettingsGroupOpen(groupType);
    }
    $('.vrai-settings-group').removeClass('is-selected');
    $group.addClass('is-selected');

    this._placeVapiComponentSharedSettings?.(groupType === 'vraiAgent');
    this._updateVraiAgentChairsVisibility?.();
    return target;
  }

  _getSelectedVraiAgentChairForAgentSettings() {
    const sel = this.elementSelected;
    if (!sel) return null;
    // Strict chair check only — isVraiAgentParent is also true for sub-components with vraiAgentRoot.
    const isChair = (o) => o && (o.type === 'vraiAgent' || o.name === 'vraiAgent');
    if (isChair(sel)) return sel;
    if (isChair(sel.parent)) return sel.parent;
    let cur = sel.parent;
    for (let i = 0; i < 8 && cur; i++) {
      if (isChair(cur)) return cur;
      cur = cur.parent;
    }
    const linked = this._getVapiComponentLinkedChair(sel);
    if (linked) return linked;
    const cid = sel?.getId?.() ?? sel?.id;
    if (cid != null && isChair(sel) && (this.vraiAgentChairs || []).length) {
      const hit = this.vraiAgentChairs.find((c) => String(c.getId?.() ?? c.id) === String(cid));
      if (hit) return hit;
    }
    return null;
  }

  _syncVraiAgentChairLinkedAgentPanel(chair) {
    const $select = $('#vrai_component_agent_select');
    const $editBtn = $('#vrai_component_agent_edit_asset_btn');
    if (!$select.length || !chair) return;

    const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
    const currentLibraryId = cfg.vapiLibraryId;

    $select.empty().append('<option value="">Loading agents...</option>');
    $select.prop('disabled', true);
    $editBtn.prop('disabled', true);

    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const agents = res?.agents || [];
        $select.empty();
        if (!agents.length) {
          $select.append('<option value="">No AI agents in library</option>');
          $select.prop('disabled', true);
          $editBtn.prop('disabled', true);
          return;
        }
        agents.forEach((a) => {
          const full = buildFullAgentConfigFromLibrary(a);
          const name = (a.name || full.chairName || a.vapi_assistant_id || 'AI Agent').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          $select.append(`<option value="${a.id}">${name}</option>`);
        });
        if (currentLibraryId != null) {
          $select.val(String(currentLibraryId));
        }
        if (!$select.val()) {
          $select.prepend('<option value="">Select library agent</option>');
          $select.val('');
        }
        $select.prop('disabled', false);
        $editBtn.prop('disabled', !$select.val());
      },
      () => {
        $select.empty().append('<option value="">Failed to load agents</option>');
        $select.prop('disabled', true);
        $editBtn.prop('disabled', true);
      }
    );
  }

  _switchVraiChairLibraryAgent(chair, libraryIdRaw) {
    const libraryId = parseInt(libraryIdRaw, 10);
    if (!chair || !libraryId) return;
    const prevCfg = chair.getDbConfig?.() || chair.dbConfig || {};
    if (String(prevCfg.vapiLibraryId) === String(libraryId)) {
      this._syncVraiAgentChairLinkedAgentPanel(chair);
      return;
    }

    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const selected = (res?.agents || []).find((a) => String(a.id) === String(libraryId));
        if (!selected) {
          this.model.alert?.('error', 'Selected AI agent was not found in your library.');
          this._syncVraiAgentChairLinkedAgentPanel(chair);
          return;
        }

        this.model.worldFetcher.switchAgentConfig(
          this.worldID,
          chair.getId?.() ?? chair.id,
          libraryId,
          () => {
            const nextData = mergeLibraryAgentIntoChairConfig(prevCfg, selected, libraryId);

            chair._preservePerspectiveOnNextImageUpdate = true;
            chair.setDbConfig?.(nextData);
            this.elementSelected = chair;
            this.modifyLocalJSON(nextData);
            this._syncVraiChairLibraryFields(chair, { ...(chair.getDbConfig?.() || chair.dbConfig), ...nextData });
            this._syncVraiAgentChairLinkedAgentPanel(chair);
          },
          (e) => {
            this.model.alert?.('error', (e?.response?.data?.error) || 'Failed to switch AI agent');
            this._syncVraiAgentChairLinkedAgentPanel(chair);
          }
        );
      },
      () => {
        this.model.alert?.('error', 'Failed to load AI agents from your library');
        this._syncVraiAgentChairLinkedAgentPanel(chair);
      }
    );
  }

  _syncVapiComponentAgentSettingsPanel(component) {
    const comp = component || this._getSelectedVapiComponentForAgentSettings();
    const $select = $('#vrai_component_agent_select');
    const $editBtn = $('#vrai_component_agent_edit_asset_btn');
    if (!$select.length) return;

    const currentAgentId = comp?.dbConfig?.vapiAgentId ?? comp?.getDbConfig?.()?.vapiAgentId;
    const chairs = (this.vraiAgentChairs || []).filter(Boolean);

    $select.empty();
    if (!chairs.length) {
      $select.append('<option value="">No AI agents in this scene</option>');
      $select.prop('disabled', true);
      $editBtn.prop('disabled', true);
      return;
    }

    chairs.forEach((chair) => {
      const chairId = chair.getId?.() ?? chair.id;
      const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
      const name = (cfg.chairName || $trans('vrai-agent-text') || 'AI Agent').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $select.append(`<option value="${chairId}">${name}</option>`);
    });

    if (currentAgentId != null) {
      $select.val(String(currentAgentId));
      if (!$select.val()) $select.append(`<option value="${String(currentAgentId)}">${$trans('vrai-agent-text') || 'AI Agent'}</option>`);
      $select.val(String(currentAgentId));
    } else {
      const firstVal = $select.find('option:first').val();
      $select.val(firstVal || '');
    }
    $select.prop('disabled', false);

    const linkedChair = this._getVapiComponentLinkedChair(comp);
    const libraryId = linkedChair?.dbConfig?.vapiLibraryId ?? linkedChair?.getDbConfig?.()?.vapiLibraryId;
    $editBtn.prop('disabled', !libraryId);
  }

  _switchVapiComponentAgent(component, nextAgentId) {
    const comp = component || this._getSelectedVapiComponentForAgentSettings();
    if (!comp || !nextAgentId) return;
    const prevAgentId = comp?.dbConfig?.vapiAgentId ?? comp?.getDbConfig?.()?.vapiAgentId;
    if (String(prevAgentId) === String(nextAgentId)) {
      this._syncVapiComponentAgentSettingsPanel(comp);
      return;
    }

    comp.setDbConfig?.({ vapiAgentId: nextAgentId });
    const compId = comp.getId?.() ?? comp.id;
    const sceneObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(compId));
    if (sceneObj) sceneObj.vapiAgentId = nextAgentId;
    this.scenes[this.currentSceneIndex] = this.currentScene;
    this.updateJSON(this.elementSelected);
    this.updateDB();
    this._syncVapiComponentAgentSettingsPanel(comp);
  }

  _openLinkedAgentAssetFromComponent(component) {
    const comp = component || this._getSelectedVapiComponentForAgentSettings();
    const chair = this._getVapiComponentLinkedChair(comp);
    this._openLibraryAssetForChair(chair);
  }

  _openLibraryAssetForChair(chair) {
    if (!chair) {
      this.model.alert?.('error', 'No AI agent selected.');
      return;
    }
    const libraryId = chair?.dbConfig?.vapiLibraryId ?? chair?.getDbConfig?.()?.vapiLibraryId;
    if (!libraryId) {
      this.model.alert?.('error', 'Linked agent does not use a library asset.');
      return;
    }

    const fallbackCfg = chair.getDbConfig?.() || chair.dbConfig || {};
    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const match = (res?.agents || []).find((a) => String(a.id) === String(libraryId));
        if (match) {
          const full = buildFullAgentConfigFromLibrary(match);
          this._openEditVapiLibraryModal(
            match.id,
            match.name || full.chairName || '',
            match.vapi_assistant_id || '',
            match.agent_image || '',
            full.chairScenario || '',
            match.keyType === 'private' ? 'private' : 'missing'
          );
          return;
        }
        this._openEditVapiLibraryModal(
          libraryId,
          fallbackCfg.chairName || '',
          fallbackCfg.VAPI_ASSISTANT_ID || '',
          fallbackCfg.agent_image || '',
          fallbackCfg.chairScenario || ''
        );
      },
      () => {
        this._openEditVapiLibraryModal(
          libraryId,
          fallbackCfg.chairName || '',
          fallbackCfg.VAPI_ASSISTANT_ID || '',
          fallbackCfg.agent_image || '',
          fallbackCfg.chairScenario || ''
        );
      }
    );
  }

  _getTestAgentFromPlaced(obj, sceneIndex, scene = null) {
    const agentId = obj?.id || obj?.unique_id;
    const liveChair = this.vraiAgentChairs?.find((c) => String(c.id || c.getId?.()) === String(agentId));
    const cfg = liveChair?.getDbConfig?.() || liveChair?.dbConfig || obj || {};
    const isSquad = !!(cfg.isSquad || obj?.isSquad);
    const assistantId = isSquad
      ? (cfg.VAPI_SQUAD_ID || cfg.VAPI_ASSISTANT_ID || obj?.VAPI_SQUAD_ID || obj?.VAPI_ASSISTANT_ID || '')
      : (cfg.VAPI_ASSISTANT_ID || obj?.VAPI_ASSISTANT_ID || '');
    const resolvedScene = scene || this.scenes?.[sceneIndex];
    return {
      name: cfg.chairName || obj?.chairName || $trans('vrai-agent-text', {}, 'AI Agent'),
      image: cfg.agent_image || obj?.agent_image || '',
      scenario: cfg.chairScenario || obj?.chairScenario || '',
      isSquad,
      assistantId,
      agentId: String(agentId),
      sceneId: String(resolvedScene?.id || this.currentScene?.id || this.currentSceneId || 'test'),
      libraryId: cfg.vapiLibraryId || obj?.vapiLibraryId || null,
      roomPrompt: cfg.vapiRoomPrompt || obj?.vapiRoomPrompt || '',
    };
  }

  _getPlacedTestAgents() {
    const agents = [];
    (this.scenes || []).forEach((scene, sceneIndex) => {
      (scene.objects || []).forEach((obj) => {
        if (obj?.type !== 'vraiAgent') return;
        agents.push(this._getTestAgentFromPlaced(obj, sceneIndex, scene));
      });
    });
    return agents;
  }

  _getTestAgentFromListItem($item) {
    const agentId = $item.data('agent-id');
    const sceneIndex = $item.data('scene-index');
    const libraryIdRaw = $item.data('library-id');
    if (agentId != null && sceneIndex != null) {
      const scene = this.scenes?.[sceneIndex];
      const obj = (scene?.objects || []).find((o) => o.type === 'vraiAgent' && (String(o.id) === String(agentId) || String(o.unique_id) === String(agentId)));
      return this._getTestAgentFromPlaced(obj || { id: agentId }, sceneIndex, scene);
    }
    const libraryId = libraryIdRaw != null ? libraryIdRaw : null;
    const isSquad = String($item.data('library-is-squad') || '') === '1' || $item.data('library-is-squad') === 1;
    return {
      name: $item.data('library-name') || $trans('vrai-agent-text', {}, 'AI Agent'),
      image: $item.attr('data-library-image') || '',
      scenario: $item.attr('data-library-scenario') || '',
      isSquad,
      assistantId: $item.attr('data-library-assistant-id') || '',
      agentId: libraryId != null ? `library-${libraryId}` : 'test',
      sceneId: String(this.currentScene?.id || this.currentSceneId || this.scenes?.[0]?.id || 'test'),
      libraryId,
      roomPrompt: '',
    };
  }

  _testAgentFromLibraryRow(row) {
    const fullConfig = buildFullAgentConfigFromLibrary(row || {});
    const isSquad = !!(fullConfig?.isSquad);
    return {
      name: row?.name || fullConfig.chairName || $trans('vrai-agent-text', {}, 'AI Agent'),
      image: row?.agent_image || fullConfig.agent_image || '',
      scenario: fullConfig.chairScenario || '',
      isSquad,
      assistantId: isSquad
        ? (fullConfig.VAPI_SQUAD_ID || row?.vapi_assistant_id || '')
        : (row?.vapi_assistant_id || fullConfig.VAPI_ASSISTANT_ID || ''),
      agentId: row?.id != null ? `library-${row.id}` : 'test',
      sceneId: String(this.currentScene?.id || this.currentSceneId || this.scenes?.[0]?.id || 'test'),
      libraryId: row?.id || null,
      roomPrompt: fullConfig.vapiRoomPrompt || '',
    };
  }

  _openTestAgentFromToken($item) {
    const id = $item.data('id');
    const row = this._aiTokensCache?.[id] || this._aiTokensCache?.[String(id)] || {};
    const tokenPrompt = String(row.prompt || '').trim();
    const tokenName = row.name || row.token || '';
    const withToken = (agent) => ({ ...agent, tokenPrompt, tokenName });
    const openAgents = (agents) => {
      if (!agents.length) {
        this.model.alert?.('error', $trans('test-agent-no-agent', {}, 'Add an AI agent first to test this token.'));
        return;
      }
      this._vapiAgentTestModal.open(withToken(agents[0]), agents.map(withToken));
    };
    const placed = this._getPlacedTestAgents();
    if (placed.length) {
      openAgents(placed);
      return;
    }
    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const libraryAgents = (res?.agents || []).map((a) => this._testAgentFromLibraryRow(a));
        openAgents(libraryAgents);
      },
      () => openAgents([])
    );
  }

  _openEditVapiLibraryModal(libraryId, name, assistantId, agentImage = '', chairScenario = '', keyType = 'missing') {
    const hasPrivate = keyType === 'private';
    this.editVapiLibraryHasPrivateKey = hasPrivate;
    $('#edit_vapi_library_id').val(libraryId);
    $('#edit_vapi_library_name').val(name || '');
    $('#edit_vapi_library_scenario').val(chairScenario || '');
    $('#edit_vapi_library_assistant_id').val(assistantId || '');
    $('#edit_vapi_library_private_key').val('');
    $('#edit_vapi_library_key_status').text(
      hasPrivate
        ? ($trans('vapi-library-key-saved-private') || 'A private key is saved. Paste a new one to replace it, or leave this empty.')
        : ($trans('vapi-library-key-missing') || 'No private key is saved. Paste one so calls can start.')
    );
    const imgSrc = agentImage || './textures/empty.png';
    $('#edit_vapi_library_image').attr('src', imgSrc);
    this.editVapiLibraryImageUrl = agentImage || '';
    $('#removeEditVapiLibraryImage').toggleClass('active', !!agentImage);
    const chair = this._getSelectedVraiAgentChairForAgentSettings();
    if (chair && String((chair.getDbConfig?.() || chair.dbConfig || {}).vapiLibraryId) === String(libraryId)) {
      $('#vrai_agent_chair_name_edit').val(name || '');
      $('#vrai_agent_chair_scenario_edit').val(chairScenario || '');
    }
    $('.edit_vapi_library_agent_holder').addClass('is-active');
  }

  _deleteVapiLibraryAgent(libraryId) {
    this.model.worldFetcher.deleteVapiLibraryAgent(
      this.worldID,
      libraryId,
      () => {
        this._renderAiAgentsList();
      },
      (e) => {
        this.model.alert?.('error', (e?.response?.data?.error) || 'Failed to delete agent');
      }
    );
  }

  _selectAgentFromAssets(agentId, sceneIndex, openEdit) {
    if (sceneIndex === this.currentSceneIndex) {
      const chair = this.vraiAgentChairs?.find(c => String(c.id || c.getId?.()) === String(agentId));
      if (chair) {
        this.deselectElement();
        this.elementSelected = chair;
        $("#elementSelected").val(chair.getId?.() ?? chair.id);
        if (chair.toggleSelect) chair.toggleSelect();
        chair.showObjectMenu?.();
        this._updateVraiAgentChairsVisibility();
        if (openEdit && editElement) editElement.click();
      }
      return;
    }
    this.pendingAgentSelect = { agentId, openEdit };
    const $target = $(".bottom-bar-scene").eq(sceneIndex);
    if ($target.length) this.changeScene(".bottom-bar-scene", { currentTarget: $target[0] });
  }

  changeScene = (cls, e) => {
    this._flushPendingSceneRotation();

    const targetSceneIndex = $(cls).index(e.currentTarget);

    const skipRoomLoading = targetSceneIndex === this.currentSceneIndex;

    this.currentSceneIndex = targetSceneIndex;

    $(".bottom-bar-scene").removeClass('active selected');
    $(".bottom-bar-scene").eq(this.currentSceneIndex).addClass('active selected');

    $(".room_img").removeClass("active");
    $(".room_img").eq(this.currentSceneIndex).addClass("active");

    if (skipRoomLoading) return;
    this.currentScene = this.scenes[this.currentSceneIndex];
    this._syncModelCurrentScene();

    this.sceneobjects = this.currentScene.objects;
    const targetID = this.currentScene.id;

    const alreadyLoadedTexture = this._getCachedTexture(targetID);

    if (alreadyLoadedTexture) {
      this._buildWorld(alreadyLoadedTexture);
    } else {

      let url = this.currentScene.background.mediumPath;
      const hasLowRes = (this.model.sceneHasLowResImage[this.currentScene.id]);
      if (hasLowRes) {
        url = getLowResImageUrl(this.currentScene.background.mediumPath)
      }
      this.model.showLoading()
      this.textureLoaderSilent.load(url, (texture) => {
        this.model.hideLoading()
        this.visitedRoomsTextures.push({ id: targetID, texture });
        this._buildWorld(texture);
      }, () => {
        this.model.hideLoading()
      });
    }
  }

  toggleOffset = () => {
    const cond = $(".settings-menu").hasClass("is-active") && !$(".settings-menu").hasClass("fixed");
    window.innerWidth > 1050 && $(".bottom-bar-room-settings").toggleClass("offset", cond);
    $("#css3d").toggleClass("offset", cond);
    $("#webgl").toggleClass("offset", cond);
    $(".crosshair").toggleClass("offset", cond);
    this.onWindowResize();
  }

  sceneSettings = () => {
    const index = this.currentSceneIndex;
    $("#scene_settings_id").val(index);
    const maxSliderValue = $("#room_settings_slider").attr('max') * 1;
    const minSliderValue = $("#room_settings_slider").attr('min') * -1;
    const degrees = radians_to_degrees(this.scenes[index].sceneRotationY);
    if (this.scenes[index].ambientAudio.hasOwnProperty('url')) {
      if (this.scenes[index].ambientAudio.url) {
        $('#song-url').text(this.scenes[index].ambientAudio.url.replace("virtualRealityFiles/", ""));
        if (this.scenes[index].ambientAudio.hasOwnProperty('volume')) {
          $('#ambient_volume').val(this.scenes[index].ambientAudio.volume);
          $("#ambient_volume_txt").text(`${Math.ceil(this.scenes[index].ambientAudio.volume * 100 / $("#ambient_volume").prop('max'))}%`);
          this.updateSliderFill('#ambient_volume');
        }
        this.loadAndPlayAmbientSound(this.scenes[index].ambientAudio, $("#toggleAmbientSound").prop("checked"));
        $('.audio_details_holder').addClass('visible');
        $('.audio_settings_holder').addClass('visible');

      } else {
        this.hideRemoveSongBtn();
      }
    } else {
      this.hideRemoveSongBtn();
    }
    this.setPublicStageStatus(this.scenes[index]);
    const withPayment = this.isPaidLocation(this.scenes[index]);
    $("#setAsHomeSceneContainer").toggleClass("disabled", this.currentSceneIndex === 0);
    $(".scene_name").val(this.scenes[index].publicName);
    $("#scene_image").attr('src', this.scenes[index].background.mediumPath);
    $('#sceneLocked').prop('checked', this.scenes[index].locked);
    $('#publicStage').prop('checked', this.model.publicStage);
    $("#locationWithPayment").prop("checked", withPayment);
    $(".publicStage").toggleClass("disabled", this.model.publicStage ? false : !this._applyValidateAction({ scenes: this.scenes, action: "publicStage" }).state);
    $(".locationWithPayment").toggleClass("disabled", withPayment ? false : !this._applyValidateAction({ scenes: this.scenes, action: "paidLocation" }).state);
    $("#room_settings_slider").val(degrees > maxSliderValue ? degrees - maxSliderValue - minSliderValue : degrees);
  }

  updateSliderFill = (el) => {
    const min = $(el).attr('min') * 1 || 0;
    const max = $(el).attr('max') * 1 || 100;
    const procent = ($(el).val() - min) * 100 / (max - min);
    $(el).css('background', `linear-gradient(to right, #94A14E 0%, #94A14E ${procent}%, #C5C5C5 ${procent}%, #C5C5C5 100%)`);
  }

  duplicateScene = (index) => {
    const { state, limit } = this._applyValidateAction({ scenesObj: this.scenes, action: 'locations' });
    if (!state) {
      this.model.alert('error', `${$trans('error-max-locations-reached')}: ${limit}`);
      return;
    }
    const publicName = this.scenes[index].publicName + ' Copy';
    const cloneElement = JSON.parse(JSON.stringify(this.scenes[index]));
    const element = { ...cloneElement, id: uuidv4(), publicName };
    const newObjects = [];

    for (let x = 0; x < element.objects.length; x++) {
      newObjects.push({ ...element.objects[x], id: uuidv4() });
    }
    element.objects = newObjects;
    this.scenes.push(element);
    const extension = element.background.mediumPath.split('.');
    const ext = `.${extension[extension.length - 1]}`;
    let thumb = element.background.mediumPath.replace(ext, `_thumb${ext}`);
    $(".roomsEditor").append(this.room_btn_template(this.scenes.length - 1, element.publicName, thumb, element.objects.length, element.id));
    $(`.room_options`).removeClass('active');
    // Update DB
    this.updateDB();
    this.generateSceneGallery();
    this.generateLocationOptions();
  }

  updateSceneCounter = () => {
    $(".room").each((index, room) => {
      const newId = `select_scene_${index}`;
      $(room).children(".customCheckbox").children(".selected_scenes").attr('id', newId);
      $(room).children(".customCheckbox").children("label").attr('for', newId);
      $(room).children(".room_img").children(".scene_index").text(index + 1);
    });
  }

  elementsGroups = () => {
    this.resetElementsMenu();
    const groups = {}
    const menuObjects = [...(this.objectsInScene || [])];
    const seenUuids = new Set(menuObjects.map((el) => el?.uuid).filter(Boolean));
    const addMenuObject = (obj) => {
      if (!obj) return;
      const mesh = obj.mesh || obj.anchor || obj.object || null;
      if (!mesh?.uuid || seenUuids.has(mesh.uuid)) return;
      if (!mesh.groupDetails) {
        if (mesh.type === 'vraiAgent') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('vrai-agent-text')) || 'AI Agent',
            icon: 'support_agent',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-vrai-agent')) || 'Edit AI Agent',
            dataLang: 'edit-vrai-agent'
          };
        } else if (mesh.type === 'vapiUserCamera') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('vrai-agent-camera')) || 'User Camera',
            icon: 'videocam',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-vrai-agent-camera')) || 'Edit User Camera',
            dataLang: 'edit-vrai-agent-camera'
          };
        } else if (mesh.type === 'vapiTranscription') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('vrai-agent-transcription')) || 'Transcription',
            icon: 'subtitles',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-vrai-agent-transcription')) || 'Edit Transcription',
            dataLang: 'edit-vrai-agent-transcription'
          };
        } else if (mesh.type === 'vapiButton') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('vrai-agent-button')) || 'Agent Button',
            icon: 'smart_button',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-vrai-agent-button')) || 'Edit Agent Button',
            dataLang: 'edit-vrai-agent-button'
          };
        } else if (mesh.type === 'timerElement') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('timer-text')) || 'Timer',
            icon: 'timer',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-timer-element')) || 'Edit timer',
            dataLang: 'edit-timer-element'
          };
        } else if (mesh.type === 'iframeElement') {
          mesh.groupDetails = {
            title: (typeof $trans !== 'undefined' && $trans('iframe-text')) || 'iFrame',
            icon: 'web',
            editTitle: (typeof $trans !== 'undefined' && $trans('edit-iframe-element')) || 'Edit iframe',
            dataLang: 'edit-iframe-element'
          };
        }
      }
      seenUuids.add(mesh.uuid);
      menuObjects.push(mesh);
    };
    const chairs = this.vraiAgentChairs || this.model?.view?.vraiAgentChairs || [];
    const cameras = this.vraiAgentCameras || this.model?.view?.vraiAgentCameras || [];
    const transcriptions = this.vraiAgentTranscriptions || this.model?.view?.vraiAgentTranscriptions || [];
    const buttons = this.vraiAgentButtons || this.model?.view?.vraiAgentButtons || [];
    const timers = this.timerElementsInScene || this.model?.view?.timerElementsInScene || [];
    const iframes = this.iframeElementsInScene || this.model?.view?.iframeElementsInScene || [];
    const inputFieldGuesses = this.inputFieldGuessElementsInScene || this.model?.view?.inputFieldGuessElementsInScene || [];
    const inputFields = this.inputFieldElementsInScene || this.model?.view?.inputFieldElementsInScene || [];
    chairs.forEach(addMenuObject);
    cameras.forEach(addMenuObject);
    transcriptions.forEach(addMenuObject);
    buttons.forEach(addMenuObject);
    timers.forEach(addMenuObject);
    iframes.forEach(addMenuObject);
    inputFieldGuesses.forEach(addMenuObject);
    inputFields.forEach(addMenuObject);
    // Safety net: include CSS3D anchors directly from scene graph if not present in arrays.
    (this.interactionGroup?.children || [])
      .filter((child) => ['vraiAgent', 'vapiUserCamera', 'vapiTranscription', 'vapiButton', 'timerElement', 'iframeElement', 'inputFieldGuess', 'inputField'].includes(child?.type))
      .forEach((child) => addMenuObject({ anchor: child }));
    this._elementsMenuObjectsByUuid = {};
    menuObjects.forEach((el) => {
      if (el?.uuid) this._elementsMenuObjectsByUuid[el.uuid] = el;
    });
    const getElementName = (el, fallbackTitle = '') => {
      const target = this._resolveEditableObject?.(el) || el;
      const targetId = target?.getId?.() ?? target?.id ?? null;
      if (targetId != null) {
        const sceneObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(targetId));
        if (sceneObj?.type) {
          const display = this._getComponentDisplayName?.(sceneObj.type, sceneObj);
          if (display && String(display).trim()) return String(display).trim();
        }
      }
      const cfg = el?.getDbConfig?.()
        || el?.dbConfig
        || el?.parent?.getDbConfig?.()
        || el?.parent?.dbConfig
        || el?.parent?.parent?.getDbConfig?.()
        || el?.parent?.parent?.dbConfig
        || {};

      const isVraiChair = target?.type === 'vraiAgent' || target?.name === 'vraiAgent';
      const candidates = isVraiChair
        ? [cfg?.name, cfg?.title, cfg?.data?.title]
        : [cfg?.name, cfg?.title, cfg?.data?.title, cfg?.chairName, cfg?.roomName];

      for (const candidate of candidates) {
        const value = typeof candidate === 'string' ? candidate.trim() : '';
        if (value) return value;
      }

      return fallbackTitle;
    };
    menuObjects.forEach((el) => {
      if (!groups.hasOwnProperty(el.type)) {
        groups[el.type] = [];
      }
      groups[el.type].push(el);
    });

    let elements = '';
    for (const [key, els] of Object.entries(groups)) {
      const gd = els[0]?.groupDetails;
      let title = gd?.title || key || 'Element';
      let icon = gd?.icon || 'extension';
      const cls = '';
      const groupID = uuidv4();
      title += ` (${els.length})`;

      const isGroupVisible = els.some((entry) => this._getEditElementState(entry).visible !== false);
      elements += `<div class="element-group" data-group-id="${groupID}">`;
      elements += group_btn(groupID, title, icon, cls, { showVisibilityControl: true, groupVisible: isGroupVisible });
      elements += '<ul class="group-elements">';

      for (let x = 0; x < els.length; x++) {
        const digit = '0' + (x + 1).toString().slice(-2);
        const fallbackBaseTitle = (
          els[x]?.groupDetails?.title
          || gd?.title
          || key
          || 'element'
        )
          .toString()
          .trim()
          .replace(/\s+/g, "_")
          .toLowerCase();
        const fallbackTitle = `${fallbackBaseTitle}_${digit}`;
        const el_title = getElementName(els[x], fallbackTitle);
        const state = this._getEditElementState(els[x]);
        const hideDeleteForType = ['vapiUserCamera', 'vapiTranscription'].includes(els[x]?.type);
        elements += group_element(els[x].uuid, el_title, { ...state, showDelete: !hideDeleteForType });
        this._applyEditElementVisibility(els[x], state.visible !== false);
      }
      elements += '</ul></div>';
    }
    $("#elements-groups").html(elements ? elements : `<span class='no_elements' data-lang="info-no-elements">${$trans('info-no-elements')}</span>`);
    this._syncElementGroupControls();
    $(".elements_options").toggleClass('disabled', elements === '');
  }

  resetElementsMenu = () => {
    $("#showSelectElements").prop("checked", false);
    $("#select_all_elements").prop("checked", false);
    $(".selected_elements").prop("checked", false);
    $(".element-group").removeClass('select-element');
    $("#elements_options").removeClass('visible');
    $(".group-btn").removeClass("selected");
    $(".group_checkbox").prop("checked", false);
    $(".group-element").removeClass("selected");
  }

  toggleCheckboxOptions = () => {
    let allUncheck = true;
    $(".selected_elements").each(el => {
      const cond = $(".selected_elements").eq(el).prop("checked");
      if (cond) {
        allUncheck = false;
      }
    });
    $("#select_all_elements").prop("checked", !allUncheck);
    $("#elements_options").toggleClass("visible", !allUncheck);
  }

  rotateToElement = (meshId) => {
    const mesh = this._elementsMenuObjectsByUuid?.[meshId]
      || this.objectsInScene.find(el => el.uuid === meshId)
      || this.interactionGroup?.children?.find?.((el) => el?.uuid === meshId)
      || null;
    if (!mesh || this._isEditElementLocked(mesh) || !this._isEditElementVisible(mesh)) return;
    const isCss3DObject = !!(
      mesh?.type === 'vraiAgent'
      || mesh?.type === 'vapiUserCamera'
      || mesh?.type === 'vapiTranscription'
      || mesh?.type === 'vapiButton'
      || mesh?.type === 'timerElement'
      || mesh?.type === 'iframeElement'
      || mesh?.type === 'inputFieldGuess'
      || mesh?.type === 'inputField'
      || mesh?.userData?.vraiAgentChair
      || mesh?.userData?.vraiAgentCamera
      || mesh?.userData?.vraiAgentTranscription
      || mesh?.userData?.vraiAgentButton
      || mesh?.userData?.vrTimerElement
      || mesh?.userData?.vrIframeElement
      || mesh?.userData?.vrInputFieldGuess
      || mesh?.userData?.vrInputField
    );
    if (isCss3DObject) {
      pointCameraToCss3DObject(this.camera, mesh, this.model.onAnimationStart, this.model.onAnimationStop);
      return;
    }
    pointCameraToObject(this.camera, mesh, this.model.onAnimationStart, this.model.onAnimationStop);
  }

  removeElementFromScene = () => {
    if (this.elementSelected) {
      let parent = this.getRoot3DObjectForDelete(this.elementSelected) || this.elementSelected.parent;
      if (parent?.userData?.vraiAgentCamera) parent = parent.userData.vraiAgentCamera;
      if (parent?.userData?.vraiAgentChair) parent = parent.userData.vraiAgentChair;
      if (parent?.userData?.vraiAgentTranscription) parent = parent.userData.vraiAgentTranscription;
      if (parent?.userData?.vraiAgentButton) parent = parent.userData.vraiAgentButton;
      if (parent?.userData?.vrIframeElement) parent = parent.userData.vrIframeElement;
      if (parent?.userData?.vrTimerElement) parent = parent.userData.vrTimerElement;
      if (parent?.userData?.vrInputFieldGuess) parent = parent.userData.vrInputFieldGuess;
      if (parent?.userData?.vrInputField) parent = parent.userData.vrInputField;
      if (!parent || typeof parent.getId !== 'function') return;

      if (parent.name === 'vraiAgent' && this.worldID) {
        const agentId = parent.getId();
        if (agentId) this.model.worldFetcher.deleteVapiAgentConfig(this.worldID, agentId, () => { }, (e) => console.warn('[VAPI] deleteConfig failed', e));
        this._removeVapiUserCamerasForAgent(agentId);
      }

      if (parent.name === 'inputFieldGuess' && this.worldID) {
        const objectId = parent.getId();
        if (objectId) {
          this.model.worldFetcher.deleteInputFieldGuessAnswer(this.worldID, objectId, () => { }, (e) => console.warn('[InputFieldGuess] deleteAnswer failed', e));
        }
      }

      // Ensure any Vapi UI DOM roots created by vrai agent are removed
      if (parent.name === 'vraiAgent' && parent._componentDivs) {
        Object.values(parent._componentDivs).forEach((div) => {
          if (!div) return;
          if (typeof div.remove === 'function') {
            div.remove();
          } else if (div.parentNode) {
            div.parentNode.removeChild(div);
          }
        });
      }

      for (let i = 0; i < this.currentScene.objects.length; i++) {
        let obj = this.currentScene.objects[i];
        if (obj.id === parent.getId()) {
          this.currentScene.objects.splice(i, 1);
          this.scenes[this.currentSceneIndex] = this.currentScene;
          this.updateDB();
          break;
        }
      }
      if (parent.object || parent.anchor) {
        const meshToRemove = parent.anchor || parent.object;
        this.interactionGroup.remove(meshToRemove);
        if (parent.name === 'vapiUserCamera' && this.vraiAgentCameras) {
          this._indicatorDomCache?.delete(parent.elementClass);
          this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
          this.vraiAgentCameras = this.vraiAgentCameras.filter(c => c !== parent);
        }
        if (parent.name === 'vapiTranscription' && this.vraiAgentTranscriptions) {
          this._indicatorDomCache?.delete(parent.elementClass);
          this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
          this.vraiAgentTranscriptions = this.vraiAgentTranscriptions.filter(t => t !== parent);
        }
        if (parent.name === 'vapiButton' && this.vraiAgentButtons) {
          this._indicatorDomCache?.delete(parent.elementClass);
          this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
          this.vraiAgentButtons = this.vraiAgentButtons.filter(b => b !== parent);
        }
        if (parent.name === 'vraiAgent') {
          this._indicatorDomCache?.delete(parent.elementClass);
          this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
          this.vraiAgentChairs = this.vraiAgentChairs?.filter(c => c !== parent) ?? [];
        }
        if (parent.name === 'iframeElement') {
          this.iframeElementsInScene = this.iframeElementsInScene?.filter((item) => item !== parent) ?? [];
        }
        if (parent.name === 'timerElement') {
          this.timerElementsInScene = this.timerElementsInScene?.filter((item) => item !== parent) ?? [];
        }
        if (parent.name === 'inputFieldGuess') {
          this.inputFieldGuessElementsInScene = this.inputFieldGuessElementsInScene?.filter((item) => item !== parent) ?? [];
        }
        if (parent.name === 'inputField') {
          this.inputFieldElementsInScene = this.inputFieldElementsInScene?.filter((item) => item !== parent) ?? [];
        }
        parent.destroy?.();
      } else {
        this.interactionGroup.remove(parent);
      }

      if (parent.name === 'sceneChange' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'webLink' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'videoPlayer' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'infoElement' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'embeddedWebpage' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'imageGallery' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }

      const meshToFind = parent.mesh || this.elementSelected;
      if (meshToFind?.uuid != null) {
        const uuidsToRemove = new Set([meshToFind.uuid]);
        if (parent.getComponentMeshesForRaycast) {
          parent.getComponentMeshesForRaycast().forEach(m => m?.uuid != null && uuidsToRemove.add(m.uuid));
        }
        this.objectsInScene = this.objectsInScene.filter(el => !uuidsToRemove.has(el.uuid));
      }
      if ((parent.name === 'vapiUserCamera' || parent.name === 'vapiTranscription') && typeof parent.disposeCss3D === 'function') {
        parent.disposeCss3D();
      }
      if (parent.name === 'vapiButton') {
        const chairId = parent.dbConfig?.vapiAgentId || parent.getDbConfig?.()?.vapiAgentId;
        if (chairId) this._renderVraiButtonsList?.(chairId);
      }
      if (parent.name === 'vapiUserCamera') {
        const chairId = parent.dbConfig?.vapiAgentId || parent.getDbConfig?.()?.vapiAgentId;
        if (chairId && this.vraiAgentChairs) {
          const chair = this.vraiAgentChairs.find(c => (c.id || c.getId?.()) != null && String(c.id || c.getId?.()) === String(chairId));
          if (chair) {
            const comp = chair.dbConfig?.components || {};
            chair.setDbConfig({ components: { ...comp, camera: { ...(comp.camera || {}), active: false } } });
            const sceneObj = this.currentScene.objects.find(el => el.id === chairId);
            if (sceneObj) {
              sceneObj.components = sceneObj.components || {};
              sceneObj.components.camera = { ...(sceneObj.components.camera || {}), active: false };
              this.scenes[this.currentSceneIndex] = this.currentScene;
              this.updateDB();
            }
            $('#vrai_component_camera').prop('checked', false);
          }
        }
      }
      const youtubeEl = parent.name === 'youtube' ? document.querySelector(`[data-id='img_${parent.getId()}']`) : null;
      const iframeEl = parent.name === 'iframeAgent'
        ? document.querySelector(`[data-id='iframe_${parent.getId()}']`)
        : (parent.name === 'iframeElement' ? document.querySelector(`[data-id='iframe_element_${parent.getId()}']`) : null);
      const timerEl = parent.name === 'timerElement' ? document.querySelector(`[data-id='timer_element_${parent.getId()}']`) : null;
      const inputFieldGuessEl = parent.name === 'inputFieldGuess' ? document.querySelector(`[data-id='input_field_guess_${parent.getId()}']`) : null;
      const inputFieldEl = parent.name === 'inputField' ? document.querySelector(`[data-id='input_field_${parent.getId()}']`) : null;
      const vraiAgentEl = parent.name === 'vraiAgent' ? document.querySelector(`[data-id='vrai_agent_${parent.getId()}']`) : null;
      const vapiCameraEl = parent.name === 'vapiUserCamera' ? document.querySelector(`[data-id='vapi_camera2_${parent.getId()}']`) : null;
      const vapiTranscriptionEl = parent.name === 'vapiTranscription' ? document.querySelector(`[data-id='vapi_transcription2_${parent.getId()}']`) : null;
      const vapiButtonEl = parent.name === 'vapiButton' ? document.querySelector(`[data-id='vapi_button2_${parent.getId()}']`) : null;
      [youtubeEl, iframeEl, timerEl, inputFieldGuessEl, inputFieldEl, vraiAgentEl, vapiCameraEl, vapiTranscriptionEl, vapiButtonEl].forEach(el => el && (typeof el.remove === 'function' ? el.remove() : el.parentNode?.removeChild(el)));
      this.deleteCallback();

      this.openSidebar && this.updateElementsInScene();
      ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
      $('.object-menu').removeClass('is-active edit');
      this._renderAiAgentsList();
    }
  }

  _removeVapiUserCamerasForAgent = (agentId) => {
    const toRemove = this.currentScene.objects.filter(o => (o.type === 'vapiUserCamera' || o.type === 'vapiTranscription' || o.type === 'vapiButton') && o.vapiAgentId === agentId);
    toRemove.forEach((sceneObj) => {
      const cam = this.vraiAgentCameras?.find(c => (c.id || c.getId?.()) === sceneObj.id);
      const tr = this.vraiAgentTranscriptions?.find(t => (t.id || t.getId?.()) === sceneObj.id);
      const btn = this.vraiAgentButtons?.find(b => (b.id || b.getId?.()) === sceneObj.id);
      if (cam) {
        this._indicatorDomCache?.delete(cam.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== cam.anchor);
        cam.destroy?.();
        if (cam.anchor?.parent) cam.anchor.parent.remove(cam.anchor);
        this.vraiAgentCameras = this.vraiAgentCameras.filter(c => c !== cam);
      } else if (tr) {
        this._indicatorDomCache?.delete(tr.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== tr.anchor);
        tr.destroy?.();
        if (tr.anchor?.parent) tr.anchor.parent.remove(tr.anchor);
        this.vraiAgentTranscriptions = this.vraiAgentTranscriptions.filter(t => t !== tr);
      } else if (btn) {
        this._indicatorDomCache?.delete(btn.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== btn.anchor);
        btn.destroy?.();
        if (btn.anchor?.parent) btn.anchor.parent.remove(btn.anchor);
        this.vraiAgentButtons = this.vraiAgentButtons.filter(b => b !== btn);
      } else {
        const children = [...(this.interactionGroup.children || [])];
        const obj = children.find(c => (c.getId?.() || c.unique_id) === sceneObj.id);
        if (obj) {
          if (typeof obj.disposeCss3D === 'function') obj.disposeCss3D();
          this.interactionGroup.remove(obj);
          this.objectsInScene = this.objectsInScene.filter(el => el !== obj.mesh);
        }
      }
      const elCamera = document.querySelector(`[data-id='vapi_camera2_${sceneObj.id}']`);
      const elTranscription = document.querySelector(`[data-id='vapi_transcription2_${sceneObj.id}']`);
      const elButton = document.querySelector(`[data-id='vapi_button2_${sceneObj.id}']`);
      elCamera?.remove?.();
      elTranscription?.remove?.();
      elButton?.remove?.();
      this.currentScene.objects = this.currentScene.objects.filter(o => o.id !== sceneObj.id);
    });
    this.scenes[this.currentSceneIndex] = this.currentScene;
  }

  getRoot3DObjectForDelete = (eventObject) => {
    if (eventObject?.userData?.vraiAgentChair) return eventObject.userData.vraiAgentChair;
    if (eventObject?.userData?.vraiAgentCamera) return eventObject.userData.vraiAgentCamera;
    if (eventObject?.userData?.vraiAgentTranscription) return eventObject.userData.vraiAgentTranscription;
    if (eventObject?.userData?.vraiAgentButton) return eventObject.userData.vraiAgentButton;
    if (eventObject?.userData?.vrIframeElement) return eventObject.userData.vrIframeElement;
    if (eventObject?.userData?.vrTimerElement) return eventObject.userData.vrTimerElement;
    if (eventObject?.userData?.vrInputFieldGuess) return eventObject.userData.vrInputFieldGuess;
    if (eventObject?.userData?.vrInputField) return eventObject.userData.vrInputField;
    if (eventObject.parent?.vraiAgentRoot) return eventObject.parent.vraiAgentRoot;
    if (eventObject.parent?.parent instanceof VRObject3D) return eventObject.parent.parent;
    if (eventObject.parent instanceof VRObject3D) return eventObject.parent;
    return eventObject;
  }

  _resolveEditableObject = (eventObject) => {
    let target = this.getRoot3DObjectForDelete(eventObject);
    if (target?.userData?.vraiAgentCamera) target = target.userData.vraiAgentCamera;
    if (target?.userData?.vraiAgentChair) target = target.userData.vraiAgentChair;
    if (target?.userData?.vraiAgentTranscription) target = target.userData.vraiAgentTranscription;
    if (target?.userData?.vraiAgentButton) target = target.userData.vraiAgentButton;
    if (target?.userData?.vrIframeElement) target = target.userData.vrIframeElement;
    if (target?.userData?.vrTimerElement) target = target.userData.vrTimerElement;
    if (target?.userData?.vrInputFieldGuess) target = target.userData.vrInputFieldGuess;
    if (target?.userData?.vrInputField) target = target.userData.vrInputField;
    return target;
  }

  _getEditElementStateKey = (eventObject) => {
    const target = this._resolveEditableObject(eventObject);
    const id = target?.getId?.() ?? target?.id ?? target?.uuid ?? target?.mesh?.uuid ?? eventObject?.uuid;
    if (id == null) return null;
    const sceneKey = this.currentScene?.id ?? this.currentSceneIndex ?? 'scene';
    return `${sceneKey}:${id}`;
  }

  _getEditElementState = (eventObject) => {
    const key = this._getEditElementStateKey(eventObject);
    if (!key) return { locked: false, visible: true };
    if (!this.editElementStates[key]) {
      this.editElementStates[key] = { locked: false, visible: true };
    }
    return this.editElementStates[key];
  }

  _isEditElementLocked = (eventObject) => {
    return !!this._getEditElementState(eventObject).locked;
  }

  _isEditElementVisible = (eventObject) => {
    return this._getEditElementState(eventObject).visible !== false;
  }

  _applyEditElementVisibility = (eventObject, visible) => {
    const target = this._resolveEditableObject(eventObject);
    if (!target) return;
    const isVisible = !!visible;
    if (target.anchor) target.anchor.visible = isVisible;
    if (target.mesh) target.mesh.visible = isVisible;
    if (!target.anchor && !target.mesh && target.visible != null) target.visible = isVisible;
    if (target.dom?.classList) {
      target.dom.classList.toggle('edit-hidden', !isVisible);
    }
    if (typeof target._syncDomVisibilityToAnchor === 'function') {
      target._syncDomVisibilityToAnchor();
    } else if (target.dom?.style) {
      target.dom.style.display = isVisible ? '' : 'none';
    }
    if (target.dom?.style) {
      target.dom.style.visibility = isVisible ? '' : 'hidden';
      target.dom.style.pointerEvents = isVisible ? (target.dbConfig?.lockedInEdit ? 'none' : '') : 'none';
    }
    if (target.css3dObject?.element?.style) {
      target.css3dObject.element.style.display = isVisible ? '' : 'none';
      target.css3dObject.element.style.visibility = isVisible ? '' : 'hidden';
      target.css3dObject.element.style.pointerEvents = isVisible ? (target.dbConfig?.lockedInEdit ? 'none' : '') : 'none';
    }
  }

  _getElementMeshByMenuId = (meshId) => {
    if (!meshId) return null;
    return this._elementsMenuObjectsByUuid?.[meshId]
      || this.objectsInScene.find((el) => el.uuid === meshId)
      || this.interactionGroup?.children?.find?.((el) => el?.uuid === meshId)
      || null;
  }

  _syncGroupElementControls = (meshId) => {
    const mesh = this._getElementMeshByMenuId(meshId);
    const state = this._getEditElementState(mesh);
    const $row = $(`.group-element[data-id='${meshId}']`);
    if (!$row.length) return;
    const $lock = $row.find('.group-element-lock');
    const $visibility = $row.find('.group-element-visibility');
    $lock.text(state.locked ? 'lock' : 'lock_open');
    $lock.attr('title', state.locked ? 'Unlock element' : 'Lock element');
    $lock.toggleClass('enabled', state.locked);
    $visibility.text(state.visible === false ? 'visibility_off' : 'visibility');
    $visibility.attr('title', state.visible === false ? 'Show element' : 'Hide element');
    $visibility.toggleClass('enabled', state.visible !== false);
    $row.toggleClass('edit-locked', state.locked);
    $row.toggleClass('edit-hidden', state.visible === false);
    this._syncElementGroupControls($row.closest('.element-group'));
  }

  _syncElementGroupControls = (groupRef = null) => {
    const syncOne = ($group) => {
      if (!$group?.length) return;
      const $items = $group.find('.group-elements .group-element');
      if (!$items.length) return;
      const allVisible = $items.toArray().every((item) => {
        const meshId = $(item).data('id');
        const mesh = this._getElementMeshByMenuId(meshId);
        return this._getEditElementState(mesh).visible !== false;
      });
      const $control = $group.find('.group-visibility-control').first();
      $control.text(allVisible ? 'visibility' : 'visibility_off');
      $control.attr('title', allVisible ? 'Hide group' : 'Show group');
      $control.toggleClass('enabled', allVisible);
    };
    if (groupRef) {
      syncOne($(groupRef));
      return;
    }
    $('.element-group').each((_, el) => syncOne($(el)));
  }

  _syncEditDragTargets = () => {
    if (!this._editDragTargets) return;
    const children = this.interactionGroup?.children || [];
    const next = children.filter((mesh) => {
      if (!mesh) return false;
      if (mesh.visible === false) return false;
      if (notDraggableItems(mesh)) return false;
      if (this._isEditElementLocked(mesh)) return false;
      if (!this._isEditElementVisible(mesh)) return false;
      return true;
    });
    this._editDragTargets.length = 0;
    this._editDragTargets.push(...next);
  }

  _setEditElementLock = (meshId, locked) => {
    const mesh = this._getElementMeshByMenuId(meshId);
    if (!mesh) {
      this._syncGroupElementControls(meshId);
      return;
    }
    const state = this._getEditElementState(mesh);
    state.locked = !!locked;
    const target = this._resolveEditableObject(mesh);
    const targetId = target?.getId?.() ?? target?.id ?? null;
    if (targetId != null) {
      // Keep CSS3D component drag/select behavior in sync with Elements-list lock state
      // without triggering component visibility recomputation.
      if (target?.dbConfig) {
        target.dbConfig = { ...target.dbConfig, lockedInEdit: state.locked };
      }
      const sceneObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(targetId));
      if (sceneObj) {
        sceneObj.lockedInEdit = state.locked;
        this.scenes[this.currentSceneIndex] = this.currentScene;
        this.updateDB();
      }
    }
    if (target?.dom?.classList) {
      target.dom.classList.toggle('edit-locked', state.locked);
    }
    if (target?.dom?.style) {
      target.dom.style.pointerEvents = state.locked ? 'none' : (this._isEditElementVisible?.(mesh) === false ? 'none' : '');
      target.dom.style.opacity = state.locked ? '0.25' : '';
      target.dom.style.filter = state.locked ? 'grayscale(0.4)' : '';
    }
    if (target?.css3dObject?.element?.style) {
      target.css3dObject.element.style.pointerEvents = state.locked ? 'none' : (this._isEditElementVisible?.(mesh) === false ? 'none' : '');
      target.css3dObject.element.style.opacity = state.locked ? '0.25' : '';
      target.css3dObject.element.style.filter = state.locked ? 'grayscale(0.4)' : '';
    }
    if (state.locked && this.elementSelected && this._getEditElementStateKey(this.elementSelected) === this._getEditElementStateKey(mesh)) {
      this.deselectElement();
    }
    this._syncEditDragTargets?.();
    this._syncGroupElementControls(meshId);
    this._updateVraiAgentChairsVisibility?.();
  }

  _setEditElementVisibility = (meshId, visible) => {
    const mesh = this._getElementMeshByMenuId(meshId);
    if (!mesh) {
      this._syncGroupElementControls(meshId);
      return;
    }
    const state = this._getEditElementState(mesh);
    state.visible = !!visible;
    this._applyEditElementVisibility(mesh, state.visible);
    if (!state.visible && this.elementSelected && this._getEditElementStateKey(this.elementSelected) === this._getEditElementStateKey(mesh)) {
      this.deselectElement();
    }
    this._syncEditDragTargets?.();
    this._syncGroupElementControls(meshId);
    this._updateVraiAgentChairsVisibility?.();
  }

  _applyEditElementStateToScene = () => {
    const seen = new Set();
    const applyToMesh = (mesh) => {
      if (!mesh?.uuid || seen.has(mesh.uuid)) return;
      seen.add(mesh.uuid);
      const state = this._getEditElementState(mesh);
      this._applyEditElementVisibility(mesh, state.visible !== false);
    };
    (this.objectsInScene || []).forEach(applyToMesh);
    (this._elementsMenuObjectsByUuid ? Object.values(this._elementsMenuObjectsByUuid) : []).forEach(applyToMesh);
    this._syncEditDragTargets?.();
  }

  removeElementsFromScene = (arr) => {
    arr.forEach(mesh => {
      let parent = this.getRoot3DObjectForDelete(mesh) || mesh.parent;
      if (parent?.userData?.vraiAgentCamera) parent = parent.userData.vraiAgentCamera;
      if (parent?.userData?.vraiAgentChair) parent = parent.userData.vraiAgentChair;
      if (parent?.userData?.vraiAgentTranscription) parent = parent.userData.vraiAgentTranscription;
      if (parent?.userData?.vraiAgentButton) parent = parent.userData.vraiAgentButton;
      if (parent?.userData?.vrIframeElement) parent = parent.userData.vrIframeElement;
      if (parent?.userData?.vrTimerElement) parent = parent.userData.vrTimerElement;
      if (parent?.userData?.vrInputFieldGuess) parent = parent.userData.vrInputFieldGuess;
      if (parent?.userData?.vrInputField) parent = parent.userData.vrInputField;
      if (!parent || typeof parent.getId !== 'function') return;

      if (parent.name === 'vraiAgent' && this.worldID) {
        const agentId = parent.getId();
        if (agentId) {
          this.model.worldFetcher.deleteVapiAgentConfig(this.worldID, agentId, () => { }, (e) => console.warn('[VAPI] deleteConfig failed', e));
          this._removeVapiUserCamerasForAgent(agentId);
        }
      }

      if (parent.name === 'inputFieldGuess' && this.worldID) {
        const objectId = parent.getId();
        if (objectId) {
          this.model.worldFetcher.deleteInputFieldGuessAnswer(this.worldID, objectId, () => { }, (e) => console.warn('[InputFieldGuess] deleteAnswer failed', e));
        }
      }

      // Ensure any Vapi UI DOM roots created by vrai agent are removed
      if (parent.name === 'vraiAgent' && parent._componentDivs) {
        Object.values(parent._componentDivs).forEach((div) => {
          if (!div) return;
          if (typeof div.remove === 'function') {
            div.remove();
          } else if (div.parentNode) {
            div.parentNode.removeChild(div);
          }
        });
      }

      for (let i = 0; i < this.currentScene.objects.length; i++) {
        let obj = this.currentScene.objects[i];
        if (obj.id === parent.getId()) {
          this.currentScene.objects.splice(i, 1);
          this.scenes[this.currentSceneIndex] = this.currentScene;
          this.updateDB();
          break;
        }
      }

      const toRemoveFromScene = ((parent.name === 'vapiUserCamera' || parent.name === 'vapiButton' || parent.name === 'vraiAgent' || parent.name === 'iframeElement' || parent.name === 'timerElement' || parent.name === 'inputFieldGuess' || parent.name === 'inputField') && parent.anchor) ? parent.anchor : parent;
      this.interactionGroup.remove(toRemoveFromScene);
      if (parent.name === 'vapiUserCamera') {
        this._indicatorDomCache?.delete(parent.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
        this.vraiAgentCameras = this.vraiAgentCameras?.filter(c => c !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'vapiButton') {
        this._indicatorDomCache?.delete(parent.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
        this.vraiAgentButtons = this.vraiAgentButtons?.filter(b => b !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'vraiAgent') {
        this._indicatorDomCache?.delete(parent.elementClass);
        this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== parent.anchor);
        this.vraiAgentChairs = this.vraiAgentChairs?.filter(c => c !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'iframeElement') {
        this.iframeElementsInScene = this.iframeElementsInScene?.filter((item) => item !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'timerElement') {
        this.timerElementsInScene = this.timerElementsInScene?.filter((item) => item !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'inputFieldGuess') {
        this.inputFieldGuessElementsInScene = this.inputFieldGuessElementsInScene?.filter((item) => item !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'inputField') {
        this.inputFieldElementsInScene = this.inputFieldElementsInScene?.filter((item) => item !== parent) ?? [];
        parent.destroy?.();
      }
      if (parent.name === 'sceneChange' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'webLink' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'videoPlayer' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'infoElement' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'embeddedWebpage' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }
      if (parent.name === 'imageGallery' && parent.mesh) {
        this._removeObjectIndicator(parent.mesh);
      }

      const meshToFind = parent.mesh || mesh;
      const uuidsToRemove = new Set([meshToFind.uuid]);
      if (parent.getComponentMeshesForRaycast) {
        parent.getComponentMeshesForRaycast().forEach(m => uuidsToRemove.add(m.uuid));
      }
      this.objectsInScene = this.objectsInScene.filter(el => !uuidsToRemove.has(el.uuid));
      const youtubeEl = parent.name === 'youtube' ? document.querySelector(`[data-id='img_${parent.getId()}']`) : null;
      const iframeEl = parent.name === 'iframeAgent'
        ? document.querySelector(`[data-id='iframe_${parent.getId()}']`)
        : (parent.name === 'iframeElement' ? document.querySelector(`[data-id='iframe_element_${parent.getId()}']`) : null);
      const timerEl = parent.name === 'timerElement' ? document.querySelector(`[data-id='timer_element_${parent.getId()}']`) : null;
      const inputFieldGuessEl = parent.name === 'inputFieldGuess' ? document.querySelector(`[data-id='input_field_guess_${parent.getId()}']`) : null;
      const inputFieldEl = parent.name === 'inputField' ? document.querySelector(`[data-id='input_field_${parent.getId()}']`) : null;
      const vraiAgentEl = parent.name === 'vraiAgent' ? document.querySelector(`[data-id='vrai_agent_${parent.getId()}']`) : null;
      const vapiCameraEl = parent.name === 'vapiUserCamera' ? document.querySelector(`[data-id='vapi_camera2_${parent.getId()}']`) : null;
      const vapiTranscriptionEl = parent.name === 'vapiTranscription' ? document.querySelector(`[data-id='vapi_transcription2_${parent.getId()}']`) : null;
      const vapiButtonEl = parent.name === 'vapiButton' ? document.querySelector(`[data-id='vapi_button2_${parent.getId()}']`) : null;
      [youtubeEl, iframeEl, timerEl, inputFieldGuessEl, inputFieldEl, vraiAgentEl, vapiCameraEl, vapiTranscriptionEl, vapiButtonEl].forEach(el => el && (typeof el.remove === 'function' ? el.remove() : el.parentNode?.removeChild(el)));
      this.deleteCallback();

    });

    this.openSidebar && this.updateElementsInScene();
    ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) && this.elementsGroups();
    this._renderAiAgentsList();
  }

  deleteCallback = () => {
    this.elementSelected = null;
    rangeHolder.classList.remove('visible');
    sizeRangeHolder.classList.remove('visible');
    removeElement.classList.remove('visible');
    editElement.classList.remove('visible');
    rotateXRangeHolder?.classList.remove('visible');
    rotateYRangeHolder?.classList.remove('visible');
    this.controls.enabled = true;
  }

  delegateCheckbox = (e) => {
    const checkbox = $(e.currentTarget).find(".customCheckbox").children(".selected_elements");
    $(checkbox).prop("checked", !$(checkbox).prop('checked'));
    $(e.currentTarget).toggleClass('selected');
    this.toggleCheckboxOptions();
  }

  validateInfoForm = () => {
    if ($("#info-element-title").val() === '') {
      this.model.alert('error', $trans('error-provide-title'));
      return { error: true };
    }

    const buttonText = $("#info-element-button-text").val();
    const buttonUrl = $("#info-element-button-url").val();

    if (buttonText && !buttonUrl) {
      this.model.alert('error', $trans('error-button-url'));
      return { error: true };
    }

    if (!buttonText && buttonUrl) {
      this.model.alert('error', $trans('error-button-title'));
      return { error: true };
    }

    const imageSrc = $("#info_element_image").attr("src");
    const videoSrc = $("#info_element_video").attr("src");

    const layout = 'complex';

    const data = {
      title: $("#info-element-title").val(),
      description: getQuillContent("#info-element-description1"),
      button: {
        text: buttonText,
        url: buttonUrl,
        show: buttonText !== '' && buttonUrl !== '',
        isLocation: $("#locationButton").val() !== '',
        locationName: $("#locationButton").find('option:selected').text(),
        locationID: $("#locationButton").val(),
      },
      image: imageSrc.includes("/empty.png") ? '' : imageSrc,
      video: videoSrc === "#" ? '' : videoSrc,
    }

    return { layout, data, error: false }
  }

  validateInputFieldGuessForm = () => {
    const title = (
      $("#input-field-guess-title").val()
      || $("#input-field-guess-question").val()
      || ''
    ).trim();
    const bodyText = ($("#input-field-guess-body").val() || '').trim();
    const correctAnswer = ($("#input-field-guess-correct-answer").val() || '').trim();
    const isEdit = $(".input-field-guess-modal").hasClass("edit");

    if (!title) {
      this.model.alert('error', $trans('error-provide-title'));
      return { error: true };
    }

    if (!isEdit && !correctAnswer) {
      this.model.alert('error', $trans('error-provide-correct-answer'));
      return { error: true };
    }

    return { title, bodyText, correctAnswer, error: false };
  }

  _fillInputFieldSettings(data = {}) {
    if (inputFieldValidationEdit) inputFieldValidationEdit.value = data.validation || 'required';
    if (inputFieldMinLengthEdit) inputFieldMinLengthEdit.value = data.minLength || 1;
    if (inputFieldKeyEdit) inputFieldKeyEdit.value = data.fieldKey || '';
    if (inputFieldFunnelStepEdit) inputFieldFunnelStepEdit.value = data.funnelStep || '';
    if (inputFieldAutocloseEdit) inputFieldAutocloseEdit.checked = data.autocloseOnSubmit !== false;
    const isMin = (data.validation || 'required') === 'minLength';
    document.querySelector('#input_field_min_length_row')?.classList.toggle('hidden', !isMin);
  }

  validateInputFieldForm = () => {
    const title = ($("#input-field-title").val() || '').trim();
    const bodyText = ($("#input-field-body").val() || '').trim();
    const placeholder = ($("#input-field-placeholder").val() || '').trim();
    const fieldKey = ($("#input-field-key").val() || '').trim();
    const funnelStep = ($("#input-field-funnel-step").val() || '').trim();
    const validation = ($("#input-field-validation").val() || 'required').trim();
    const minLength = Math.max(1, parseInt($("#input-field-min-length").val(), 10) || 1);

    if (!title) {
      this.model.alert('error', $trans('error-provide-title'));
      return { error: true };
    }

    return { title, bodyText, placeholder, fieldKey, funnelStep, validation, minLength, error: false };
  }

  validateEmbeddedWebpage = () => {
    const iframe = $("#embedded-webpage-iframe-url").val();

    if (iframe && !isValidUrl(iframe)) {
      this.model.alert('error', $trans('error-iframe-url'));
      return { error: true };
    }

    let imageSrc = $("#embedded_webpage_image").attr('src');
    let imageAspectRatio = $("#embedded_webpage_image_aspect_ratio").val();

    if (imageSrc.includes('/empty.png')) {
      imageSrc = "";
      imageAspectRatio = "1";
    }

    return { iframe, imageSrc, imageAspectRatio, useIcon: $("#use_embedded_webpage_icon").is(':checked') }
  }

  deselectElement = () => {
    if (this.elementSelected !== null) {
      $('#distance_range').trigger('change');

      if (this.elementSelected.parent.name === "youtube" || this.elementSelected.parent.name === "iframeAgent" || isVraiAgentParent(this.elementSelected.parent) || this.elementSelected.parent.name === "vapiUserCamera") {
        if (this.elementSelected.material) this.elementSelected.material.opacity = 0;
        this.elementSelected.parent.toggleSelect && this.elementSelected.parent.toggleSelect();
      } else if (this.elementSelected.material) {
        this.elementSelected.material.opacity = 1;
      }

      // Call onDeselect if the object has this method
      if (isVideoPlayerType(this.elementSelected.parent.name)
        && (this.elementSelected.parent.placeAs3dElement || this.elementSelected.parent.useIcon === false)) {
        this.autoSaveVideoPlayer();
      }
      if (this.elementSelected.parent.onDeselect) {
        this.elementSelected.parent.onDeselect();
      }
    }
    this.interactionGroup.children.forEach(obj => {
      if (obj instanceof VRObject3D && obj.onDeselect) {
        obj.onDeselect();
      }
    });

    $(".object-menu").removeClass("is-active edit");
    this.elementSelected = null;
    this._updateVraiAgentChairsVisibility();
  }

  _updateVraiAgentChairsVisibility() {
    const chairs = this.vraiAgentChairs || [];
    let selectedId = null;
    if (this.elementSelected) {
      if (isVraiAgentParent(this.elementSelected)) {
        selectedId = this.elementSelected.getId?.() ?? this.elementSelected.id;
      } else {
        selectedId = this.elementSelected.dbConfig?.vapiAgentId ?? this.elementSelected.getDbConfig?.()?.vapiAgentId;
      }
    }
    const selectedChairInScene = selectedId != null && chairs.some(c => String(c.getId?.() ?? c.id) === String(selectedId));
    const effectiveSelectedId = selectedChairInScene ? selectedId : null;

    const setDimmed = (obj, agentId, isSelected) => {
      if (!obj?.dom) return;
      const chairObj = this.currentScene?.objects?.find(o => o.type === 'vraiAgent' && (String(o.id) === String(agentId) || String(o.unique_id) === String(agentId)));
      const lockedByChair = !!chairObj?.lockedInEdit;
      const lockedBySelf = !!obj?.dbConfig?.lockedInEdit || !!obj?.getDbConfig?.()?.lockedInEdit || !!this._isEditElementLocked?.(obj);
      const locked = lockedByChair || lockedBySelf;
      const editVisible = this._isEditElementVisible?.(obj) !== false;
      const opacity = locked ? '0.1' : (isSelected || !effectiveSelectedId ? '1' : '0.2');
      const pointerEvents = locked ? 'none' : '';
      obj.dom.style.opacity = opacity;
      obj.dom.style.pointerEvents = pointerEvents;
      obj.dom.style.visibility = editVisible ? '' : 'hidden';
      if (obj?.anchor) obj.anchor.visible = editVisible;
    };

    chairs.forEach(chair => {
      const chairId = chair.getId?.() ?? chair.id;
      const isSelected = effectiveSelectedId != null && String(chairId) === String(effectiveSelectedId);
      setDimmed(chair, chairId, isSelected || !effectiveSelectedId);
    });
    (this.vraiAgentCameras || []).forEach(cam => {
      const agentId = cam.dbConfig?.vapiAgentId ?? cam.getDbConfig?.()?.vapiAgentId;
      const isSelected = effectiveSelectedId != null && agentId != null && String(agentId) === String(effectiveSelectedId);
      setDimmed(cam, agentId, isSelected || !effectiveSelectedId);
    });
    (this.vraiAgentTranscriptions || []).forEach(tr => {
      const agentId = tr.dbConfig?.vapiAgentId ?? tr.getDbConfig?.()?.vapiAgentId;
      const isSelected = effectiveSelectedId != null && agentId != null && String(agentId) === String(effectiveSelectedId);
      setDimmed(tr, agentId, isSelected || !effectiveSelectedId);
    });
    (this.vraiAgentButtons || []).forEach(btn => {
      const agentId = btn.dbConfig?.vapiAgentId ?? btn.getDbConfig?.()?.vapiAgentId;
      const isSelected = effectiveSelectedId != null && agentId != null && String(agentId) === String(effectiveSelectedId);
      setDimmed(btn, agentId, isSelected || !effectiveSelectedId);
    });
  }

  _findSceneObjectForComponent(target) {
    if (!target) return null;
    const objs = this.currentScene?.objects || [];
    const type = target.type || target.name;
    if (type === 'vapiUserCamera' || type === 'vapiTranscription' || type === 'vapiButton') {
      const ownId = target.id;
      if (ownId != null) {
        return objs.find((o) => o.type === type && String(o.id) === String(ownId)) || null;
      }
    }
    const id = target.getId?.() ?? target.id;
    if (id == null) return null;
    return objs.find((o) => String(o.id) === String(id)) || null;
  }

  _getEditableComponentConfig(target) {
    const resolved = target
      || this._resolveEditableObject(this.elementSelected)
      || this.elementSelected;
    if (!resolved) return {};
    const componentType = resolved.type || resolved.name;
    const sceneObj = this._findSceneObjectForComponent(resolved);
    const instanceConfig = resolved.dbConfig || {};
    // VAPI sub-components must not use getDbConfig() — camera/transcription delegate to the agent chair.
    if (componentType === 'vapiUserCamera' || componentType === 'vapiTranscription' || componentType === 'vapiButton') {
      return sceneObj ? { ...instanceConfig, ...sceneObj } : { ...instanceConfig };
    }
    if (sceneObj) return { ...instanceConfig, ...sceneObj };
    if (resolved.getDbConfig) return resolved.getDbConfig() || instanceConfig;
    return instanceConfig;
  }

  _getComponentOwnName(data, type) {
    if (!data) return '';
    const resolve = (value) => (value != null ? String(value).trim() : '');
    if (type === 'vraiAgent') {
      return resolve(data.name);
    }
    if (type === 'vapiButton') {
      return resolve(data.name || data.commandName || data.label);
    }
    if (type === 'vapiUserCamera' || type === 'vapiTranscription') {
      return resolve(data.name);
    }
    return resolve(data.name);
  }

  _applyComponentNameChange(name) {
    if (!this.elementSelected) return;
    const target = this._resolveEditableObject(this.elementSelected)
      || this.elementSelected.parent
      || this.elementSelected;
    const trimmed = (name || '').trim();
    const payload = { name: trimmed || undefined };
    const sceneObj = this._findSceneObjectForComponent(target);
    const componentType = sceneObj?.type || target?.type || target?.name;

    if (componentType === 'vapiButton') {
      payload.commandName = trimmed || undefined;
      payload.label = trimmed || undefined;
    }
    // vraiAgent: component "name" is separate from agent "chairName" (edited in agent settings).
    if (componentType === 'vraiAgent') {
      delete payload.chairName;
    }

    if (target.setDbConfig) {
      target.setDbConfig(payload);
    } else if (target.dbConfig) {
      Object.assign(target.dbConfig, payload);
    }

    if (sceneObj) {
      Object.assign(sceneObj, payload);
      this.scenes[this.currentSceneIndex] = this.currentScene;
      this.updateDB();
    } else {
      this.modifyLocalJSON(payload);
    }

    this._refreshElementNameDisplays();
  }

  modifyLocalJSON = (obj, configDB) => {
    const target = this._resolveEditableObject(this.elementSelected)
      || this.elementSelected?.parent?.vraiAgentRoot
      || this.elementSelected?.parent;
    if (!target) return;
    const sceneObj = this._findSceneObjectForComponent(target);
    const matchId = sceneObj?.id ?? target.getId?.() ?? target.id;
    if (matchId == null) return;
    for (let x = 0; x < this.currentScene.objects.length; x++) {
      const el = this.currentScene.objects[x];
      if (String(el.id) === String(matchId)) {
        Object.assign(this.currentScene.objects[x], this._serializeForSceneJson(obj));
        this.scenes[this.currentSceneIndex] = this.currentScene;
        this._preserveSceneRotationY();
        this.updateDB();
        break;
      }
    }
  }

  _refreshElementNameDisplays() {
    if (!this.elementSelected) return;
    const target = this._resolveEditableObject?.(this.elementSelected)
      || this.elementSelected.parent
      || this.elementSelected;
    const sceneObj = this._findSceneObjectForComponent(target);
    const displayName = sceneObj
      ? this._getComponentDisplayName(sceneObj.type || '', sceneObj)
      : String(target?.dbConfig?.name || target?.getDbConfig?.()?.name || '').trim();

    if ($('.object-menu').hasClass('edit')) {
      const headerName = displayName || this.elementSelected.groupDetails?.editTitle || '';
      $('.object-menu .object-name').text(headerName);
      if (sceneObjectTypeSupportsEventActionsTab(this._getSelectedEventObjectType())) {
        this._renderObjectEventsList();
        this._renderShowHideItems();
      }
    }

    if ($("#scene-menu").hasClass("is-active") && $("#showElementsMenu").hasClass("active")) {
      this.elementsGroups();
    } else {
      const meshIds = [];
      if (this.elementSelected?.uuid) meshIds.push(this.elementSelected.uuid);
      const mesh = target?.mesh || target?.anchor;
      if (mesh?.uuid) meshIds.push(mesh.uuid);
      meshIds.forEach((meshId) => {
        const $title = $(`.group-element[data-id="${meshId}"] .element-title`);
        if ($title.length && displayName) $title.text(displayName);
      });
    }
  }

  showEditInformationButton = () => {
    $(".object-menu").addClass("edit");
    $('.info-settings-section').removeClass('hidden');
    const editTitle = this.elementSelected?.groupDetails?.editTitle
      || this.elementSelected?.parent?.mesh?.groupDetails?.editTitle
      || '';
    $('.object-menu .object-name').text(editTitle);
  }

  _isControlMeshType(type) {
    return type === 'settings' || type === 'delete' || type === 'menuPosition' || type === 'vraiAgentComponent';
  }

  _resolveElementSettingsType(parent, editableTarget) {
    const root = this._resolveEditableObject(this.elementSelected) || editableTarget || parent;
    const meshSceneType = root?.mesh?.type || root?.name || root?.type
      || parent?.mesh?.type || parent?.name || parent?.type;

    if (parent?.name === 'iframeAgent' || root?.name === 'iframeAgent') return 'iframeAgent';
    if (parent?.name === 'iframeElement' || root?.name === 'iframeElement' || parent?.type === 'iframeElement' || root?.type === 'iframeElement') return 'iframeElement';
    if (parent?.name === 'timerElement' || root?.name === 'timerElement' || parent?.type === 'timerElement' || root?.type === 'timerElement') return 'timerElement';
    if (parent?.name === 'inputFieldGuess' || root?.name === 'inputFieldGuess' || parent?.type === 'inputFieldGuess' || root?.type === 'inputFieldGuess') return 'inputFieldGuess';
    if (parent?.name === 'inputField' || root?.name === 'inputField' || parent?.type === 'inputField' || root?.type === 'inputField') return 'inputField';
    if (parent?.name === 'vapiTranscription' || root?.name === 'vapiTranscription' || parent?.type === 'vapiTranscription' || root?.type === 'vapiTranscription') return 'vapiTranscription';
    if (parent?.name === 'vapiUserCamera' || root?.name === 'vapiUserCamera' || parent?.type === 'vapiUserCamera' || root?.type === 'vapiUserCamera') return 'vapiUserCamera';
    if (parent?.name === 'vapiButton' || root?.name === 'vapiButton' || parent?.type === 'vapiButton' || root?.type === 'vapiButton') return 'vapiButton';
    if (isVraiAgentParent(parent) || isVraiAgentParent(root)) return 'vraiAgent';
    if (parent?.name === 'youtube' || root?.name === 'youtube') return 'youtube';
    if (meshSceneType === 'imageGallery') return 'imageGallery';
    if (meshSceneType === SCENE_OBJECT_TYPES.videoGallery) return 'videoGallery';
    if (meshSceneType === 'vrMusicObject') return 'vrMusicObject';
    if (meshSceneType === 'videoPlayer' || meshSceneType === 'videoPlayerWebGL') return meshSceneType;

    const fromHelper = this._getSelectedEventObjectType();
    if (fromHelper) return fromHelper;

    if (meshSceneType && !this._isControlMeshType(meshSceneType) && meshSceneType !== 'Object3D' && meshSceneType !== 'Mesh') {
      return meshSceneType;
    }

    const rawType = editableTarget?.type || this.elementSelected?.type;
    if (rawType && !this._isControlMeshType(rawType) && rawType !== 'Object3D' && rawType !== 'Mesh') {
      return rawType;
    }

    return root?.name || root?.mesh?.type || '';
  }

  _renderObjectEventTypeControls(objName) {
    const $container = $('.object-events-type-controls');
    if (!$container.length) return;
    $container.empty();
    const addEventLabel = $trans('object-events-click-add') || 'Add Event';
    const events = this._getEventsForObjectType(objName);
    if (!events.length) {
      $container.append(
        `<div class="flx-sb object-events-type-row">
          <span class="lbl" data-lang="object-events-click">${$trans('object-events-click') || 'Bind Event to Action'}</span>
          <button type="button" class="buttn primary add-object-event" data-event="click" data-lang="object-events-click-add">${addEventLabel}</button>
        </div>`
      );
      return;
    }
    events.forEach((eventDef) => {
      const eventLabel = eventDef.label
        || (eventDef.labelKey ? ($trans(eventDef.labelKey) || eventDef.value) : eventDef.value);
      $container.append(
        `<div class="flx-sb object-events-type-row">
          <span class="lbl">${eventLabel}</span>
          <button type="button" class="buttn primary add-object-event" data-event="${eventDef.value}" data-lang="object-events-click-add">${addEventLabel}</button>
        </div>`
      );
    });
  }

  _updateObjectEventsVisibility() {
    const objName = this._getSelectedEventObjectType();
    $('.object-events-placeholder').show();
    $('.object-events-section').hide();
    $('.object-event-action-group--image-gallery').hide();
    $('.object-event-action-group--vapi').hide();
    $('.object-event-action-group--music').hide();
    $('.object-event-action-group--camera').hide();
    $('.object-event-action-group--input-field').hide();
    $('.object-event-action-group--embedded-webpage').hide();
    if (sceneObjectTypeSupportsEventActionsTab(objName)) {
      $('.object-events-placeholder').hide();
      $('.link-events-section').show();
      $('.object-event-action-group--camera').show();
      this._renderObjectEventTypeControls(objName);
      this._renderObjectEventsList();
      if (['vraiAgent', 'vapiButton', 'vapiUserCamera', 'vapiTranscription'].includes(objName)) {
        $('.object-event-action-group--vapi').show();
      }
      if (objName === 'vrMusicObject' || isVideoPlayerType(objName) || objName === 'videoGallery' || objName === 'youtube') {
        $('.object-event-action-group--music').show();
      }
      if (objName === 'inputField' || objName === 'inputFieldGuess') {
        $('.object-event-action-group--input-field').show();
      }
      if (objName === 'embeddedWebpage') {
        $('.object-event-action-group--embedded-webpage').show();
      }
    }
  }

  /** Actions already listed under Bind Action panels for this object type (avoid duplicate rows). */
  _getBindPanelCoveredActions(objName) {
    const covered = new Set(['show', 'hide', 'animateCameraLookAt']);
    if (objName === 'imageGallery') {
      getImageGalleryPanelActions().forEach((a) => covered.add(a.value));
    }
    if (['vraiAgent', 'vapiButton', 'vapiUserCamera', 'vapiTranscription'].includes(objName)) {
      ['sendCommand', 'startCall', 'endCall', 'switchAgent', 'openInputField'].forEach((a) => covered.add(a));
    }
    if (objName === 'vrMusicObject' || isVideoPlayerType(objName) || objName === 'videoGallery' || objName === 'youtube') {
      ['playOnce', 'playLoop', 'stopPlaying', 'play', 'pause', 'openGallery', 'closeVideo', 'closeElement'].forEach((a) => covered.add(a));
    }
    if (objName === 'inputField' || objName === 'inputFieldGuess') {
      ['openInputField', 'open', 'close', 'closeElement'].forEach((a) => covered.add(a));
    }
    if (objName === 'embeddedWebpage') {
      covered.add('openEmbeddedWebpage');
    }
    return covered;
  }

  _findSceneObjectByAnyId(objectId) {
    if (objectId == null || objectId === '') return null;
    const id = String(objectId);
    if (id === WELCOME_OBJECT_ID) {
      return { id: WELCOME_OBJECT_ID, type: WELCOME_SOURCE_TYPE };
    }
    return (this.currentScene?.objects || []).find((o) =>
      String(o.id) === id || String(o.unique_id || '') === id
    ) || null;
  }

  _deleteWorldEventById(eventId, $item) {
    this.model.worldFetcher.deleteWorldEvent(this.worldID, eventId, () => {
      this.model.worldEvents = (this.model.worldEvents || []).filter((ev) => String(ev.id) !== String(eventId));
      $item.remove();
      this._renderShowHideItems();
      this._renderSceneEventsList();
      this.updateDB();
    }, (err) => {
      this.model.alert?.('error', err?.response?.data?.error || 'Failed to remove event');
    });
  }

  _getWorldEventConnectionDisplay(ev, mode) {
    const sceneId = this.currentScene?.id || '';
    const sid = String(ev.source_object_id ?? '');
    const tid = String(ev.target_object_id ?? '');
    if (isSceneLevelSource(sid, sceneId) && isSceneLevelEventType(ev.event_type)) {
      const sceneLabel = this._getSceneEventSourceLabel();
      if (mode === 'outgoing') {
        const rowT = this._findSceneObjectByAnyId(tid);
        return rowT
          ? this._getComponentDisplayName((ev.target_object_type || rowT.type || '').toString(), rowT)
          : tid;
      }
      return sceneLabel;
    }
    const rowS = this._findSceneObjectByAnyId(sid);
    const rowT = this._findSceneObjectByAnyId(tid);
    if (sid && tid && sid === tid) {
      const row = rowS || rowT;
      const one = row ? this._getComponentDisplayName(row.type || '', row) : sid;
      return `${one} → ${one}`;
    }
    if (mode === 'outgoing') {
      const row = rowT;
      return row
        ? this._getComponentDisplayName((ev.target_object_type || row.type || '').toString(), row)
        : tid;
    }
    const row = rowS;
    return row ? this._getComponentDisplayName(row.type || '', row) : sid;
  }

  _renderObjectEventsList() {
    const $list = $('.object-settings-tab-events .object-events-list');
    $list.empty();
    const selectedEventIds = this._getSelectedEventObjectIdsForActions();
    const selectedEventIdSet = new Set(selectedEventIds.map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const objName = this._getSelectedEventObjectType();
    const coveredActions = this._getBindPanelCoveredActions(objName);
    const allSceneEvents = (this.model.worldEvents || []).filter(
      (e) => String(e.scene_id) === String(sceneId)
    );
    // Outgoing: this object is the event source. Self-loops (source === target) are listed here;
    // bind sub-panels below list incoming bindings for actions they cover.
    const outgoingEvents = allSceneEvents.filter((e) =>
      selectedEventIdSet.has(String(e.source_object_id))
    );
    // Incoming not covered by a visible bind panel (e.g. goToScene, openLink, timers,
    // scene lifecycle → play on types without a media panel, guestSeat → any action, etc.).
    const incomingEvents = allSceneEvents.filter((e) => {
      if (!selectedEventIdSet.has(String(e.target_object_id))) return false;
      if (selectedEventIdSet.has(String(e.source_object_id))) return false;
      return !coveredActions.has(String(e.action || ''));
    });
    const events = [...outgoingEvents, ...incomingEvents];
    events.forEach((ev) => {
      const isOutgoing = selectedEventIdSet.has(String(ev.source_object_id));
      const display = this._getWorldEventConnectionDisplay(ev, isOutgoing ? 'outgoing' : 'incoming');
      let actionLabel = ev.action;
      if (ev.action === 'switchAgent' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          actionLabel = `${$trans('action-switch-agent')} (${params.chairScenario || params.name || 'Agent'})`;
        } catch (_) { }
      } else {
        const labelKey = getActionLabelKey(ev.action);
        if (labelKey) actionLabel = $trans(labelKey) || ev.action;
      }
      if (ev.action === 'showImage' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params.imageIndex !== undefined) actionLabel += ` (#${params.imageIndex + 1})`;
        } catch (_) { }
      } else if (ev.action === 'sendCommand' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params.commandName) actionLabel += ` (${String(params.commandName)})`;
          if (params.commandText) actionLabel += `: ${String(params.commandText).slice(0, 40)}`;
        } catch (_) { }
      }
      const actionIcon = this._getActionIcon(ev.action);
      const triggerObj = isOutgoing ? null : this._findSceneObjectByAnyId(ev.source_object_id);
      const rowIconType = isOutgoing
        ? (ev.target_object_type || '')
        : (triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
      const rowIcon = this._getComponentIcon(rowIconType);
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $list.append(`<div class="object-event-connect-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}" data-action="${ev.action}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${ev.action}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${rowIcon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
    this._renderShowHideItems();
  }

  _getSelectedEventObjectIdsForActions() {
    const primary = this._getSelectedEventObjectId();
    if (primary == null) return [];

    const selectedObj = this._getSelectedEventObject();
    const selectedType = this._getSelectedEventObjectType();
    const objs = this.currentScene?.objects || [];
    const idSet = new Set();
    const add = (v) => {
      if (v === undefined || v === null) return;
      const s = String(v).trim();
      if (s !== '') idSet.add(s);
    };

    add(primary);
    add(selectedObj?.id);
    add(selectedObj?.unique_id);
    add(selectedObj?.dbConfig?.id);
    add(selectedObj?.dbConfig?.unique_id);

    let row = objs.find(
      (o) => String(o.id) === String(primary) || String(o.unique_id || '') === String(primary)
    );

    // Chair instance id can diverge from persisted scene row id; match assistant to recover row ids.
    if (!row && String(selectedType) === 'vraiAgent') {
      const asst = selectedObj?.dbConfig?.VAPI_ASSISTANT_ID || selectedObj?.VAPI_ASSISTANT_ID;
      if (asst) {
        row = objs.find((o) => o.type === 'vraiAgent' && String(o.VAPI_ASSISTANT_ID || '') === String(asst));
      }
    }

    // Guest seats / generic objects: recover scene row when runtime id differs from persisted id.
    if (!row && selectedType) {
      const cfgId = selectedObj?.dbConfig?.id ?? selectedObj?.dbConfig?.unique_id;
      if (cfgId != null) {
        row = objs.find((o) =>
          String(o.type) === String(selectedType)
          && (String(o.id) === String(cfgId) || String(o.unique_id || '') === String(cfgId))
        );
      }
    }

    if (row) {
      add(row.id);
      if (row.unique_id != null) add(row.unique_id);
    }

    if (String(selectedType) === 'vraiAgent') {
      const agentKeys = [...idSet];
      objs
        .filter(
          (o) =>
            o?.type === 'vapiButton' &&
            agentKeys.some((k) => String(o?.vapiAgentId) === String(k))
        )
        .forEach((o) => add(o.id));
    }

    return [...idSet];
  }

  _getComponentIcon(type) {
    const icons = {
      webLink: 'link',
      sceneChange: 'door_front',
      guestSeat: 'chair',
      screenStream: 'screen_share',
      tourScreenShare: 'screen_share',
      payPalDonation: 'volunteer_activism',
      chessGame: 'chess',
      infoElement: 'info',
      inputFieldGuess: 'quiz',
      inputField: 'text_fields',
      vrInvisibleAction: 'crop_square',
      embeddedWebpage: 'info',
      shopLink: 'shopping_cart',
      vraiAgent: 'smart_toy',
      vapiUserCamera: 'videocam',
      vapiTranscription: 'subtitles',
      vapiButton: 'smart_button',
      youtube: 'play_circle',
      iframeAgent: 'web',
      iframeElement: 'web',
      timerElement: 'timer',
      videoPlayer: 'play_circle',
      videoPlayerWebGL: 'play_circle',
      vrMusicObject: 'music_note',
      imageGallery: 'photo_library',
      videoGallery: 'collections',
      baglessRoom: 'meeting_room',
      scene: 'meeting_room',
      profile: 'person',
      welcome: 'waving_hand',
    };
    return icons[type] || 'extension';
  }

  _getActionIcon(action) {
    const icons = {
      show: 'visibility',
      hide: 'visibility_off',
      showImage: 'image',
      openModal: 'open_in_new',
      showGallery: 'photo_library',
      startSlideshow: 'slideshow',
      nextImage: 'skip_next',
      previousImage: 'skip_previous',
      closeGallery: 'close',
      closeElement: 'close',
      goToScene: 'door_front',
      goToRoom: 'meeting_room',
      openLink: 'link',
      play: 'play_circle',
      pause: 'pause_circle',
      playOnce: 'play_circle',
      playLoop: 'repeat',
      stopPlaying: 'stop_circle',
      closeVideo: 'close',
      startCall: 'call',
      endCall: 'call_end',
      switchAgent: 'swap_horiz',
      sendCommand: 'send',
      open: 'open_in_new',
      showProfile: 'person',
      showInfo: 'info',
      openGallery: 'collections',
      animateCameraLookAt: '3d_rotation',
      startTimer: 'timer',
      stopTimer: 'pause_circle',
      resetTimer: 'restart_alt',
      openWelcome: 'open_in_new',
      closeWelcome: 'close',
      openInputField: 'text_fields',
      openEmbeddedWebpage: 'web',
      close: 'close',
    };
    return icons[action] || 'extension';
  }

  _getSceneEventSourceLabel() {
    const name = this.currentScene?.publicName || this.currentScene?.name;
    if (name && String(name).trim()) return String(name).trim();
    return $trans('scene-event-source') || 'Room';
  }

  _getSceneRoomSelectLabel() {
    const prefix = $trans('scene-event-source') || 'Room';
    return `${prefix}: ${this._getSceneEventSourceLabel()}`;
  }

  _liveComponentToEventObject(el) {
    if (!el) return null;
    const type = el.type || el.name || el.dbConfig?.type;
    const id = el.id ?? el.getId?.() ?? el.dbConfig?.id;
    if (!type || id == null || id === '') return null;
    return {
      ...(el.dbConfig || {}),
      id,
      type,
      title: el.dbConfig?.title,
      name: el.dbConfig?.name || el.dbConfig?.title,
      fieldKey: el.dbConfig?.fieldKey,
    };
  }

  _getEventDropdownObjects() {
    const objects = [...(this.currentScene?.objects || [])];
    const seen = new Set(
      objects.map((o) => `${o?.type}_${o?.id ?? o?.unique_id ?? ''}`).filter((k) => !k.endsWith('_'))
    );
    const live = [
      ...(this.inputFieldElementsInScene || []),
      ...(this.inputFieldGuessElementsInScene || []),
      ...(this.iframeElementsInScene || []),
      ...(this.timerElementsInScene || []),
      ...(this.vraiAgentChairs || []),
      ...(this.vraiAgentCameras || []),
      ...(this.vraiAgentTranscriptions || []),
      ...(this.vraiAgentButtons || []),
    ];
    live.forEach((el) => {
      const obj = this._liveComponentToEventObject(el);
      if (!obj) return;
      const key = `${obj.type}_${obj.id}`;
      if (seen.has(key)) return;
      seen.add(key);
      objects.push(obj);
    });
    return objects;
  }

  _populateGroupedEventComponentSelect($select, { includeRooms = false, allowAllVapiButtons = false, includeWelcome = false } = {}) {
    // Remove prior optgroups as well as options (option-only cleanup leaves empty group headers).
    $select.children(':not(:first-child)').remove();
    const sceneId = this.currentScene?.id;
    const roomsGroupLabel = ($trans('event-selector-group-rooms') || 'Rooms').replace(/"/g, '&quot;');
    const componentsGroupLabel = ($trans('event-selector-group-components') || 'Components').replace(/"/g, '&quot;');

    if (includeRooms && sceneId) {
      const $roomsGroup = $(`<optgroup label="${roomsGroupLabel}"></optgroup>`);
      const sceneDisplay = String(this._getSceneRoomSelectLabel()).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $roomsGroup.append(`<option value="${sceneId}" data-type="${SCENE_SOURCE_TYPE}">${sceneDisplay}</option>`);
      $select.append($roomsGroup);
    }

    const objects = this._getEventDropdownObjects();
    const seen = new Set();
    const $componentsGroup = $(`<optgroup label="${componentsGroupLabel}"></optgroup>`);
    let hasComponents = false;
    objects.forEach((obj) => {
      const type = obj.type;
      if (!type) return;
      if (!this._shouldIncludeVapiButtonInEventDropdown(obj, { allowAllButtons: allowAllVapiButtons })) return;
      const objId = obj.id ?? obj.unique_id;
      const objKey = String(objId ?? '');
      if (!objKey || seen.has(type + '_' + objKey)) return;
      seen.add(type + '_' + objKey);
      const display = String(this._getComponentDisplayName(type, obj)).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $componentsGroup.append(`<option value="${objId}" data-type="${type}">${display}</option>`);
      hasComponents = true;
    });
    if (includeWelcome) {
      const welcomeLabel = String($trans('welcome-screen-text') || 'Welcome screen')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $componentsGroup.prepend(`<option value="${WELCOME_OBJECT_ID}" data-type="${WELCOME_SOURCE_TYPE}">${welcomeLabel}</option>`);
      hasComponents = true;
    }
    if (hasComponents) $select.append($componentsGroup);
  }

  _populateBindActionTriggerComponents($select) {
    this._populateGroupedEventComponentSelect($select, { includeRooms: true });
  }

  _populateConnectEventSourceComponents($select) {
    this._populateGroupedEventComponentSelect($select, { includeRooms: true });
  }

  _populateConnectEventTargetComponents($select) {
    this._populateGroupedEventComponentSelect($select, { includeRooms: false, allowAllVapiButtons: true, includeWelcome: true });
  }

  _getSceneEventSourceId() {
    return this.currentScene?.id || '';
  }

  _openSceneConnectEventModal(options = {}) {
    const sceneId = this._getSceneEventSourceId();
    if (!sceneId) return;
    this._openConnectEventModal(null, {
      sourceObjectId: sceneId,
      sourceObjectType: SCENE_SOURCE_TYPE,
      ...options,
    });
  }

  _openEditSceneConnectEventModal(eventId) {
    const currentEvent = (this.model.worldEvents || []).find((ev) => String(ev.id) === String(eventId));
    if (!currentEvent) return;
    this._openSceneConnectEventModal({ editingEventId: currentEvent.id });
    let parsedParams = null;
    try {
      parsedParams = currentEvent.action_params
        ? (typeof currentEvent.action_params === 'string' ? JSON.parse(currentEvent.action_params) : currentEvent.action_params)
        : null;
    } catch (_) {
      parsedParams = null;
    }
    this._connectEventPreferredLibraryId = null;
    this._connectEventPreferredAssistantId = '';
    this._connectEventPreferredSwitchAgentParams = null;
    if (currentEvent.action === 'switchAgent' && parsedParams) {
      this._connectEventPreferredSwitchAgentParams = { ...parsedParams };
      const lid = parsedParams.libraryId ?? parsedParams.vapiLibraryId;
      if (lid != null && String(lid) !== '') this._connectEventPreferredLibraryId = String(lid);
      const asst = String(parsedParams.VAPI_ASSISTANT_ID || '').trim();
      if (asst) this._connectEventPreferredAssistantId = asst;
    }
    $('#connect_event_source_component').val(String(currentEvent.source_object_id || '')).trigger('change');
    $('#connect_event_type').val(currentEvent.event_type || 'roomEntered');
    $('#connect_event_component').val(String(currentEvent.target_object_id || '')).trigger('change');
    $('#connect_event_action').val(currentEvent.action || '').trigger('change');
    if (currentEvent.action === 'showImage' && parsedParams?.imageIndex != null) {
      $('#connect_event_image_index').val(String(parsedParams.imageIndex));
    } else if (currentEvent.action === 'sendCommand' && parsedParams) {
      if (parsedParams.commandButtonId != null) {
        $('#connect_event_command_select').val(String(parsedParams.commandButtonId));
      }
      if (parsedParams.commandText) {
        $('#connect_event_command_text').val(String(parsedParams.commandText));
      }
    } else if (currentEvent.action === 'openInputField' && parsedParams?.inputFieldId != null) {
      $('#connect_event_input_field').val(String(parsedParams.inputFieldId));
    }
  }

  _renderSceneEventsList() {
    const $list = $('.scene-events-section .scene-events-list');
    if (!$list.length) return;
    $list.empty();
    const sceneId = this._getSceneEventSourceId();
    if (!sceneId) return;
    const events = (this.model.worldEvents || []).filter(
      (e) => String(e.scene_id) === String(sceneId)
        && isSceneLevelSource(e.source_object_id, sceneId)
        && isSceneLevelEventType(e.event_type)
    );
    events.forEach((ev) => {
      const refObj = this._findSceneObjectByAnyId(ev.target_object_id);
      const display = refObj
        ? this._getComponentDisplayName((refObj.type || ev.target_object_type || '').toString(), refObj)
        : ev.target_object_id;
      let actionLabel = ev.action;
      if (ev.action === 'switchAgent' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          actionLabel = `${$trans('action-switch-agent')} (${params.chairScenario || params.name || 'Agent'})`;
        } catch (_) { }
      } else {
        const labelKey = getActionLabelKey(ev.action);
        if (labelKey) actionLabel = $trans(labelKey) || ev.action;
      }
      if (ev.action === 'showImage' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params.imageIndex !== undefined) actionLabel += ` (#${params.imageIndex + 1})`;
        } catch (_) { }
      } else if (ev.action === 'sendCommand' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params.commandName) actionLabel += ` (${String(params.commandName)})`;
          if (params.commandText) actionLabel += `: ${String(params.commandText).slice(0, 40)}`;
        } catch (_) { }
      }
      const actionIcon = this._getActionIcon(ev.action);
      const targetIcon = this._getComponentIcon((ev.target_object_type || refObj?.type) || '');
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'roomEntered');
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $list.append(`<div class="object-event-connect-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}" data-action="${ev.action}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${ev.action}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${targetIcon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
  }

  _getEventTypeDisplay(eventType) {
    if (!eventType) return '';
    const labelKey = getEventLabelKey(eventType);
    if (labelKey) {
      const t = $trans(labelKey);
      if (t && t !== labelKey) return t;
    }
    const aiLabel = this._resolveAiEventDisplayName(eventType);
    if (aiLabel) return aiLabel;
    const key = `event-${eventType}`;
    const t = $trans(key);
    return t && t !== key ? t : String(eventType).charAt(0).toUpperCase() + String(eventType).slice(1);
  }

  _resolveAiEventDisplayName(eventType) {
    const type = String(eventType || '').trim();
    if (!type) return '';
    const objs = this.currentScene?.objects || [];
    for (const obj of objs) {
      if (obj?.type !== 'vraiAgent') continue;
      const match = getAiEventsFromConfig(obj).find((e) => e.name === type);
      if (match) return match.label || match.name;
    }
    const chairs = this.vraiAgentChairs || [];
    for (const chair of chairs) {
      const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
      const match = getAiEventsFromConfig(cfg).find((e) => e.name === type);
      if (match) return match.label || match.name;
    }
    return '';
  }

  /**
   * Built-in component events plus dynamic Room-AI events from the chair config.
   */
  _getEventsForObjectType(type, sourceId = null) {
    const base = getEventsForComponentType(type);
    if (type !== 'vraiAgent') return base;
    const id = sourceId ?? this._getSelectedEventObjectId();
    let aiEvents = [];
    if (id != null) {
      const sceneObj = this._findAgentSceneObject(id);
      const chair = (this.vraiAgentChairs || []).find(
        (c) => String(c.getId?.() ?? c.id) === String(id)
      );
      const cfg = chair?.getDbConfig?.() || chair?.dbConfig || sceneObj || {};
      aiEvents = getAiEventsFromConfig({
        aiEvents: sceneObj?.aiEvents ?? cfg.aiEvents,
      });
    }
    return mergeComponentEventsWithAiEvents(base, aiEvents);
  }

  _findAgentSceneObject(agentId) {
    if (agentId == null) return null;
    const sid = String(agentId);
    return (this.currentScene?.objects || []).find(
      (o) => o.type === 'vraiAgent' && (String(o.id) === sid || String(o.unique_id) === sid)
    ) || null;
  }

  _getAiComponentTypeLabel(type) {
    const labels = {
      vraiAgent: $trans('vrai-agent-text') || 'AI Agent',
      vapiUserCamera: $trans('vrai-agent-camera') || 'Camera',
      vapiTranscription: $trans('vrai-agent-transcription') || 'Transcription',
      vapiButton: $trans('vapi-command-action') || 'Command Action',
    };
    return labels[type] || type || 'Component';
  }

  _getVraiAgentDisplayName(obj) {
    if (!obj) return this._getAiComponentTypeLabel('vraiAgent');
    const resolveName = (value) => (value != null ? String(value).trim() : '');
    const componentName = resolveName(obj.name || obj?.dbConfig?.name);
    if (componentName) return componentName;
    const label = this._getAiComponentTypeLabel('vraiAgent');
    return `${label} #${obj.id || obj.unique_id || 'unknown'}`;
  }

  _getAiComponentDisplayName(type, obj) {
    if (!obj) return this._getAiComponentTypeLabel(type);

    const resolveName = (value) => (value != null ? String(value).trim() : '');

    if (type === 'vraiAgent') {
      return this._getVraiAgentDisplayName(obj);
    }

    const componentType = this._getAiComponentTypeLabel(type);

    if (type === 'vapiButton') {
      const buttonName = resolveName(
        obj.name
        || obj.commandName
        || obj.label
        || obj?.dbConfig?.name
        || obj?.dbConfig?.commandName
        || obj?.dbConfig?.label
      );
      if (buttonName) return buttonName;
      return `${componentType} #${obj.id || obj.unique_id || 'unknown'}`;
    }

    if (type === 'vapiUserCamera' || type === 'vapiTranscription') {
      const ownName = resolveName(obj.name || obj?.dbConfig?.name);
      if (ownName) return ownName;
      return `${componentType} #${obj.id || obj.unique_id || 'unknown'}`;
    }

    const ownName = resolveName(obj.name || obj?.dbConfig?.name);
    if (ownName) return ownName;
    return `${componentType} #${obj.id || obj.unique_id || 'unknown'}`;
  }

  _getComponentDisplayName(type, obj) {
    if (type === WELCOME_SOURCE_TYPE || isWelcomeEventTarget(obj?.id, type)) {
      return $trans('welcome-screen-text') || 'Welcome screen';
    }
    if (type === 'vraiAgent' || type === 'vapiUserCamera' || type === 'vapiTranscription' || type === 'vapiButton') {
      return this._getAiComponentDisplayName(type, obj);
    }
    if (obj?.name && String(obj.name).trim()) return String(obj.name).trim();
    const meta = ComponentRegistry.get(type);
    if (meta?.getDisplayName) return meta.getDisplayName(obj);
    if (meta?.displayNameKey) return $trans(meta.displayNameKey);
    if (obj?.videoTitle && String(obj.videoTitle).trim()) return String(obj.videoTitle).trim();
    if (obj?.roomName && String(obj.roomName).trim()) return String(obj.roomName).trim();
    const labels = {
      webLink: 'image-link',
      vapiUserCamera: 'vrai-agent-camera',
      vapiTranscription: 'vrai-agent-transcription',
      vapiButton: 'vapi-command-action',
      youtube: 'add-youtube-text',
      iframeAgent: 'iframe-text',
      iframeElement: 'iframe-text',
      timerElement: 'timer-text',
      inputFieldGuess: 'input-field-guess',
      inputField: 'input-field',
      sceneChange: 'go-to-scene-text',
      videoPlayer: 'add-video-player-text',
      videoPlayerWebGL: 'add-video-background-text',
      vrMusicObject: 'vr-music-object',
      imageGallery: 'add-image-gallery',
      vrInvisibleAction: 'vr-invisible-action',
    };
    const key = labels[type];
    if (key) return $trans(key);
    return type || 'Unknown';
  }

  _getSelectedEventObject() {
    if (!this.elementSelected) return null;
    const resolved = this._resolveEditableObject?.(this.elementSelected);
    if (resolved) return resolved;
    return this.elementSelected?.parent || this.elementSelected;
  }

  _getSelectedEventObjectId() {
    const selectedObj = this._getSelectedEventObject();
    return selectedObj?.getId?.() ?? selectedObj?.id ?? null;
  }

  _getSelectedEventObjectType() {
    const selectedObj = this._getSelectedEventObject();
    if (!selectedObj) return '';
    const candidates = [
      selectedObj.dbConfig?.type,
      selectedObj.mesh?.type,
      selectedObj.name,
      selectedObj.type,
    ];
    for (const candidate of candidates) {
      if (!candidate || candidate === 'Object3D' || candidate === 'Mesh') continue;
      if (this._isControlMeshType(candidate)) continue;
      return candidate;
    }
    return '';
  }

  _shouldIncludeVapiButtonInEventDropdown(obj, options = {}) {
    if (obj?.type !== 'vapiButton') return true;
    if (options?.allowAllButtons) return true;
    const selectedType = this._getSelectedEventObjectType();
    if (selectedType !== 'vraiAgent') return false;
    const selectedId = String(this._getSelectedEventObjectId() ?? '');
    const ownerId = String(obj?.vapiAgentId ?? '');
    return !!selectedId && !!ownerId && selectedId === ownerId;
  }

  _populateConnectEventComponents() {
    this._populateConnectEventTargetComponents($('#connect_event_component'));
  }

  _populateConnectEventTypes(sourceType) {
    const $eventSelect = $('#connect_event_type');
    $eventSelect.find('option:not(:first)').remove();
    const sourceId = $('#connect_event_source_component').val() || this._connectEventSourceId;
    this._getEventsForObjectType(sourceType, sourceId).forEach((e) => {
      const label = e.label || (e.labelKey ? ($trans(e.labelKey) || e.value) : e.value);
      $eventSelect.append(`<option value="${e.value}">${label}</option>`);
    });
    const firstVal = $eventSelect.find('option:eq(1)')?.val();
    if (firstVal) $eventSelect.val(firstVal);
  }

  _populateConnectEventActions() {
    const $select = $('#connect_event_action');
    $select.find('option:not(:first)').remove();
    const componentOpt = $('#connect_event_component option:selected');
    const targetType = componentOpt.data('type');
    if (!targetType) return;
    const actions = [...getActionsForType(targetType)];
    if (this._editingConnectEventId && targetType === 'imageGallery') {
      const currentEvent = (this.model.worldEvents || []).find((ev) => String(ev.id) === String(this._editingConnectEventId));
      const currentAction = currentEvent?.action;
      if (currentAction && !actions.some((a) => a.value === currentAction)) {
        const labelKey = getActionLabelKey(currentAction);
        actions.push({ value: currentAction, labelKey });
      }
    }
    actions.forEach((a) => {
      $select.append(`<option value="${a.value}">${$trans(a.labelKey) || a.value}</option>`);
    });
  }

  _openSelectVapiAgentModal() {
    if (!this._canManageVapiComponents()) return;
    const $list = $('#vapi_agent_list');
    const $empty = $('#vapi_agent_list_empty');
    $list.empty();
    $empty.hide();
    $('.select_vapi_agent_holder').addClass('is-active');
    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const agents = res?.agents || [];
        if (agents.length === 0) {
          $empty.show();
        } else {
          agents.forEach((a) => {
            const name = a.name || a.vapi_assistant_id || 'AI Agent';
            $list.append(`<div class="vapi-agent-list-item" data-library-id="${a.id}" data-name="${(name || '').replace(/"/g, '&quot;')}">${name}</div>`);
          });
          $(document).off('click.vapiAgentList').on('click.vapiAgentList', '.vapi-agent-list-item', (e) => {
            const libraryId = $(e.currentTarget).data('library-id');
            this._placeVapiAgentFromLibrary(libraryId);
            $('.select_vapi_agent_holder').removeClass('is-active');
          });
        }
      },
      (e) => {
        console.warn('[VAPI] listVapiAgents failed', e);
        $empty.show();
      }
    );
  }

  _placeVapiAgentFromLibrary(libraryId) {
    if (!this._canManageVapiComponents()) return;
    this.model.worldFetcher.placeVapiAgentFromLibrary(
      this.worldID,
      libraryId,
      (res) => {
        if (!res || !res.agentId) return;
        const { agentId, chairName, assistantId, agentImage = '', agent_config } = res;
        const fullConfig = buildFullAgentConfigFromLibrary({ name: chairName, vapi_assistant_id: assistantId, agent_image: agentImage, agent_config });
        const dbConfig = {
          ...generate_template('vraiAgent', { unique_id: agentId, VAPI_ASSISTANT_ID: assistantId, agent_image: agentImage, chairName: chairName || undefined }),
          ...fullConfig,
          id: agentId,
          vapiLibraryId: libraryId
        };
        const dir = new Vector3();
        this.camera.getWorldDirection(dir);
        const pos = this.camera.position.clone().addScaledVector(dir, 540);
        const position = { x: pos.x, y: pos.y, z: pos.z };
        const obj = new VRVapiChairWithCSS3D({
          model: this.model,
          camera: this.camera,
          controls: this.controls,
          raycaster: this.raycaster,
          position,
          id: agentId,
          dbConfig,
          editMode: true,
          sizes: this.sizes,
          viewportElement: this.webglRenderer?.domElement || document.querySelector('#webgl')
        });
        obj.setDbConfig(dbConfig);
        this.interactionGroup.add(obj.anchor);
        const anchorParent = obj.anchor.parent;
        if (anchorParent) {
          const worldPos = new Vector3(position.x, position.y, position.z);
          anchorParent.worldToLocal(worldPos);
          obj.anchor.position.copy(worldPos);
        }
        // Chair is now a CSS3DObject attached to anchor, not external overlay layer.
        // Force matrices now so first drag on newly created chair uses stable world position.
        this.interactionGroup.updateMatrixWorld(true);
        if (this.model.view && this.model.view.vraiAgentChairs) this.model.view.vraiAgentChairs.push(obj);
        this.updateJSON(obj.anchor, dbConfig);
        distanceRange.value = 0;
        this.openSidebar && this.openSidebar();
        this.updateElementsInScene && this.updateElementsInScene();
        this._renderAiAgentsList && this._renderAiAgentsList();
      },
      (e) => {
        console.warn('[VAPI] placeFromLibrary failed', e);
        this.model.alert && this.model.alert('error', (e?.response?.data?.error) || 'Failed to add agent');
      }
    );
  }

  _resolveEventSourceType(sourceObjectId, eventType) {
    const sceneId = this.currentScene?.id || '';
    if (isSceneLevelSource(sourceObjectId, sceneId) && isSceneLevelEventType(eventType)) {
      return SCENE_SOURCE_TYPE;
    }
    const sourceObj = (this.currentScene?.objects || []).find(
      (o) => String(o.id) === String(sourceObjectId)
    );
    return sourceObj?.type || this._connectEventSourceType || 'webLink';
  }

  _populateBindActionTriggerEvents(triggerType) {
    const $eventSelect = $('#bind_action_trigger_event');
    $eventSelect.find('option:not(:first)').remove();
    const triggerId = $('#bind_action_trigger_component').val();
    this._getEventsForObjectType(triggerType, triggerId).forEach((e) => {
      const label = e.label || (e.labelKey ? ($trans(e.labelKey) || e.value) : e.value);
      $eventSelect.append(`<option value="${e.value}">${label}</option>`);
    });
    const firstVal = $eventSelect.find('option:eq(1)')?.val();
    if (firstVal) $eventSelect.val(firstVal);
  }

  _openConnectEventModal(eventType, options = {}) {
    this._editingConnectEventId = options.editingEventId || null;
    this._connectEventSourceId = options.sourceObjectId ?? this._getSelectedEventObjectId();
    this._connectEventSourceType = options.sourceObjectType || this._getSelectedEventObjectType() || 'webLink';
    this._populateConnectEventSourceComponents($('#connect_event_source_component'));
    this._populateConnectEventComponents();
    const defaultSourceId = options.sourceObjectId ?? this._getSelectedEventObjectId();
    if (defaultSourceId) {
      $('#connect_event_source_component').val(String(defaultSourceId)).trigger('change');
    } else {
      $('#connect_event_type').find('option:not(:first)').remove();
    }
    if (eventType) {
      $('#connect_event_type').val(eventType);
    }
    $('#connect_event_component').val('');
    $('#connect_event_action').val('');
    $('#connect_event_agent_panel').hide();
    $('#connect_event_image_index_panel').hide();
    $('#connect_event_command_panel').hide();
    $('#connect_event_command_select_panel').hide();
    $('#connect_event_command_select').val('').find('option:not(:first)').remove();
    $('#connect_event_command_text').val('');
    $('#connect_event_input_field_panel').hide();
    $('#connect_event_input_field').val('').find('option:not(:first)').remove();
    $('#connect_event_library_agent').val('').find('option:not(:first)').remove();
    this._connectEventLibraryConfigs = {};
    this._connectEventPreferredLibraryId = null;
    this._connectEventPreferredAssistantId = '';
    this._connectEventPreferredSwitchAgentParams = null;
    $('.connect_event_holder').addClass('is-active');
  }

  _openEditConnectEventModal(eventId) {
    const currentEvent = (this.model.worldEvents || []).find((ev) => String(ev.id) === String(eventId));
    if (!currentEvent) return;
    this._openConnectEventModal(currentEvent.event_type || 'click', {
      sourceObjectId: currentEvent.source_object_id,
      sourceObjectType: this._resolveEventSourceType(currentEvent.source_object_id, currentEvent.event_type),
      editingEventId: currentEvent.id,
    });
    let parsedParams = null;
    try {
      parsedParams = currentEvent.action_params
        ? (typeof currentEvent.action_params === 'string' ? JSON.parse(currentEvent.action_params) : currentEvent.action_params)
        : null;
    } catch (_) {
      parsedParams = null;
    }
    this._connectEventPreferredLibraryId = null;
    this._connectEventPreferredAssistantId = '';
    this._connectEventPreferredSwitchAgentParams = null;
    if (currentEvent.action === 'switchAgent' && parsedParams) {
      this._connectEventPreferredSwitchAgentParams = { ...parsedParams };
      const lid = parsedParams.libraryId ?? parsedParams.vapiLibraryId;
      if (lid != null && String(lid) !== '') this._connectEventPreferredLibraryId = String(lid);
      const asst = String(parsedParams.VAPI_ASSISTANT_ID || '').trim();
      if (asst) this._connectEventPreferredAssistantId = asst;
    }
    $('#connect_event_source_component').val(String(currentEvent.source_object_id || '')).trigger('change');
    $('#connect_event_type').val(currentEvent.event_type || 'click');
    $('#connect_event_component').val(String(currentEvent.target_object_id || '')).trigger('change');
    $('#connect_event_action').val(currentEvent.action || '').trigger('change');
    if (currentEvent.action === 'showImage' && parsedParams?.imageIndex != null) {
      $('#connect_event_image_index').val(String(parsedParams.imageIndex));
    } else if (currentEvent.action === 'sendCommand' && parsedParams) {
      if (parsedParams.commandButtonId != null) {
        $('#connect_event_command_select').val(String(parsedParams.commandButtonId));
      }
      if (parsedParams.commandText) {
        $('#connect_event_command_text').val(String(parsedParams.commandText));
      }
    } else if (currentEvent.action === 'openInputField' && parsedParams?.inputFieldId != null) {
      $('#connect_event_input_field').val(String(parsedParams.inputFieldId));
    }
  }

  _populateConnectEventImageIndex() {
    const componentId = $('#connect_event_component').val();
    if (!componentId) return;
    const targetObj = (this.currentScene?.objects || []).find((o) => String(o.id) === String(componentId));
    const images = targetObj?.dbConfig?.images || targetObj?.images || [];
    const $select = $('#connect_event_image_index');
    $select.find('option:not(:first)').remove();
    images.forEach((_, i) => {
      $select.append(`<option value="${i}">${$trans('bind-action-image-n') || 'Image'} ${i + 1}</option>`);
    });
    if (images.length > 0) $select.val('0');
  }

  _populateConnectEventAgentCommands(agentId) {
    const $select = $('#connect_event_command_select');
    $select.find('option:not(:first)').remove();
    if (!agentId) return;
    const buttons = (this.currentScene?.objects || []).filter(
      (o) => String(o?.type) === 'vapiButton' && String(o?.vapiAgentId) === String(agentId)
    );
    buttons.forEach((btn) => {
      const name = String(btn.commandName || btn.label || btn.name || btn.commandText || btn.action || '').trim() || `Command ${btn.id}`;
      const text = String(btn.commandText || btn.action || '').trim();
      const preview = text ? ` - ${text.slice(0, 48)}` : '';
      const safe = `${name}${preview}`.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $select.append(`<option value="${btn.id}">${safe}</option>`);
    });
    if (buttons.length > 0) $select.val(String(buttons[0].id));
  }

  _getSceneInputFieldObjects() {
    const fromScene = (this.currentScene?.objects || []).filter((o) => o?.type === 'inputField');
    const seen = new Set(fromScene.map((o) => String(o.id ?? o.unique_id ?? '')));
    const fromLive = (this.inputFieldElementsInScene || [])
      .map((el) => this._liveComponentToEventObject(el))
      .filter((o) => o && !seen.has(String(o.id)));
    return [...fromScene, ...fromLive];
  }

  _populateInputFieldSelect($select) {
    if (!$select?.length) return;
    $select.find('option:not(:first)').remove();
    const fields = this._getSceneInputFieldObjects();
    fields.forEach((obj) => {
      const display = String(this._getComponentDisplayName('inputField', obj) || obj.title || obj.name || 'Input field').trim();
      const key = String(obj.fieldKey || obj.dbConfig?.fieldKey || '').trim();
      const label = key ? `${display} (${key})` : display;
      const safe = label.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $select.append(`<option value="${obj.id}">${safe}</option>`);
    });
    if (fields.length > 0) $select.val(String(fields[0].id));
  }

  _readInputFieldSelectParams($select) {
    const selectedId = ($select?.val() || '').trim();
    if (!selectedId) return null;
    const field = this._getSceneInputFieldObjects().find((o) => String(o.id) === String(selectedId));
    if (!field) return null;
    return {
      inputFieldId: field.id,
      fieldKey: String(field.fieldKey || field.dbConfig?.fieldKey || '').trim(),
    };
  }

  _openBindActionModal() {
    this._connectEventSourceId = this._getSelectedEventObjectId();
    const targetType = this._getSelectedEventObjectType() || 'webLink';
    const $actionSelect = $('#bind_action_type');
    const $triggerSelect = $('#bind_action_trigger_component');
    const $eventSelect = $('#bind_action_trigger_event');
    $actionSelect.find('option:not(:first)').remove();
    const actions = getActionsForType(targetType);
    actions.forEach((a) => {
      $actionSelect.append(`<option value="${a.value}">${$trans(a.labelKey) || a.value}</option>`);
    });
    $eventSelect.find('option:not(:first)').remove();
    $('#bind_action_image_index_panel').hide();
    $('#bind_action_command_select_panel').hide();
    $('#bind_action_input_field_panel').hide();
    $('#bind_action_command_select').val('').find('option:not(:first)').remove();
    this._populateBindActionTriggerComponents($triggerSelect);
    $actionSelect.val('');
    const sceneId = this.currentScene?.id;
    if (sceneId) {
      $triggerSelect.val(String(sceneId)).trigger('change');
    } else {
      $triggerSelect.val('');
    }
    $('.add_bind_action_holder').addClass('is-active');
  }

  _populateBindActionImageIndex() {
    const $select = $('#bind_action_image_index');
    $select.find('option:not(:first)').remove();
    const selectedObj = this._getSelectedEventObject();
    const images = selectedObj?.dbConfig?.images || selectedObj?.images || [];
    images.forEach((_, i) => {
      $select.append(`<option value="${i}">${$trans('bind-action-image-n') || 'Image'} ${i + 1}</option>`);
    });
    if (images.length > 0) $select.val('0');
  }

  _populateBindActionAgentCommands() {
    const $select = $('#bind_action_command_select');
    $select.find('option:not(:first)').remove();
    const targetId = this._connectEventSourceId;
    if (!targetId) return;
    const buttons = (this.currentScene?.objects || []).filter(
      (o) => String(o?.type) === 'vapiButton' && String(o?.vapiAgentId) === String(targetId)
    );
    buttons.forEach((btn) => {
      const name = String(btn.commandName || btn.label || btn.name || btn.commandText || btn.action || '').trim() || `Command ${btn.id}`;
      const text = String(btn.commandText || btn.action || '').trim();
      const preview = text ? ` - ${text.slice(0, 48)}` : '';
      const safe = `${name}${preview}`.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $select.append(`<option value="${btn.id}">${safe}</option>`);
    });
    if (buttons.length > 0) $select.val(String(buttons[0].id));
  }

  _getEventTriggerDisplay(ev) {
    const sceneId = this.currentScene?.id || '';
    const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
    if (triggerObj) {
      return this._getComponentDisplayName(triggerObj.type || '', triggerObj);
    }
    if (isSceneLevelSource(ev.source_object_id, sceneId) && isSceneLevelEventType(ev.event_type)) {
      return this._getSceneEventSourceLabel();
    }
    return ev.source_object_id;
  }

  _renderShowHideItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const allEvents = this.model.worldEvents || [];
    const showEvents = allEvents.filter(
      (e) => e.action === 'show'
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const hideEvents = allEvents.filter(
      (e) => e.action === 'hide'
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const render = (action, events) => {
      const $container = $(`.object-event-action-items[data-action="${action}"]`);
      $container.empty();
      events.forEach((ev) => {
        const display = this._getEventTriggerDisplay(ev);
        const actionIcon = action === 'show' ? 'visibility' : 'visibility_off';
        const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
        const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
        const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
        const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        $container.append(`<div class="object-event-show-hide-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${action}" title="${action === 'show' ? 'Show' : 'Hide'}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
      });
    };
    render('show', showEvents);
    render('hide', hideEvents);
    this._renderImageActionItems();
    this._renderCommandActionItems();
    this._renderMusicActionItems();
    this._renderInputFieldActionItems();
    this._renderEmbeddedWebpageActionItems();
    this._renderCameraLookAtItems();
  }

  _renderEmbeddedWebpageActionItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const events = (this.model.worldEvents || []).filter(
      (e) => String(e.action || '') === 'openEmbeddedWebpage'
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const $container = $('.object-event-action-items[data-action="openEmbeddedWebpage"]');
    $container.empty();
    events.forEach((ev) => {
      const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
      const display = this._getEventTriggerDisplay(ev);
      const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
      const labelKey = getActionLabelKey('openEmbeddedWebpage');
      const actionLabel = (labelKey ? ($trans(labelKey) || 'openEmbeddedWebpage') : 'openEmbeddedWebpage');
      const actionIcon = this._getActionIcon('openEmbeddedWebpage');
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="openEmbeddedWebpage" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
  }

  _renderCameraLookAtItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const events = (this.model.worldEvents || []).filter(
      (e) => e.action === 'animateCameraLookAt'
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const $container = $('.object-event-action-items[data-action="animateCameraLookAt"]');
    $container.empty();
    events.forEach((ev) => {
      const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
      const display = this._getEventTriggerDisplay(ev);
      const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
      const labelKey = getActionLabelKey('animateCameraLookAt');
      const actionLabel = (labelKey ? ($trans(labelKey) || 'animateCameraLookAt') : 'animateCameraLookAt');
      const actionIcon = this._getActionIcon('animateCameraLookAt');
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="animateCameraLookAt" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
  }

  _renderImageActionItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    getImageGalleryPanelActions().forEach(({ value: action, labelKey }) => {
      const events = (this.model.worldEvents || []).filter(
        (e) => e.action === action
          && String(e.scene_id) === String(sceneId)
          && targetIdSet.has(String(e.target_object_id))
          && String(e.source_object_id) !== String(e.target_object_id)
      );
      const $container = $(`.object-event-action-items[data-action="${action}"]`);
      $container.empty();
      events.forEach((ev) => {
        const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
        const display = this._getEventTriggerDisplay(ev);
        const actionIcon = this._getActionIcon(action);
        const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
        const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
        let actionLabel = $trans(labelKey) || action;
        if (action === 'showImage' && ev.action_params) {
          try {
            const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
            if (params.imageIndex !== undefined) actionLabel += ` (#${params.imageIndex + 1})`;
          } catch (_) { }
        }
        const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${action}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
      });
      $(`.object-event-action-group--image-gallery[data-action="${action}"]`).toggle(events.length > 0);
    });
  }

  _renderCommandActionItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const agentActions = ['sendCommand', 'startCall', 'endCall', 'switchAgent', 'openInputField'];
    const events = (this.model.worldEvents || []).filter(
      (e) => agentActions.includes(String(e.action || ''))
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const $container = $('.object-event-action-items[data-action="sendCommand"]');
    $container.empty();
    events.forEach((ev) => {
      const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
      const display = this._getEventTriggerDisplay(ev);
      const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
      const actionValue = String(ev.action || '');
      const labelKey = getActionLabelKey(actionValue);
      let actionLabel = (labelKey ? ($trans(labelKey) || actionValue) : actionValue) || actionValue;
      if (actionValue === 'switchAgent' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params?.name) actionLabel += ` (${String(params.name)})`;
        } catch (_) { }
      } else if (actionValue === 'sendCommand' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          if (params.commandName) actionLabel += ` (${String(params.commandName)})`;
          if (params.commandText) actionLabel += `: ${String(params.commandText).slice(0, 40)}`;
        } catch (_) { }
      } else if (actionValue === 'openInputField' && ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          const field = this._findSceneObjectByAnyId(params.inputFieldId);
          const fieldName = field
            ? this._getComponentDisplayName(field.type || 'inputField', field)
            : (params.fieldKey || '');
          if (fieldName) actionLabel += ` (${String(fieldName)})`;
        } catch (_) { }
      }
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      let actionIcon = 'send';
      if (actionValue === 'startCall') actionIcon = 'call';
      if (actionValue === 'endCall') actionIcon = 'call_end';
      if (actionValue === 'switchAgent') actionIcon = 'switch_account';
      if (actionValue === 'openInputField') actionIcon = 'text_fields';
      $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${actionValue}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
  }

  _renderMusicActionItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    // Include play/pause/closeVideo (videoPlayer/youtube) and openGallery (videoGallery) so
    // scene-level triggers like introAnimationEnded → play show on the Events/Actions tab.
    const musicActions = ['playOnce', 'playLoop', 'stopPlaying', 'play', 'pause', 'openGallery', 'closeVideo', 'closeElement'];
    const events = (this.model.worldEvents || []).filter(
      (e) => musicActions.includes(String(e.action || ''))
        && String(e.scene_id) === String(sceneId)
        && targetIdSet.has(String(e.target_object_id))
        && String(e.source_object_id) !== String(e.target_object_id)
    );
    const $container = $('.object-event-action-items[data-action="music"]');
    $container.empty();
    events.forEach((ev) => {
      const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
      const display = this._getEventTriggerDisplay(ev);
      const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
      const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
      const actionValue = String(ev.action || '');
      const labelKey = getActionLabelKey(actionValue);
      const actionLabel = (labelKey ? ($trans(labelKey) || actionValue) : actionValue) || actionValue;
      const actionIcon = this._getActionIcon(actionValue);
      const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${actionValue}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
    });
  }

  _renderInputFieldActionItems() {
    const targetIdSet = new Set(this._getSelectedEventObjectIdsForActions().map((id) => String(id)));
    const sceneId = this.currentScene?.id || '';
    const groups = [
      { action: 'openInputField', match: (a) => a === 'openInputField' || a === 'open' },
      { action: 'close', match: (a) => a === 'close' || a === 'closeElement' },
    ];
    groups.forEach(({ action, match }) => {
      const events = (this.model.worldEvents || []).filter(
        (e) => match(String(e.action || ''))
          && String(e.scene_id) === String(sceneId)
          && targetIdSet.has(String(e.target_object_id))
          && String(e.source_object_id) !== String(e.target_object_id)
      );
      const $container = $(`.object-event-action-items[data-action="${action}"]`);
      $container.empty();
      events.forEach((ev) => {
        const triggerObj = this._findSceneObjectByAnyId(ev.source_object_id);
        const display = this._getEventTriggerDisplay(ev);
        const icon = this._getComponentIcon(triggerObj?.type || (isSceneLevelEventType(ev.event_type) ? SCENE_SOURCE_TYPE : ''));
        const eventLabel = this._getEventTypeDisplay(ev.event_type || 'click');
        const actionValue = String(ev.action || '');
        const labelKey = getActionLabelKey(actionValue);
        const actionLabel = (labelKey ? ($trans(labelKey) || actionValue) : actionValue) || actionValue;
        const actionIcon = this._getActionIcon(actionValue);
        const safeDisplay = String(display).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const safeActionLabel = String(actionLabel).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        $container.append(`<div class="object-event-image-action-item object-event-item ai-agent-item flx-sb" data-event-id="${ev.id}"><span class="object-event-item-action material-icons-outlined md-18" data-action="${actionValue}" title="${safeActionLabel}">${actionIcon}</span><span class="object-event-item-icon material-icons-outlined md-18">${icon}</span><span class="ai-agent-name" title="${safeDisplay}">${safeDisplay}</span><span class="object-event-item-event" title="${eventLabel}">${eventLabel}</span><span class="ai-agent-edit material-icons-outlined md-18" title="${$trans('edit-text') || 'Edit'}">edit</span><span class="ai-agent-delete material-icons-outlined md-18" title="Remove">delete</span></div>`);
      });
    });
  }

  _populateConnectEventLibraryAgents() {
    const $select = $('#connect_event_library_agent');
    $select.find('option:not(:first)').remove();
    this._connectEventLibraryConfigs = {};
    const applySavedAgentFallback = (agents) => {
      const prefLib = this._connectEventPreferredLibraryId;
      const prefAsst = (this._connectEventPreferredAssistantId || '').trim();
      const snap = this._connectEventPreferredSwitchAgentParams;
      this._connectEventPreferredLibraryId = null;
      this._connectEventPreferredAssistantId = '';
      this._connectEventPreferredSwitchAgentParams = null;

      const prefLibStr = prefLib != null && String(prefLib) !== '' ? String(prefLib) : '';
      const inList = prefLibStr && agents.some((a) => String(a.id) === prefLibStr);
      if (prefLibStr && snap && !inList) {
        const label = String(snap.name || snap.chairName || `Agent #${prefLibStr}`).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        $select.append(`<option value="${prefLibStr}">${label}</option>`);
        this._connectEventLibraryConfigs[prefLibStr] = { ...snap };
      }

      let chosen = '';
      if (prefLibStr && (inList || (snap && String(snap.libraryId ?? snap.vapiLibraryId ?? '') === prefLibStr))) {
        chosen = prefLibStr;
      }
      if (!chosen && prefLibStr && snap && !inList) {
        chosen = prefLibStr;
      }
      if (!chosen && prefAsst) {
        const hit = agents.find((a) => String(a.vapi_assistant_id || a.vapiAssistantId || '').trim() === prefAsst);
        if (hit) chosen = String(hit.id);
      }
      if (chosen) $select.val(chosen);
      if (this.model?.customSelect?.refresh) this.model.customSelect.refresh();
    };

    this.model.worldFetcher.listVapiAgents(
      this.worldID,
      (res) => {
        const agents = res?.agents || [];
        agents.forEach((a) => {
          const assistantId = String(a.vapi_assistant_id || a.vapiAssistantId || '').trim();
          const name = (a.name || assistantId || a.vapi_assistant_id || a.vapiAssistantId || 'AI Agent')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;');
          const fullConfig = buildFullAgentConfigFromLibrary(a);
          this._connectEventLibraryConfigs[a.id] = fullConfig;
          const asstAttr = (assistantId || '').replace(/"/g, '&quot;');
          $select.append(`<option value="${a.id}" data-assistant-id="${asstAttr}">${name}</option>`);
        });
        applySavedAgentFallback(agents);
      },
      (err) => {
        console.warn('[VAPI] listVapiAgents (connect event library) failed', err);
        this.model.alert?.('error', $trans('vapi-library-load-failed') || 'Could not load your AI agent library. Try again.');
        applySavedAgentFallback([]);
      }
    );
  }

  generateLocationOptions = () => {
    emptySelectOptions('locationButton');
    $('#locationButton').append(`<option value=""></option>`);
    for (let x = 0; x < this.scenes.length; x++) {
      $('#locationButton').append(`<option value="${this.scenes[x].id}">${this.scenes[x].publicName}</option>`);
    }
    this.model.customSelect.refresh();
  }

  formatTimestamp(timestamp) {
    const date = new Date(timestamp); // Convert timestamp to Date object

    // Extract hours and minutes
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    // Format as "HH:mm DD/MM/YYYY"
    return `${hours}:${minutes} ${day}/${month}/${year}`;
  }

  initWorldVersionDropdown() {
    $('#room-version-dropdown-btn').on('click', (e) => {
      e.stopPropagation();

      const $menu = $('#room-version-dropdown-menu');

      $menu.find('.app-dropdown__item:not(.app-dropdown__item--template)').remove();

      if (!$menu.is(':visible')) {
        this.model.worldFetcher.getWorldVersions(this.worldID, (response) => {
          $menu.find('.app-dropdown__item:not(.app-dropdown__item--template)').remove();

          response.data.forEach((item) => {
            this.renderWorldVersionDropdownItem(item)
          })
        })
      }

      $menu.toggle();
    })

    // Hide dropdown when clicking outside
    $(document).on('click', () => {
      $('#room-version-dropdown-menu').hide();
    });

    // Prevent hiding the dropdown when clicking inside
    $('#room-version-dropdown-menu').on('click', (e) => {
      e.stopPropagation(); // Prevent event from bubbling to the document
    });
  }

  renderWorldVersionDropdownItem(item) {
    const versionName = `Version ${item.version}`;
    const time = item.created ? this.formatTimestamp(item.created) : ''

    const $el = $($('.app-dropdown__item--template').get(0)).clone();
    $el.find('.app-dropdown__item__name').text(versionName);
    $el.find('.app-dropdown__item__time').text(time)
    $el.removeClass('app-dropdown__item--template');
    $('#room-version-dropdown-menu').append($el);

    $el.on('click', () => {
      $('#room-version-dropdown-menu').hide();

      $('.confirm-footer').removeClass('leaveEditMode');

      this.model.confirm(
        `
        <div class="has-text-centered mb-3">
          <div class='world-version-modal__name'>${versionName}</div>
          <div class='world-version-modal__time'>${time}</div>
        </div>
        <div class="mb-3">Are you sure you want to apply this history version to current room?</div>
        `,
        () => {
          this.applyWorldVersion(item);
        }
      );
    });
  }

  applyWorldVersion(item) {
    this.worldData = {
      ...this.worldData,
      ...item.data,
    };
    this.scenes = item.data.scenes;
    this.updateDB();

    // reload to apply the selected history version in this session until Publish
    this.model.markRestoreEditorDraft();
    const url = new URL(window.location.href);
    url.searchParams.delete('mode');
    window.history.replaceState(null, '', url.toString());
    window.location.reload();
  }

  _loadProducts(products, total) {
    let lastProdNum = parseInt($('#products').find('.product-container').last().attr('data-order'));

    for (let i = 0; i < total; i++) {
      if (i > 0) {
        $('#add_more_products').trigger('click');
      }
      let num = i + 1;
      const product = products[i];

      // Initialize Quill editor for each product
      const editorSelector = '#product_description' + num + '_editor';
      const editor = initQuillEditor(editorSelector);
      setQuillContent(editorSelector, product.product_description);

      $(".product-container[data-order=" + num + "] input[name=product_name]").val(product.product_name);
      $(".product-container[data-order=" + num + "] .upload_product_image .default_image").attr('src', product.product_image);
      $(".product-container[data-order=" + num + "] input[name=product_image]").val(product.product_image);
      $(".product-container[data-order=" + num + "] input[name=product_price]").val(product.product_price);
      $(".product-container[data-order=" + num + "] input[name=product_url]").val(product.product_url);
      $(".product-container[data-order=" + num + "] input[name=product_button_label]").val(product.product_button_label);
    }
  }

  componentWillUnmount() {
    // Remove all Quill editor instances
    const editors = document.querySelectorAll('.quill-editor');
    editors.forEach(editor => {
      removeQuillEditor('#' + editor.id);
    });

    // Clean up Quill editor
    if (this.infoElementQuill) {
      removeQuillEditor("#info-element-description1");
      this.infoElementQuill = null;
    }
    if (this.welcomeScreenQuill) {
      removeQuillEditor("#welcome-screen-description1");
      this.welcomeScreenQuill = null;
    }
    if (this.consentScreenQuill) {
      removeQuillEditor("#consent-screen-description1");
      this.consentScreenQuill = null;
    }
  }
}

export { ModeEdit }
